import sn, { createContext as RT, useContext as nd, Fragment as Jy, useState as va } from "react";
import { Combobox as NT, FormField as Qy, Label as jy, ComboboxInput as $T, FormHelp as n2, Popover as e2, Heading as ed, Text as ka, Spacer as e0, Flex as ni, Popper as t2, AdornedInput as kT, Adornment as dv, Input as OT, Form as IT, Button as r2, Box as td, token as rl, spaceMixin as il, Paragraph as Ai, IconExclamationCircleOutline as LT, Card as i2, mediaBreakpointMixin as al, Table as Ue, Collapsible as DT, IconChevronDown as FT, IconChevronUp as BT } from "@zillow/constellation";
import Zt from "styled-components";
function Dt(n, e) {
  for (var t = 0; t < e.length; t++) {
    const r = e[t];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const i in r)
        if (i !== "default" && !(i in n)) {
          const o = Object.getOwnPropertyDescriptor(r, i);
          o && Object.defineProperty(n, i, o.get ? o : {
            enumerable: !0,
            get: () => r[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }));
}
var Dn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Br(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function xt(n) {
  if (n.__esModule)
    return n;
  var e = n.default;
  if (typeof e == "function") {
    var t = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(n).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(n, r);
    Object.defineProperty(t, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return n[r];
      }
    });
  }), t;
}
var us = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
us.exports;
(function(n, e) {
  (function() {
    var t, r = "4.17.21", i = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", f = "Expected a function", s = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", c = 500, p = "__lodash_placeholder__", g = 1, d = 2, v = 4, b = 1, w = 2, m = 1, _ = 2, x = 4, A = 8, T = 16, S = 32, R = 64, I = 128, B = 256, F = 512, V = 30, E = "...", L = 800, $ = 16, P = 1, k = 2, O = 3, W = 1 / 0, K = 9007199254740991, Q = 17976931348623157e292, z = 0 / 0, q = 4294967295, J = q - 1, en = q >>> 1, fn = [
      ["ary", I],
      ["bind", m],
      ["bindKey", _],
      ["curry", A],
      ["curryRight", T],
      ["flip", F],
      ["partial", S],
      ["partialRight", R],
      ["rearg", B]
    ], ln = "[object Arguments]", Tn = "[object Array]", gn = "[object AsyncFunction]", _n = "[object Boolean]", tn = "[object Date]", hn = "[object DOMException]", vn = "[object Error]", an = "[object Function]", xn = "[object GeneratorFunction]", En = "[object Map]", In = "[object Number]", Ln = "[object Null]", pn = "[object Object]", Pn = "[object Promise]", U = "[object Proxy]", X = "[object RegExp]", j = "[object Set]", mn = "[object String]", dn = "[object Symbol]", cn = "[object Undefined]", An = "[object WeakMap]", Zn = "[object WeakSet]", ie = "[object ArrayBuffer]", Bt = "[object DataView]", nr = "[object Float32Array]", uo = "[object Float64Array]", di = "[object Int8Array]", pi = "[object Int16Array]", fo = "[object Int32Array]", na = "[object Uint8Array]", so = "[object Uint8ClampedArray]", ea = "[object Uint16Array]", Jl = "[object Uint32Array]", J3 = /\b__p \+= '';/g, Q3 = /\b(__p \+=) '' \+/g, j3 = /(__e\(.*?\)|\b__t\)) \+\n'';/g, F1 = /&(?:amp|lt|gt|quot|#39);/g, B1 = /[&<>"']/g, nx = RegExp(F1.source), ex = RegExp(B1.source), tx = /<%-([\s\S]+?)%>/g, rx = /<%([\s\S]+?)%>/g, z1 = /<%=([\s\S]+?)%>/g, ix = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ax = /^\w*$/, ox = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ql = /[\\^$.*+?()[\]{}|]/g, ux = RegExp(Ql.source), jl = /^\s+/, fx = /\s/, sx = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, lx = /\{\n\/\* \[wrapped with (.+)\] \*/, cx = /,? & /, hx = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, dx = /[()=,{}\[\]\/\s]/, px = /\\(\\)?/g, gx = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, V1 = /\w*$/, vx = /^[-+]0x[0-9a-f]+$/i, mx = /^0b[01]+$/i, yx = /^\[object .+?Constructor\]$/, _x = /^0o[0-7]+$/i, bx = /^(?:0|[1-9]\d*)$/, wx = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Iu = /($^)/, xx = /['\n\r\u2028\u2029\\]/g, Lu = "\\ud800-\\udfff", Tx = "\\u0300-\\u036f", Ax = "\\ufe20-\\ufe2f", Mx = "\\u20d0-\\u20ff", U1 = Tx + Ax + Mx, G1 = "\\u2700-\\u27bf", q1 = "a-z\\xdf-\\xf6\\xf8-\\xff", Sx = "\\xac\\xb1\\xd7\\xf7", Ex = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Cx = "\\u2000-\\u206f", Px = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", W1 = "A-Z\\xc0-\\xd6\\xd8-\\xde", H1 = "\\ufe0e\\ufe0f", Y1 = Sx + Ex + Cx + Px, nc = "['’]", Rx = "[" + Lu + "]", X1 = "[" + Y1 + "]", Du = "[" + U1 + "]", K1 = "\\d+", Nx = "[" + G1 + "]", Z1 = "[" + q1 + "]", J1 = "[^" + Lu + Y1 + K1 + G1 + q1 + W1 + "]", ec = "\\ud83c[\\udffb-\\udfff]", $x = "(?:" + Du + "|" + ec + ")", Q1 = "[^" + Lu + "]", tc = "(?:\\ud83c[\\udde6-\\uddff]){2}", rc = "[\\ud800-\\udbff][\\udc00-\\udfff]", ta = "[" + W1 + "]", j1 = "\\u200d", np = "(?:" + Z1 + "|" + J1 + ")", kx = "(?:" + ta + "|" + J1 + ")", ep = "(?:" + nc + "(?:d|ll|m|re|s|t|ve))?", tp = "(?:" + nc + "(?:D|LL|M|RE|S|T|VE))?", rp = $x + "?", ip = "[" + H1 + "]?", Ox = "(?:" + j1 + "(?:" + [Q1, tc, rc].join("|") + ")" + ip + rp + ")*", Ix = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Lx = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ap = ip + rp + Ox, Dx = "(?:" + [Nx, tc, rc].join("|") + ")" + ap, Fx = "(?:" + [Q1 + Du + "?", Du, tc, rc, Rx].join("|") + ")", Bx = RegExp(nc, "g"), zx = RegExp(Du, "g"), ic = RegExp(ec + "(?=" + ec + ")|" + Fx + ap, "g"), Vx = RegExp([
      ta + "?" + Z1 + "+" + ep + "(?=" + [X1, ta, "$"].join("|") + ")",
      kx + "+" + tp + "(?=" + [X1, ta + np, "$"].join("|") + ")",
      ta + "?" + np + "+" + ep,
      ta + "+" + tp,
      Lx,
      Ix,
      K1,
      Dx
    ].join("|"), "g"), Ux = RegExp("[" + j1 + Lu + U1 + H1 + "]"), Gx = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, qx = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Wx = -1, oe = {};
    oe[nr] = oe[uo] = oe[di] = oe[pi] = oe[fo] = oe[na] = oe[so] = oe[ea] = oe[Jl] = !0, oe[ln] = oe[Tn] = oe[ie] = oe[_n] = oe[Bt] = oe[tn] = oe[vn] = oe[an] = oe[En] = oe[In] = oe[pn] = oe[X] = oe[j] = oe[mn] = oe[An] = !1;
    var ae = {};
    ae[ln] = ae[Tn] = ae[ie] = ae[Bt] = ae[_n] = ae[tn] = ae[nr] = ae[uo] = ae[di] = ae[pi] = ae[fo] = ae[En] = ae[In] = ae[pn] = ae[X] = ae[j] = ae[mn] = ae[dn] = ae[na] = ae[so] = ae[ea] = ae[Jl] = !0, ae[vn] = ae[an] = ae[An] = !1;
    var Hx = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Yx = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Xx = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Kx = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Zx = parseFloat, Jx = parseInt, op = typeof Dn == "object" && Dn && Dn.Object === Object && Dn, Qx = typeof self == "object" && self && self.Object === Object && self, $e = op || Qx || Function("return this")(), ac = e && !e.nodeType && e, gi = ac && !0 && n && !n.nodeType && n, up = gi && gi.exports === ac, oc = up && op.process, Tt = function() {
      try {
        var H = gi && gi.require && gi.require("util").types;
        return H || oc && oc.binding && oc.binding("util");
      } catch {
      }
    }(), fp = Tt && Tt.isArrayBuffer, sp = Tt && Tt.isDate, lp = Tt && Tt.isMap, cp = Tt && Tt.isRegExp, hp = Tt && Tt.isSet, dp = Tt && Tt.isTypedArray;
    function dt(H, nn, Z) {
      switch (Z.length) {
        case 0:
          return H.call(nn);
        case 1:
          return H.call(nn, Z[0]);
        case 2:
          return H.call(nn, Z[0], Z[1]);
        case 3:
          return H.call(nn, Z[0], Z[1], Z[2]);
      }
      return H.apply(nn, Z);
    }
    function jx(H, nn, Z, bn) {
      for (var Fn = -1, Qn = H == null ? 0 : H.length; ++Fn < Qn; ) {
        var we = H[Fn];
        nn(bn, we, Z(we), H);
      }
      return bn;
    }
    function At(H, nn) {
      for (var Z = -1, bn = H == null ? 0 : H.length; ++Z < bn && nn(H[Z], Z, H) !== !1; )
        ;
      return H;
    }
    function n5(H, nn) {
      for (var Z = H == null ? 0 : H.length; Z-- && nn(H[Z], Z, H) !== !1; )
        ;
      return H;
    }
    function pp(H, nn) {
      for (var Z = -1, bn = H == null ? 0 : H.length; ++Z < bn; )
        if (!nn(H[Z], Z, H))
          return !1;
      return !0;
    }
    function Vr(H, nn) {
      for (var Z = -1, bn = H == null ? 0 : H.length, Fn = 0, Qn = []; ++Z < bn; ) {
        var we = H[Z];
        nn(we, Z, H) && (Qn[Fn++] = we);
      }
      return Qn;
    }
    function Fu(H, nn) {
      var Z = H == null ? 0 : H.length;
      return !!Z && ra(H, nn, 0) > -1;
    }
    function uc(H, nn, Z) {
      for (var bn = -1, Fn = H == null ? 0 : H.length; ++bn < Fn; )
        if (Z(nn, H[bn]))
          return !0;
      return !1;
    }
    function fe(H, nn) {
      for (var Z = -1, bn = H == null ? 0 : H.length, Fn = Array(bn); ++Z < bn; )
        Fn[Z] = nn(H[Z], Z, H);
      return Fn;
    }
    function Ur(H, nn) {
      for (var Z = -1, bn = nn.length, Fn = H.length; ++Z < bn; )
        H[Fn + Z] = nn[Z];
      return H;
    }
    function fc(H, nn, Z, bn) {
      var Fn = -1, Qn = H == null ? 0 : H.length;
      for (bn && Qn && (Z = H[++Fn]); ++Fn < Qn; )
        Z = nn(Z, H[Fn], Fn, H);
      return Z;
    }
    function e5(H, nn, Z, bn) {
      var Fn = H == null ? 0 : H.length;
      for (bn && Fn && (Z = H[--Fn]); Fn--; )
        Z = nn(Z, H[Fn], Fn, H);
      return Z;
    }
    function sc(H, nn) {
      for (var Z = -1, bn = H == null ? 0 : H.length; ++Z < bn; )
        if (nn(H[Z], Z, H))
          return !0;
      return !1;
    }
    var t5 = lc("length");
    function r5(H) {
      return H.split("");
    }
    function i5(H) {
      return H.match(hx) || [];
    }
    function gp(H, nn, Z) {
      var bn;
      return Z(H, function(Fn, Qn, we) {
        if (nn(Fn, Qn, we))
          return bn = Qn, !1;
      }), bn;
    }
    function Bu(H, nn, Z, bn) {
      for (var Fn = H.length, Qn = Z + (bn ? 1 : -1); bn ? Qn-- : ++Qn < Fn; )
        if (nn(H[Qn], Qn, H))
          return Qn;
      return -1;
    }
    function ra(H, nn, Z) {
      return nn === nn ? v5(H, nn, Z) : Bu(H, vp, Z);
    }
    function a5(H, nn, Z, bn) {
      for (var Fn = Z - 1, Qn = H.length; ++Fn < Qn; )
        if (bn(H[Fn], nn))
          return Fn;
      return -1;
    }
    function vp(H) {
      return H !== H;
    }
    function mp(H, nn) {
      var Z = H == null ? 0 : H.length;
      return Z ? hc(H, nn) / Z : z;
    }
    function lc(H) {
      return function(nn) {
        return nn == null ? t : nn[H];
      };
    }
    function cc(H) {
      return function(nn) {
        return H == null ? t : H[nn];
      };
    }
    function yp(H, nn, Z, bn, Fn) {
      return Fn(H, function(Qn, we, ee) {
        Z = bn ? (bn = !1, Qn) : nn(Z, Qn, we, ee);
      }), Z;
    }
    function o5(H, nn) {
      var Z = H.length;
      for (H.sort(nn); Z--; )
        H[Z] = H[Z].value;
      return H;
    }
    function hc(H, nn) {
      for (var Z, bn = -1, Fn = H.length; ++bn < Fn; ) {
        var Qn = nn(H[bn]);
        Qn !== t && (Z = Z === t ? Qn : Z + Qn);
      }
      return Z;
    }
    function dc(H, nn) {
      for (var Z = -1, bn = Array(H); ++Z < H; )
        bn[Z] = nn(Z);
      return bn;
    }
    function u5(H, nn) {
      return fe(nn, function(Z) {
        return [Z, H[Z]];
      });
    }
    function _p(H) {
      return H && H.slice(0, Tp(H) + 1).replace(jl, "");
    }
    function pt(H) {
      return function(nn) {
        return H(nn);
      };
    }
    function pc(H, nn) {
      return fe(nn, function(Z) {
        return H[Z];
      });
    }
    function lo(H, nn) {
      return H.has(nn);
    }
    function bp(H, nn) {
      for (var Z = -1, bn = H.length; ++Z < bn && ra(nn, H[Z], 0) > -1; )
        ;
      return Z;
    }
    function wp(H, nn) {
      for (var Z = H.length; Z-- && ra(nn, H[Z], 0) > -1; )
        ;
      return Z;
    }
    function f5(H, nn) {
      for (var Z = H.length, bn = 0; Z--; )
        H[Z] === nn && ++bn;
      return bn;
    }
    var s5 = cc(Hx), l5 = cc(Yx);
    function c5(H) {
      return "\\" + Kx[H];
    }
    function h5(H, nn) {
      return H == null ? t : H[nn];
    }
    function ia(H) {
      return Ux.test(H);
    }
    function d5(H) {
      return Gx.test(H);
    }
    function p5(H) {
      for (var nn, Z = []; !(nn = H.next()).done; )
        Z.push(nn.value);
      return Z;
    }
    function gc(H) {
      var nn = -1, Z = Array(H.size);
      return H.forEach(function(bn, Fn) {
        Z[++nn] = [Fn, bn];
      }), Z;
    }
    function xp(H, nn) {
      return function(Z) {
        return H(nn(Z));
      };
    }
    function Gr(H, nn) {
      for (var Z = -1, bn = H.length, Fn = 0, Qn = []; ++Z < bn; ) {
        var we = H[Z];
        (we === nn || we === p) && (H[Z] = p, Qn[Fn++] = Z);
      }
      return Qn;
    }
    function zu(H) {
      var nn = -1, Z = Array(H.size);
      return H.forEach(function(bn) {
        Z[++nn] = bn;
      }), Z;
    }
    function g5(H) {
      var nn = -1, Z = Array(H.size);
      return H.forEach(function(bn) {
        Z[++nn] = [bn, bn];
      }), Z;
    }
    function v5(H, nn, Z) {
      for (var bn = Z - 1, Fn = H.length; ++bn < Fn; )
        if (H[bn] === nn)
          return bn;
      return -1;
    }
    function m5(H, nn, Z) {
      for (var bn = Z + 1; bn--; )
        if (H[bn] === nn)
          return bn;
      return bn;
    }
    function aa(H) {
      return ia(H) ? _5(H) : t5(H);
    }
    function zt(H) {
      return ia(H) ? b5(H) : r5(H);
    }
    function Tp(H) {
      for (var nn = H.length; nn-- && fx.test(H.charAt(nn)); )
        ;
      return nn;
    }
    var y5 = cc(Xx);
    function _5(H) {
      for (var nn = ic.lastIndex = 0; ic.test(H); )
        ++nn;
      return nn;
    }
    function b5(H) {
      return H.match(ic) || [];
    }
    function w5(H) {
      return H.match(Vx) || [];
    }
    var x5 = function H(nn) {
      nn = nn == null ? $e : oa.defaults($e.Object(), nn, oa.pick($e, qx));
      var Z = nn.Array, bn = nn.Date, Fn = nn.Error, Qn = nn.Function, we = nn.Math, ee = nn.Object, vc = nn.RegExp, T5 = nn.String, Mt = nn.TypeError, Vu = Z.prototype, A5 = Qn.prototype, ua = ee.prototype, Uu = nn["__core-js_shared__"], Gu = A5.toString, ne = ua.hasOwnProperty, M5 = 0, Ap = function() {
        var a = /[^.]+$/.exec(Uu && Uu.keys && Uu.keys.IE_PROTO || "");
        return a ? "Symbol(src)_1." + a : "";
      }(), qu = ua.toString, S5 = Gu.call(ee), E5 = $e._, C5 = vc(
        "^" + Gu.call(ne).replace(Ql, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Wu = up ? nn.Buffer : t, qr = nn.Symbol, Hu = nn.Uint8Array, Mp = Wu ? Wu.allocUnsafe : t, Yu = xp(ee.getPrototypeOf, ee), Sp = ee.create, Ep = ua.propertyIsEnumerable, Xu = Vu.splice, Cp = qr ? qr.isConcatSpreadable : t, co = qr ? qr.iterator : t, vi = qr ? qr.toStringTag : t, Ku = function() {
        try {
          var a = wi(ee, "defineProperty");
          return a({}, "", {}), a;
        } catch {
        }
      }(), P5 = nn.clearTimeout !== $e.clearTimeout && nn.clearTimeout, R5 = bn && bn.now !== $e.Date.now && bn.now, N5 = nn.setTimeout !== $e.setTimeout && nn.setTimeout, Zu = we.ceil, Ju = we.floor, mc = ee.getOwnPropertySymbols, $5 = Wu ? Wu.isBuffer : t, Pp = nn.isFinite, k5 = Vu.join, O5 = xp(ee.keys, ee), xe = we.max, Le = we.min, I5 = bn.now, L5 = nn.parseInt, Rp = we.random, D5 = Vu.reverse, yc = wi(nn, "DataView"), ho = wi(nn, "Map"), _c = wi(nn, "Promise"), fa = wi(nn, "Set"), po = wi(nn, "WeakMap"), go = wi(ee, "create"), Qu = po && new po(), sa = {}, F5 = xi(yc), B5 = xi(ho), z5 = xi(_c), V5 = xi(fa), U5 = xi(po), ju = qr ? qr.prototype : t, vo = ju ? ju.valueOf : t, Np = ju ? ju.toString : t;
      function C(a) {
        if (pe(a) && !Bn(a) && !(a instanceof Yn)) {
          if (a instanceof St)
            return a;
          if (ne.call(a, "__wrapped__"))
            return $g(a);
        }
        return new St(a);
      }
      var la = function() {
        function a() {
        }
        return function(u) {
          if (!le(u))
            return {};
          if (Sp)
            return Sp(u);
          a.prototype = u;
          var h = new a();
          return a.prototype = t, h;
        };
      }();
      function nf() {
      }
      function St(a, u) {
        this.__wrapped__ = a, this.__actions__ = [], this.__chain__ = !!u, this.__index__ = 0, this.__values__ = t;
      }
      C.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: tx,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: rx,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: z1,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: C
        }
      }, C.prototype = nf.prototype, C.prototype.constructor = C, St.prototype = la(nf.prototype), St.prototype.constructor = St;
      function Yn(a) {
        this.__wrapped__ = a, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = q, this.__views__ = [];
      }
      function G5() {
        var a = new Yn(this.__wrapped__);
        return a.__actions__ = ot(this.__actions__), a.__dir__ = this.__dir__, a.__filtered__ = this.__filtered__, a.__iteratees__ = ot(this.__iteratees__), a.__takeCount__ = this.__takeCount__, a.__views__ = ot(this.__views__), a;
      }
      function q5() {
        if (this.__filtered__) {
          var a = new Yn(this);
          a.__dir__ = -1, a.__filtered__ = !0;
        } else
          a = this.clone(), a.__dir__ *= -1;
        return a;
      }
      function W5() {
        var a = this.__wrapped__.value(), u = this.__dir__, h = Bn(a), y = u < 0, M = h ? a.length : 0, N = r8(0, M, this.__views__), D = N.start, G = N.end, Y = G - D, rn = y ? G : D - 1, on = this.__iteratees__, un = on.length, yn = 0, Mn = Le(Y, this.__takeCount__);
        if (!h || !y && M == Y && Mn == Y)
          return eg(a, this.__actions__);
        var kn = [];
        n:
          for (; Y-- && yn < Mn; ) {
            rn += u;
            for (var Gn = -1, On = a[rn]; ++Gn < un; ) {
              var Hn = on[Gn], Kn = Hn.iteratee, mt = Hn.type, Ye = Kn(On);
              if (mt == k)
                On = Ye;
              else if (!Ye) {
                if (mt == P)
                  continue n;
                break n;
              }
            }
            kn[yn++] = On;
          }
        return kn;
      }
      Yn.prototype = la(nf.prototype), Yn.prototype.constructor = Yn;
      function mi(a) {
        var u = -1, h = a == null ? 0 : a.length;
        for (this.clear(); ++u < h; ) {
          var y = a[u];
          this.set(y[0], y[1]);
        }
      }
      function H5() {
        this.__data__ = go ? go(null) : {}, this.size = 0;
      }
      function Y5(a) {
        var u = this.has(a) && delete this.__data__[a];
        return this.size -= u ? 1 : 0, u;
      }
      function X5(a) {
        var u = this.__data__;
        if (go) {
          var h = u[a];
          return h === l ? t : h;
        }
        return ne.call(u, a) ? u[a] : t;
      }
      function K5(a) {
        var u = this.__data__;
        return go ? u[a] !== t : ne.call(u, a);
      }
      function Z5(a, u) {
        var h = this.__data__;
        return this.size += this.has(a) ? 0 : 1, h[a] = go && u === t ? l : u, this;
      }
      mi.prototype.clear = H5, mi.prototype.delete = Y5, mi.prototype.get = X5, mi.prototype.has = K5, mi.prototype.set = Z5;
      function vr(a) {
        var u = -1, h = a == null ? 0 : a.length;
        for (this.clear(); ++u < h; ) {
          var y = a[u];
          this.set(y[0], y[1]);
        }
      }
      function J5() {
        this.__data__ = [], this.size = 0;
      }
      function Q5(a) {
        var u = this.__data__, h = ef(u, a);
        if (h < 0)
          return !1;
        var y = u.length - 1;
        return h == y ? u.pop() : Xu.call(u, h, 1), --this.size, !0;
      }
      function j5(a) {
        var u = this.__data__, h = ef(u, a);
        return h < 0 ? t : u[h][1];
      }
      function n6(a) {
        return ef(this.__data__, a) > -1;
      }
      function e6(a, u) {
        var h = this.__data__, y = ef(h, a);
        return y < 0 ? (++this.size, h.push([a, u])) : h[y][1] = u, this;
      }
      vr.prototype.clear = J5, vr.prototype.delete = Q5, vr.prototype.get = j5, vr.prototype.has = n6, vr.prototype.set = e6;
      function mr(a) {
        var u = -1, h = a == null ? 0 : a.length;
        for (this.clear(); ++u < h; ) {
          var y = a[u];
          this.set(y[0], y[1]);
        }
      }
      function t6() {
        this.size = 0, this.__data__ = {
          hash: new mi(),
          map: new (ho || vr)(),
          string: new mi()
        };
      }
      function r6(a) {
        var u = pf(this, a).delete(a);
        return this.size -= u ? 1 : 0, u;
      }
      function i6(a) {
        return pf(this, a).get(a);
      }
      function a6(a) {
        return pf(this, a).has(a);
      }
      function o6(a, u) {
        var h = pf(this, a), y = h.size;
        return h.set(a, u), this.size += h.size == y ? 0 : 1, this;
      }
      mr.prototype.clear = t6, mr.prototype.delete = r6, mr.prototype.get = i6, mr.prototype.has = a6, mr.prototype.set = o6;
      function yi(a) {
        var u = -1, h = a == null ? 0 : a.length;
        for (this.__data__ = new mr(); ++u < h; )
          this.add(a[u]);
      }
      function u6(a) {
        return this.__data__.set(a, l), this;
      }
      function f6(a) {
        return this.__data__.has(a);
      }
      yi.prototype.add = yi.prototype.push = u6, yi.prototype.has = f6;
      function Vt(a) {
        var u = this.__data__ = new vr(a);
        this.size = u.size;
      }
      function s6() {
        this.__data__ = new vr(), this.size = 0;
      }
      function l6(a) {
        var u = this.__data__, h = u.delete(a);
        return this.size = u.size, h;
      }
      function c6(a) {
        return this.__data__.get(a);
      }
      function h6(a) {
        return this.__data__.has(a);
      }
      function d6(a, u) {
        var h = this.__data__;
        if (h instanceof vr) {
          var y = h.__data__;
          if (!ho || y.length < i - 1)
            return y.push([a, u]), this.size = ++h.size, this;
          h = this.__data__ = new mr(y);
        }
        return h.set(a, u), this.size = h.size, this;
      }
      Vt.prototype.clear = s6, Vt.prototype.delete = l6, Vt.prototype.get = c6, Vt.prototype.has = h6, Vt.prototype.set = d6;
      function $p(a, u) {
        var h = Bn(a), y = !h && Ti(a), M = !h && !y && Kr(a), N = !h && !y && !M && pa(a), D = h || y || M || N, G = D ? dc(a.length, T5) : [], Y = G.length;
        for (var rn in a)
          (u || ne.call(a, rn)) && !(D && // Safari 9 has enumerable `arguments.length` in strict mode.
          (rn == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          M && (rn == "offset" || rn == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          N && (rn == "buffer" || rn == "byteLength" || rn == "byteOffset") || // Skip index properties.
          wr(rn, Y))) && G.push(rn);
        return G;
      }
      function kp(a) {
        var u = a.length;
        return u ? a[Rc(0, u - 1)] : t;
      }
      function p6(a, u) {
        return gf(ot(a), _i(u, 0, a.length));
      }
      function g6(a) {
        return gf(ot(a));
      }
      function bc(a, u, h) {
        (h !== t && !Ut(a[u], h) || h === t && !(u in a)) && yr(a, u, h);
      }
      function mo(a, u, h) {
        var y = a[u];
        (!(ne.call(a, u) && Ut(y, h)) || h === t && !(u in a)) && yr(a, u, h);
      }
      function ef(a, u) {
        for (var h = a.length; h--; )
          if (Ut(a[h][0], u))
            return h;
        return -1;
      }
      function v6(a, u, h, y) {
        return Wr(a, function(M, N, D) {
          u(y, M, h(M), D);
        }), y;
      }
      function Op(a, u) {
        return a && tr(u, Se(u), a);
      }
      function m6(a, u) {
        return a && tr(u, ft(u), a);
      }
      function yr(a, u, h) {
        u == "__proto__" && Ku ? Ku(a, u, {
          configurable: !0,
          enumerable: !0,
          value: h,
          writable: !0
        }) : a[u] = h;
      }
      function wc(a, u) {
        for (var h = -1, y = u.length, M = Z(y), N = a == null; ++h < y; )
          M[h] = N ? t : eh(a, u[h]);
        return M;
      }
      function _i(a, u, h) {
        return a === a && (h !== t && (a = a <= h ? a : h), u !== t && (a = a >= u ? a : u)), a;
      }
      function Et(a, u, h, y, M, N) {
        var D, G = u & g, Y = u & d, rn = u & v;
        if (h && (D = M ? h(a, y, M, N) : h(a)), D !== t)
          return D;
        if (!le(a))
          return a;
        var on = Bn(a);
        if (on) {
          if (D = a8(a), !G)
            return ot(a, D);
        } else {
          var un = De(a), yn = un == an || un == xn;
          if (Kr(a))
            return ig(a, G);
          if (un == pn || un == ln || yn && !M) {
            if (D = Y || yn ? {} : Tg(a), !G)
              return Y ? X6(a, m6(D, a)) : Y6(a, Op(D, a));
          } else {
            if (!ae[un])
              return M ? a : {};
            D = o8(a, un, G);
          }
        }
        N || (N = new Vt());
        var Mn = N.get(a);
        if (Mn)
          return Mn;
        N.set(a, D), Qg(a) ? a.forEach(function(On) {
          D.add(Et(On, u, h, On, a, N));
        }) : Zg(a) && a.forEach(function(On, Hn) {
          D.set(Hn, Et(On, u, h, Hn, a, N));
        });
        var kn = rn ? Y ? Vc : zc : Y ? ft : Se, Gn = on ? t : kn(a);
        return At(Gn || a, function(On, Hn) {
          Gn && (Hn = On, On = a[Hn]), mo(D, Hn, Et(On, u, h, Hn, a, N));
        }), D;
      }
      function y6(a) {
        var u = Se(a);
        return function(h) {
          return Ip(h, a, u);
        };
      }
      function Ip(a, u, h) {
        var y = h.length;
        if (a == null)
          return !y;
        for (a = ee(a); y--; ) {
          var M = h[y], N = u[M], D = a[M];
          if (D === t && !(M in a) || !N(D))
            return !1;
        }
        return !0;
      }
      function Lp(a, u, h) {
        if (typeof a != "function")
          throw new Mt(f);
        return Ao(function() {
          a.apply(t, h);
        }, u);
      }
      function yo(a, u, h, y) {
        var M = -1, N = Fu, D = !0, G = a.length, Y = [], rn = u.length;
        if (!G)
          return Y;
        h && (u = fe(u, pt(h))), y ? (N = uc, D = !1) : u.length >= i && (N = lo, D = !1, u = new yi(u));
        n:
          for (; ++M < G; ) {
            var on = a[M], un = h == null ? on : h(on);
            if (on = y || on !== 0 ? on : 0, D && un === un) {
              for (var yn = rn; yn--; )
                if (u[yn] === un)
                  continue n;
              Y.push(on);
            } else
              N(u, un, y) || Y.push(on);
          }
        return Y;
      }
      var Wr = sg(er), Dp = sg(Tc, !0);
      function _6(a, u) {
        var h = !0;
        return Wr(a, function(y, M, N) {
          return h = !!u(y, M, N), h;
        }), h;
      }
      function tf(a, u, h) {
        for (var y = -1, M = a.length; ++y < M; ) {
          var N = a[y], D = u(N);
          if (D != null && (G === t ? D === D && !vt(D) : h(D, G)))
            var G = D, Y = N;
        }
        return Y;
      }
      function b6(a, u, h, y) {
        var M = a.length;
        for (h = Un(h), h < 0 && (h = -h > M ? 0 : M + h), y = y === t || y > M ? M : Un(y), y < 0 && (y += M), y = h > y ? 0 : nv(y); h < y; )
          a[h++] = u;
        return a;
      }
      function Fp(a, u) {
        var h = [];
        return Wr(a, function(y, M, N) {
          u(y, M, N) && h.push(y);
        }), h;
      }
      function ke(a, u, h, y, M) {
        var N = -1, D = a.length;
        for (h || (h = f8), M || (M = []); ++N < D; ) {
          var G = a[N];
          u > 0 && h(G) ? u > 1 ? ke(G, u - 1, h, y, M) : Ur(M, G) : y || (M[M.length] = G);
        }
        return M;
      }
      var xc = lg(), Bp = lg(!0);
      function er(a, u) {
        return a && xc(a, u, Se);
      }
      function Tc(a, u) {
        return a && Bp(a, u, Se);
      }
      function rf(a, u) {
        return Vr(u, function(h) {
          return xr(a[h]);
        });
      }
      function bi(a, u) {
        u = Yr(u, a);
        for (var h = 0, y = u.length; a != null && h < y; )
          a = a[rr(u[h++])];
        return h && h == y ? a : t;
      }
      function zp(a, u, h) {
        var y = u(a);
        return Bn(a) ? y : Ur(y, h(a));
      }
      function We(a) {
        return a == null ? a === t ? cn : Ln : vi && vi in ee(a) ? t8(a) : g8(a);
      }
      function Ac(a, u) {
        return a > u;
      }
      function w6(a, u) {
        return a != null && ne.call(a, u);
      }
      function x6(a, u) {
        return a != null && u in ee(a);
      }
      function T6(a, u, h) {
        return a >= Le(u, h) && a < xe(u, h);
      }
      function Mc(a, u, h) {
        for (var y = h ? uc : Fu, M = a[0].length, N = a.length, D = N, G = Z(N), Y = 1 / 0, rn = []; D--; ) {
          var on = a[D];
          D && u && (on = fe(on, pt(u))), Y = Le(on.length, Y), G[D] = !h && (u || M >= 120 && on.length >= 120) ? new yi(D && on) : t;
        }
        on = a[0];
        var un = -1, yn = G[0];
        n:
          for (; ++un < M && rn.length < Y; ) {
            var Mn = on[un], kn = u ? u(Mn) : Mn;
            if (Mn = h || Mn !== 0 ? Mn : 0, !(yn ? lo(yn, kn) : y(rn, kn, h))) {
              for (D = N; --D; ) {
                var Gn = G[D];
                if (!(Gn ? lo(Gn, kn) : y(a[D], kn, h)))
                  continue n;
              }
              yn && yn.push(kn), rn.push(Mn);
            }
          }
        return rn;
      }
      function A6(a, u, h, y) {
        return er(a, function(M, N, D) {
          u(y, h(M), N, D);
        }), y;
      }
      function _o(a, u, h) {
        u = Yr(u, a), a = Eg(a, u);
        var y = a == null ? a : a[rr(Pt(u))];
        return y == null ? t : dt(y, a, h);
      }
      function Vp(a) {
        return pe(a) && We(a) == ln;
      }
      function M6(a) {
        return pe(a) && We(a) == ie;
      }
      function S6(a) {
        return pe(a) && We(a) == tn;
      }
      function bo(a, u, h, y, M) {
        return a === u ? !0 : a == null || u == null || !pe(a) && !pe(u) ? a !== a && u !== u : E6(a, u, h, y, bo, M);
      }
      function E6(a, u, h, y, M, N) {
        var D = Bn(a), G = Bn(u), Y = D ? Tn : De(a), rn = G ? Tn : De(u);
        Y = Y == ln ? pn : Y, rn = rn == ln ? pn : rn;
        var on = Y == pn, un = rn == pn, yn = Y == rn;
        if (yn && Kr(a)) {
          if (!Kr(u))
            return !1;
          D = !0, on = !1;
        }
        if (yn && !on)
          return N || (N = new Vt()), D || pa(a) ? bg(a, u, h, y, M, N) : n8(a, u, Y, h, y, M, N);
        if (!(h & b)) {
          var Mn = on && ne.call(a, "__wrapped__"), kn = un && ne.call(u, "__wrapped__");
          if (Mn || kn) {
            var Gn = Mn ? a.value() : a, On = kn ? u.value() : u;
            return N || (N = new Vt()), M(Gn, On, h, y, N);
          }
        }
        return yn ? (N || (N = new Vt()), e8(a, u, h, y, M, N)) : !1;
      }
      function C6(a) {
        return pe(a) && De(a) == En;
      }
      function Sc(a, u, h, y) {
        var M = h.length, N = M, D = !y;
        if (a == null)
          return !N;
        for (a = ee(a); M--; ) {
          var G = h[M];
          if (D && G[2] ? G[1] !== a[G[0]] : !(G[0] in a))
            return !1;
        }
        for (; ++M < N; ) {
          G = h[M];
          var Y = G[0], rn = a[Y], on = G[1];
          if (D && G[2]) {
            if (rn === t && !(Y in a))
              return !1;
          } else {
            var un = new Vt();
            if (y)
              var yn = y(rn, on, Y, a, u, un);
            if (!(yn === t ? bo(on, rn, b | w, y, un) : yn))
              return !1;
          }
        }
        return !0;
      }
      function Up(a) {
        if (!le(a) || l8(a))
          return !1;
        var u = xr(a) ? C5 : yx;
        return u.test(xi(a));
      }
      function P6(a) {
        return pe(a) && We(a) == X;
      }
      function R6(a) {
        return pe(a) && De(a) == j;
      }
      function N6(a) {
        return pe(a) && wf(a.length) && !!oe[We(a)];
      }
      function Gp(a) {
        return typeof a == "function" ? a : a == null ? st : typeof a == "object" ? Bn(a) ? Hp(a[0], a[1]) : Wp(a) : cv(a);
      }
      function Ec(a) {
        if (!To(a))
          return O5(a);
        var u = [];
        for (var h in ee(a))
          ne.call(a, h) && h != "constructor" && u.push(h);
        return u;
      }
      function $6(a) {
        if (!le(a))
          return p8(a);
        var u = To(a), h = [];
        for (var y in a)
          y == "constructor" && (u || !ne.call(a, y)) || h.push(y);
        return h;
      }
      function Cc(a, u) {
        return a < u;
      }
      function qp(a, u) {
        var h = -1, y = ut(a) ? Z(a.length) : [];
        return Wr(a, function(M, N, D) {
          y[++h] = u(M, N, D);
        }), y;
      }
      function Wp(a) {
        var u = Gc(a);
        return u.length == 1 && u[0][2] ? Mg(u[0][0], u[0][1]) : function(h) {
          return h === a || Sc(h, a, u);
        };
      }
      function Hp(a, u) {
        return Wc(a) && Ag(u) ? Mg(rr(a), u) : function(h) {
          var y = eh(h, a);
          return y === t && y === u ? th(h, a) : bo(u, y, b | w);
        };
      }
      function af(a, u, h, y, M) {
        a !== u && xc(u, function(N, D) {
          if (M || (M = new Vt()), le(N))
            k6(a, u, D, h, af, y, M);
          else {
            var G = y ? y(Yc(a, D), N, D + "", a, u, M) : t;
            G === t && (G = N), bc(a, D, G);
          }
        }, ft);
      }
      function k6(a, u, h, y, M, N, D) {
        var G = Yc(a, h), Y = Yc(u, h), rn = D.get(Y);
        if (rn) {
          bc(a, h, rn);
          return;
        }
        var on = N ? N(G, Y, h + "", a, u, D) : t, un = on === t;
        if (un) {
          var yn = Bn(Y), Mn = !yn && Kr(Y), kn = !yn && !Mn && pa(Y);
          on = Y, yn || Mn || kn ? Bn(G) ? on = G : me(G) ? on = ot(G) : Mn ? (un = !1, on = ig(Y, !0)) : kn ? (un = !1, on = ag(Y, !0)) : on = [] : Mo(Y) || Ti(Y) ? (on = G, Ti(G) ? on = ev(G) : (!le(G) || xr(G)) && (on = Tg(Y))) : un = !1;
        }
        un && (D.set(Y, on), M(on, Y, y, N, D), D.delete(Y)), bc(a, h, on);
      }
      function Yp(a, u) {
        var h = a.length;
        if (h)
          return u += u < 0 ? h : 0, wr(u, h) ? a[u] : t;
      }
      function Xp(a, u, h) {
        u.length ? u = fe(u, function(N) {
          return Bn(N) ? function(D) {
            return bi(D, N.length === 1 ? N[0] : N);
          } : N;
        }) : u = [st];
        var y = -1;
        u = fe(u, pt($n()));
        var M = qp(a, function(N, D, G) {
          var Y = fe(u, function(rn) {
            return rn(N);
          });
          return { criteria: Y, index: ++y, value: N };
        });
        return o5(M, function(N, D) {
          return H6(N, D, h);
        });
      }
      function O6(a, u) {
        return Kp(a, u, function(h, y) {
          return th(a, y);
        });
      }
      function Kp(a, u, h) {
        for (var y = -1, M = u.length, N = {}; ++y < M; ) {
          var D = u[y], G = bi(a, D);
          h(G, D) && wo(N, Yr(D, a), G);
        }
        return N;
      }
      function I6(a) {
        return function(u) {
          return bi(u, a);
        };
      }
      function Pc(a, u, h, y) {
        var M = y ? a5 : ra, N = -1, D = u.length, G = a;
        for (a === u && (u = ot(u)), h && (G = fe(a, pt(h))); ++N < D; )
          for (var Y = 0, rn = u[N], on = h ? h(rn) : rn; (Y = M(G, on, Y, y)) > -1; )
            G !== a && Xu.call(G, Y, 1), Xu.call(a, Y, 1);
        return a;
      }
      function Zp(a, u) {
        for (var h = a ? u.length : 0, y = h - 1; h--; ) {
          var M = u[h];
          if (h == y || M !== N) {
            var N = M;
            wr(M) ? Xu.call(a, M, 1) : kc(a, M);
          }
        }
        return a;
      }
      function Rc(a, u) {
        return a + Ju(Rp() * (u - a + 1));
      }
      function L6(a, u, h, y) {
        for (var M = -1, N = xe(Zu((u - a) / (h || 1)), 0), D = Z(N); N--; )
          D[y ? N : ++M] = a, a += h;
        return D;
      }
      function Nc(a, u) {
        var h = "";
        if (!a || u < 1 || u > K)
          return h;
        do
          u % 2 && (h += a), u = Ju(u / 2), u && (a += a);
        while (u);
        return h;
      }
      function qn(a, u) {
        return Xc(Sg(a, u, st), a + "");
      }
      function D6(a) {
        return kp(ga(a));
      }
      function F6(a, u) {
        var h = ga(a);
        return gf(h, _i(u, 0, h.length));
      }
      function wo(a, u, h, y) {
        if (!le(a))
          return a;
        u = Yr(u, a);
        for (var M = -1, N = u.length, D = N - 1, G = a; G != null && ++M < N; ) {
          var Y = rr(u[M]), rn = h;
          if (Y === "__proto__" || Y === "constructor" || Y === "prototype")
            return a;
          if (M != D) {
            var on = G[Y];
            rn = y ? y(on, Y, G) : t, rn === t && (rn = le(on) ? on : wr(u[M + 1]) ? [] : {});
          }
          mo(G, Y, rn), G = G[Y];
        }
        return a;
      }
      var Jp = Qu ? function(a, u) {
        return Qu.set(a, u), a;
      } : st, B6 = Ku ? function(a, u) {
        return Ku(a, "toString", {
          configurable: !0,
          enumerable: !1,
          value: ih(u),
          writable: !0
        });
      } : st;
      function z6(a) {
        return gf(ga(a));
      }
      function Ct(a, u, h) {
        var y = -1, M = a.length;
        u < 0 && (u = -u > M ? 0 : M + u), h = h > M ? M : h, h < 0 && (h += M), M = u > h ? 0 : h - u >>> 0, u >>>= 0;
        for (var N = Z(M); ++y < M; )
          N[y] = a[y + u];
        return N;
      }
      function V6(a, u) {
        var h;
        return Wr(a, function(y, M, N) {
          return h = u(y, M, N), !h;
        }), !!h;
      }
      function of(a, u, h) {
        var y = 0, M = a == null ? y : a.length;
        if (typeof u == "number" && u === u && M <= en) {
          for (; y < M; ) {
            var N = y + M >>> 1, D = a[N];
            D !== null && !vt(D) && (h ? D <= u : D < u) ? y = N + 1 : M = N;
          }
          return M;
        }
        return $c(a, u, st, h);
      }
      function $c(a, u, h, y) {
        var M = 0, N = a == null ? 0 : a.length;
        if (N === 0)
          return 0;
        u = h(u);
        for (var D = u !== u, G = u === null, Y = vt(u), rn = u === t; M < N; ) {
          var on = Ju((M + N) / 2), un = h(a[on]), yn = un !== t, Mn = un === null, kn = un === un, Gn = vt(un);
          if (D)
            var On = y || kn;
          else
            rn ? On = kn && (y || yn) : G ? On = kn && yn && (y || !Mn) : Y ? On = kn && yn && !Mn && (y || !Gn) : Mn || Gn ? On = !1 : On = y ? un <= u : un < u;
          On ? M = on + 1 : N = on;
        }
        return Le(N, J);
      }
      function Qp(a, u) {
        for (var h = -1, y = a.length, M = 0, N = []; ++h < y; ) {
          var D = a[h], G = u ? u(D) : D;
          if (!h || !Ut(G, Y)) {
            var Y = G;
            N[M++] = D === 0 ? 0 : D;
          }
        }
        return N;
      }
      function jp(a) {
        return typeof a == "number" ? a : vt(a) ? z : +a;
      }
      function gt(a) {
        if (typeof a == "string")
          return a;
        if (Bn(a))
          return fe(a, gt) + "";
        if (vt(a))
          return Np ? Np.call(a) : "";
        var u = a + "";
        return u == "0" && 1 / a == -W ? "-0" : u;
      }
      function Hr(a, u, h) {
        var y = -1, M = Fu, N = a.length, D = !0, G = [], Y = G;
        if (h)
          D = !1, M = uc;
        else if (N >= i) {
          var rn = u ? null : Q6(a);
          if (rn)
            return zu(rn);
          D = !1, M = lo, Y = new yi();
        } else
          Y = u ? [] : G;
        n:
          for (; ++y < N; ) {
            var on = a[y], un = u ? u(on) : on;
            if (on = h || on !== 0 ? on : 0, D && un === un) {
              for (var yn = Y.length; yn--; )
                if (Y[yn] === un)
                  continue n;
              u && Y.push(un), G.push(on);
            } else
              M(Y, un, h) || (Y !== G && Y.push(un), G.push(on));
          }
        return G;
      }
      function kc(a, u) {
        return u = Yr(u, a), a = Eg(a, u), a == null || delete a[rr(Pt(u))];
      }
      function ng(a, u, h, y) {
        return wo(a, u, h(bi(a, u)), y);
      }
      function uf(a, u, h, y) {
        for (var M = a.length, N = y ? M : -1; (y ? N-- : ++N < M) && u(a[N], N, a); )
          ;
        return h ? Ct(a, y ? 0 : N, y ? N + 1 : M) : Ct(a, y ? N + 1 : 0, y ? M : N);
      }
      function eg(a, u) {
        var h = a;
        return h instanceof Yn && (h = h.value()), fc(u, function(y, M) {
          return M.func.apply(M.thisArg, Ur([y], M.args));
        }, h);
      }
      function Oc(a, u, h) {
        var y = a.length;
        if (y < 2)
          return y ? Hr(a[0]) : [];
        for (var M = -1, N = Z(y); ++M < y; )
          for (var D = a[M], G = -1; ++G < y; )
            G != M && (N[M] = yo(N[M] || D, a[G], u, h));
        return Hr(ke(N, 1), u, h);
      }
      function tg(a, u, h) {
        for (var y = -1, M = a.length, N = u.length, D = {}; ++y < M; ) {
          var G = y < N ? u[y] : t;
          h(D, a[y], G);
        }
        return D;
      }
      function Ic(a) {
        return me(a) ? a : [];
      }
      function Lc(a) {
        return typeof a == "function" ? a : st;
      }
      function Yr(a, u) {
        return Bn(a) ? a : Wc(a, u) ? [a] : Ng(jn(a));
      }
      var U6 = qn;
      function Xr(a, u, h) {
        var y = a.length;
        return h = h === t ? y : h, !u && h >= y ? a : Ct(a, u, h);
      }
      var rg = P5 || function(a) {
        return $e.clearTimeout(a);
      };
      function ig(a, u) {
        if (u)
          return a.slice();
        var h = a.length, y = Mp ? Mp(h) : new a.constructor(h);
        return a.copy(y), y;
      }
      function Dc(a) {
        var u = new a.constructor(a.byteLength);
        return new Hu(u).set(new Hu(a)), u;
      }
      function G6(a, u) {
        var h = u ? Dc(a.buffer) : a.buffer;
        return new a.constructor(h, a.byteOffset, a.byteLength);
      }
      function q6(a) {
        var u = new a.constructor(a.source, V1.exec(a));
        return u.lastIndex = a.lastIndex, u;
      }
      function W6(a) {
        return vo ? ee(vo.call(a)) : {};
      }
      function ag(a, u) {
        var h = u ? Dc(a.buffer) : a.buffer;
        return new a.constructor(h, a.byteOffset, a.length);
      }
      function og(a, u) {
        if (a !== u) {
          var h = a !== t, y = a === null, M = a === a, N = vt(a), D = u !== t, G = u === null, Y = u === u, rn = vt(u);
          if (!G && !rn && !N && a > u || N && D && Y && !G && !rn || y && D && Y || !h && Y || !M)
            return 1;
          if (!y && !N && !rn && a < u || rn && h && M && !y && !N || G && h && M || !D && M || !Y)
            return -1;
        }
        return 0;
      }
      function H6(a, u, h) {
        for (var y = -1, M = a.criteria, N = u.criteria, D = M.length, G = h.length; ++y < D; ) {
          var Y = og(M[y], N[y]);
          if (Y) {
            if (y >= G)
              return Y;
            var rn = h[y];
            return Y * (rn == "desc" ? -1 : 1);
          }
        }
        return a.index - u.index;
      }
      function ug(a, u, h, y) {
        for (var M = -1, N = a.length, D = h.length, G = -1, Y = u.length, rn = xe(N - D, 0), on = Z(Y + rn), un = !y; ++G < Y; )
          on[G] = u[G];
        for (; ++M < D; )
          (un || M < N) && (on[h[M]] = a[M]);
        for (; rn--; )
          on[G++] = a[M++];
        return on;
      }
      function fg(a, u, h, y) {
        for (var M = -1, N = a.length, D = -1, G = h.length, Y = -1, rn = u.length, on = xe(N - G, 0), un = Z(on + rn), yn = !y; ++M < on; )
          un[M] = a[M];
        for (var Mn = M; ++Y < rn; )
          un[Mn + Y] = u[Y];
        for (; ++D < G; )
          (yn || M < N) && (un[Mn + h[D]] = a[M++]);
        return un;
      }
      function ot(a, u) {
        var h = -1, y = a.length;
        for (u || (u = Z(y)); ++h < y; )
          u[h] = a[h];
        return u;
      }
      function tr(a, u, h, y) {
        var M = !h;
        h || (h = {});
        for (var N = -1, D = u.length; ++N < D; ) {
          var G = u[N], Y = y ? y(h[G], a[G], G, h, a) : t;
          Y === t && (Y = a[G]), M ? yr(h, G, Y) : mo(h, G, Y);
        }
        return h;
      }
      function Y6(a, u) {
        return tr(a, qc(a), u);
      }
      function X6(a, u) {
        return tr(a, wg(a), u);
      }
      function ff(a, u) {
        return function(h, y) {
          var M = Bn(h) ? jx : v6, N = u ? u() : {};
          return M(h, a, $n(y, 2), N);
        };
      }
      function ca(a) {
        return qn(function(u, h) {
          var y = -1, M = h.length, N = M > 1 ? h[M - 1] : t, D = M > 2 ? h[2] : t;
          for (N = a.length > 3 && typeof N == "function" ? (M--, N) : t, D && He(h[0], h[1], D) && (N = M < 3 ? t : N, M = 1), u = ee(u); ++y < M; ) {
            var G = h[y];
            G && a(u, G, y, N);
          }
          return u;
        });
      }
      function sg(a, u) {
        return function(h, y) {
          if (h == null)
            return h;
          if (!ut(h))
            return a(h, y);
          for (var M = h.length, N = u ? M : -1, D = ee(h); (u ? N-- : ++N < M) && y(D[N], N, D) !== !1; )
            ;
          return h;
        };
      }
      function lg(a) {
        return function(u, h, y) {
          for (var M = -1, N = ee(u), D = y(u), G = D.length; G--; ) {
            var Y = D[a ? G : ++M];
            if (h(N[Y], Y, N) === !1)
              break;
          }
          return u;
        };
      }
      function K6(a, u, h) {
        var y = u & m, M = xo(a);
        function N() {
          var D = this && this !== $e && this instanceof N ? M : a;
          return D.apply(y ? h : this, arguments);
        }
        return N;
      }
      function cg(a) {
        return function(u) {
          u = jn(u);
          var h = ia(u) ? zt(u) : t, y = h ? h[0] : u.charAt(0), M = h ? Xr(h, 1).join("") : u.slice(1);
          return y[a]() + M;
        };
      }
      function ha(a) {
        return function(u) {
          return fc(sv(fv(u).replace(Bx, "")), a, "");
        };
      }
      function xo(a) {
        return function() {
          var u = arguments;
          switch (u.length) {
            case 0:
              return new a();
            case 1:
              return new a(u[0]);
            case 2:
              return new a(u[0], u[1]);
            case 3:
              return new a(u[0], u[1], u[2]);
            case 4:
              return new a(u[0], u[1], u[2], u[3]);
            case 5:
              return new a(u[0], u[1], u[2], u[3], u[4]);
            case 6:
              return new a(u[0], u[1], u[2], u[3], u[4], u[5]);
            case 7:
              return new a(u[0], u[1], u[2], u[3], u[4], u[5], u[6]);
          }
          var h = la(a.prototype), y = a.apply(h, u);
          return le(y) ? y : h;
        };
      }
      function Z6(a, u, h) {
        var y = xo(a);
        function M() {
          for (var N = arguments.length, D = Z(N), G = N, Y = da(M); G--; )
            D[G] = arguments[G];
          var rn = N < 3 && D[0] !== Y && D[N - 1] !== Y ? [] : Gr(D, Y);
          if (N -= rn.length, N < h)
            return vg(
              a,
              u,
              sf,
              M.placeholder,
              t,
              D,
              rn,
              t,
              t,
              h - N
            );
          var on = this && this !== $e && this instanceof M ? y : a;
          return dt(on, this, D);
        }
        return M;
      }
      function hg(a) {
        return function(u, h, y) {
          var M = ee(u);
          if (!ut(u)) {
            var N = $n(h, 3);
            u = Se(u), h = function(G) {
              return N(M[G], G, M);
            };
          }
          var D = a(u, h, y);
          return D > -1 ? M[N ? u[D] : D] : t;
        };
      }
      function dg(a) {
        return br(function(u) {
          var h = u.length, y = h, M = St.prototype.thru;
          for (a && u.reverse(); y--; ) {
            var N = u[y];
            if (typeof N != "function")
              throw new Mt(f);
            if (M && !D && df(N) == "wrapper")
              var D = new St([], !0);
          }
          for (y = D ? y : h; ++y < h; ) {
            N = u[y];
            var G = df(N), Y = G == "wrapper" ? Uc(N) : t;
            Y && Hc(Y[0]) && Y[1] == (I | A | S | B) && !Y[4].length && Y[9] == 1 ? D = D[df(Y[0])].apply(D, Y[3]) : D = N.length == 1 && Hc(N) ? D[G]() : D.thru(N);
          }
          return function() {
            var rn = arguments, on = rn[0];
            if (D && rn.length == 1 && Bn(on))
              return D.plant(on).value();
            for (var un = 0, yn = h ? u[un].apply(this, rn) : on; ++un < h; )
              yn = u[un].call(this, yn);
            return yn;
          };
        });
      }
      function sf(a, u, h, y, M, N, D, G, Y, rn) {
        var on = u & I, un = u & m, yn = u & _, Mn = u & (A | T), kn = u & F, Gn = yn ? t : xo(a);
        function On() {
          for (var Hn = arguments.length, Kn = Z(Hn), mt = Hn; mt--; )
            Kn[mt] = arguments[mt];
          if (Mn)
            var Ye = da(On), yt = f5(Kn, Ye);
          if (y && (Kn = ug(Kn, y, M, Mn)), N && (Kn = fg(Kn, N, D, Mn)), Hn -= yt, Mn && Hn < rn) {
            var ye = Gr(Kn, Ye);
            return vg(
              a,
              u,
              sf,
              On.placeholder,
              h,
              Kn,
              ye,
              G,
              Y,
              rn - Hn
            );
          }
          var Gt = un ? h : this, Ar = yn ? Gt[a] : a;
          return Hn = Kn.length, G ? Kn = v8(Kn, G) : kn && Hn > 1 && Kn.reverse(), on && Y < Hn && (Kn.length = Y), this && this !== $e && this instanceof On && (Ar = Gn || xo(Ar)), Ar.apply(Gt, Kn);
        }
        return On;
      }
      function pg(a, u) {
        return function(h, y) {
          return A6(h, a, u(y), {});
        };
      }
      function lf(a, u) {
        return function(h, y) {
          var M;
          if (h === t && y === t)
            return u;
          if (h !== t && (M = h), y !== t) {
            if (M === t)
              return y;
            typeof h == "string" || typeof y == "string" ? (h = gt(h), y = gt(y)) : (h = jp(h), y = jp(y)), M = a(h, y);
          }
          return M;
        };
      }
      function Fc(a) {
        return br(function(u) {
          return u = fe(u, pt($n())), qn(function(h) {
            var y = this;
            return a(u, function(M) {
              return dt(M, y, h);
            });
          });
        });
      }
      function cf(a, u) {
        u = u === t ? " " : gt(u);
        var h = u.length;
        if (h < 2)
          return h ? Nc(u, a) : u;
        var y = Nc(u, Zu(a / aa(u)));
        return ia(u) ? Xr(zt(y), 0, a).join("") : y.slice(0, a);
      }
      function J6(a, u, h, y) {
        var M = u & m, N = xo(a);
        function D() {
          for (var G = -1, Y = arguments.length, rn = -1, on = y.length, un = Z(on + Y), yn = this && this !== $e && this instanceof D ? N : a; ++rn < on; )
            un[rn] = y[rn];
          for (; Y--; )
            un[rn++] = arguments[++G];
          return dt(yn, M ? h : this, un);
        }
        return D;
      }
      function gg(a) {
        return function(u, h, y) {
          return y && typeof y != "number" && He(u, h, y) && (h = y = t), u = Tr(u), h === t ? (h = u, u = 0) : h = Tr(h), y = y === t ? u < h ? 1 : -1 : Tr(y), L6(u, h, y, a);
        };
      }
      function hf(a) {
        return function(u, h) {
          return typeof u == "string" && typeof h == "string" || (u = Rt(u), h = Rt(h)), a(u, h);
        };
      }
      function vg(a, u, h, y, M, N, D, G, Y, rn) {
        var on = u & A, un = on ? D : t, yn = on ? t : D, Mn = on ? N : t, kn = on ? t : N;
        u |= on ? S : R, u &= ~(on ? R : S), u & x || (u &= ~(m | _));
        var Gn = [
          a,
          u,
          M,
          Mn,
          un,
          kn,
          yn,
          G,
          Y,
          rn
        ], On = h.apply(t, Gn);
        return Hc(a) && Cg(On, Gn), On.placeholder = y, Pg(On, a, u);
      }
      function Bc(a) {
        var u = we[a];
        return function(h, y) {
          if (h = Rt(h), y = y == null ? 0 : Le(Un(y), 292), y && Pp(h)) {
            var M = (jn(h) + "e").split("e"), N = u(M[0] + "e" + (+M[1] + y));
            return M = (jn(N) + "e").split("e"), +(M[0] + "e" + (+M[1] - y));
          }
          return u(h);
        };
      }
      var Q6 = fa && 1 / zu(new fa([, -0]))[1] == W ? function(a) {
        return new fa(a);
      } : uh;
      function mg(a) {
        return function(u) {
          var h = De(u);
          return h == En ? gc(u) : h == j ? g5(u) : u5(u, a(u));
        };
      }
      function _r(a, u, h, y, M, N, D, G) {
        var Y = u & _;
        if (!Y && typeof a != "function")
          throw new Mt(f);
        var rn = y ? y.length : 0;
        if (rn || (u &= ~(S | R), y = M = t), D = D === t ? D : xe(Un(D), 0), G = G === t ? G : Un(G), rn -= M ? M.length : 0, u & R) {
          var on = y, un = M;
          y = M = t;
        }
        var yn = Y ? t : Uc(a), Mn = [
          a,
          u,
          h,
          y,
          M,
          on,
          un,
          N,
          D,
          G
        ];
        if (yn && d8(Mn, yn), a = Mn[0], u = Mn[1], h = Mn[2], y = Mn[3], M = Mn[4], G = Mn[9] = Mn[9] === t ? Y ? 0 : a.length : xe(Mn[9] - rn, 0), !G && u & (A | T) && (u &= ~(A | T)), !u || u == m)
          var kn = K6(a, u, h);
        else
          u == A || u == T ? kn = Z6(a, u, G) : (u == S || u == (m | S)) && !M.length ? kn = J6(a, u, h, y) : kn = sf.apply(t, Mn);
        var Gn = yn ? Jp : Cg;
        return Pg(Gn(kn, Mn), a, u);
      }
      function yg(a, u, h, y) {
        return a === t || Ut(a, ua[h]) && !ne.call(y, h) ? u : a;
      }
      function _g(a, u, h, y, M, N) {
        return le(a) && le(u) && (N.set(u, a), af(a, u, t, _g, N), N.delete(u)), a;
      }
      function j6(a) {
        return Mo(a) ? t : a;
      }
      function bg(a, u, h, y, M, N) {
        var D = h & b, G = a.length, Y = u.length;
        if (G != Y && !(D && Y > G))
          return !1;
        var rn = N.get(a), on = N.get(u);
        if (rn && on)
          return rn == u && on == a;
        var un = -1, yn = !0, Mn = h & w ? new yi() : t;
        for (N.set(a, u), N.set(u, a); ++un < G; ) {
          var kn = a[un], Gn = u[un];
          if (y)
            var On = D ? y(Gn, kn, un, u, a, N) : y(kn, Gn, un, a, u, N);
          if (On !== t) {
            if (On)
              continue;
            yn = !1;
            break;
          }
          if (Mn) {
            if (!sc(u, function(Hn, Kn) {
              if (!lo(Mn, Kn) && (kn === Hn || M(kn, Hn, h, y, N)))
                return Mn.push(Kn);
            })) {
              yn = !1;
              break;
            }
          } else if (!(kn === Gn || M(kn, Gn, h, y, N))) {
            yn = !1;
            break;
          }
        }
        return N.delete(a), N.delete(u), yn;
      }
      function n8(a, u, h, y, M, N, D) {
        switch (h) {
          case Bt:
            if (a.byteLength != u.byteLength || a.byteOffset != u.byteOffset)
              return !1;
            a = a.buffer, u = u.buffer;
          case ie:
            return !(a.byteLength != u.byteLength || !N(new Hu(a), new Hu(u)));
          case _n:
          case tn:
          case In:
            return Ut(+a, +u);
          case vn:
            return a.name == u.name && a.message == u.message;
          case X:
          case mn:
            return a == u + "";
          case En:
            var G = gc;
          case j:
            var Y = y & b;
            if (G || (G = zu), a.size != u.size && !Y)
              return !1;
            var rn = D.get(a);
            if (rn)
              return rn == u;
            y |= w, D.set(a, u);
            var on = bg(G(a), G(u), y, M, N, D);
            return D.delete(a), on;
          case dn:
            if (vo)
              return vo.call(a) == vo.call(u);
        }
        return !1;
      }
      function e8(a, u, h, y, M, N) {
        var D = h & b, G = zc(a), Y = G.length, rn = zc(u), on = rn.length;
        if (Y != on && !D)
          return !1;
        for (var un = Y; un--; ) {
          var yn = G[un];
          if (!(D ? yn in u : ne.call(u, yn)))
            return !1;
        }
        var Mn = N.get(a), kn = N.get(u);
        if (Mn && kn)
          return Mn == u && kn == a;
        var Gn = !0;
        N.set(a, u), N.set(u, a);
        for (var On = D; ++un < Y; ) {
          yn = G[un];
          var Hn = a[yn], Kn = u[yn];
          if (y)
            var mt = D ? y(Kn, Hn, yn, u, a, N) : y(Hn, Kn, yn, a, u, N);
          if (!(mt === t ? Hn === Kn || M(Hn, Kn, h, y, N) : mt)) {
            Gn = !1;
            break;
          }
          On || (On = yn == "constructor");
        }
        if (Gn && !On) {
          var Ye = a.constructor, yt = u.constructor;
          Ye != yt && "constructor" in a && "constructor" in u && !(typeof Ye == "function" && Ye instanceof Ye && typeof yt == "function" && yt instanceof yt) && (Gn = !1);
        }
        return N.delete(a), N.delete(u), Gn;
      }
      function br(a) {
        return Xc(Sg(a, t, Ig), a + "");
      }
      function zc(a) {
        return zp(a, Se, qc);
      }
      function Vc(a) {
        return zp(a, ft, wg);
      }
      var Uc = Qu ? function(a) {
        return Qu.get(a);
      } : uh;
      function df(a) {
        for (var u = a.name + "", h = sa[u], y = ne.call(sa, u) ? h.length : 0; y--; ) {
          var M = h[y], N = M.func;
          if (N == null || N == a)
            return M.name;
        }
        return u;
      }
      function da(a) {
        var u = ne.call(C, "placeholder") ? C : a;
        return u.placeholder;
      }
      function $n() {
        var a = C.iteratee || ah;
        return a = a === ah ? Gp : a, arguments.length ? a(arguments[0], arguments[1]) : a;
      }
      function pf(a, u) {
        var h = a.__data__;
        return s8(u) ? h[typeof u == "string" ? "string" : "hash"] : h.map;
      }
      function Gc(a) {
        for (var u = Se(a), h = u.length; h--; ) {
          var y = u[h], M = a[y];
          u[h] = [y, M, Ag(M)];
        }
        return u;
      }
      function wi(a, u) {
        var h = h5(a, u);
        return Up(h) ? h : t;
      }
      function t8(a) {
        var u = ne.call(a, vi), h = a[vi];
        try {
          a[vi] = t;
          var y = !0;
        } catch {
        }
        var M = qu.call(a);
        return y && (u ? a[vi] = h : delete a[vi]), M;
      }
      var qc = mc ? function(a) {
        return a == null ? [] : (a = ee(a), Vr(mc(a), function(u) {
          return Ep.call(a, u);
        }));
      } : fh, wg = mc ? function(a) {
        for (var u = []; a; )
          Ur(u, qc(a)), a = Yu(a);
        return u;
      } : fh, De = We;
      (yc && De(new yc(new ArrayBuffer(1))) != Bt || ho && De(new ho()) != En || _c && De(_c.resolve()) != Pn || fa && De(new fa()) != j || po && De(new po()) != An) && (De = function(a) {
        var u = We(a), h = u == pn ? a.constructor : t, y = h ? xi(h) : "";
        if (y)
          switch (y) {
            case F5:
              return Bt;
            case B5:
              return En;
            case z5:
              return Pn;
            case V5:
              return j;
            case U5:
              return An;
          }
        return u;
      });
      function r8(a, u, h) {
        for (var y = -1, M = h.length; ++y < M; ) {
          var N = h[y], D = N.size;
          switch (N.type) {
            case "drop":
              a += D;
              break;
            case "dropRight":
              u -= D;
              break;
            case "take":
              u = Le(u, a + D);
              break;
            case "takeRight":
              a = xe(a, u - D);
              break;
          }
        }
        return { start: a, end: u };
      }
      function i8(a) {
        var u = a.match(lx);
        return u ? u[1].split(cx) : [];
      }
      function xg(a, u, h) {
        u = Yr(u, a);
        for (var y = -1, M = u.length, N = !1; ++y < M; ) {
          var D = rr(u[y]);
          if (!(N = a != null && h(a, D)))
            break;
          a = a[D];
        }
        return N || ++y != M ? N : (M = a == null ? 0 : a.length, !!M && wf(M) && wr(D, M) && (Bn(a) || Ti(a)));
      }
      function a8(a) {
        var u = a.length, h = new a.constructor(u);
        return u && typeof a[0] == "string" && ne.call(a, "index") && (h.index = a.index, h.input = a.input), h;
      }
      function Tg(a) {
        return typeof a.constructor == "function" && !To(a) ? la(Yu(a)) : {};
      }
      function o8(a, u, h) {
        var y = a.constructor;
        switch (u) {
          case ie:
            return Dc(a);
          case _n:
          case tn:
            return new y(+a);
          case Bt:
            return G6(a, h);
          case nr:
          case uo:
          case di:
          case pi:
          case fo:
          case na:
          case so:
          case ea:
          case Jl:
            return ag(a, h);
          case En:
            return new y();
          case In:
          case mn:
            return new y(a);
          case X:
            return q6(a);
          case j:
            return new y();
          case dn:
            return W6(a);
        }
      }
      function u8(a, u) {
        var h = u.length;
        if (!h)
          return a;
        var y = h - 1;
        return u[y] = (h > 1 ? "& " : "") + u[y], u = u.join(h > 2 ? ", " : " "), a.replace(sx, `{
/* [wrapped with ` + u + `] */
`);
      }
      function f8(a) {
        return Bn(a) || Ti(a) || !!(Cp && a && a[Cp]);
      }
      function wr(a, u) {
        var h = typeof a;
        return u = u ?? K, !!u && (h == "number" || h != "symbol" && bx.test(a)) && a > -1 && a % 1 == 0 && a < u;
      }
      function He(a, u, h) {
        if (!le(h))
          return !1;
        var y = typeof u;
        return (y == "number" ? ut(h) && wr(u, h.length) : y == "string" && u in h) ? Ut(h[u], a) : !1;
      }
      function Wc(a, u) {
        if (Bn(a))
          return !1;
        var h = typeof a;
        return h == "number" || h == "symbol" || h == "boolean" || a == null || vt(a) ? !0 : ax.test(a) || !ix.test(a) || u != null && a in ee(u);
      }
      function s8(a) {
        var u = typeof a;
        return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? a !== "__proto__" : a === null;
      }
      function Hc(a) {
        var u = df(a), h = C[u];
        if (typeof h != "function" || !(u in Yn.prototype))
          return !1;
        if (a === h)
          return !0;
        var y = Uc(h);
        return !!y && a === y[0];
      }
      function l8(a) {
        return !!Ap && Ap in a;
      }
      var c8 = Uu ? xr : sh;
      function To(a) {
        var u = a && a.constructor, h = typeof u == "function" && u.prototype || ua;
        return a === h;
      }
      function Ag(a) {
        return a === a && !le(a);
      }
      function Mg(a, u) {
        return function(h) {
          return h == null ? !1 : h[a] === u && (u !== t || a in ee(h));
        };
      }
      function h8(a) {
        var u = _f(a, function(y) {
          return h.size === c && h.clear(), y;
        }), h = u.cache;
        return u;
      }
      function d8(a, u) {
        var h = a[1], y = u[1], M = h | y, N = M < (m | _ | I), D = y == I && h == A || y == I && h == B && a[7].length <= u[8] || y == (I | B) && u[7].length <= u[8] && h == A;
        if (!(N || D))
          return a;
        y & m && (a[2] = u[2], M |= h & m ? 0 : x);
        var G = u[3];
        if (G) {
          var Y = a[3];
          a[3] = Y ? ug(Y, G, u[4]) : G, a[4] = Y ? Gr(a[3], p) : u[4];
        }
        return G = u[5], G && (Y = a[5], a[5] = Y ? fg(Y, G, u[6]) : G, a[6] = Y ? Gr(a[5], p) : u[6]), G = u[7], G && (a[7] = G), y & I && (a[8] = a[8] == null ? u[8] : Le(a[8], u[8])), a[9] == null && (a[9] = u[9]), a[0] = u[0], a[1] = M, a;
      }
      function p8(a) {
        var u = [];
        if (a != null)
          for (var h in ee(a))
            u.push(h);
        return u;
      }
      function g8(a) {
        return qu.call(a);
      }
      function Sg(a, u, h) {
        return u = xe(u === t ? a.length - 1 : u, 0), function() {
          for (var y = arguments, M = -1, N = xe(y.length - u, 0), D = Z(N); ++M < N; )
            D[M] = y[u + M];
          M = -1;
          for (var G = Z(u + 1); ++M < u; )
            G[M] = y[M];
          return G[u] = h(D), dt(a, this, G);
        };
      }
      function Eg(a, u) {
        return u.length < 2 ? a : bi(a, Ct(u, 0, -1));
      }
      function v8(a, u) {
        for (var h = a.length, y = Le(u.length, h), M = ot(a); y--; ) {
          var N = u[y];
          a[y] = wr(N, h) ? M[N] : t;
        }
        return a;
      }
      function Yc(a, u) {
        if (!(u === "constructor" && typeof a[u] == "function") && u != "__proto__")
          return a[u];
      }
      var Cg = Rg(Jp), Ao = N5 || function(a, u) {
        return $e.setTimeout(a, u);
      }, Xc = Rg(B6);
      function Pg(a, u, h) {
        var y = u + "";
        return Xc(a, u8(y, m8(i8(y), h)));
      }
      function Rg(a) {
        var u = 0, h = 0;
        return function() {
          var y = I5(), M = $ - (y - h);
          if (h = y, M > 0) {
            if (++u >= L)
              return arguments[0];
          } else
            u = 0;
          return a.apply(t, arguments);
        };
      }
      function gf(a, u) {
        var h = -1, y = a.length, M = y - 1;
        for (u = u === t ? y : u; ++h < u; ) {
          var N = Rc(h, M), D = a[N];
          a[N] = a[h], a[h] = D;
        }
        return a.length = u, a;
      }
      var Ng = h8(function(a) {
        var u = [];
        return a.charCodeAt(0) === 46 && u.push(""), a.replace(ox, function(h, y, M, N) {
          u.push(M ? N.replace(px, "$1") : y || h);
        }), u;
      });
      function rr(a) {
        if (typeof a == "string" || vt(a))
          return a;
        var u = a + "";
        return u == "0" && 1 / a == -W ? "-0" : u;
      }
      function xi(a) {
        if (a != null) {
          try {
            return Gu.call(a);
          } catch {
          }
          try {
            return a + "";
          } catch {
          }
        }
        return "";
      }
      function m8(a, u) {
        return At(fn, function(h) {
          var y = "_." + h[0];
          u & h[1] && !Fu(a, y) && a.push(y);
        }), a.sort();
      }
      function $g(a) {
        if (a instanceof Yn)
          return a.clone();
        var u = new St(a.__wrapped__, a.__chain__);
        return u.__actions__ = ot(a.__actions__), u.__index__ = a.__index__, u.__values__ = a.__values__, u;
      }
      function y8(a, u, h) {
        (h ? He(a, u, h) : u === t) ? u = 1 : u = xe(Un(u), 0);
        var y = a == null ? 0 : a.length;
        if (!y || u < 1)
          return [];
        for (var M = 0, N = 0, D = Z(Zu(y / u)); M < y; )
          D[N++] = Ct(a, M, M += u);
        return D;
      }
      function _8(a) {
        for (var u = -1, h = a == null ? 0 : a.length, y = 0, M = []; ++u < h; ) {
          var N = a[u];
          N && (M[y++] = N);
        }
        return M;
      }
      function b8() {
        var a = arguments.length;
        if (!a)
          return [];
        for (var u = Z(a - 1), h = arguments[0], y = a; y--; )
          u[y - 1] = arguments[y];
        return Ur(Bn(h) ? ot(h) : [h], ke(u, 1));
      }
      var w8 = qn(function(a, u) {
        return me(a) ? yo(a, ke(u, 1, me, !0)) : [];
      }), x8 = qn(function(a, u) {
        var h = Pt(u);
        return me(h) && (h = t), me(a) ? yo(a, ke(u, 1, me, !0), $n(h, 2)) : [];
      }), T8 = qn(function(a, u) {
        var h = Pt(u);
        return me(h) && (h = t), me(a) ? yo(a, ke(u, 1, me, !0), t, h) : [];
      });
      function A8(a, u, h) {
        var y = a == null ? 0 : a.length;
        return y ? (u = h || u === t ? 1 : Un(u), Ct(a, u < 0 ? 0 : u, y)) : [];
      }
      function M8(a, u, h) {
        var y = a == null ? 0 : a.length;
        return y ? (u = h || u === t ? 1 : Un(u), u = y - u, Ct(a, 0, u < 0 ? 0 : u)) : [];
      }
      function S8(a, u) {
        return a && a.length ? uf(a, $n(u, 3), !0, !0) : [];
      }
      function E8(a, u) {
        return a && a.length ? uf(a, $n(u, 3), !0) : [];
      }
      function C8(a, u, h, y) {
        var M = a == null ? 0 : a.length;
        return M ? (h && typeof h != "number" && He(a, u, h) && (h = 0, y = M), b6(a, u, h, y)) : [];
      }
      function kg(a, u, h) {
        var y = a == null ? 0 : a.length;
        if (!y)
          return -1;
        var M = h == null ? 0 : Un(h);
        return M < 0 && (M = xe(y + M, 0)), Bu(a, $n(u, 3), M);
      }
      function Og(a, u, h) {
        var y = a == null ? 0 : a.length;
        if (!y)
          return -1;
        var M = y - 1;
        return h !== t && (M = Un(h), M = h < 0 ? xe(y + M, 0) : Le(M, y - 1)), Bu(a, $n(u, 3), M, !0);
      }
      function Ig(a) {
        var u = a == null ? 0 : a.length;
        return u ? ke(a, 1) : [];
      }
      function P8(a) {
        var u = a == null ? 0 : a.length;
        return u ? ke(a, W) : [];
      }
      function R8(a, u) {
        var h = a == null ? 0 : a.length;
        return h ? (u = u === t ? 1 : Un(u), ke(a, u)) : [];
      }
      function N8(a) {
        for (var u = -1, h = a == null ? 0 : a.length, y = {}; ++u < h; ) {
          var M = a[u];
          y[M[0]] = M[1];
        }
        return y;
      }
      function Lg(a) {
        return a && a.length ? a[0] : t;
      }
      function $8(a, u, h) {
        var y = a == null ? 0 : a.length;
        if (!y)
          return -1;
        var M = h == null ? 0 : Un(h);
        return M < 0 && (M = xe(y + M, 0)), ra(a, u, M);
      }
      function k8(a) {
        var u = a == null ? 0 : a.length;
        return u ? Ct(a, 0, -1) : [];
      }
      var O8 = qn(function(a) {
        var u = fe(a, Ic);
        return u.length && u[0] === a[0] ? Mc(u) : [];
      }), I8 = qn(function(a) {
        var u = Pt(a), h = fe(a, Ic);
        return u === Pt(h) ? u = t : h.pop(), h.length && h[0] === a[0] ? Mc(h, $n(u, 2)) : [];
      }), L8 = qn(function(a) {
        var u = Pt(a), h = fe(a, Ic);
        return u = typeof u == "function" ? u : t, u && h.pop(), h.length && h[0] === a[0] ? Mc(h, t, u) : [];
      });
      function D8(a, u) {
        return a == null ? "" : k5.call(a, u);
      }
      function Pt(a) {
        var u = a == null ? 0 : a.length;
        return u ? a[u - 1] : t;
      }
      function F8(a, u, h) {
        var y = a == null ? 0 : a.length;
        if (!y)
          return -1;
        var M = y;
        return h !== t && (M = Un(h), M = M < 0 ? xe(y + M, 0) : Le(M, y - 1)), u === u ? m5(a, u, M) : Bu(a, vp, M, !0);
      }
      function B8(a, u) {
        return a && a.length ? Yp(a, Un(u)) : t;
      }
      var z8 = qn(Dg);
      function Dg(a, u) {
        return a && a.length && u && u.length ? Pc(a, u) : a;
      }
      function V8(a, u, h) {
        return a && a.length && u && u.length ? Pc(a, u, $n(h, 2)) : a;
      }
      function U8(a, u, h) {
        return a && a.length && u && u.length ? Pc(a, u, t, h) : a;
      }
      var G8 = br(function(a, u) {
        var h = a == null ? 0 : a.length, y = wc(a, u);
        return Zp(a, fe(u, function(M) {
          return wr(M, h) ? +M : M;
        }).sort(og)), y;
      });
      function q8(a, u) {
        var h = [];
        if (!(a && a.length))
          return h;
        var y = -1, M = [], N = a.length;
        for (u = $n(u, 3); ++y < N; ) {
          var D = a[y];
          u(D, y, a) && (h.push(D), M.push(y));
        }
        return Zp(a, M), h;
      }
      function Kc(a) {
        return a == null ? a : D5.call(a);
      }
      function W8(a, u, h) {
        var y = a == null ? 0 : a.length;
        return y ? (h && typeof h != "number" && He(a, u, h) ? (u = 0, h = y) : (u = u == null ? 0 : Un(u), h = h === t ? y : Un(h)), Ct(a, u, h)) : [];
      }
      function H8(a, u) {
        return of(a, u);
      }
      function Y8(a, u, h) {
        return $c(a, u, $n(h, 2));
      }
      function X8(a, u) {
        var h = a == null ? 0 : a.length;
        if (h) {
          var y = of(a, u);
          if (y < h && Ut(a[y], u))
            return y;
        }
        return -1;
      }
      function K8(a, u) {
        return of(a, u, !0);
      }
      function Z8(a, u, h) {
        return $c(a, u, $n(h, 2), !0);
      }
      function J8(a, u) {
        var h = a == null ? 0 : a.length;
        if (h) {
          var y = of(a, u, !0) - 1;
          if (Ut(a[y], u))
            return y;
        }
        return -1;
      }
      function Q8(a) {
        return a && a.length ? Qp(a) : [];
      }
      function j8(a, u) {
        return a && a.length ? Qp(a, $n(u, 2)) : [];
      }
      function n4(a) {
        var u = a == null ? 0 : a.length;
        return u ? Ct(a, 1, u) : [];
      }
      function e4(a, u, h) {
        return a && a.length ? (u = h || u === t ? 1 : Un(u), Ct(a, 0, u < 0 ? 0 : u)) : [];
      }
      function t4(a, u, h) {
        var y = a == null ? 0 : a.length;
        return y ? (u = h || u === t ? 1 : Un(u), u = y - u, Ct(a, u < 0 ? 0 : u, y)) : [];
      }
      function r4(a, u) {
        return a && a.length ? uf(a, $n(u, 3), !1, !0) : [];
      }
      function i4(a, u) {
        return a && a.length ? uf(a, $n(u, 3)) : [];
      }
      var a4 = qn(function(a) {
        return Hr(ke(a, 1, me, !0));
      }), o4 = qn(function(a) {
        var u = Pt(a);
        return me(u) && (u = t), Hr(ke(a, 1, me, !0), $n(u, 2));
      }), u4 = qn(function(a) {
        var u = Pt(a);
        return u = typeof u == "function" ? u : t, Hr(ke(a, 1, me, !0), t, u);
      });
      function f4(a) {
        return a && a.length ? Hr(a) : [];
      }
      function s4(a, u) {
        return a && a.length ? Hr(a, $n(u, 2)) : [];
      }
      function l4(a, u) {
        return u = typeof u == "function" ? u : t, a && a.length ? Hr(a, t, u) : [];
      }
      function Zc(a) {
        if (!(a && a.length))
          return [];
        var u = 0;
        return a = Vr(a, function(h) {
          if (me(h))
            return u = xe(h.length, u), !0;
        }), dc(u, function(h) {
          return fe(a, lc(h));
        });
      }
      function Fg(a, u) {
        if (!(a && a.length))
          return [];
        var h = Zc(a);
        return u == null ? h : fe(h, function(y) {
          return dt(u, t, y);
        });
      }
      var c4 = qn(function(a, u) {
        return me(a) ? yo(a, u) : [];
      }), h4 = qn(function(a) {
        return Oc(Vr(a, me));
      }), d4 = qn(function(a) {
        var u = Pt(a);
        return me(u) && (u = t), Oc(Vr(a, me), $n(u, 2));
      }), p4 = qn(function(a) {
        var u = Pt(a);
        return u = typeof u == "function" ? u : t, Oc(Vr(a, me), t, u);
      }), g4 = qn(Zc);
      function v4(a, u) {
        return tg(a || [], u || [], mo);
      }
      function m4(a, u) {
        return tg(a || [], u || [], wo);
      }
      var y4 = qn(function(a) {
        var u = a.length, h = u > 1 ? a[u - 1] : t;
        return h = typeof h == "function" ? (a.pop(), h) : t, Fg(a, h);
      });
      function Bg(a) {
        var u = C(a);
        return u.__chain__ = !0, u;
      }
      function _4(a, u) {
        return u(a), a;
      }
      function vf(a, u) {
        return u(a);
      }
      var b4 = br(function(a) {
        var u = a.length, h = u ? a[0] : 0, y = this.__wrapped__, M = function(N) {
          return wc(N, a);
        };
        return u > 1 || this.__actions__.length || !(y instanceof Yn) || !wr(h) ? this.thru(M) : (y = y.slice(h, +h + (u ? 1 : 0)), y.__actions__.push({
          func: vf,
          args: [M],
          thisArg: t
        }), new St(y, this.__chain__).thru(function(N) {
          return u && !N.length && N.push(t), N;
        }));
      });
      function w4() {
        return Bg(this);
      }
      function x4() {
        return new St(this.value(), this.__chain__);
      }
      function T4() {
        this.__values__ === t && (this.__values__ = jg(this.value()));
        var a = this.__index__ >= this.__values__.length, u = a ? t : this.__values__[this.__index__++];
        return { done: a, value: u };
      }
      function A4() {
        return this;
      }
      function M4(a) {
        for (var u, h = this; h instanceof nf; ) {
          var y = $g(h);
          y.__index__ = 0, y.__values__ = t, u ? M.__wrapped__ = y : u = y;
          var M = y;
          h = h.__wrapped__;
        }
        return M.__wrapped__ = a, u;
      }
      function S4() {
        var a = this.__wrapped__;
        if (a instanceof Yn) {
          var u = a;
          return this.__actions__.length && (u = new Yn(this)), u = u.reverse(), u.__actions__.push({
            func: vf,
            args: [Kc],
            thisArg: t
          }), new St(u, this.__chain__);
        }
        return this.thru(Kc);
      }
      function E4() {
        return eg(this.__wrapped__, this.__actions__);
      }
      var C4 = ff(function(a, u, h) {
        ne.call(a, h) ? ++a[h] : yr(a, h, 1);
      });
      function P4(a, u, h) {
        var y = Bn(a) ? pp : _6;
        return h && He(a, u, h) && (u = t), y(a, $n(u, 3));
      }
      function R4(a, u) {
        var h = Bn(a) ? Vr : Fp;
        return h(a, $n(u, 3));
      }
      var N4 = hg(kg), $4 = hg(Og);
      function k4(a, u) {
        return ke(mf(a, u), 1);
      }
      function O4(a, u) {
        return ke(mf(a, u), W);
      }
      function I4(a, u, h) {
        return h = h === t ? 1 : Un(h), ke(mf(a, u), h);
      }
      function zg(a, u) {
        var h = Bn(a) ? At : Wr;
        return h(a, $n(u, 3));
      }
      function Vg(a, u) {
        var h = Bn(a) ? n5 : Dp;
        return h(a, $n(u, 3));
      }
      var L4 = ff(function(a, u, h) {
        ne.call(a, h) ? a[h].push(u) : yr(a, h, [u]);
      });
      function D4(a, u, h, y) {
        a = ut(a) ? a : ga(a), h = h && !y ? Un(h) : 0;
        var M = a.length;
        return h < 0 && (h = xe(M + h, 0)), xf(a) ? h <= M && a.indexOf(u, h) > -1 : !!M && ra(a, u, h) > -1;
      }
      var F4 = qn(function(a, u, h) {
        var y = -1, M = typeof u == "function", N = ut(a) ? Z(a.length) : [];
        return Wr(a, function(D) {
          N[++y] = M ? dt(u, D, h) : _o(D, u, h);
        }), N;
      }), B4 = ff(function(a, u, h) {
        yr(a, h, u);
      });
      function mf(a, u) {
        var h = Bn(a) ? fe : qp;
        return h(a, $n(u, 3));
      }
      function z4(a, u, h, y) {
        return a == null ? [] : (Bn(u) || (u = u == null ? [] : [u]), h = y ? t : h, Bn(h) || (h = h == null ? [] : [h]), Xp(a, u, h));
      }
      var V4 = ff(function(a, u, h) {
        a[h ? 0 : 1].push(u);
      }, function() {
        return [[], []];
      });
      function U4(a, u, h) {
        var y = Bn(a) ? fc : yp, M = arguments.length < 3;
        return y(a, $n(u, 4), h, M, Wr);
      }
      function G4(a, u, h) {
        var y = Bn(a) ? e5 : yp, M = arguments.length < 3;
        return y(a, $n(u, 4), h, M, Dp);
      }
      function q4(a, u) {
        var h = Bn(a) ? Vr : Fp;
        return h(a, bf($n(u, 3)));
      }
      function W4(a) {
        var u = Bn(a) ? kp : D6;
        return u(a);
      }
      function H4(a, u, h) {
        (h ? He(a, u, h) : u === t) ? u = 1 : u = Un(u);
        var y = Bn(a) ? p6 : F6;
        return y(a, u);
      }
      function Y4(a) {
        var u = Bn(a) ? g6 : z6;
        return u(a);
      }
      function X4(a) {
        if (a == null)
          return 0;
        if (ut(a))
          return xf(a) ? aa(a) : a.length;
        var u = De(a);
        return u == En || u == j ? a.size : Ec(a).length;
      }
      function K4(a, u, h) {
        var y = Bn(a) ? sc : V6;
        return h && He(a, u, h) && (u = t), y(a, $n(u, 3));
      }
      var Z4 = qn(function(a, u) {
        if (a == null)
          return [];
        var h = u.length;
        return h > 1 && He(a, u[0], u[1]) ? u = [] : h > 2 && He(u[0], u[1], u[2]) && (u = [u[0]]), Xp(a, ke(u, 1), []);
      }), yf = R5 || function() {
        return $e.Date.now();
      };
      function J4(a, u) {
        if (typeof u != "function")
          throw new Mt(f);
        return a = Un(a), function() {
          if (--a < 1)
            return u.apply(this, arguments);
        };
      }
      function Ug(a, u, h) {
        return u = h ? t : u, u = a && u == null ? a.length : u, _r(a, I, t, t, t, t, u);
      }
      function Gg(a, u) {
        var h;
        if (typeof u != "function")
          throw new Mt(f);
        return a = Un(a), function() {
          return --a > 0 && (h = u.apply(this, arguments)), a <= 1 && (u = t), h;
        };
      }
      var Jc = qn(function(a, u, h) {
        var y = m;
        if (h.length) {
          var M = Gr(h, da(Jc));
          y |= S;
        }
        return _r(a, y, u, h, M);
      }), qg = qn(function(a, u, h) {
        var y = m | _;
        if (h.length) {
          var M = Gr(h, da(qg));
          y |= S;
        }
        return _r(u, y, a, h, M);
      });
      function Wg(a, u, h) {
        u = h ? t : u;
        var y = _r(a, A, t, t, t, t, t, u);
        return y.placeholder = Wg.placeholder, y;
      }
      function Hg(a, u, h) {
        u = h ? t : u;
        var y = _r(a, T, t, t, t, t, t, u);
        return y.placeholder = Hg.placeholder, y;
      }
      function Yg(a, u, h) {
        var y, M, N, D, G, Y, rn = 0, on = !1, un = !1, yn = !0;
        if (typeof a != "function")
          throw new Mt(f);
        u = Rt(u) || 0, le(h) && (on = !!h.leading, un = "maxWait" in h, N = un ? xe(Rt(h.maxWait) || 0, u) : N, yn = "trailing" in h ? !!h.trailing : yn);
        function Mn(ye) {
          var Gt = y, Ar = M;
          return y = M = t, rn = ye, D = a.apply(Ar, Gt), D;
        }
        function kn(ye) {
          return rn = ye, G = Ao(Hn, u), on ? Mn(ye) : D;
        }
        function Gn(ye) {
          var Gt = ye - Y, Ar = ye - rn, hv = u - Gt;
          return un ? Le(hv, N - Ar) : hv;
        }
        function On(ye) {
          var Gt = ye - Y, Ar = ye - rn;
          return Y === t || Gt >= u || Gt < 0 || un && Ar >= N;
        }
        function Hn() {
          var ye = yf();
          if (On(ye))
            return Kn(ye);
          G = Ao(Hn, Gn(ye));
        }
        function Kn(ye) {
          return G = t, yn && y ? Mn(ye) : (y = M = t, D);
        }
        function mt() {
          G !== t && rg(G), rn = 0, y = Y = M = G = t;
        }
        function Ye() {
          return G === t ? D : Kn(yf());
        }
        function yt() {
          var ye = yf(), Gt = On(ye);
          if (y = arguments, M = this, Y = ye, Gt) {
            if (G === t)
              return kn(Y);
            if (un)
              return rg(G), G = Ao(Hn, u), Mn(Y);
          }
          return G === t && (G = Ao(Hn, u)), D;
        }
        return yt.cancel = mt, yt.flush = Ye, yt;
      }
      var Q4 = qn(function(a, u) {
        return Lp(a, 1, u);
      }), j4 = qn(function(a, u, h) {
        return Lp(a, Rt(u) || 0, h);
      });
      function n7(a) {
        return _r(a, F);
      }
      function _f(a, u) {
        if (typeof a != "function" || u != null && typeof u != "function")
          throw new Mt(f);
        var h = function() {
          var y = arguments, M = u ? u.apply(this, y) : y[0], N = h.cache;
          if (N.has(M))
            return N.get(M);
          var D = a.apply(this, y);
          return h.cache = N.set(M, D) || N, D;
        };
        return h.cache = new (_f.Cache || mr)(), h;
      }
      _f.Cache = mr;
      function bf(a) {
        if (typeof a != "function")
          throw new Mt(f);
        return function() {
          var u = arguments;
          switch (u.length) {
            case 0:
              return !a.call(this);
            case 1:
              return !a.call(this, u[0]);
            case 2:
              return !a.call(this, u[0], u[1]);
            case 3:
              return !a.call(this, u[0], u[1], u[2]);
          }
          return !a.apply(this, u);
        };
      }
      function e7(a) {
        return Gg(2, a);
      }
      var t7 = U6(function(a, u) {
        u = u.length == 1 && Bn(u[0]) ? fe(u[0], pt($n())) : fe(ke(u, 1), pt($n()));
        var h = u.length;
        return qn(function(y) {
          for (var M = -1, N = Le(y.length, h); ++M < N; )
            y[M] = u[M].call(this, y[M]);
          return dt(a, this, y);
        });
      }), Qc = qn(function(a, u) {
        var h = Gr(u, da(Qc));
        return _r(a, S, t, u, h);
      }), Xg = qn(function(a, u) {
        var h = Gr(u, da(Xg));
        return _r(a, R, t, u, h);
      }), r7 = br(function(a, u) {
        return _r(a, B, t, t, t, u);
      });
      function i7(a, u) {
        if (typeof a != "function")
          throw new Mt(f);
        return u = u === t ? u : Un(u), qn(a, u);
      }
      function a7(a, u) {
        if (typeof a != "function")
          throw new Mt(f);
        return u = u == null ? 0 : xe(Un(u), 0), qn(function(h) {
          var y = h[u], M = Xr(h, 0, u);
          return y && Ur(M, y), dt(a, this, M);
        });
      }
      function o7(a, u, h) {
        var y = !0, M = !0;
        if (typeof a != "function")
          throw new Mt(f);
        return le(h) && (y = "leading" in h ? !!h.leading : y, M = "trailing" in h ? !!h.trailing : M), Yg(a, u, {
          leading: y,
          maxWait: u,
          trailing: M
        });
      }
      function u7(a) {
        return Ug(a, 1);
      }
      function f7(a, u) {
        return Qc(Lc(u), a);
      }
      function s7() {
        if (!arguments.length)
          return [];
        var a = arguments[0];
        return Bn(a) ? a : [a];
      }
      function l7(a) {
        return Et(a, v);
      }
      function c7(a, u) {
        return u = typeof u == "function" ? u : t, Et(a, v, u);
      }
      function h7(a) {
        return Et(a, g | v);
      }
      function d7(a, u) {
        return u = typeof u == "function" ? u : t, Et(a, g | v, u);
      }
      function p7(a, u) {
        return u == null || Ip(a, u, Se(u));
      }
      function Ut(a, u) {
        return a === u || a !== a && u !== u;
      }
      var g7 = hf(Ac), v7 = hf(function(a, u) {
        return a >= u;
      }), Ti = Vp(function() {
        return arguments;
      }()) ? Vp : function(a) {
        return pe(a) && ne.call(a, "callee") && !Ep.call(a, "callee");
      }, Bn = Z.isArray, m7 = fp ? pt(fp) : M6;
      function ut(a) {
        return a != null && wf(a.length) && !xr(a);
      }
      function me(a) {
        return pe(a) && ut(a);
      }
      function y7(a) {
        return a === !0 || a === !1 || pe(a) && We(a) == _n;
      }
      var Kr = $5 || sh, _7 = sp ? pt(sp) : S6;
      function b7(a) {
        return pe(a) && a.nodeType === 1 && !Mo(a);
      }
      function w7(a) {
        if (a == null)
          return !0;
        if (ut(a) && (Bn(a) || typeof a == "string" || typeof a.splice == "function" || Kr(a) || pa(a) || Ti(a)))
          return !a.length;
        var u = De(a);
        if (u == En || u == j)
          return !a.size;
        if (To(a))
          return !Ec(a).length;
        for (var h in a)
          if (ne.call(a, h))
            return !1;
        return !0;
      }
      function x7(a, u) {
        return bo(a, u);
      }
      function T7(a, u, h) {
        h = typeof h == "function" ? h : t;
        var y = h ? h(a, u) : t;
        return y === t ? bo(a, u, t, h) : !!y;
      }
      function jc(a) {
        if (!pe(a))
          return !1;
        var u = We(a);
        return u == vn || u == hn || typeof a.message == "string" && typeof a.name == "string" && !Mo(a);
      }
      function A7(a) {
        return typeof a == "number" && Pp(a);
      }
      function xr(a) {
        if (!le(a))
          return !1;
        var u = We(a);
        return u == an || u == xn || u == gn || u == U;
      }
      function Kg(a) {
        return typeof a == "number" && a == Un(a);
      }
      function wf(a) {
        return typeof a == "number" && a > -1 && a % 1 == 0 && a <= K;
      }
      function le(a) {
        var u = typeof a;
        return a != null && (u == "object" || u == "function");
      }
      function pe(a) {
        return a != null && typeof a == "object";
      }
      var Zg = lp ? pt(lp) : C6;
      function M7(a, u) {
        return a === u || Sc(a, u, Gc(u));
      }
      function S7(a, u, h) {
        return h = typeof h == "function" ? h : t, Sc(a, u, Gc(u), h);
      }
      function E7(a) {
        return Jg(a) && a != +a;
      }
      function C7(a) {
        if (c8(a))
          throw new Fn(o);
        return Up(a);
      }
      function P7(a) {
        return a === null;
      }
      function R7(a) {
        return a == null;
      }
      function Jg(a) {
        return typeof a == "number" || pe(a) && We(a) == In;
      }
      function Mo(a) {
        if (!pe(a) || We(a) != pn)
          return !1;
        var u = Yu(a);
        if (u === null)
          return !0;
        var h = ne.call(u, "constructor") && u.constructor;
        return typeof h == "function" && h instanceof h && Gu.call(h) == S5;
      }
      var nh = cp ? pt(cp) : P6;
      function N7(a) {
        return Kg(a) && a >= -K && a <= K;
      }
      var Qg = hp ? pt(hp) : R6;
      function xf(a) {
        return typeof a == "string" || !Bn(a) && pe(a) && We(a) == mn;
      }
      function vt(a) {
        return typeof a == "symbol" || pe(a) && We(a) == dn;
      }
      var pa = dp ? pt(dp) : N6;
      function $7(a) {
        return a === t;
      }
      function k7(a) {
        return pe(a) && De(a) == An;
      }
      function O7(a) {
        return pe(a) && We(a) == Zn;
      }
      var I7 = hf(Cc), L7 = hf(function(a, u) {
        return a <= u;
      });
      function jg(a) {
        if (!a)
          return [];
        if (ut(a))
          return xf(a) ? zt(a) : ot(a);
        if (co && a[co])
          return p5(a[co]());
        var u = De(a), h = u == En ? gc : u == j ? zu : ga;
        return h(a);
      }
      function Tr(a) {
        if (!a)
          return a === 0 ? a : 0;
        if (a = Rt(a), a === W || a === -W) {
          var u = a < 0 ? -1 : 1;
          return u * Q;
        }
        return a === a ? a : 0;
      }
      function Un(a) {
        var u = Tr(a), h = u % 1;
        return u === u ? h ? u - h : u : 0;
      }
      function nv(a) {
        return a ? _i(Un(a), 0, q) : 0;
      }
      function Rt(a) {
        if (typeof a == "number")
          return a;
        if (vt(a))
          return z;
        if (le(a)) {
          var u = typeof a.valueOf == "function" ? a.valueOf() : a;
          a = le(u) ? u + "" : u;
        }
        if (typeof a != "string")
          return a === 0 ? a : +a;
        a = _p(a);
        var h = mx.test(a);
        return h || _x.test(a) ? Jx(a.slice(2), h ? 2 : 8) : vx.test(a) ? z : +a;
      }
      function ev(a) {
        return tr(a, ft(a));
      }
      function D7(a) {
        return a ? _i(Un(a), -K, K) : a === 0 ? a : 0;
      }
      function jn(a) {
        return a == null ? "" : gt(a);
      }
      var F7 = ca(function(a, u) {
        if (To(u) || ut(u)) {
          tr(u, Se(u), a);
          return;
        }
        for (var h in u)
          ne.call(u, h) && mo(a, h, u[h]);
      }), tv = ca(function(a, u) {
        tr(u, ft(u), a);
      }), Tf = ca(function(a, u, h, y) {
        tr(u, ft(u), a, y);
      }), B7 = ca(function(a, u, h, y) {
        tr(u, Se(u), a, y);
      }), z7 = br(wc);
      function V7(a, u) {
        var h = la(a);
        return u == null ? h : Op(h, u);
      }
      var U7 = qn(function(a, u) {
        a = ee(a);
        var h = -1, y = u.length, M = y > 2 ? u[2] : t;
        for (M && He(u[0], u[1], M) && (y = 1); ++h < y; )
          for (var N = u[h], D = ft(N), G = -1, Y = D.length; ++G < Y; ) {
            var rn = D[G], on = a[rn];
            (on === t || Ut(on, ua[rn]) && !ne.call(a, rn)) && (a[rn] = N[rn]);
          }
        return a;
      }), G7 = qn(function(a) {
        return a.push(t, _g), dt(rv, t, a);
      });
      function q7(a, u) {
        return gp(a, $n(u, 3), er);
      }
      function W7(a, u) {
        return gp(a, $n(u, 3), Tc);
      }
      function H7(a, u) {
        return a == null ? a : xc(a, $n(u, 3), ft);
      }
      function Y7(a, u) {
        return a == null ? a : Bp(a, $n(u, 3), ft);
      }
      function X7(a, u) {
        return a && er(a, $n(u, 3));
      }
      function K7(a, u) {
        return a && Tc(a, $n(u, 3));
      }
      function Z7(a) {
        return a == null ? [] : rf(a, Se(a));
      }
      function J7(a) {
        return a == null ? [] : rf(a, ft(a));
      }
      function eh(a, u, h) {
        var y = a == null ? t : bi(a, u);
        return y === t ? h : y;
      }
      function Q7(a, u) {
        return a != null && xg(a, u, w6);
      }
      function th(a, u) {
        return a != null && xg(a, u, x6);
      }
      var j7 = pg(function(a, u, h) {
        u != null && typeof u.toString != "function" && (u = qu.call(u)), a[u] = h;
      }, ih(st)), n9 = pg(function(a, u, h) {
        u != null && typeof u.toString != "function" && (u = qu.call(u)), ne.call(a, u) ? a[u].push(h) : a[u] = [h];
      }, $n), e9 = qn(_o);
      function Se(a) {
        return ut(a) ? $p(a) : Ec(a);
      }
      function ft(a) {
        return ut(a) ? $p(a, !0) : $6(a);
      }
      function t9(a, u) {
        var h = {};
        return u = $n(u, 3), er(a, function(y, M, N) {
          yr(h, u(y, M, N), y);
        }), h;
      }
      function r9(a, u) {
        var h = {};
        return u = $n(u, 3), er(a, function(y, M, N) {
          yr(h, M, u(y, M, N));
        }), h;
      }
      var i9 = ca(function(a, u, h) {
        af(a, u, h);
      }), rv = ca(function(a, u, h, y) {
        af(a, u, h, y);
      }), a9 = br(function(a, u) {
        var h = {};
        if (a == null)
          return h;
        var y = !1;
        u = fe(u, function(N) {
          return N = Yr(N, a), y || (y = N.length > 1), N;
        }), tr(a, Vc(a), h), y && (h = Et(h, g | d | v, j6));
        for (var M = u.length; M--; )
          kc(h, u[M]);
        return h;
      });
      function o9(a, u) {
        return iv(a, bf($n(u)));
      }
      var u9 = br(function(a, u) {
        return a == null ? {} : O6(a, u);
      });
      function iv(a, u) {
        if (a == null)
          return {};
        var h = fe(Vc(a), function(y) {
          return [y];
        });
        return u = $n(u), Kp(a, h, function(y, M) {
          return u(y, M[0]);
        });
      }
      function f9(a, u, h) {
        u = Yr(u, a);
        var y = -1, M = u.length;
        for (M || (M = 1, a = t); ++y < M; ) {
          var N = a == null ? t : a[rr(u[y])];
          N === t && (y = M, N = h), a = xr(N) ? N.call(a) : N;
        }
        return a;
      }
      function s9(a, u, h) {
        return a == null ? a : wo(a, u, h);
      }
      function l9(a, u, h, y) {
        return y = typeof y == "function" ? y : t, a == null ? a : wo(a, u, h, y);
      }
      var av = mg(Se), ov = mg(ft);
      function c9(a, u, h) {
        var y = Bn(a), M = y || Kr(a) || pa(a);
        if (u = $n(u, 4), h == null) {
          var N = a && a.constructor;
          M ? h = y ? new N() : [] : le(a) ? h = xr(N) ? la(Yu(a)) : {} : h = {};
        }
        return (M ? At : er)(a, function(D, G, Y) {
          return u(h, D, G, Y);
        }), h;
      }
      function h9(a, u) {
        return a == null ? !0 : kc(a, u);
      }
      function d9(a, u, h) {
        return a == null ? a : ng(a, u, Lc(h));
      }
      function p9(a, u, h, y) {
        return y = typeof y == "function" ? y : t, a == null ? a : ng(a, u, Lc(h), y);
      }
      function ga(a) {
        return a == null ? [] : pc(a, Se(a));
      }
      function g9(a) {
        return a == null ? [] : pc(a, ft(a));
      }
      function v9(a, u, h) {
        return h === t && (h = u, u = t), h !== t && (h = Rt(h), h = h === h ? h : 0), u !== t && (u = Rt(u), u = u === u ? u : 0), _i(Rt(a), u, h);
      }
      function m9(a, u, h) {
        return u = Tr(u), h === t ? (h = u, u = 0) : h = Tr(h), a = Rt(a), T6(a, u, h);
      }
      function y9(a, u, h) {
        if (h && typeof h != "boolean" && He(a, u, h) && (u = h = t), h === t && (typeof u == "boolean" ? (h = u, u = t) : typeof a == "boolean" && (h = a, a = t)), a === t && u === t ? (a = 0, u = 1) : (a = Tr(a), u === t ? (u = a, a = 0) : u = Tr(u)), a > u) {
          var y = a;
          a = u, u = y;
        }
        if (h || a % 1 || u % 1) {
          var M = Rp();
          return Le(a + M * (u - a + Zx("1e-" + ((M + "").length - 1))), u);
        }
        return Rc(a, u);
      }
      var _9 = ha(function(a, u, h) {
        return u = u.toLowerCase(), a + (h ? uv(u) : u);
      });
      function uv(a) {
        return rh(jn(a).toLowerCase());
      }
      function fv(a) {
        return a = jn(a), a && a.replace(wx, s5).replace(zx, "");
      }
      function b9(a, u, h) {
        a = jn(a), u = gt(u);
        var y = a.length;
        h = h === t ? y : _i(Un(h), 0, y);
        var M = h;
        return h -= u.length, h >= 0 && a.slice(h, M) == u;
      }
      function w9(a) {
        return a = jn(a), a && ex.test(a) ? a.replace(B1, l5) : a;
      }
      function x9(a) {
        return a = jn(a), a && ux.test(a) ? a.replace(Ql, "\\$&") : a;
      }
      var T9 = ha(function(a, u, h) {
        return a + (h ? "-" : "") + u.toLowerCase();
      }), A9 = ha(function(a, u, h) {
        return a + (h ? " " : "") + u.toLowerCase();
      }), M9 = cg("toLowerCase");
      function S9(a, u, h) {
        a = jn(a), u = Un(u);
        var y = u ? aa(a) : 0;
        if (!u || y >= u)
          return a;
        var M = (u - y) / 2;
        return cf(Ju(M), h) + a + cf(Zu(M), h);
      }
      function E9(a, u, h) {
        a = jn(a), u = Un(u);
        var y = u ? aa(a) : 0;
        return u && y < u ? a + cf(u - y, h) : a;
      }
      function C9(a, u, h) {
        a = jn(a), u = Un(u);
        var y = u ? aa(a) : 0;
        return u && y < u ? cf(u - y, h) + a : a;
      }
      function P9(a, u, h) {
        return h || u == null ? u = 0 : u && (u = +u), L5(jn(a).replace(jl, ""), u || 0);
      }
      function R9(a, u, h) {
        return (h ? He(a, u, h) : u === t) ? u = 1 : u = Un(u), Nc(jn(a), u);
      }
      function N9() {
        var a = arguments, u = jn(a[0]);
        return a.length < 3 ? u : u.replace(a[1], a[2]);
      }
      var $9 = ha(function(a, u, h) {
        return a + (h ? "_" : "") + u.toLowerCase();
      });
      function k9(a, u, h) {
        return h && typeof h != "number" && He(a, u, h) && (u = h = t), h = h === t ? q : h >>> 0, h ? (a = jn(a), a && (typeof u == "string" || u != null && !nh(u)) && (u = gt(u), !u && ia(a)) ? Xr(zt(a), 0, h) : a.split(u, h)) : [];
      }
      var O9 = ha(function(a, u, h) {
        return a + (h ? " " : "") + rh(u);
      });
      function I9(a, u, h) {
        return a = jn(a), h = h == null ? 0 : _i(Un(h), 0, a.length), u = gt(u), a.slice(h, h + u.length) == u;
      }
      function L9(a, u, h) {
        var y = C.templateSettings;
        h && He(a, u, h) && (u = t), a = jn(a), u = Tf({}, u, y, yg);
        var M = Tf({}, u.imports, y.imports, yg), N = Se(M), D = pc(M, N), G, Y, rn = 0, on = u.interpolate || Iu, un = "__p += '", yn = vc(
          (u.escape || Iu).source + "|" + on.source + "|" + (on === z1 ? gx : Iu).source + "|" + (u.evaluate || Iu).source + "|$",
          "g"
        ), Mn = "//# sourceURL=" + (ne.call(u, "sourceURL") ? (u.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Wx + "]") + `
`;
        a.replace(yn, function(On, Hn, Kn, mt, Ye, yt) {
          return Kn || (Kn = mt), un += a.slice(rn, yt).replace(xx, c5), Hn && (G = !0, un += `' +
__e(` + Hn + `) +
'`), Ye && (Y = !0, un += `';
` + Ye + `;
__p += '`), Kn && (un += `' +
((__t = (` + Kn + `)) == null ? '' : __t) +
'`), rn = yt + On.length, On;
        }), un += `';
`;
        var kn = ne.call(u, "variable") && u.variable;
        if (!kn)
          un = `with (obj) {
` + un + `
}
`;
        else if (dx.test(kn))
          throw new Fn(s);
        un = (Y ? un.replace(J3, "") : un).replace(Q3, "$1").replace(j3, "$1;"), un = "function(" + (kn || "obj") + `) {
` + (kn ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (G ? ", __e = _.escape" : "") + (Y ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + un + `return __p
}`;
        var Gn = lv(function() {
          return Qn(N, Mn + "return " + un).apply(t, D);
        });
        if (Gn.source = un, jc(Gn))
          throw Gn;
        return Gn;
      }
      function D9(a) {
        return jn(a).toLowerCase();
      }
      function F9(a) {
        return jn(a).toUpperCase();
      }
      function B9(a, u, h) {
        if (a = jn(a), a && (h || u === t))
          return _p(a);
        if (!a || !(u = gt(u)))
          return a;
        var y = zt(a), M = zt(u), N = bp(y, M), D = wp(y, M) + 1;
        return Xr(y, N, D).join("");
      }
      function z9(a, u, h) {
        if (a = jn(a), a && (h || u === t))
          return a.slice(0, Tp(a) + 1);
        if (!a || !(u = gt(u)))
          return a;
        var y = zt(a), M = wp(y, zt(u)) + 1;
        return Xr(y, 0, M).join("");
      }
      function V9(a, u, h) {
        if (a = jn(a), a && (h || u === t))
          return a.replace(jl, "");
        if (!a || !(u = gt(u)))
          return a;
        var y = zt(a), M = bp(y, zt(u));
        return Xr(y, M).join("");
      }
      function U9(a, u) {
        var h = V, y = E;
        if (le(u)) {
          var M = "separator" in u ? u.separator : M;
          h = "length" in u ? Un(u.length) : h, y = "omission" in u ? gt(u.omission) : y;
        }
        a = jn(a);
        var N = a.length;
        if (ia(a)) {
          var D = zt(a);
          N = D.length;
        }
        if (h >= N)
          return a;
        var G = h - aa(y);
        if (G < 1)
          return y;
        var Y = D ? Xr(D, 0, G).join("") : a.slice(0, G);
        if (M === t)
          return Y + y;
        if (D && (G += Y.length - G), nh(M)) {
          if (a.slice(G).search(M)) {
            var rn, on = Y;
            for (M.global || (M = vc(M.source, jn(V1.exec(M)) + "g")), M.lastIndex = 0; rn = M.exec(on); )
              var un = rn.index;
            Y = Y.slice(0, un === t ? G : un);
          }
        } else if (a.indexOf(gt(M), G) != G) {
          var yn = Y.lastIndexOf(M);
          yn > -1 && (Y = Y.slice(0, yn));
        }
        return Y + y;
      }
      function G9(a) {
        return a = jn(a), a && nx.test(a) ? a.replace(F1, y5) : a;
      }
      var q9 = ha(function(a, u, h) {
        return a + (h ? " " : "") + u.toUpperCase();
      }), rh = cg("toUpperCase");
      function sv(a, u, h) {
        return a = jn(a), u = h ? t : u, u === t ? d5(a) ? w5(a) : i5(a) : a.match(u) || [];
      }
      var lv = qn(function(a, u) {
        try {
          return dt(a, t, u);
        } catch (h) {
          return jc(h) ? h : new Fn(h);
        }
      }), W9 = br(function(a, u) {
        return At(u, function(h) {
          h = rr(h), yr(a, h, Jc(a[h], a));
        }), a;
      });
      function H9(a) {
        var u = a == null ? 0 : a.length, h = $n();
        return a = u ? fe(a, function(y) {
          if (typeof y[1] != "function")
            throw new Mt(f);
          return [h(y[0]), y[1]];
        }) : [], qn(function(y) {
          for (var M = -1; ++M < u; ) {
            var N = a[M];
            if (dt(N[0], this, y))
              return dt(N[1], this, y);
          }
        });
      }
      function Y9(a) {
        return y6(Et(a, g));
      }
      function ih(a) {
        return function() {
          return a;
        };
      }
      function X9(a, u) {
        return a == null || a !== a ? u : a;
      }
      var K9 = dg(), Z9 = dg(!0);
      function st(a) {
        return a;
      }
      function ah(a) {
        return Gp(typeof a == "function" ? a : Et(a, g));
      }
      function J9(a) {
        return Wp(Et(a, g));
      }
      function Q9(a, u) {
        return Hp(a, Et(u, g));
      }
      var j9 = qn(function(a, u) {
        return function(h) {
          return _o(h, a, u);
        };
      }), nT = qn(function(a, u) {
        return function(h) {
          return _o(a, h, u);
        };
      });
      function oh(a, u, h) {
        var y = Se(u), M = rf(u, y);
        h == null && !(le(u) && (M.length || !y.length)) && (h = u, u = a, a = this, M = rf(u, Se(u)));
        var N = !(le(h) && "chain" in h) || !!h.chain, D = xr(a);
        return At(M, function(G) {
          var Y = u[G];
          a[G] = Y, D && (a.prototype[G] = function() {
            var rn = this.__chain__;
            if (N || rn) {
              var on = a(this.__wrapped__), un = on.__actions__ = ot(this.__actions__);
              return un.push({ func: Y, args: arguments, thisArg: a }), on.__chain__ = rn, on;
            }
            return Y.apply(a, Ur([this.value()], arguments));
          });
        }), a;
      }
      function eT() {
        return $e._ === this && ($e._ = E5), this;
      }
      function uh() {
      }
      function tT(a) {
        return a = Un(a), qn(function(u) {
          return Yp(u, a);
        });
      }
      var rT = Fc(fe), iT = Fc(pp), aT = Fc(sc);
      function cv(a) {
        return Wc(a) ? lc(rr(a)) : I6(a);
      }
      function oT(a) {
        return function(u) {
          return a == null ? t : bi(a, u);
        };
      }
      var uT = gg(), fT = gg(!0);
      function fh() {
        return [];
      }
      function sh() {
        return !1;
      }
      function sT() {
        return {};
      }
      function lT() {
        return "";
      }
      function cT() {
        return !0;
      }
      function hT(a, u) {
        if (a = Un(a), a < 1 || a > K)
          return [];
        var h = q, y = Le(a, q);
        u = $n(u), a -= q;
        for (var M = dc(y, u); ++h < a; )
          u(h);
        return M;
      }
      function dT(a) {
        return Bn(a) ? fe(a, rr) : vt(a) ? [a] : ot(Ng(jn(a)));
      }
      function pT(a) {
        var u = ++M5;
        return jn(a) + u;
      }
      var gT = lf(function(a, u) {
        return a + u;
      }, 0), vT = Bc("ceil"), mT = lf(function(a, u) {
        return a / u;
      }, 1), yT = Bc("floor");
      function _T(a) {
        return a && a.length ? tf(a, st, Ac) : t;
      }
      function bT(a, u) {
        return a && a.length ? tf(a, $n(u, 2), Ac) : t;
      }
      function wT(a) {
        return mp(a, st);
      }
      function xT(a, u) {
        return mp(a, $n(u, 2));
      }
      function TT(a) {
        return a && a.length ? tf(a, st, Cc) : t;
      }
      function AT(a, u) {
        return a && a.length ? tf(a, $n(u, 2), Cc) : t;
      }
      var MT = lf(function(a, u) {
        return a * u;
      }, 1), ST = Bc("round"), ET = lf(function(a, u) {
        return a - u;
      }, 0);
      function CT(a) {
        return a && a.length ? hc(a, st) : 0;
      }
      function PT(a, u) {
        return a && a.length ? hc(a, $n(u, 2)) : 0;
      }
      return C.after = J4, C.ary = Ug, C.assign = F7, C.assignIn = tv, C.assignInWith = Tf, C.assignWith = B7, C.at = z7, C.before = Gg, C.bind = Jc, C.bindAll = W9, C.bindKey = qg, C.castArray = s7, C.chain = Bg, C.chunk = y8, C.compact = _8, C.concat = b8, C.cond = H9, C.conforms = Y9, C.constant = ih, C.countBy = C4, C.create = V7, C.curry = Wg, C.curryRight = Hg, C.debounce = Yg, C.defaults = U7, C.defaultsDeep = G7, C.defer = Q4, C.delay = j4, C.difference = w8, C.differenceBy = x8, C.differenceWith = T8, C.drop = A8, C.dropRight = M8, C.dropRightWhile = S8, C.dropWhile = E8, C.fill = C8, C.filter = R4, C.flatMap = k4, C.flatMapDeep = O4, C.flatMapDepth = I4, C.flatten = Ig, C.flattenDeep = P8, C.flattenDepth = R8, C.flip = n7, C.flow = K9, C.flowRight = Z9, C.fromPairs = N8, C.functions = Z7, C.functionsIn = J7, C.groupBy = L4, C.initial = k8, C.intersection = O8, C.intersectionBy = I8, C.intersectionWith = L8, C.invert = j7, C.invertBy = n9, C.invokeMap = F4, C.iteratee = ah, C.keyBy = B4, C.keys = Se, C.keysIn = ft, C.map = mf, C.mapKeys = t9, C.mapValues = r9, C.matches = J9, C.matchesProperty = Q9, C.memoize = _f, C.merge = i9, C.mergeWith = rv, C.method = j9, C.methodOf = nT, C.mixin = oh, C.negate = bf, C.nthArg = tT, C.omit = a9, C.omitBy = o9, C.once = e7, C.orderBy = z4, C.over = rT, C.overArgs = t7, C.overEvery = iT, C.overSome = aT, C.partial = Qc, C.partialRight = Xg, C.partition = V4, C.pick = u9, C.pickBy = iv, C.property = cv, C.propertyOf = oT, C.pull = z8, C.pullAll = Dg, C.pullAllBy = V8, C.pullAllWith = U8, C.pullAt = G8, C.range = uT, C.rangeRight = fT, C.rearg = r7, C.reject = q4, C.remove = q8, C.rest = i7, C.reverse = Kc, C.sampleSize = H4, C.set = s9, C.setWith = l9, C.shuffle = Y4, C.slice = W8, C.sortBy = Z4, C.sortedUniq = Q8, C.sortedUniqBy = j8, C.split = k9, C.spread = a7, C.tail = n4, C.take = e4, C.takeRight = t4, C.takeRightWhile = r4, C.takeWhile = i4, C.tap = _4, C.throttle = o7, C.thru = vf, C.toArray = jg, C.toPairs = av, C.toPairsIn = ov, C.toPath = dT, C.toPlainObject = ev, C.transform = c9, C.unary = u7, C.union = a4, C.unionBy = o4, C.unionWith = u4, C.uniq = f4, C.uniqBy = s4, C.uniqWith = l4, C.unset = h9, C.unzip = Zc, C.unzipWith = Fg, C.update = d9, C.updateWith = p9, C.values = ga, C.valuesIn = g9, C.without = c4, C.words = sv, C.wrap = f7, C.xor = h4, C.xorBy = d4, C.xorWith = p4, C.zip = g4, C.zipObject = v4, C.zipObjectDeep = m4, C.zipWith = y4, C.entries = av, C.entriesIn = ov, C.extend = tv, C.extendWith = Tf, oh(C, C), C.add = gT, C.attempt = lv, C.camelCase = _9, C.capitalize = uv, C.ceil = vT, C.clamp = v9, C.clone = l7, C.cloneDeep = h7, C.cloneDeepWith = d7, C.cloneWith = c7, C.conformsTo = p7, C.deburr = fv, C.defaultTo = X9, C.divide = mT, C.endsWith = b9, C.eq = Ut, C.escape = w9, C.escapeRegExp = x9, C.every = P4, C.find = N4, C.findIndex = kg, C.findKey = q7, C.findLast = $4, C.findLastIndex = Og, C.findLastKey = W7, C.floor = yT, C.forEach = zg, C.forEachRight = Vg, C.forIn = H7, C.forInRight = Y7, C.forOwn = X7, C.forOwnRight = K7, C.get = eh, C.gt = g7, C.gte = v7, C.has = Q7, C.hasIn = th, C.head = Lg, C.identity = st, C.includes = D4, C.indexOf = $8, C.inRange = m9, C.invoke = e9, C.isArguments = Ti, C.isArray = Bn, C.isArrayBuffer = m7, C.isArrayLike = ut, C.isArrayLikeObject = me, C.isBoolean = y7, C.isBuffer = Kr, C.isDate = _7, C.isElement = b7, C.isEmpty = w7, C.isEqual = x7, C.isEqualWith = T7, C.isError = jc, C.isFinite = A7, C.isFunction = xr, C.isInteger = Kg, C.isLength = wf, C.isMap = Zg, C.isMatch = M7, C.isMatchWith = S7, C.isNaN = E7, C.isNative = C7, C.isNil = R7, C.isNull = P7, C.isNumber = Jg, C.isObject = le, C.isObjectLike = pe, C.isPlainObject = Mo, C.isRegExp = nh, C.isSafeInteger = N7, C.isSet = Qg, C.isString = xf, C.isSymbol = vt, C.isTypedArray = pa, C.isUndefined = $7, C.isWeakMap = k7, C.isWeakSet = O7, C.join = D8, C.kebabCase = T9, C.last = Pt, C.lastIndexOf = F8, C.lowerCase = A9, C.lowerFirst = M9, C.lt = I7, C.lte = L7, C.max = _T, C.maxBy = bT, C.mean = wT, C.meanBy = xT, C.min = TT, C.minBy = AT, C.stubArray = fh, C.stubFalse = sh, C.stubObject = sT, C.stubString = lT, C.stubTrue = cT, C.multiply = MT, C.nth = B8, C.noConflict = eT, C.noop = uh, C.now = yf, C.pad = S9, C.padEnd = E9, C.padStart = C9, C.parseInt = P9, C.random = y9, C.reduce = U4, C.reduceRight = G4, C.repeat = R9, C.replace = N9, C.result = f9, C.round = ST, C.runInContext = H, C.sample = W4, C.size = X4, C.snakeCase = $9, C.some = K4, C.sortedIndex = H8, C.sortedIndexBy = Y8, C.sortedIndexOf = X8, C.sortedLastIndex = K8, C.sortedLastIndexBy = Z8, C.sortedLastIndexOf = J8, C.startCase = O9, C.startsWith = I9, C.subtract = ET, C.sum = CT, C.sumBy = PT, C.template = L9, C.times = hT, C.toFinite = Tr, C.toInteger = Un, C.toLength = nv, C.toLower = D9, C.toNumber = Rt, C.toSafeInteger = D7, C.toString = jn, C.toUpper = F9, C.trim = B9, C.trimEnd = z9, C.trimStart = V9, C.truncate = U9, C.unescape = G9, C.uniqueId = pT, C.upperCase = q9, C.upperFirst = rh, C.each = zg, C.eachRight = Vg, C.first = Lg, oh(C, function() {
        var a = {};
        return er(C, function(u, h) {
          ne.call(C.prototype, h) || (a[h] = u);
        }), a;
      }(), { chain: !1 }), C.VERSION = r, At(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(a) {
        C[a].placeholder = C;
      }), At(["drop", "take"], function(a, u) {
        Yn.prototype[a] = function(h) {
          h = h === t ? 1 : xe(Un(h), 0);
          var y = this.__filtered__ && !u ? new Yn(this) : this.clone();
          return y.__filtered__ ? y.__takeCount__ = Le(h, y.__takeCount__) : y.__views__.push({
            size: Le(h, q),
            type: a + (y.__dir__ < 0 ? "Right" : "")
          }), y;
        }, Yn.prototype[a + "Right"] = function(h) {
          return this.reverse()[a](h).reverse();
        };
      }), At(["filter", "map", "takeWhile"], function(a, u) {
        var h = u + 1, y = h == P || h == O;
        Yn.prototype[a] = function(M) {
          var N = this.clone();
          return N.__iteratees__.push({
            iteratee: $n(M, 3),
            type: h
          }), N.__filtered__ = N.__filtered__ || y, N;
        };
      }), At(["head", "last"], function(a, u) {
        var h = "take" + (u ? "Right" : "");
        Yn.prototype[a] = function() {
          return this[h](1).value()[0];
        };
      }), At(["initial", "tail"], function(a, u) {
        var h = "drop" + (u ? "" : "Right");
        Yn.prototype[a] = function() {
          return this.__filtered__ ? new Yn(this) : this[h](1);
        };
      }), Yn.prototype.compact = function() {
        return this.filter(st);
      }, Yn.prototype.find = function(a) {
        return this.filter(a).head();
      }, Yn.prototype.findLast = function(a) {
        return this.reverse().find(a);
      }, Yn.prototype.invokeMap = qn(function(a, u) {
        return typeof a == "function" ? new Yn(this) : this.map(function(h) {
          return _o(h, a, u);
        });
      }), Yn.prototype.reject = function(a) {
        return this.filter(bf($n(a)));
      }, Yn.prototype.slice = function(a, u) {
        a = Un(a);
        var h = this;
        return h.__filtered__ && (a > 0 || u < 0) ? new Yn(h) : (a < 0 ? h = h.takeRight(-a) : a && (h = h.drop(a)), u !== t && (u = Un(u), h = u < 0 ? h.dropRight(-u) : h.take(u - a)), h);
      }, Yn.prototype.takeRightWhile = function(a) {
        return this.reverse().takeWhile(a).reverse();
      }, Yn.prototype.toArray = function() {
        return this.take(q);
      }, er(Yn.prototype, function(a, u) {
        var h = /^(?:filter|find|map|reject)|While$/.test(u), y = /^(?:head|last)$/.test(u), M = C[y ? "take" + (u == "last" ? "Right" : "") : u], N = y || /^find/.test(u);
        M && (C.prototype[u] = function() {
          var D = this.__wrapped__, G = y ? [1] : arguments, Y = D instanceof Yn, rn = G[0], on = Y || Bn(D), un = function(Hn) {
            var Kn = M.apply(C, Ur([Hn], G));
            return y && yn ? Kn[0] : Kn;
          };
          on && h && typeof rn == "function" && rn.length != 1 && (Y = on = !1);
          var yn = this.__chain__, Mn = !!this.__actions__.length, kn = N && !yn, Gn = Y && !Mn;
          if (!N && on) {
            D = Gn ? D : new Yn(this);
            var On = a.apply(D, G);
            return On.__actions__.push({ func: vf, args: [un], thisArg: t }), new St(On, yn);
          }
          return kn && Gn ? a.apply(this, G) : (On = this.thru(un), kn ? y ? On.value()[0] : On.value() : On);
        });
      }), At(["pop", "push", "shift", "sort", "splice", "unshift"], function(a) {
        var u = Vu[a], h = /^(?:push|sort|unshift)$/.test(a) ? "tap" : "thru", y = /^(?:pop|shift)$/.test(a);
        C.prototype[a] = function() {
          var M = arguments;
          if (y && !this.__chain__) {
            var N = this.value();
            return u.apply(Bn(N) ? N : [], M);
          }
          return this[h](function(D) {
            return u.apply(Bn(D) ? D : [], M);
          });
        };
      }), er(Yn.prototype, function(a, u) {
        var h = C[u];
        if (h) {
          var y = h.name + "";
          ne.call(sa, y) || (sa[y] = []), sa[y].push({ name: u, func: h });
        }
      }), sa[sf(t, _).name] = [{
        name: "wrapper",
        func: t
      }], Yn.prototype.clone = G5, Yn.prototype.reverse = q5, Yn.prototype.value = W5, C.prototype.at = b4, C.prototype.chain = w4, C.prototype.commit = x4, C.prototype.next = T4, C.prototype.plant = M4, C.prototype.reverse = S4, C.prototype.toJSON = C.prototype.valueOf = C.prototype.value = E4, C.prototype.first = C.prototype.head, co && (C.prototype[co] = A4), C;
    }, oa = x5();
    gi ? ((gi.exports = oa)._ = oa, ac._ = oa) : $e._ = oa;
  }).call(Dn);
})(us, us.exports);
var fs = us.exports;
const zT = /* @__PURE__ */ Br(fs), VT = /* @__PURE__ */ Dt({
  __proto__: null,
  default: zT
}, [fs]), ol = RT({}), UT = "https://www.zillow.com/zg-graph", GT = "zrs-traffic", qT = "https://mortgageapi.zillow.com/getAnnualPropertyTaxRate", WT = "RD-WXDQSGN", HT = async ({ zgGraphUrl: n, callerId: e = "qa", input: t }) => await (await fetch(n, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "x-caller-id": e
  },
  body: JSON.stringify({
    query: `
            query autocomplete($query: String!) {
                zgsAutocompleteRequest(query: $query, resultType: COUNTIES) {
                    results {
                        ... on SearchAssistanceRegionResult {
                                    id
                                    regionId   
                                }
                    }    
                }
            }
        `,
    variables: {
      query: t
    }
  })
})).json(), YT = async ({ mortgageUrl: n, mortgagePartnerId: e, input: t }) => await (await fetch(`${n}?partnerId=${e}&countyRegionId=${t}`)).json();
var _u = (n) => n.type === "checkbox", Pa = (n) => n instanceof Date, Ke = (n) => n == null;
const a2 = (n) => typeof n == "object";
var Me = (n) => !Ke(n) && !Array.isArray(n) && a2(n) && !Pa(n), XT = (n) => Me(n) && n.target ? _u(n.target) ? n.target.checked : n.target.value : n, KT = (n) => n.substring(0, n.search(/\.\d+(\.|$)/)) || n, ZT = (n, e) => n.has(KT(e)), JT = (n) => {
  const e = n.constructor && n.constructor.prototype;
  return Me(e) && e.hasOwnProperty("isPrototypeOf");
}, rd = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Rr(n) {
  let e;
  const t = Array.isArray(n);
  if (n instanceof Date)
    e = new Date(n);
  else if (n instanceof Set)
    e = new Set(n);
  else if (!(rd && (n instanceof Blob || n instanceof FileList)) && (t || Me(n)))
    if (e = t ? [] : {}, !t && !JT(n))
      e = n;
    else
      for (const r in n)
        n.hasOwnProperty(r) && (e[r] = Rr(n[r]));
  else
    return n;
  return e;
}
var bu = (n) => Array.isArray(n) ? n.filter(Boolean) : [], _e = (n) => n === void 0, Cn = (n, e, t) => {
  if (!e || !Me(n))
    return t;
  const r = bu(e.split(/[,[\].]+?/)).reduce((i, o) => Ke(i) ? i : i[o], n);
  return _e(r) || r === n ? _e(n[e]) ? t : n[e] : r;
}, Qr = (n) => typeof n == "boolean";
const pv = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, qt = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Mr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, o2 = sn.createContext(null), id = () => sn.useContext(o2), QT = (n) => {
  const { children: e, ...t } = n;
  return sn.createElement(o2.Provider, { value: t }, e);
};
var u2 = (n, e, t, r = !0) => {
  const i = {
    defaultValues: e._defaultValues
  };
  for (const o in n)
    Object.defineProperty(i, o, {
      get: () => {
        const f = o;
        return e._proxyFormState[f] !== qt.all && (e._proxyFormState[f] = !r || qt.all), t && (t[f] = !0), n[f];
      }
    });
  return i;
}, kt = (n) => Me(n) && !Object.keys(n).length, f2 = (n, e, t, r) => {
  t(n);
  const { name: i, ...o } = n;
  return kt(o) || Object.keys(o).length >= Object.keys(e).length || Object.keys(o).find((f) => e[f] === (!r || qt.all));
}, Hf = (n) => Array.isArray(n) ? n : [n], jT = (n, e, t) => !n || !e || n === e || Hf(n).some((r) => r && (t ? r === e : r.startsWith(e) || e.startsWith(r)));
function s2(n) {
  const e = sn.useRef(n);
  e.current = n, sn.useEffect(() => {
    const t = !n.disabled && e.current.subject && e.current.subject.subscribe({
      next: e.current.next
    });
    return () => {
      t && t.unsubscribe();
    };
  }, [n.disabled]);
}
function nA(n) {
  const e = id(), { control: t = e.control, disabled: r, name: i, exact: o } = n || {}, [f, s] = sn.useState(t._formState), l = sn.useRef(!0), c = sn.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), p = sn.useRef(i);
  return p.current = i, s2({
    disabled: r,
    next: (g) => l.current && jT(p.current, g.name, o) && f2(g, c.current, t._updateFormState) && s({
      ...t._formState,
      ...g
    }),
    subject: t._subjects.state
  }), sn.useEffect(() => (l.current = !0, c.current.isValid && t._updateValid(!0), () => {
    l.current = !1;
  }), [t]), u2(f, t, c.current, !1);
}
var or = (n) => typeof n == "string", eA = (n, e, t, r, i) => or(n) ? (r && e.watch.add(n), Cn(t, n, i)) : Array.isArray(n) ? n.map((o) => (r && e.watch.add(o), Cn(t, o))) : (r && (e.watchAll = !0), t), ad = (n) => /^\w*$/.test(n), l2 = (n) => bu(n.replace(/["|']|\]/g, "").split(/\.|\[/));
function se(n, e, t) {
  let r = -1;
  const i = ad(e) ? [e] : l2(e), o = i.length, f = o - 1;
  for (; ++r < o; ) {
    const s = i[r];
    let l = t;
    if (r !== f) {
      const c = n[s];
      l = Me(c) || Array.isArray(c) ? c : isNaN(+i[r + 1]) ? {} : [];
    }
    n[s] = l, n = n[s];
  }
  return n;
}
var tA = (n, e, t, r, i) => e ? {
  ...t[n],
  types: {
    ...t[n] && t[n].types ? t[n].types : {},
    [r]: i || !0
  }
} : {}, gv = (n) => ({
  isOnSubmit: !n || n === qt.onSubmit,
  isOnBlur: n === qt.onBlur,
  isOnChange: n === qt.onChange,
  isOnAll: n === qt.all,
  isOnTouch: n === qt.onTouched
}), vv = (n, e, t) => !t && (e.watchAll || e.watch.has(n) || [...e.watch].some((r) => n.startsWith(r) && /^\.\w+/.test(n.slice(r.length))));
const Yf = (n, e, t, r) => {
  for (const i of t || Object.keys(n)) {
    const o = Cn(n, i);
    if (o) {
      const { _f: f, ...s } = o;
      if (f) {
        if (f.refs && f.refs[0] && e(f.refs[0], i) && !r)
          break;
        if (f.ref && e(f.ref, f.name) && !r)
          break;
      } else
        Me(s) && Yf(s, e);
    }
  }
};
var rA = (n, e, t) => {
  const r = bu(Cn(n, t));
  return se(r, "root", e[t]), se(n, t, r), n;
}, od = (n) => n.type === "file", ei = (n) => typeof n == "function", ss = (n) => {
  if (!rd)
    return !1;
  const e = n ? n.ownerDocument : 0;
  return n instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, Xf = (n) => or(n), ud = (n) => n.type === "radio", ls = (n) => n instanceof RegExp;
const mv = {
  value: !1,
  isValid: !1
}, yv = { value: !0, isValid: !0 };
var c2 = (n) => {
  if (Array.isArray(n)) {
    if (n.length > 1) {
      const e = n.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: e, isValid: !!e.length };
    }
    return n[0].checked && !n[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      n[0].attributes && !_e(n[0].attributes.value) ? _e(n[0].value) || n[0].value === "" ? yv : { value: n[0].value, isValid: !0 } : yv
    ) : mv;
  }
  return mv;
};
const _v = {
  isValid: !1,
  value: null
};
var h2 = (n) => Array.isArray(n) ? n.reduce((e, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : e, _v) : _v;
function bv(n, e, t = "validate") {
  if (Xf(n) || Array.isArray(n) && n.every(Xf) || Qr(n) && !n)
    return {
      type: t,
      message: Xf(n) ? n : "",
      ref: e
    };
}
var ma = (n) => Me(n) && !ls(n) ? n : {
  value: n,
  message: ""
}, wv = async (n, e, t, r, i) => {
  const { ref: o, refs: f, required: s, maxLength: l, minLength: c, min: p, max: g, pattern: d, validate: v, name: b, valueAsNumber: w, mount: m, disabled: _ } = n._f, x = Cn(e, b);
  if (!m || _)
    return {};
  const A = f ? f[0] : o, T = (L) => {
    r && A.reportValidity && (A.setCustomValidity(Qr(L) ? "" : L || ""), A.reportValidity());
  }, S = {}, R = ud(o), I = _u(o), B = R || I, F = (w || od(o)) && _e(o.value) && _e(x) || ss(o) && o.value === "" || x === "" || Array.isArray(x) && !x.length, V = tA.bind(null, b, t, S), E = (L, $, P, k = Mr.maxLength, O = Mr.minLength) => {
    const W = L ? $ : P;
    S[b] = {
      type: L ? k : O,
      message: W,
      ref: o,
      ...V(L ? k : O, W)
    };
  };
  if (i ? !Array.isArray(x) || !x.length : s && (!B && (F || Ke(x)) || Qr(x) && !x || I && !c2(f).isValid || R && !h2(f).isValid)) {
    const { value: L, message: $ } = Xf(s) ? { value: !!s, message: s } : ma(s);
    if (L && (S[b] = {
      type: Mr.required,
      message: $,
      ref: A,
      ...V(Mr.required, $)
    }, !t))
      return T($), S;
  }
  if (!F && (!Ke(p) || !Ke(g))) {
    let L, $;
    const P = ma(g), k = ma(p);
    if (!Ke(x) && !isNaN(x)) {
      const O = o.valueAsNumber || x && +x;
      Ke(P.value) || (L = O > P.value), Ke(k.value) || ($ = O < k.value);
    } else {
      const O = o.valueAsDate || new Date(x), W = (z) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + z), K = o.type == "time", Q = o.type == "week";
      or(P.value) && x && (L = K ? W(x) > W(P.value) : Q ? x > P.value : O > new Date(P.value)), or(k.value) && x && ($ = K ? W(x) < W(k.value) : Q ? x < k.value : O < new Date(k.value));
    }
    if ((L || $) && (E(!!L, P.message, k.message, Mr.max, Mr.min), !t))
      return T(S[b].message), S;
  }
  if ((l || c) && !F && (or(x) || i && Array.isArray(x))) {
    const L = ma(l), $ = ma(c), P = !Ke(L.value) && x.length > +L.value, k = !Ke($.value) && x.length < +$.value;
    if ((P || k) && (E(P, L.message, $.message), !t))
      return T(S[b].message), S;
  }
  if (d && !F && or(x)) {
    const { value: L, message: $ } = ma(d);
    if (ls(L) && !x.match(L) && (S[b] = {
      type: Mr.pattern,
      message: $,
      ref: o,
      ...V(Mr.pattern, $)
    }, !t))
      return T($), S;
  }
  if (v) {
    if (ei(v)) {
      const L = await v(x, e), $ = bv(L, A);
      if ($ && (S[b] = {
        ...$,
        ...V(Mr.validate, $.message)
      }, !t))
        return T($.message), S;
    } else if (Me(v)) {
      let L = {};
      for (const $ in v) {
        if (!kt(L) && !t)
          break;
        const P = bv(await v[$](x, e), A, $);
        P && (L = {
          ...P,
          ...V($, P.message)
        }, T(P.message), t && (S[b] = L));
      }
      if (!kt(L) && (S[b] = {
        ref: A,
        ...L
      }, !t))
        return S;
    }
  }
  return T(!0), S;
};
function iA(n, e) {
  const t = e.slice(0, -1).length;
  let r = 0;
  for (; r < t; )
    n = _e(n) ? r++ : n[e[r++]];
  return n;
}
function aA(n) {
  for (const e in n)
    if (n.hasOwnProperty(e) && !_e(n[e]))
      return !1;
  return !0;
}
function Oe(n, e) {
  const t = Array.isArray(e) ? e : ad(e) ? [e] : l2(e), r = t.length === 1 ? n : iA(n, t), i = t.length - 1, o = t[i];
  return r && delete r[o], i !== 0 && (Me(r) && kt(r) || Array.isArray(r) && aA(r)) && Oe(n, t.slice(0, -1)), n;
}
function lh() {
  let n = [];
  return {
    get observers() {
      return n;
    },
    next: (i) => {
      for (const o of n)
        o.next && o.next(i);
    },
    subscribe: (i) => (n.push(i), {
      unsubscribe: () => {
        n = n.filter((o) => o !== i);
      }
    }),
    unsubscribe: () => {
      n = [];
    }
  };
}
var cs = (n) => Ke(n) || !a2(n);
function Ri(n, e) {
  if (cs(n) || cs(e))
    return n === e;
  if (Pa(n) && Pa(e))
    return n.getTime() === e.getTime();
  const t = Object.keys(n), r = Object.keys(e);
  if (t.length !== r.length)
    return !1;
  for (const i of t) {
    const o = n[i];
    if (!r.includes(i))
      return !1;
    if (i !== "ref") {
      const f = e[i];
      if (Pa(o) && Pa(f) || Me(o) && Me(f) || Array.isArray(o) && Array.isArray(f) ? !Ri(o, f) : o !== f)
        return !1;
    }
  }
  return !0;
}
var d2 = (n) => n.type === "select-multiple", oA = (n) => ud(n) || _u(n), ch = (n) => ss(n) && n.isConnected, p2 = (n) => {
  for (const e in n)
    if (ei(n[e]))
      return !0;
  return !1;
};
function hs(n, e = {}) {
  const t = Array.isArray(n);
  if (Me(n) || t)
    for (const r in n)
      Array.isArray(n[r]) || Me(n[r]) && !p2(n[r]) ? (e[r] = Array.isArray(n[r]) ? [] : {}, hs(n[r], e[r])) : Ke(n[r]) || (e[r] = !0);
  return e;
}
function g2(n, e, t) {
  const r = Array.isArray(n);
  if (Me(n) || r)
    for (const i in n)
      Array.isArray(n[i]) || Me(n[i]) && !p2(n[i]) ? _e(e) || cs(t[i]) ? t[i] = Array.isArray(n[i]) ? hs(n[i], []) : { ...hs(n[i]) } : g2(n[i], Ke(e) ? {} : e[i], t[i]) : t[i] = !Ri(n[i], e[i]);
  return t;
}
var hh = (n, e) => g2(n, e, hs(e)), v2 = (n, { valueAsNumber: e, valueAsDate: t, setValueAs: r }) => _e(n) ? n : e ? n === "" ? NaN : n && +n : t && or(n) ? new Date(n) : r ? r(n) : n;
function dh(n) {
  const e = n.ref;
  if (!(n.refs ? n.refs.every((t) => t.disabled) : e.disabled))
    return od(e) ? e.files : ud(e) ? h2(n.refs).value : d2(e) ? [...e.selectedOptions].map(({ value: t }) => t) : _u(e) ? c2(n.refs).value : v2(_e(e.value) ? n.ref.value : e.value, n);
}
var uA = (n, e, t, r) => {
  const i = {};
  for (const o of n) {
    const f = Cn(e, o);
    f && se(i, o, f._f);
  }
  return {
    criteriaMode: t,
    names: [...n],
    fields: i,
    shouldUseNativeValidation: r
  };
}, So = (n) => _e(n) ? n : ls(n) ? n.source : Me(n) ? ls(n.value) ? n.value.source : n.value : n, fA = (n) => n.mount && (n.required || n.min || n.max || n.maxLength || n.minLength || n.pattern || n.validate);
function xv(n, e, t) {
  const r = Cn(n, t);
  if (r || ad(t))
    return {
      error: r,
      name: t
    };
  const i = t.split(".");
  for (; i.length; ) {
    const o = i.join("."), f = Cn(e, o), s = Cn(n, o);
    if (f && !Array.isArray(f) && t !== o)
      return { name: t };
    if (s && s.type)
      return {
        name: o,
        error: s
      };
    i.pop();
  }
  return {
    name: t
  };
}
var sA = (n, e, t, r, i) => i.isOnAll ? !1 : !t && i.isOnTouch ? !(e || n) : (t ? r.isOnBlur : i.isOnBlur) ? !n : (t ? r.isOnChange : i.isOnChange) ? n : !0, lA = (n, e) => !bu(Cn(n, e)).length && Oe(n, e);
const cA = {
  mode: qt.onSubmit,
  reValidateMode: qt.onChange,
  shouldFocusError: !0
};
function hA(n = {}, e) {
  let t = {
    ...cA,
    ...n
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: ei(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    errors: {},
    disabled: !1
  }, i = {}, o = Me(t.defaultValues) || Me(t.values) ? Rr(t.defaultValues || t.values) || {} : {}, f = t.shouldUnregister ? {} : Rr(o), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, p = 0;
  const g = {
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, d = {
    values: lh(),
    array: lh(),
    state: lh()
  }, v = n.resetOptions && n.resetOptions.keepDirtyValues, b = gv(t.mode), w = gv(t.reValidateMode), m = t.criteriaMode === qt.all, _ = (U) => (X) => {
    clearTimeout(p), p = setTimeout(U, X);
  }, x = async (U) => {
    if (g.isValid || U) {
      const X = t.resolver ? kt((await F()).errors) : await E(i, !0);
      X !== r.isValid && d.state.next({
        isValid: X
      });
    }
  }, A = (U) => g.isValidating && d.state.next({
    isValidating: U
  }), T = (U, X = [], j, mn, dn = !0, cn = !0) => {
    if (mn && j) {
      if (s.action = !0, cn && Array.isArray(Cn(i, U))) {
        const An = j(Cn(i, U), mn.argA, mn.argB);
        dn && se(i, U, An);
      }
      if (cn && Array.isArray(Cn(r.errors, U))) {
        const An = j(Cn(r.errors, U), mn.argA, mn.argB);
        dn && se(r.errors, U, An), lA(r.errors, U);
      }
      if (g.touchedFields && cn && Array.isArray(Cn(r.touchedFields, U))) {
        const An = j(Cn(r.touchedFields, U), mn.argA, mn.argB);
        dn && se(r.touchedFields, U, An);
      }
      g.dirtyFields && (r.dirtyFields = hh(o, f)), d.state.next({
        name: U,
        isDirty: $(U, X),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      se(f, U, X);
  }, S = (U, X) => {
    se(r.errors, U, X), d.state.next({
      errors: r.errors
    });
  }, R = (U, X, j, mn) => {
    const dn = Cn(i, U);
    if (dn) {
      const cn = Cn(f, U, _e(j) ? Cn(o, U) : j);
      _e(cn) || mn && mn.defaultChecked || X ? se(f, U, X ? cn : dh(dn._f)) : O(U, cn), s.mount && x();
    }
  }, I = (U, X, j, mn, dn) => {
    let cn = !1, An = !1;
    const Zn = {
      name: U
    };
    if (!j || mn) {
      g.isDirty && (An = r.isDirty, r.isDirty = Zn.isDirty = $(), cn = An !== Zn.isDirty);
      const ie = Ri(Cn(o, U), X);
      An = Cn(r.dirtyFields, U), ie ? Oe(r.dirtyFields, U) : se(r.dirtyFields, U, !0), Zn.dirtyFields = r.dirtyFields, cn = cn || g.dirtyFields && An !== !ie;
    }
    if (j) {
      const ie = Cn(r.touchedFields, U);
      ie || (se(r.touchedFields, U, j), Zn.touchedFields = r.touchedFields, cn = cn || g.touchedFields && ie !== j);
    }
    return cn && dn && d.state.next(Zn), cn ? Zn : {};
  }, B = (U, X, j, mn) => {
    const dn = Cn(r.errors, U), cn = g.isValid && Qr(X) && r.isValid !== X;
    if (n.delayError && j ? (c = _(() => S(U, j)), c(n.delayError)) : (clearTimeout(p), c = null, j ? se(r.errors, U, j) : Oe(r.errors, U)), (j ? !Ri(dn, j) : dn) || !kt(mn) || cn) {
      const An = {
        ...mn,
        ...cn && Qr(X) ? { isValid: X } : {},
        errors: r.errors,
        name: U
      };
      r = {
        ...r,
        ...An
      }, d.state.next(An);
    }
    A(!1);
  }, F = async (U) => t.resolver(f, t.context, uA(U || l.mount, i, t.criteriaMode, t.shouldUseNativeValidation)), V = async (U) => {
    const { errors: X } = await F(U);
    if (U)
      for (const j of U) {
        const mn = Cn(X, j);
        mn ? se(r.errors, j, mn) : Oe(r.errors, j);
      }
    else
      r.errors = X;
    return X;
  }, E = async (U, X, j = {
    valid: !0
  }) => {
    for (const mn in U) {
      const dn = U[mn];
      if (dn) {
        const { _f: cn, ...An } = dn;
        if (cn) {
          const Zn = l.array.has(cn.name), ie = await wv(dn, f, m, t.shouldUseNativeValidation && !X, Zn);
          if (ie[cn.name] && (j.valid = !1, X))
            break;
          !X && (Cn(ie, cn.name) ? Zn ? rA(r.errors, ie, cn.name) : se(r.errors, cn.name, ie[cn.name]) : Oe(r.errors, cn.name));
        }
        An && await E(An, X, j);
      }
    }
    return j.valid;
  }, L = () => {
    for (const U of l.unMount) {
      const X = Cn(i, U);
      X && (X._f.refs ? X._f.refs.every((j) => !ch(j)) : !ch(X._f.ref)) && gn(U);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, $ = (U, X) => (U && X && se(f, U, X), !Ri(J(), o)), P = (U, X, j) => eA(U, l, {
    ...s.mount ? f : _e(X) ? o : or(U) ? { [U]: X } : X
  }, j, X), k = (U) => bu(Cn(s.mount ? f : o, U, n.shouldUnregister ? Cn(o, U, []) : [])), O = (U, X, j = {}) => {
    const mn = Cn(i, U);
    let dn = X;
    if (mn) {
      const cn = mn._f;
      cn && (!cn.disabled && se(f, U, v2(X, cn)), dn = ss(cn.ref) && Ke(X) ? "" : X, d2(cn.ref) ? [...cn.ref.options].forEach((An) => An.selected = dn.includes(An.value)) : cn.refs ? _u(cn.ref) ? cn.refs.length > 1 ? cn.refs.forEach((An) => (!An.defaultChecked || !An.disabled) && (An.checked = Array.isArray(dn) ? !!dn.find((Zn) => Zn === An.value) : dn === An.value)) : cn.refs[0] && (cn.refs[0].checked = !!dn) : cn.refs.forEach((An) => An.checked = An.value === dn) : od(cn.ref) ? cn.ref.value = "" : (cn.ref.value = dn, cn.ref.type || d.values.next({
        name: U,
        values: { ...f }
      })));
    }
    (j.shouldDirty || j.shouldTouch) && I(U, dn, j.shouldTouch, j.shouldDirty, !0), j.shouldValidate && q(U);
  }, W = (U, X, j) => {
    for (const mn in X) {
      const dn = X[mn], cn = `${U}.${mn}`, An = Cn(i, cn);
      (l.array.has(U) || !cs(dn) || An && !An._f) && !Pa(dn) ? W(cn, dn, j) : O(cn, dn, j);
    }
  }, K = (U, X, j = {}) => {
    const mn = Cn(i, U), dn = l.array.has(U), cn = Rr(X);
    se(f, U, cn), dn ? (d.array.next({
      name: U,
      values: { ...f }
    }), (g.isDirty || g.dirtyFields) && j.shouldDirty && d.state.next({
      name: U,
      dirtyFields: hh(o, f),
      isDirty: $(U, cn)
    })) : mn && !mn._f && !Ke(cn) ? W(U, cn, j) : O(U, cn, j), vv(U, l) && d.state.next({ ...r }), d.values.next({
      name: U,
      values: { ...f }
    }), !s.mount && e();
  }, Q = async (U) => {
    const X = U.target;
    let j = X.name, mn = !0;
    const dn = Cn(i, j), cn = () => X.type ? dh(dn._f) : XT(U), An = (Zn) => {
      mn = Number.isNaN(Zn) || Zn === Cn(f, j, Zn);
    };
    if (dn) {
      let Zn, ie;
      const Bt = cn(), nr = U.type === pv.BLUR || U.type === pv.FOCUS_OUT, uo = !fA(dn._f) && !t.resolver && !Cn(r.errors, j) && !dn._f.deps || sA(nr, Cn(r.touchedFields, j), r.isSubmitted, w, b), di = vv(j, l, nr);
      se(f, j, Bt), nr ? (dn._f.onBlur && dn._f.onBlur(U), c && c(0)) : dn._f.onChange && dn._f.onChange(U);
      const pi = I(j, Bt, nr, !1), fo = !kt(pi) || di;
      if (!nr && d.values.next({
        name: j,
        type: U.type,
        values: { ...f }
      }), uo)
        return g.isValid && x(), fo && d.state.next({ name: j, ...di ? {} : pi });
      if (!nr && di && d.state.next({ ...r }), A(!0), t.resolver) {
        const { errors: na } = await F([j]);
        if (An(Bt), mn) {
          const so = xv(r.errors, i, j), ea = xv(na, i, so.name || j);
          Zn = ea.error, j = ea.name, ie = kt(na);
        }
      } else
        Zn = (await wv(dn, f, m, t.shouldUseNativeValidation))[j], An(Bt), mn && (Zn ? ie = !1 : g.isValid && (ie = await E(i, !0)));
      mn && (dn._f.deps && q(dn._f.deps), B(j, ie, Zn, pi));
    }
  }, z = (U, X) => {
    if (Cn(r.errors, X) && U.focus)
      return U.focus(), 1;
  }, q = async (U, X = {}) => {
    let j, mn;
    const dn = Hf(U);
    if (A(!0), t.resolver) {
      const cn = await V(_e(U) ? U : dn);
      j = kt(cn), mn = U ? !dn.some((An) => Cn(cn, An)) : j;
    } else
      U ? (mn = (await Promise.all(dn.map(async (cn) => {
        const An = Cn(i, cn);
        return await E(An && An._f ? { [cn]: An } : An);
      }))).every(Boolean), !(!mn && !r.isValid) && x()) : mn = j = await E(i);
    return d.state.next({
      ...!or(U) || g.isValid && j !== r.isValid ? {} : { name: U },
      ...t.resolver || !U ? { isValid: j } : {},
      errors: r.errors,
      isValidating: !1
    }), X.shouldFocus && !mn && Yf(i, z, U ? dn : l.mount), mn;
  }, J = (U) => {
    const X = {
      ...o,
      ...s.mount ? f : {}
    };
    return _e(U) ? X : or(U) ? Cn(X, U) : U.map((j) => Cn(X, j));
  }, en = (U, X) => ({
    invalid: !!Cn((X || r).errors, U),
    isDirty: !!Cn((X || r).dirtyFields, U),
    isTouched: !!Cn((X || r).touchedFields, U),
    error: Cn((X || r).errors, U)
  }), fn = (U) => {
    U && Hf(U).forEach((X) => Oe(r.errors, X)), d.state.next({
      errors: U ? r.errors : {}
    });
  }, ln = (U, X, j) => {
    const mn = (Cn(i, U, { _f: {} })._f || {}).ref;
    se(r.errors, U, {
      ...X,
      ref: mn
    }), d.state.next({
      name: U,
      errors: r.errors,
      isValid: !1
    }), j && j.shouldFocus && mn && mn.focus && mn.focus();
  }, Tn = (U, X) => ei(U) ? d.values.subscribe({
    next: (j) => U(P(void 0, X), j)
  }) : P(U, X, !0), gn = (U, X = {}) => {
    for (const j of U ? Hf(U) : l.mount)
      l.mount.delete(j), l.array.delete(j), X.keepValue || (Oe(i, j), Oe(f, j)), !X.keepError && Oe(r.errors, j), !X.keepDirty && Oe(r.dirtyFields, j), !X.keepTouched && Oe(r.touchedFields, j), !t.shouldUnregister && !X.keepDefaultValue && Oe(o, j);
    d.values.next({
      values: { ...f }
    }), d.state.next({
      ...r,
      ...X.keepDirty ? { isDirty: $() } : {}
    }), !X.keepIsValid && x();
  }, _n = ({ disabled: U, name: X, field: j, fields: mn, value: dn }) => {
    if (Qr(U)) {
      const cn = U ? void 0 : _e(dn) ? dh(j ? j._f : Cn(mn, X)._f) : dn;
      se(f, X, cn), I(X, cn, !1, !1, !0);
    }
  }, tn = (U, X = {}) => {
    let j = Cn(i, U);
    const mn = Qr(X.disabled);
    return se(i, U, {
      ...j || {},
      _f: {
        ...j && j._f ? j._f : { ref: { name: U } },
        name: U,
        mount: !0,
        ...X
      }
    }), l.mount.add(U), j ? _n({
      field: j,
      disabled: X.disabled,
      name: U
    }) : R(U, !0, X.value), {
      ...mn ? { disabled: X.disabled } : {},
      ...t.progressive ? {
        required: !!X.required,
        min: So(X.min),
        max: So(X.max),
        minLength: So(X.minLength),
        maxLength: So(X.maxLength),
        pattern: So(X.pattern)
      } : {},
      name: U,
      onChange: Q,
      onBlur: Q,
      ref: (dn) => {
        if (dn) {
          tn(U, X), j = Cn(i, U);
          const cn = _e(dn.value) && dn.querySelectorAll && dn.querySelectorAll("input,select,textarea")[0] || dn, An = oA(cn), Zn = j._f.refs || [];
          if (An ? Zn.find((ie) => ie === cn) : cn === j._f.ref)
            return;
          se(i, U, {
            _f: {
              ...j._f,
              ...An ? {
                refs: [
                  ...Zn.filter(ch),
                  cn,
                  ...Array.isArray(Cn(o, U)) ? [{}] : []
                ],
                ref: { type: cn.type, name: U }
              } : { ref: cn }
            }
          }), R(U, !1, void 0, cn);
        } else
          j = Cn(i, U, {}), j._f && (j._f.mount = !1), (t.shouldUnregister || X.shouldUnregister) && !(ZT(l.array, U) && s.action) && l.unMount.add(U);
      }
    };
  }, hn = () => t.shouldFocusError && Yf(i, z, l.mount), vn = (U) => {
    Qr(U) && (d.state.next({ disabled: U }), Yf(i, (X) => {
      X.disabled = U;
    }, 0, !1));
  }, an = (U, X) => async (j) => {
    j && (j.preventDefault && j.preventDefault(), j.persist && j.persist());
    let mn = Rr(f);
    if (d.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: dn, values: cn } = await F();
      r.errors = dn, mn = cn;
    } else
      await E(i);
    Oe(r.errors, "root"), kt(r.errors) ? (d.state.next({
      errors: {}
    }), await U(mn, j)) : (X && await X({ ...r.errors }, j), hn(), setTimeout(hn)), d.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: kt(r.errors),
      submitCount: r.submitCount + 1,
      errors: r.errors
    });
  }, xn = (U, X = {}) => {
    Cn(i, U) && (_e(X.defaultValue) ? K(U, Cn(o, U)) : (K(U, X.defaultValue), se(o, U, X.defaultValue)), X.keepTouched || Oe(r.touchedFields, U), X.keepDirty || (Oe(r.dirtyFields, U), r.isDirty = X.defaultValue ? $(U, Cn(o, U)) : $()), X.keepError || (Oe(r.errors, U), g.isValid && x()), d.state.next({ ...r }));
  }, En = (U, X = {}) => {
    const j = U ? Rr(U) : o, mn = Rr(j), dn = U && !kt(U) ? mn : o;
    if (X.keepDefaultValues || (o = j), !X.keepValues) {
      if (X.keepDirtyValues || v)
        for (const cn of l.mount)
          Cn(r.dirtyFields, cn) ? se(dn, cn, Cn(f, cn)) : K(cn, Cn(dn, cn));
      else {
        if (rd && _e(U))
          for (const cn of l.mount) {
            const An = Cn(i, cn);
            if (An && An._f) {
              const Zn = Array.isArray(An._f.refs) ? An._f.refs[0] : An._f.ref;
              if (ss(Zn)) {
                const ie = Zn.closest("form");
                if (ie) {
                  ie.reset();
                  break;
                }
              }
            }
          }
        i = {};
      }
      f = n.shouldUnregister ? X.keepDefaultValues ? Rr(o) : {} : Rr(dn), d.array.next({
        values: { ...dn }
      }), d.values.next({
        values: { ...dn }
      });
    }
    l = {
      mount: /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, !s.mount && e(), s.mount = !g.isValid || !!X.keepIsValid, s.watch = !!n.shouldUnregister, d.state.next({
      submitCount: X.keepSubmitCount ? r.submitCount : 0,
      isDirty: X.keepDirty ? r.isDirty : !!(X.keepDefaultValues && !Ri(U, o)),
      isSubmitted: X.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: X.keepDirtyValues ? r.dirtyFields : X.keepDefaultValues && U ? hh(o, U) : {},
      touchedFields: X.keepTouched ? r.touchedFields : {},
      errors: X.keepErrors ? r.errors : {},
      isSubmitSuccessful: X.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, In = (U, X) => En(ei(U) ? U(f) : U, X);
  return {
    control: {
      register: tn,
      unregister: gn,
      getFieldState: en,
      handleSubmit: an,
      setError: ln,
      _executeSchema: F,
      _getWatch: P,
      _getDirty: $,
      _updateValid: x,
      _removeUnmounted: L,
      _updateFieldArray: T,
      _updateDisabledField: _n,
      _getFieldArray: k,
      _reset: En,
      _resetDefaultValues: () => ei(t.defaultValues) && t.defaultValues().then((U) => {
        In(U, t.resetOptions), d.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (U) => {
        r = {
          ...r,
          ...U
        };
      },
      _disableForm: vn,
      _subjects: d,
      _proxyFormState: g,
      get _fields() {
        return i;
      },
      get _formValues() {
        return f;
      },
      get _state() {
        return s;
      },
      set _state(U) {
        s = U;
      },
      get _defaultValues() {
        return o;
      },
      get _names() {
        return l;
      },
      set _names(U) {
        l = U;
      },
      get _formState() {
        return r;
      },
      set _formState(U) {
        r = U;
      },
      get _options() {
        return t;
      },
      set _options(U) {
        t = {
          ...t,
          ...U
        };
      }
    },
    trigger: q,
    register: tn,
    handleSubmit: an,
    watch: Tn,
    setValue: K,
    getValues: J,
    reset: In,
    resetField: xn,
    clearErrors: fn,
    unregister: gn,
    setError: ln,
    setFocus: (U, X = {}) => {
      const j = Cn(i, U), mn = j && j._f;
      if (mn) {
        const dn = mn.refs ? mn.refs[0] : mn.ref;
        dn.focus && (dn.focus(), X.shouldSelect && dn.select());
      }
    },
    getFieldState: en
  };
}
function dA(n = {}) {
  const e = sn.useRef(), t = sn.useRef(), [r, i] = sn.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: ei(n.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: {},
    disabled: !1,
    defaultValues: ei(n.defaultValues) ? void 0 : n.defaultValues
  });
  e.current || (e.current = {
    ...hA(n, () => i((f) => ({ ...f }))),
    formState: r
  });
  const o = e.current.control;
  return o._options = n, s2({
    subject: o._subjects.state,
    next: (f) => {
      f2(f, o._proxyFormState, o._updateFormState, !0) && i({ ...o._formState });
    }
  }), sn.useEffect(() => o._disableForm(n.disabled), [o, n.disabled]), sn.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const f = o._getDirty();
      f !== r.isDirty && o._subjects.state.next({
        isDirty: f
      });
    }
  }, [o, r.isDirty]), sn.useEffect(() => {
    n.values && !Ri(n.values, t.current) ? (o._reset(n.values, o._options.resetOptions), t.current = n.values) : o._resetDefaultValues();
  }, [n.values, o]), sn.useEffect(() => {
    o._state.mount || (o._updateValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), e.current.formState = u2(r, o), e.current;
}
const pA = 2, gA = ({ zgGraphUrl: n, callerId: e }) => {
  const { register: t } = id(), { setTargetedRegionId: r, regions: i, setRegions: o, errorMessage: f, setErrorMessage: s } = nd(ol), l = fs.debounce(async (g) => {
    var d, v, b, w, m;
    try {
      const _ = g.trim();
      if (_.length >= pA)
        if (fs.includes(i == null ? void 0 : i.map((x) => x.id), _)) {
          const x = i == null ? void 0 : i.filter((A) => A.id === _);
          x && x.length > 0 && r(x[0].regionId);
        } else {
          const x = await HT({
            zgGraphUrl: n,
            callerId: e,
            input: g
          });
          !((v = (d = x == null ? void 0 : x.data) == null ? void 0 : d.zgsAutocompleteRequest) != null && v.results) || ((m = (w = (b = x == null ? void 0 : x.data) == null ? void 0 : b.zgsAutocompleteRequest) == null ? void 0 : w.results) == null ? void 0 : m.length) === 0 ? (s("Please enter a valid county name."), o([])) : o(x.data.zgsAutocompleteRequest.results);
        }
      else
        r(""), o([]);
    } catch (_) {
      console.error(`fetchAutoCompleteLocations error: ${_}`);
    }
  }, 250), c = () => {
    f && s("");
  }, p = (g) => sn.createElement(Qy, { label: sn.createElement(jy, null, "Property location"), control: sn.createElement($T, { ...t("regionName"), ...g, autoComplete: "off", placeholder: "King County, WA", disabled: !1 }), error: !!f, description: sn.createElement(n2, null, f || "Enter the county name and state"), required: !0 });
  return sn.createElement(NT, {
    focusFirstOption: !0,
    freeForm: !0,
    appearance: "input",
    autoCompleteBehavior: "none",
    renderInput: p,
    options: i.map((g) => g.id),
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    onChange: l,
    onOptionSelect: c,
    renderEmptyState: null,
    size: "sm"
  });
};
var vA = String.fromCharCode(8202), mA = {
  CAD: "C$",
  USD: "$"
};
function t0(n) {
  if (isNaN(n))
    return n;
  for (var e = /(\d+)(\d{3})/, t = ("" + n).split("."), r = t[0], i = t.length > 1 ? "." + t[1] : ""; e.test(r); )
    r = r.replace(e, "$1,$2");
  return r + i;
}
function yA(n, e) {
  return isNaN(n) ? n : parseFloat(n).toFixed(e || 2);
}
function r0(n, e) {
  return isNaN(n) ? n : yA(n, e) + vA + "%";
}
function Ra(n, e, t) {
  if (isNaN(n))
    return n;
  var r = void 0, i = e || "$", o = mA[i] || i;
  return t ? r = t0(_A(n)) : r = t0(Math.round(n)), r.charAt(0) === "-" ? "-" + o + r.slice(1) : "" + o + r;
}
function _A(n) {
  return isNaN(n) ? n : parseFloat(n).toFixed(2);
}
var Xt;
(function(n) {
  n.STRONG_SELLER = "strong seller", n.SELLER = "seller", n.NEUTRAL = "neutral", n.BUYER = "buyer", n.STRONG_BUYER = "strong buyer";
})(Xt || (Xt = {}));
function ul(n) {
  return typeof n == "string" ? Number(n.trim().replace(/,/g, "")) : n;
}
function bA(n) {
  if (n !== "") {
    const e = Number(n.trim().replace(/,/g, ""));
    if (!Number.isNaN(e))
      return e;
  }
  return n;
}
function wA(n) {
  return function(t) {
    let r = null;
    if (t && isNaN(ul(t)))
      return r = n, r;
  };
}
const Tv = 1e8, xA = {
  required: "Required",
  max: {
    value: Tv,
    message: `Must be $${t0(Tv)} at most.`
  },
  min: {
    value: 0,
    message: "Must be at least $0."
  },
  validate: {
    nan: wA("Must be numeric amount.")
  },
  setValueAs: bA
}, TA = (n, e) => ul(n) * (e / 100) / 12, AA = (n, e) => ul(n) * (e / 100);
function MA(n) {
  return n.toLocaleString("en-US", { style: "decimal" });
}
function SA(n) {
  if (n) {
    const e = typeof n == "string" ? n.trim() : String(n);
    if (e) {
      const t = ul(e);
      return Number.isNaN(t) ? void 0 : MA(t);
    }
  }
}
function EA(n) {
  switch (n) {
    case Xt.STRONG_SELLER:
      return "Potential buyers greatly outnumber sellers. Multiple offer situations are the norm for homes at most price levels.  Most homes go pending quickly, often after the first weekend. Waving of contingencies is common.  Price growth is strong.";
    case Xt.SELLER:
      return "Potential buyers outnumber sellers. Multiple offers and waived contingencies are still common but tend to happen on the most desirable or well-priced homes. Price growth is solid, but not rapid.";
    case Xt.NEUTRAL:
      return "Buyers and sellers are fairly evenly balanced overall. Choice homes still may see intense competition and quick to pending while others can sit for months and see multiple price cuts.";
    case Xt.BUYER:
      return "Sellers outnumber buyers.  Listing cuts and concessions are common, but not automatic.  Prices are generally flat.";
    default:
      return "Sellers greatly outnumber buyers with listing cuts and concessions very common. Prices are declining.  Buyers may be able to find good deals from sellers needing to move.";
  }
}
function CA(n) {
  switch (n) {
    case Xt.STRONG_SELLER:
      return 90;
    case Xt.SELLER:
      return 70;
    case Xt.NEUTRAL:
      return 50;
    case Xt.BUYER:
      return 30;
    default:
      return 10;
  }
}
const PA = ({ label: n, leftAdornment: e = void 0, rightAdornment: t = void 0, name: r, config: i = void 0, onChange: o, autoComplete: f, format: s = void 0, required: l, popover: c, placeholder: p = void 0, disabled: g }) => {
  var _;
  const d = id(), v = nA(), b = (_ = v == null ? void 0 : v.errors[r]) == null ? void 0 : _.message, w = d.register(r, i), m = c ? sn.createElement(e2, { appearance: "info", renderHeader: sn.createElement(ed, { level: "6" }, c.title), renderBody: sn.createElement(
    ka,
    null,
    " ",
    c.body
  ) }) : null;
  return sn.createElement(
    e0,
    { marginBottom: "xs", marginTop: "sm" },
    sn.createElement(Qy, { disabled: g, label: sn.createElement(
      ni,
      { display: "flex", gap: "xs", alignItems: "center", marginBottom: "xs" },
      sn.createElement(jy, null, n),
      m && sn.createElement(t2, { triggered: m })
    ), required: l, description: sn.createElement(n2, { error: !!b }, (b == null ? void 0 : b.toString()) || sn.createElement(Jy, null, " ")), control: sn.createElement(kT, { error: !!b, leftAdornment: e && sn.createElement(dv, null, e), rightAdornment: t && sn.createElement(dv, null, t), input: sn.createElement(OT, { ...w, placeholder: p, onChange: (x) => {
      w.onChange(x), o == null || o(x);
    }, onInput: s ? (x) => {
      x.target.value = s(x.target.value) ?? x.target.value;
    } : void 0, autoComplete: f }) }) })
  );
}, RA = Zt(IT)`
  flex: 1;
`, NA = ({ zgGraphUrl: n, callerId: e, mortgageUrl: t, mortgagePartnerId: r }) => {
  const { targetedRegionId: i, regions: o, setAvgRate: f, setMonthlyTaxes: s, setAnnualTaxes: l, errorMessage: c, setErrorMessage: p } = nd(ol), g = async (v) => {
    try {
      if (i || o && o.length > 0) {
        const { rate: b } = await YT({
          mortgageUrl: t,
          mortgagePartnerId: r,
          input: i
        });
        b || p("We do not have property tax data for this county at this time."), f(b), s(TA(v.estimatedPropertyValue, b)), l(AA(v.estimatedPropertyValue, b));
      }
    } catch (b) {
      console.error(`fetchAnnualPropertyTaxRate error: ${b}`);
    }
  }, d = dA({
    mode: "onTouched",
    defaultValues: {
      estimatedPropertyValue: "500,000",
      regionName: "King County, WA"
    }
  });
  return (
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    sn.createElement(
      RA,
      { onSubmit: d.handleSubmit(g) },
      sn.createElement(
        QT,
        { ...d },
        sn.createElement(gA, { zgGraphUrl: n, callerId: e }),
        sn.createElement(PA, { ...d.register("estimatedPropertyValue"), label: "Estimated property value", leftAdornment: "$", config: xA, autoComplete: "off", format: SA, popover: {
          title: "Estimated property value",
          body: "Your best guess at the property's value. If you know the property's assessed value or market value, you'll receive a more accurate property tax estimate."
        }, placeholder: "500,000", ref: null, required: !0 }),
        sn.createElement(r2, { buttonType: "primary", fluid: !0, size: "md", marginTop: "md", type: "submit", disabled: !!c || !!d.formState.errors.estimatedPropertyValue }, "Calculate")
      )
    )
  );
}, $A = Zt(td)`
  background-color: ${rl("colors.blue100")};
  padding: ${il("sm")};
  flex-grow: 2;
  border-radius: 4px;
`, kA = Zt(td)`
  background-color: ${rl("colors.blue200")};
  padding: ${il("sm")} 0;
  flex-grow: 2;
  border-radius: 4px;
`, OA = Zt(td)`
  background-color: ${rl("colors.coolGray200")};
  padding: ${il("sm")};
  flex-grow: 1;
  border-radius: 4px;
`, IA = () => {
  const n = sn.createElement(e2, { appearance: "info", renderHeader: sn.createElement(ed, { level: "6" }, "Average tax rate"), renderBody: sn.createElement(ka, null, "The percentage of median real estate taxes paid in the selected or nearest county, according to reports from 2021.") }), { avgRate: e, monthlyTaxes: t, annualTaxes: r, errorMessage: i } = nd(ol);
  return sn.createElement(
    ni,
    { display: "flex", gap: "sm", flexDirection: "column", justifyContent: "center", flex: "1" },
    sn.createElement(
      Ai,
      { fontType: "bodyHeading" },
      " ",
      "Your property tax estimate is:"
    ),
    sn.createElement(
      $A,
      null,
      sn.createElement(
        Ai,
        { fontType: "bodySmallHeading" },
        " ",
        "Annual property taxes"
      ),
      sn.createElement(Ai, { fontType: { default: "h2", sm_lte: "h3" }, fontColor: "blue500" }, r ? Ra(r, "$", !0) : i ? " " : Ra(4200, "$", !0))
    ),
    sn.createElement(
      ni,
      { display: "flex", gap: "sm", flexGrow: 1, flexDirection: { default: "row", sm_lte: "column" } },
      sn.createElement(
        kA,
        null,
        sn.createElement(Ai, { fontType: "bodySmallHeading", marginLeft: "sm" }, "Monthly property taxes"),
        sn.createElement(Ai, { fontType: "h4", fontColor: "blue500", marginLeft: "sm" }, t ? Ra(t, "$", !0) : i ? " " : Ra(350, "$", !0)),
        sn.createElement(
          ni,
          { display: "flex", marginTop: "xs", marginLeft: "xs" },
          sn.createElement(LT, { fontColor: "blue500" }),
          sn.createElement(ka, { fontType: "legal", marginLeft: "xs" }, "Property taxes are billed bi-annually")
        )
      ),
      sn.createElement(
        OA,
        null,
        sn.createElement(
          ni,
          { display: "flex", alignItems: "center" },
          sn.createElement(Ai, { fontType: "bodySmallHeading", marginRight: "xs" }, "Avg. tax rate"),
          sn.createElement(t2, { triggered: n })
        ),
        sn.createElement(Ai, { fontType: "h4", fontColor: "blue500" }, e ? r0(e) : i ? " " : r0(0.84))
      )
    )
  );
}, LA = Zt(i2)`
  @media ${al("sm_lte")} {
    height: auto;
  }
  padding: ${il("md")};
`, iz = ({ zgGraphUrl: n = UT, callerId: e = GT, mortgageUrl: t = qT, mortgagePartnerId: r = WT }) => {
  const [i, o] = va("207"), [f, s] = va(null), [l, c] = va(null), [p, g] = va(null), [d, v] = va([]), [b, w] = va("");
  return sn.createElement(
    ol.Provider,
    { value: {
      targetedRegionId: i,
      setTargetedRegionId: o,
      annualTaxes: f,
      setAnnualTaxes: s,
      monthlyTaxes: l,
      setMonthlyTaxes: c,
      avgRate: p,
      setAvgRate: g,
      regions: d,
      setRegions: v,
      errorMessage: b,
      setErrorMessage: w
    } },
    sn.createElement(
      LA,
      { cardType: "secondary" },
      sn.createElement(
        ni,
        { display: "flex", gap: "md", flexDirection: { default: "row", sm_lte: "column" } },
        sn.createElement(NA, { zgGraphUrl: n, callerId: e, mortgageUrl: t, mortgagePartnerId: r }),
        sn.createElement(IA, null)
      )
    )
  );
}, DA = {
  data: [
    {
      regionid: 102001,
      msa: "United States",
      sizerank: 0,
      year: 2021,
      TaxRate: 0.882,
      AnnualTaxesPaid: 2561.276028,
      MonthlyTaxesPaid: 213.439669
    },
    {
      regionid: 394913,
      msa: "New York, NY",
      sizerank: 1,
      year: 2021,
      TaxRate: 1.903,
      AnnualTaxesPaid: 10310.88762,
      MonthlyTaxesPaid: 859.2406352
    },
    {
      regionid: 753899,
      msa: "Los Angeles, CA",
      sizerank: 2,
      year: 2021,
      TaxRate: 0.689,
      AnnualTaxesPaid: 5425.162492,
      MonthlyTaxesPaid: 452.0968743
    },
    {
      regionid: 394463,
      msa: "Chicago, IL",
      sizerank: 3,
      year: 2021,
      TaxRate: 1.966,
      AnnualTaxesPaid: 5241.430116,
      MonthlyTaxesPaid: 436.785843
    },
    {
      regionid: 394514,
      msa: "Dallas, TX",
      sizerank: 4,
      year: 2021,
      TaxRate: 1.485,
      AnnualTaxesPaid: 4669.326316,
      MonthlyTaxesPaid: 389.1105263
    },
    {
      regionid: 394692,
      msa: "Houston, TX",
      sizerank: 5,
      year: 2021,
      TaxRate: 1.349,
      AnnualTaxesPaid: 3478.186088,
      MonthlyTaxesPaid: 289.8488406
    },
    {
      regionid: 395209,
      msa: "Washington, DC",
      sizerank: 6,
      year: 2021,
      TaxRate: 0.871,
      AnnualTaxesPaid: 4279.810715,
      MonthlyTaxesPaid: 356.650893
    },
    {
      regionid: 394974,
      msa: "Philadelphia, PA",
      sizerank: 7,
      year: 2021,
      TaxRate: 1.348,
      AnnualTaxesPaid: 3944.360318,
      MonthlyTaxesPaid: 328.6966932
    },
    {
      regionid: 394856,
      msa: "Miami, FL",
      sizerank: 8,
      year: 2021,
      TaxRate: 1.123,
      AnnualTaxesPaid: 3902.709188,
      MonthlyTaxesPaid: 325.2257657
    },
    {
      regionid: 394347,
      msa: "Atlanta, GA",
      sizerank: 9,
      year: 2021,
      TaxRate: 0.882,
      AnnualTaxesPaid: 2681.372238,
      MonthlyTaxesPaid: 223.4476865
    },
    {
      regionid: 394404,
      msa: "Boston, MA",
      sizerank: 10,
      year: 2021,
      TaxRate: 1.043,
      AnnualTaxesPaid: 6044.658195,
      MonthlyTaxesPaid: 503.7215162
    },
    {
      regionid: 394976,
      msa: "Phoenix, AZ",
      sizerank: 11,
      year: 2021,
      TaxRate: 0.426,
      AnnualTaxesPaid: 1671.161013,
      MonthlyTaxesPaid: 139.2634177
    },
    {
      regionid: 395057,
      msa: "San Francisco, CA",
      sizerank: 12,
      year: 2021,
      TaxRate: 0.691,
      AnnualTaxesPaid: 7294.750035,
      MonthlyTaxesPaid: 607.8958363
    },
    {
      regionid: 395025,
      msa: "Riverside, CA",
      sizerank: 13,
      year: 2021,
      TaxRate: 0.823,
      AnnualTaxesPaid: 3952.282965,
      MonthlyTaxesPaid: 329.3569137
    },
    {
      regionid: 394532,
      msa: "Detroit, MI",
      sizerank: 14,
      year: 2021,
      TaxRate: 1.174,
      AnnualTaxesPaid: 2465.876903,
      MonthlyTaxesPaid: 205.4897419
    },
    {
      regionid: 395078,
      msa: "Seattle, WA",
      sizerank: 15,
      year: 2021,
      TaxRate: 0.851,
      AnnualTaxesPaid: 5350.432917,
      MonthlyTaxesPaid: 445.8694098
    },
    {
      regionid: 394865,
      msa: "Minneapolis, MN",
      sizerank: 16,
      year: 2021,
      TaxRate: 1.041,
      AnnualTaxesPaid: 3524.483751,
      MonthlyTaxesPaid: 293.7069793
    },
    {
      regionid: 395056,
      msa: "San Diego, CA",
      sizerank: 17,
      year: 2021,
      TaxRate: 0.706,
      AnnualTaxesPaid: 5355.40477,
      MonthlyTaxesPaid: 446.2837309
    },
    {
      regionid: 395148,
      msa: "Tampa, FL",
      sizerank: 18,
      year: 2021,
      TaxRate: 0.91,
      AnnualTaxesPaid: 2707.859113,
      MonthlyTaxesPaid: 225.6549261
    },
    {
      regionid: 394530,
      msa: "Denver, CO",
      sizerank: 19,
      year: 2021,
      TaxRate: 0.439,
      AnnualTaxesPaid: 2317.508274,
      MonthlyTaxesPaid: 193.1256895
    },
    {
      regionid: 394358,
      msa: "Baltimore, MD",
      sizerank: 20,
      year: 2021,
      TaxRate: 0.915,
      AnnualTaxesPaid: 2996.614568,
      MonthlyTaxesPaid: 249.7178807
    },
    {
      regionid: 395121,
      msa: "St. Louis, MO",
      sizerank: 21,
      year: 2021,
      TaxRate: 1.295,
      AnnualTaxesPaid: 2660.60151,
      MonthlyTaxesPaid: 221.7167925
    },
    {
      regionid: 394943,
      msa: "Orlando, FL",
      sizerank: 22,
      year: 2021,
      TaxRate: 0.915,
      AnnualTaxesPaid: 2853.679994,
      MonthlyTaxesPaid: 237.8066662
    },
    {
      regionid: 394458,
      msa: "Charlotte, NC",
      sizerank: 23,
      year: 2021,
      TaxRate: 0.698,
      AnnualTaxesPaid: 2084.02561,
      MonthlyTaxesPaid: 173.6688009
    },
    {
      regionid: 395055,
      msa: "San Antonio, TX",
      sizerank: 24,
      year: 2021,
      TaxRate: 1.527,
      AnnualTaxesPaid: 3792.550236,
      MonthlyTaxesPaid: 316.045853
    },
    {
      regionid: 394998,
      msa: "Portland, OR",
      sizerank: 25,
      year: 2021,
      TaxRate: 0.896,
      AnnualTaxesPaid: 4448.313316,
      MonthlyTaxesPaid: 370.6927763
    },
    {
      regionid: 395045,
      msa: "Sacramento, CA",
      sizerank: 26,
      year: 2021,
      TaxRate: 0.764,
      AnnualTaxesPaid: 4004.226903,
      MonthlyTaxesPaid: 333.6855752
    },
    {
      regionid: 394982,
      msa: "Pittsburgh, PA",
      sizerank: 27,
      year: 2021,
      TaxRate: 0.415,
      AnnualTaxesPaid: 778.0955628,
      MonthlyTaxesPaid: 64.8412969
    },
    {
      regionid: 394466,
      msa: "Cincinnati, OH",
      sizerank: 28,
      year: 2021,
      TaxRate: 1.281,
      AnnualTaxesPaid: 2940.866155,
      MonthlyTaxesPaid: 245.0721796
    },
    {
      regionid: 394355,
      msa: "Austin, TX",
      sizerank: 29,
      year: 2021,
      TaxRate: 1.535,
      AnnualTaxesPaid: 6722.452264,
      MonthlyTaxesPaid: 560.2043553
    },
    {
      regionid: 394775,
      msa: "Las Vegas, NV",
      sizerank: 30,
      year: 2021,
      TaxRate: 0.44,
      AnnualTaxesPaid: 1577.729517,
      MonthlyTaxesPaid: 131.4774598
    },
    {
      regionid: 394735,
      msa: "Kansas City, MO",
      sizerank: 31,
      year: 2021,
      TaxRate: 1.092,
      AnnualTaxesPaid: 2668.413559,
      MonthlyTaxesPaid: 222.3677966
    },
    {
      regionid: 394492,
      msa: "Columbus, OH",
      sizerank: 32,
      year: 2021,
      TaxRate: 1.356,
      AnnualTaxesPaid: 3417.720709,
      MonthlyTaxesPaid: 284.8100591
    },
    {
      regionid: 394705,
      msa: "Indianapolis, IN",
      sizerank: 33,
      year: 2021,
      TaxRate: 0.813,
      AnnualTaxesPaid: 1828.335679,
      MonthlyTaxesPaid: 152.3613066
    },
    {
      regionid: 394475,
      msa: "Cleveland, OH",
      sizerank: 34,
      year: 2021,
      TaxRate: 1.765,
      AnnualTaxesPaid: 3260.957533,
      MonthlyTaxesPaid: 271.7464611
    },
    {
      regionid: 395059,
      msa: "San Jose, CA",
      sizerank: 35,
      year: 2021,
      TaxRate: 0.656,
      AnnualTaxesPaid: 8381.800623,
      MonthlyTaxesPaid: 698.4833853
    },
    {
      regionid: 394902,
      msa: "Nashville, TN",
      sizerank: 36,
      year: 2021,
      TaxRate: 0.541,
      AnnualTaxesPaid: 1898.488312,
      MonthlyTaxesPaid: 158.2073593
    },
    {
      regionid: 395194,
      msa: "Virginia Beach, VA",
      sizerank: 37,
      year: 2021,
      TaxRate: 0.873,
      AnnualTaxesPaid: 2541.835854,
      MonthlyTaxesPaid: 211.8196545
    },
    {
      regionid: 395005,
      msa: "Providence, RI",
      sizerank: 38,
      year: 2021,
      TaxRate: 1.221,
      AnnualTaxesPaid: 4726.117044,
      MonthlyTaxesPaid: 393.843087
    },
    {
      regionid: 394714,
      msa: "Jacksonville, FL",
      sizerank: 39,
      year: 2021,
      TaxRate: 0.871,
      AnnualTaxesPaid: 2470.382606,
      MonthlyTaxesPaid: 205.8652172
    },
    {
      regionid: 394862,
      msa: "Milwaukee, WI",
      sizerank: 40,
      year: 2021,
      TaxRate: 1.548,
      AnnualTaxesPaid: 4451.608832,
      MonthlyTaxesPaid: 370.9674026
    },
    {
      regionid: 394935,
      msa: "Oklahoma City, OK",
      sizerank: 41,
      year: 2021,
      TaxRate: 0.978,
      AnnualTaxesPaid: 1830.0672,
      MonthlyTaxesPaid: 152.5056
    },
    {
      regionid: 395012,
      msa: "Raleigh, NC",
      sizerank: 42,
      year: 2021,
      TaxRate: 0.744,
      AnnualTaxesPaid: 2631.691054,
      MonthlyTaxesPaid: 219.3075878
    },
    {
      regionid: 394849,
      msa: "Memphis, TN",
      sizerank: 43,
      year: 2021,
      TaxRate: 0.634,
      AnnualTaxesPaid: 1246.053822,
      MonthlyTaxesPaid: 103.8378185
    },
    {
      regionid: 395022,
      msa: "Richmond, VA",
      sizerank: 44,
      year: 2021,
      TaxRate: 0.776,
      AnnualTaxesPaid: 2251.124103,
      MonthlyTaxesPaid: 187.5936752
    },
    {
      regionid: 394910,
      msa: "New Orleans, LA",
      sizerank: 46,
      year: 2021,
      TaxRate: 0.584,
      AnnualTaxesPaid: 1337.890509,
      MonthlyTaxesPaid: 111.4908758
    },
    {
      regionid: 395053,
      msa: "Salt Lake City, UT",
      sizerank: 47,
      year: 2021,
      TaxRate: 0.517,
      AnnualTaxesPaid: 2434.396018,
      MonthlyTaxesPaid: 202.8663348
    },
    {
      regionid: 394669,
      msa: "Hartford, CT",
      sizerank: 48,
      year: 2021,
      TaxRate: 2.027,
      AnnualTaxesPaid: 5706.491535,
      MonthlyTaxesPaid: 475.5409613
    },
    {
      regionid: 394388,
      msa: "Birmingham, AL",
      sizerank: 50,
      year: 2021,
      TaxRate: 0.501,
      AnnualTaxesPaid: 1050.228917,
      MonthlyTaxesPaid: 87.51907642
    },
    {
      regionid: 394640,
      msa: "Grand Rapids, MI",
      sizerank: 52,
      year: 2021,
      TaxRate: 0.938,
      AnnualTaxesPaid: 2406.25769,
      MonthlyTaxesPaid: 200.5214742
    }
  ]
}, FA = Zt(Ue.HeaderCell)`
    width: 25%;
    @media ${al("sm_lte")} {
        width: 35%;
    }
`, Av = Zt(Ue.Cell)`
  @media ${al("sm_lte")} {
    display: none;
  }
`, Mv = Zt(Ue.HeaderCell)`
  @media ${al("sm_lte")} {
    display: none;
  }
`, az = () => {
  const n = [];
  DA.data.forEach((i) => {
    n.push(sn.createElement(
      Ue.Row,
      { key: i.msa },
      sn.createElement(Ue.Cell, null, i.msa),
      sn.createElement(Ue.Cell, null, r0(i.TaxRate)),
      sn.createElement(Av, null, Ra(i.AnnualTaxesPaid)),
      sn.createElement(Av, null, Ra(i.MonthlyTaxesPaid))
    ));
  });
  const e = n.slice(0, 10), t = n.slice(10), r = sn.createElement(DT, { defaultCollapsed: !0 }, (i, o) => sn.createElement(
    Jy,
    null,
    !i && sn.createElement(Ue.Body, null, t),
    sn.createElement(
      Ue.Body,
      null,
      sn.createElement(
        Ue.Row,
        null,
        sn.createElement(
          Ue.Cell,
          null,
          sn.createElement(r2, { onClick: o, iconPosition: "end", size: "sm", icon: i ? sn.createElement(FT, null) : sn.createElement(BT, null) }, i ? "Show More" : "Show Less")
        )
      )
    )
  ));
  return sn.createElement(
    Ue.Responsive,
    null,
    sn.createElement(
      Ue,
      { appearance: "barebones", "aria-label": "Tax Comparison Table", alignments: ["left", "center", "center", "center"] },
      sn.createElement(
        Ue.Header,
        null,
        sn.createElement(
          Ue.Row,
          null,
          sn.createElement(Ue.HeaderCell, null, "Location"),
          sn.createElement(FA, null, "Rate"),
          sn.createElement(Mv, null, "Annual Property Tax"),
          sn.createElement(Mv, null, "Monthly Property Tax")
        )
      ),
      sn.createElement(Ue.Body, null, e),
      r
    )
  );
};
var m2 = {}, fd = {};
function de(n, e) {
  return n == null || e == null ? NaN : n < e ? -1 : n > e ? 1 : n >= e ? 0 : NaN;
}
function y2(n, e) {
  return n == null || e == null ? NaN : e < n ? -1 : e > n ? 1 : e >= n ? 0 : NaN;
}
function fl(n) {
  let e, t, r;
  n.length !== 2 ? (e = de, t = (s, l) => de(n(s), l), r = (s, l) => n(s) - l) : (e = n === de || n === y2 ? n : BA, t = n, r = n);
  function i(s, l, c = 0, p = s.length) {
    if (c < p) {
      if (e(l, l) !== 0)
        return p;
      do {
        const g = c + p >>> 1;
        t(s[g], l) < 0 ? c = g + 1 : p = g;
      } while (c < p);
    }
    return c;
  }
  function o(s, l, c = 0, p = s.length) {
    if (c < p) {
      if (e(l, l) !== 0)
        return p;
      do {
        const g = c + p >>> 1;
        t(s[g], l) <= 0 ? c = g + 1 : p = g;
      } while (c < p);
    }
    return c;
  }
  function f(s, l, c = 0, p = s.length) {
    const g = i(s, l, c, p - 1);
    return g > c && r(s[g - 1], l) > -r(s[g], l) ? g - 1 : g;
  }
  return { left: i, center: f, right: o };
}
function BA() {
  return 0;
}
function ds(n) {
  return n === null ? NaN : +n;
}
function* zA(n, e) {
  if (e === void 0)
    for (let t of n)
      t != null && (t = +t) >= t && (yield t);
  else {
    let t = -1;
    for (let r of n)
      (r = e(r, ++t, n)) != null && (r = +r) >= r && (yield r);
  }
}
const _2 = fl(de), b2 = _2.right, VA = _2.left, UA = fl(ds).center, Yi = b2;
function GA(n, e) {
  if (!((e = +e) >= 0))
    throw new RangeError("invalid r");
  let t = n.length;
  if (!((t = Math.floor(t)) >= 0))
    throw new RangeError("invalid length");
  if (!t || !e)
    return n;
  const r = sd(e), i = n.slice();
  return r(n, i, 0, t, 1), r(i, n, 0, t, 1), r(n, i, 0, t, 1), n;
}
const w2 = x2(sd), qA = x2(WA);
function x2(n) {
  return function(e, t, r = t) {
    if (!((t = +t) >= 0))
      throw new RangeError("invalid rx");
    if (!((r = +r) >= 0))
      throw new RangeError("invalid ry");
    let { data: i, width: o, height: f } = e;
    if (!((o = Math.floor(o)) >= 0))
      throw new RangeError("invalid width");
    if (!((f = Math.floor(f !== void 0 ? f : i.length / o)) >= 0))
      throw new RangeError("invalid height");
    if (!o || !f || !t && !r)
      return e;
    const s = t && n(t), l = r && n(r), c = i.slice();
    return s && l ? (ya(s, c, i, o, f), ya(s, i, c, o, f), ya(s, c, i, o, f), _a(l, i, c, o, f), _a(l, c, i, o, f), _a(l, i, c, o, f)) : s ? (ya(s, i, c, o, f), ya(s, c, i, o, f), ya(s, i, c, o, f)) : l && (_a(l, i, c, o, f), _a(l, c, i, o, f), _a(l, i, c, o, f)), e;
  };
}
function ya(n, e, t, r, i) {
  for (let o = 0, f = r * i; o < f; )
    n(e, t, o, o += r, 1);
}
function _a(n, e, t, r, i) {
  for (let o = 0, f = r * i; o < r; ++o)
    n(e, t, o, o + f, r);
}
function WA(n) {
  const e = sd(n);
  return (t, r, i, o, f) => {
    i <<= 2, o <<= 2, f <<= 2, e(t, r, i + 0, o + 0, f), e(t, r, i + 1, o + 1, f), e(t, r, i + 2, o + 2, f), e(t, r, i + 3, o + 3, f);
  };
}
function sd(n) {
  const e = Math.floor(n);
  if (e === n)
    return HA(n);
  const t = n - e, r = 2 * n + 1;
  return (i, o, f, s, l) => {
    if (!((s -= l) >= f))
      return;
    let c = e * o[f];
    const p = l * e, g = p + l;
    for (let d = f, v = f + p; d < v; d += l)
      c += o[Math.min(s, d)];
    for (let d = f, v = s; d <= v; d += l)
      c += o[Math.min(s, d + p)], i[d] = (c + t * (o[Math.max(f, d - g)] + o[Math.min(s, d + g)])) / r, c -= o[Math.max(f, d - p)];
  };
}
function HA(n) {
  const e = 2 * n + 1;
  return (t, r, i, o, f) => {
    if (!((o -= f) >= i))
      return;
    let s = n * r[i];
    const l = f * n;
    for (let c = i, p = i + l; c < p; c += f)
      s += r[Math.min(o, c)];
    for (let c = i, p = o; c <= p; c += f)
      s += r[Math.min(o, c + l)], t[c] = s / e, s -= r[Math.max(i, c - l)];
  };
}
function sl(n, e) {
  let t = 0;
  if (e === void 0)
    for (let r of n)
      r != null && (r = +r) >= r && ++t;
  else {
    let r = -1;
    for (let i of n)
      (i = e(i, ++r, n)) != null && (i = +i) >= i && ++t;
  }
  return t;
}
function YA(n) {
  return n.length | 0;
}
function XA(n) {
  return !(n > 0);
}
function KA(n) {
  return typeof n != "object" || "length" in n ? n : Array.from(n);
}
function ZA(n) {
  return (e) => n(...e);
}
function JA(...n) {
  const e = typeof n[n.length - 1] == "function" && ZA(n.pop());
  n = n.map(KA);
  const t = n.map(YA), r = n.length - 1, i = new Array(r + 1).fill(0), o = [];
  if (r < 0 || t.some(XA))
    return o;
  for (; ; ) {
    o.push(i.map((s, l) => n[l][s]));
    let f = r;
    for (; ++i[f] === t[f]; ) {
      if (f === 0)
        return e ? o.map(e) : o;
      i[f--] = 0;
    }
  }
}
function QA(n, e) {
  var t = 0, r = 0;
  return Float64Array.from(n, e === void 0 ? (i) => t += +i || 0 : (i) => t += +e(i, r++, n) || 0);
}
function T2(n, e) {
  let t = 0, r, i = 0, o = 0;
  if (e === void 0)
    for (let f of n)
      f != null && (f = +f) >= f && (r = f - i, i += r / ++t, o += r * (f - i));
  else {
    let f = -1;
    for (let s of n)
      (s = e(s, ++f, n)) != null && (s = +s) >= s && (r = s - i, i += r / ++t, o += r * (s - i));
  }
  if (t > 1)
    return o / (t - 1);
}
function A2(n, e) {
  const t = T2(n, e);
  return t && Math.sqrt(t);
}
function Yo(n, e) {
  let t, r;
  if (e === void 0)
    for (const i of n)
      i != null && (t === void 0 ? i >= i && (t = r = i) : (t > i && (t = i), r < i && (r = i)));
  else {
    let i = -1;
    for (let o of n)
      (o = e(o, ++i, n)) != null && (t === void 0 ? o >= o && (t = r = o) : (t > o && (t = o), r < o && (r = o)));
  }
  return [t, r];
}
class Ae {
  constructor() {
    this._partials = new Float64Array(32), this._n = 0;
  }
  add(e) {
    const t = this._partials;
    let r = 0;
    for (let i = 0; i < this._n && i < 32; i++) {
      const o = t[i], f = e + o, s = Math.abs(e) < Math.abs(o) ? e - (f - o) : o - (f - e);
      s && (t[r++] = s), e = f;
    }
    return t[r] = e, this._n = r + 1, this;
  }
  valueOf() {
    const e = this._partials;
    let t = this._n, r, i, o, f = 0;
    if (t > 0) {
      for (f = e[--t]; t > 0 && (r = f, i = e[--t], f = r + i, o = i - (f - r), !o); )
        ;
      t > 0 && (o < 0 && e[t - 1] < 0 || o > 0 && e[t - 1] > 0) && (i = o * 2, r = f + i, i == r - f && (f = r));
    }
    return f;
  }
}
function jA(n, e) {
  const t = new Ae();
  if (e === void 0)
    for (let r of n)
      (r = +r) && t.add(r);
  else {
    let r = -1;
    for (let i of n)
      (i = +e(i, ++r, n)) && t.add(i);
  }
  return +t;
}
function nM(n, e) {
  const t = new Ae();
  let r = -1;
  return Float64Array.from(
    n,
    e === void 0 ? (i) => t.add(+i || 0) : (i) => t.add(+e(i, ++r, n) || 0)
  );
}
class nu extends Map {
  constructor(e, t = E2) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: t } }), e != null)
      for (const [r, i] of e)
        this.set(r, i);
  }
  get(e) {
    return super.get(i0(this, e));
  }
  has(e) {
    return super.has(i0(this, e));
  }
  set(e, t) {
    return super.set(M2(this, e), t);
  }
  delete(e) {
    return super.delete(S2(this, e));
  }
}
class Li extends Set {
  constructor(e, t = E2) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: t } }), e != null)
      for (const r of e)
        this.add(r);
  }
  has(e) {
    return super.has(i0(this, e));
  }
  add(e) {
    return super.add(M2(this, e));
  }
  delete(e) {
    return super.delete(S2(this, e));
  }
}
function i0({ _intern: n, _key: e }, t) {
  const r = e(t);
  return n.has(r) ? n.get(r) : t;
}
function M2({ _intern: n, _key: e }, t) {
  const r = e(t);
  return n.has(r) ? n.get(r) : (n.set(r, t), t);
}
function S2({ _intern: n, _key: e }, t) {
  const r = e(t);
  return n.has(r) && (t = n.get(r), n.delete(r)), t;
}
function E2(n) {
  return n !== null && typeof n == "object" ? n.valueOf() : n;
}
function Ba(n) {
  return n;
}
function C2(n, ...e) {
  return to(n, Ba, Ba, e);
}
function P2(n, ...e) {
  return to(n, Array.from, Ba, e);
}
function R2(n, e) {
  for (let t = 1, r = e.length; t < r; ++t)
    n = n.flatMap((i) => i.pop().map(([o, f]) => [...i, o, f]));
  return n;
}
function eM(n, ...e) {
  return R2(P2(n, ...e), e);
}
function tM(n, e, ...t) {
  return R2($2(n, e, ...t), t);
}
function N2(n, e, ...t) {
  return to(n, Ba, e, t);
}
function $2(n, e, ...t) {
  return to(n, Array.from, e, t);
}
function rM(n, ...e) {
  return to(n, Ba, k2, e);
}
function iM(n, ...e) {
  return to(n, Array.from, k2, e);
}
function k2(n) {
  if (n.length !== 1)
    throw new Error("duplicate key");
  return n[0];
}
function to(n, e, t, r) {
  return function i(o, f) {
    if (f >= r.length)
      return t(o);
    const s = new nu(), l = r[f++];
    let c = -1;
    for (const p of o) {
      const g = l(p, ++c, o), d = s.get(g);
      d ? d.push(p) : s.set(g, [p]);
    }
    for (const [p, g] of s)
      s.set(p, i(g, f));
    return e(s);
  }(n, 0);
}
function O2(n, e) {
  return Array.from(e, (t) => n[t]);
}
function a0(n, ...e) {
  if (typeof n[Symbol.iterator] != "function")
    throw new TypeError("values is not iterable");
  n = Array.from(n);
  let [t] = e;
  if (t && t.length !== 2 || e.length > 1) {
    const r = Uint32Array.from(n, (i, o) => o);
    return e.length > 1 ? (e = e.map((i) => n.map(i)), r.sort((i, o) => {
      for (const f of e) {
        const s = za(f[i], f[o]);
        if (s)
          return s;
      }
    })) : (t = n.map(t), r.sort((i, o) => za(t[i], t[o]))), O2(n, r);
  }
  return n.sort(ld(t));
}
function ld(n = de) {
  if (n === de)
    return za;
  if (typeof n != "function")
    throw new TypeError("compare is not a function");
  return (e, t) => {
    const r = n(e, t);
    return r || r === 0 ? r : (n(t, t) === 0) - (n(e, e) === 0);
  };
}
function za(n, e) {
  return (n == null || !(n >= n)) - (e == null || !(e >= e)) || (n < e ? -1 : n > e ? 1 : 0);
}
function aM(n, e, t) {
  return (e.length !== 2 ? a0(N2(n, e, t), ([r, i], [o, f]) => de(i, f) || de(r, o)) : a0(C2(n, t), ([r, i], [o, f]) => e(i, f) || de(r, o))).map(([r]) => r);
}
var oM = Array.prototype, uM = oM.slice;
function ph(n) {
  return () => n;
}
const fM = Math.sqrt(50), sM = Math.sqrt(10), lM = Math.sqrt(2);
function ps(n, e, t) {
  const r = (e - n) / Math.max(0, t), i = Math.floor(Math.log10(r)), o = r / Math.pow(10, i), f = o >= fM ? 10 : o >= sM ? 5 : o >= lM ? 2 : 1;
  let s, l, c;
  return i < 0 ? (c = Math.pow(10, -i) / f, s = Math.round(n * c), l = Math.round(e * c), s / c < n && ++s, l / c > e && --l, c = -c) : (c = Math.pow(10, i) * f, s = Math.round(n / c), l = Math.round(e / c), s * c < n && ++s, l * c > e && --l), l < s && 0.5 <= t && t < 2 ? ps(n, e, t * 2) : [s, l, c];
}
function Di(n, e, t) {
  if (e = +e, n = +n, t = +t, !(t > 0))
    return [];
  if (n === e)
    return [n];
  const r = e < n, [i, o, f] = r ? ps(e, n, t) : ps(n, e, t);
  if (!(o >= i))
    return [];
  const s = o - i + 1, l = new Array(s);
  if (r)
    if (f < 0)
      for (let c = 0; c < s; ++c)
        l[c] = (o - c) / -f;
    else
      for (let c = 0; c < s; ++c)
        l[c] = (o - c) * f;
  else if (f < 0)
    for (let c = 0; c < s; ++c)
      l[c] = (i + c) / -f;
  else
    for (let c = 0; c < s; ++c)
      l[c] = (i + c) * f;
  return l;
}
function Fi(n, e, t) {
  return e = +e, n = +n, t = +t, ps(n, e, t)[2];
}
function gs(n, e, t) {
  e = +e, n = +n, t = +t;
  const r = e < n, i = r ? Fi(e, n, t) : Fi(n, e, t);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function cd(n, e, t) {
  let r;
  for (; ; ) {
    const i = Fi(n, e, t);
    if (i === r || i === 0 || !isFinite(i))
      return [n, e];
    i > 0 ? (n = Math.floor(n / i) * i, e = Math.ceil(e / i) * i) : i < 0 && (n = Math.ceil(n * i) / i, e = Math.floor(e * i) / i), r = i;
  }
}
function hd(n) {
  return Math.max(1, Math.ceil(Math.log(sl(n)) / Math.LN2) + 1);
}
function Sv() {
  var n = Ba, e = Yo, t = hd;
  function r(i) {
    Array.isArray(i) || (i = Array.from(i));
    var o, f = i.length, s, l, c = new Array(f);
    for (o = 0; o < f; ++o)
      c[o] = n(i[o], o, i);
    var p = e(c), g = p[0], d = p[1], v = t(c, g, d);
    if (!Array.isArray(v)) {
      const A = d, T = +v;
      if (e === Yo && ([g, d] = cd(g, d, T)), v = Di(g, d, T), v[0] <= g && (l = Fi(g, d, T)), v[v.length - 1] >= d)
        if (A >= d && e === Yo) {
          const S = Fi(g, d, T);
          isFinite(S) && (S > 0 ? d = (Math.floor(d / S) + 1) * S : S < 0 && (d = (Math.ceil(d * -S) + 1) / -S));
        } else
          v.pop();
    }
    for (var b = v.length, w = 0, m = b; v[w] <= g; )
      ++w;
    for (; v[m - 1] > d; )
      --m;
    (w || m < b) && (v = v.slice(w, m), b = m - w);
    var _ = new Array(b + 1), x;
    for (o = 0; o <= b; ++o)
      x = _[o] = [], x.x0 = o > 0 ? v[o - 1] : g, x.x1 = o < b ? v[o] : d;
    if (isFinite(l)) {
      if (l > 0)
        for (o = 0; o < f; ++o)
          (s = c[o]) != null && g <= s && s <= d && _[Math.min(b, Math.floor((s - g) / l))].push(i[o]);
      else if (l < 0) {
        for (o = 0; o < f; ++o)
          if ((s = c[o]) != null && g <= s && s <= d) {
            const A = Math.floor((g - s) * l);
            _[Math.min(b, A + (v[A] <= s))].push(i[o]);
          }
      }
    } else
      for (o = 0; o < f; ++o)
        (s = c[o]) != null && g <= s && s <= d && _[Yi(v, s, 0, b)].push(i[o]);
    return _;
  }
  return r.value = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : ph(i), r) : n;
  }, r.domain = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : ph([i[0], i[1]]), r) : e;
  }, r.thresholds = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : ph(Array.isArray(i) ? uM.call(i) : i), r) : t;
  }, r;
}
function eu(n, e) {
  let t;
  if (e === void 0)
    for (const r of n)
      r != null && (t < r || t === void 0 && r >= r) && (t = r);
  else {
    let r = -1;
    for (let i of n)
      (i = e(i, ++r, n)) != null && (t < i || t === void 0 && i >= i) && (t = i);
  }
  return t;
}
function dd(n, e) {
  let t, r = -1, i = -1;
  if (e === void 0)
    for (const o of n)
      ++i, o != null && (t < o || t === void 0 && o >= o) && (t = o, r = i);
  else
    for (let o of n)
      (o = e(o, ++i, n)) != null && (t < o || t === void 0 && o >= o) && (t = o, r = i);
  return r;
}
function vs(n, e) {
  let t;
  if (e === void 0)
    for (const r of n)
      r != null && (t > r || t === void 0 && r >= r) && (t = r);
  else {
    let r = -1;
    for (let i of n)
      (i = e(i, ++r, n)) != null && (t > i || t === void 0 && i >= i) && (t = i);
  }
  return t;
}
function pd(n, e) {
  let t, r = -1, i = -1;
  if (e === void 0)
    for (const o of n)
      ++i, o != null && (t > o || t === void 0 && o >= o) && (t = o, r = i);
  else
    for (let o of n)
      (o = e(o, ++i, n)) != null && (t > o || t === void 0 && o >= o) && (t = o, r = i);
  return r;
}
function ll(n, e, t = 0, r = 1 / 0, i) {
  if (e = Math.floor(e), t = Math.floor(Math.max(0, t)), r = Math.floor(Math.min(n.length - 1, r)), !(t <= e && e <= r))
    return n;
  for (i = i === void 0 ? za : ld(i); r > t; ) {
    if (r - t > 600) {
      const l = r - t + 1, c = e - t + 1, p = Math.log(l), g = 0.5 * Math.exp(2 * p / 3), d = 0.5 * Math.sqrt(p * g * (l - g) / l) * (c - l / 2 < 0 ? -1 : 1), v = Math.max(t, Math.floor(e - c * g / l + d)), b = Math.min(r, Math.floor(e + (l - c) * g / l + d));
      ll(n, e, v, b, i);
    }
    const o = n[e];
    let f = t, s = r;
    for (Eo(n, t, e), i(n[r], o) > 0 && Eo(n, t, r); f < s; ) {
      for (Eo(n, f, s), ++f, --s; i(n[f], o) < 0; )
        ++f;
      for (; i(n[s], o) > 0; )
        --s;
    }
    i(n[t], o) === 0 ? Eo(n, t, s) : (++s, Eo(n, s, r)), s <= e && (t = s + 1), e <= s && (r = s - 1);
  }
  return n;
}
function Eo(n, e, t) {
  const r = n[e];
  n[e] = n[t], n[t] = r;
}
function I2(n, e = de) {
  let t, r = !1;
  if (e.length === 1) {
    let i;
    for (const o of n) {
      const f = e(o);
      (r ? de(f, i) > 0 : de(f, f) === 0) && (t = o, i = f, r = !0);
    }
  } else
    for (const i of n)
      (r ? e(i, t) > 0 : e(i, i) === 0) && (t = i, r = !0);
  return t;
}
function tu(n, e, t) {
  if (n = Float64Array.from(zA(n, t)), !(!(r = n.length) || isNaN(e = +e))) {
    if (e <= 0 || r < 2)
      return vs(n);
    if (e >= 1)
      return eu(n);
    var r, i = (r - 1) * e, o = Math.floor(i), f = eu(ll(n, o).subarray(0, o + 1)), s = vs(n.subarray(o + 1));
    return f + (s - f) * (i - o);
  }
}
function L2(n, e, t = ds) {
  if (!(!(r = n.length) || isNaN(e = +e))) {
    if (e <= 0 || r < 2)
      return +t(n[0], 0, n);
    if (e >= 1)
      return +t(n[r - 1], r - 1, n);
    var r, i = (r - 1) * e, o = Math.floor(i), f = +t(n[o], o, n), s = +t(n[o + 1], o + 1, n);
    return f + (s - f) * (i - o);
  }
}
function D2(n, e, t = ds) {
  if (!isNaN(e = +e)) {
    if (r = Float64Array.from(n, (s, l) => ds(t(n[l], l, n))), e <= 0)
      return pd(r);
    if (e >= 1)
      return dd(r);
    var r, i = Uint32Array.from(n, (s, l) => l), o = r.length - 1, f = Math.floor(o * e);
    return ll(i, f, 0, o, (s, l) => za(r[s], r[l])), f = I2(i.subarray(0, f + 1), (s) => r[s]), f >= 0 ? f : -1;
  }
}
function cM(n, e, t) {
  const r = sl(n), i = tu(n, 0.75) - tu(n, 0.25);
  return r && i ? Math.ceil((t - e) / (2 * i * Math.pow(r, -1 / 3))) : 1;
}
function hM(n, e, t) {
  const r = sl(n), i = A2(n);
  return r && i ? Math.ceil((t - e) * Math.cbrt(r) / (3.49 * i)) : 1;
}
function dM(n, e) {
  let t = 0, r = 0;
  if (e === void 0)
    for (let i of n)
      i != null && (i = +i) >= i && (++t, r += i);
  else {
    let i = -1;
    for (let o of n)
      (o = e(o, ++i, n)) != null && (o = +o) >= o && (++t, r += o);
  }
  if (t)
    return r / t;
}
function pM(n, e) {
  return tu(n, 0.5, e);
}
function gM(n, e) {
  return D2(n, 0.5, e);
}
function* vM(n) {
  for (const e of n)
    yield* e;
}
function gd(n) {
  return Array.from(vM(n));
}
function mM(n, e) {
  const t = new nu();
  if (e === void 0)
    for (let o of n)
      o != null && o >= o && t.set(o, (t.get(o) || 0) + 1);
  else {
    let o = -1;
    for (let f of n)
      (f = e(f, ++o, n)) != null && f >= f && t.set(f, (t.get(f) || 0) + 1);
  }
  let r, i = 0;
  for (const [o, f] of t)
    f > i && (i = f, r = o);
  return r;
}
function yM(n, e = _M) {
  const t = [];
  let r, i = !1;
  for (const o of n)
    i && t.push(e(r, o)), r = o, i = !0;
  return t;
}
function _M(n, e) {
  return [n, e];
}
function ti(n, e, t) {
  n = +n, e = +e, t = (i = arguments.length) < 2 ? (e = n, n = 0, 1) : i < 3 ? 1 : +t;
  for (var r = -1, i = Math.max(0, Math.ceil((e - n) / t)) | 0, o = new Array(i); ++r < i; )
    o[r] = n + r * t;
  return o;
}
function bM(n, e = de) {
  if (typeof n[Symbol.iterator] != "function")
    throw new TypeError("values is not iterable");
  let t = Array.from(n);
  const r = new Float64Array(t.length);
  e.length !== 2 && (t = t.map(e), e = de);
  const i = (s, l) => e(t[s], t[l]);
  let o, f;
  return n = Uint32Array.from(t, (s, l) => l), n.sort(e === de ? (s, l) => za(t[s], t[l]) : ld(i)), n.forEach((s, l) => {
    const c = i(s, o === void 0 ? s : o);
    c >= 0 ? ((o === void 0 || c > 0) && (o = s, f = l), r[s] = f) : r[s] = NaN;
  }), r;
}
function wM(n, e = de) {
  let t, r = !1;
  if (e.length === 1) {
    let i;
    for (const o of n) {
      const f = e(o);
      (r ? de(f, i) < 0 : de(f, f) === 0) && (t = o, i = f, r = !0);
    }
  } else
    for (const i of n)
      (r ? e(i, t) < 0 : e(i, i) === 0) && (t = i, r = !0);
  return t;
}
function F2(n, e = de) {
  if (e.length === 1)
    return pd(n, e);
  let t, r = -1, i = -1;
  for (const o of n)
    ++i, (r < 0 ? e(o, o) === 0 : e(o, t) < 0) && (t = o, r = i);
  return r;
}
function xM(n, e = de) {
  if (e.length === 1)
    return dd(n, e);
  let t, r = -1, i = -1;
  for (const o of n)
    ++i, (r < 0 ? e(o, o) === 0 : e(o, t) > 0) && (t = o, r = i);
  return r;
}
function TM(n, e) {
  const t = F2(n, e);
  return t < 0 ? void 0 : t;
}
const AM = B2(Math.random);
function B2(n) {
  return function(t, r = 0, i = t.length) {
    let o = i - (r = +r);
    for (; o; ) {
      const f = n() * o-- | 0, s = t[o + r];
      t[o + r] = t[f + r], t[f + r] = s;
    }
    return t;
  };
}
function MM(n, e) {
  let t = 0;
  if (e === void 0)
    for (let r of n)
      (r = +r) && (t += r);
  else {
    let r = -1;
    for (let i of n)
      (i = +e(i, ++r, n)) && (t += i);
  }
  return t;
}
function z2(n) {
  if (!(o = n.length))
    return [];
  for (var e = -1, t = vs(n, SM), r = new Array(t); ++e < t; )
    for (var i = -1, o, f = r[e] = new Array(o); ++i < o; )
      f[i] = n[i][e];
  return r;
}
function SM(n) {
  return n.length;
}
function EM() {
  return z2(arguments);
}
function CM(n, e) {
  if (typeof e != "function")
    throw new TypeError("test is not a function");
  let t = -1;
  for (const r of n)
    if (!e(r, ++t, n))
      return !1;
  return !0;
}
function PM(n, e) {
  if (typeof e != "function")
    throw new TypeError("test is not a function");
  let t = -1;
  for (const r of n)
    if (e(r, ++t, n))
      return !0;
  return !1;
}
function RM(n, e) {
  if (typeof e != "function")
    throw new TypeError("test is not a function");
  const t = [];
  let r = -1;
  for (const i of n)
    e(i, ++r, n) && t.push(i);
  return t;
}
function NM(n, e) {
  if (typeof n[Symbol.iterator] != "function")
    throw new TypeError("values is not iterable");
  if (typeof e != "function")
    throw new TypeError("mapper is not a function");
  return Array.from(n, (t, r) => e(t, r, n));
}
function $M(n, e, t) {
  if (typeof e != "function")
    throw new TypeError("reducer is not a function");
  const r = n[Symbol.iterator]();
  let i, o, f = -1;
  if (arguments.length < 3) {
    if ({ done: i, value: t } = r.next(), i)
      return;
    ++f;
  }
  for (; { done: i, value: o } = r.next(), !i; )
    t = e(t, o, ++f, n);
  return t;
}
function kM(n) {
  if (typeof n[Symbol.iterator] != "function")
    throw new TypeError("values is not iterable");
  return Array.from(n).reverse();
}
function OM(n, ...e) {
  n = new Li(n);
  for (const t of e)
    for (const r of t)
      n.delete(r);
  return n;
}
function IM(n, e) {
  const t = e[Symbol.iterator](), r = new Li();
  for (const i of n) {
    if (r.has(i))
      return !1;
    let o, f;
    for (; ({ value: o, done: f } = t.next()) && !f; ) {
      if (Object.is(i, o))
        return !1;
      r.add(o);
    }
  }
  return !0;
}
function LM(n, ...e) {
  n = new Li(n), e = e.map(DM);
  n:
    for (const t of n)
      for (const r of e)
        if (!r.has(t)) {
          n.delete(t);
          continue n;
        }
  return n;
}
function DM(n) {
  return n instanceof Li ? n : new Li(n);
}
function V2(n, e) {
  const t = n[Symbol.iterator](), r = /* @__PURE__ */ new Set();
  for (const i of e) {
    const o = Ev(i);
    if (r.has(o))
      continue;
    let f, s;
    for (; { value: f, done: s } = t.next(); ) {
      if (s)
        return !1;
      const l = Ev(f);
      if (r.add(l), Object.is(o, l))
        break;
    }
  }
  return !0;
}
function Ev(n) {
  return n !== null && typeof n == "object" ? n.valueOf() : n;
}
function FM(n, e) {
  return V2(e, n);
}
function BM(...n) {
  const e = new Li();
  for (const t of n)
    for (const r of t)
      e.add(r);
  return e;
}
function zM(n) {
  return n;
}
var Kf = 1, Zf = 2, o0 = 3, Io = 4, Cv = 1e-6;
function VM(n) {
  return "translate(" + n + ",0)";
}
function UM(n) {
  return "translate(0," + n + ")";
}
function GM(n) {
  return (e) => +n(e);
}
function qM(n, e) {
  return e = Math.max(0, n.bandwidth() - e * 2) / 2, n.round() && (e = Math.round(e)), (t) => +n(t) + e;
}
function WM() {
  return !this.__axis;
}
function cl(n, e) {
  var t = [], r = null, i = null, o = 6, f = 6, s = 3, l = typeof window < "u" && window.devicePixelRatio > 1 ? 0 : 0.5, c = n === Kf || n === Io ? -1 : 1, p = n === Io || n === Zf ? "x" : "y", g = n === Kf || n === o0 ? VM : UM;
  function d(v) {
    var b = r ?? (e.ticks ? e.ticks.apply(e, t) : e.domain()), w = i ?? (e.tickFormat ? e.tickFormat.apply(e, t) : zM), m = Math.max(o, 0) + s, _ = e.range(), x = +_[0] + l, A = +_[_.length - 1] + l, T = (e.bandwidth ? qM : GM)(e.copy(), l), S = v.selection ? v.selection() : v, R = S.selectAll(".domain").data([null]), I = S.selectAll(".tick").data(b, e).order(), B = I.exit(), F = I.enter().append("g").attr("class", "tick"), V = I.select("line"), E = I.select("text");
    R = R.merge(R.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), I = I.merge(F), V = V.merge(F.append("line").attr("stroke", "currentColor").attr(p + "2", c * o)), E = E.merge(F.append("text").attr("fill", "currentColor").attr(p, c * m).attr("dy", n === Kf ? "0em" : n === o0 ? "0.71em" : "0.32em")), v !== S && (R = R.transition(v), I = I.transition(v), V = V.transition(v), E = E.transition(v), B = B.transition(v).attr("opacity", Cv).attr("transform", function(L) {
      return isFinite(L = T(L)) ? g(L + l) : this.getAttribute("transform");
    }), F.attr("opacity", Cv).attr("transform", function(L) {
      var $ = this.parentNode.__axis;
      return g(($ && isFinite($ = $(L)) ? $ : T(L)) + l);
    })), B.remove(), R.attr("d", n === Io || n === Zf ? f ? "M" + c * f + "," + x + "H" + l + "V" + A + "H" + c * f : "M" + l + "," + x + "V" + A : f ? "M" + x + "," + c * f + "V" + l + "H" + A + "V" + c * f : "M" + x + "," + l + "H" + A), I.attr("opacity", 1).attr("transform", function(L) {
      return g(T(L) + l);
    }), V.attr(p + "2", c * o), E.attr(p, c * m).text(w), S.filter(WM).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", n === Zf ? "start" : n === Io ? "end" : "middle"), S.each(function() {
      this.__axis = T;
    });
  }
  return d.scale = function(v) {
    return arguments.length ? (e = v, d) : e;
  }, d.ticks = function() {
    return t = Array.from(arguments), d;
  }, d.tickArguments = function(v) {
    return arguments.length ? (t = v == null ? [] : Array.from(v), d) : t.slice();
  }, d.tickValues = function(v) {
    return arguments.length ? (r = v == null ? null : Array.from(v), d) : r && r.slice();
  }, d.tickFormat = function(v) {
    return arguments.length ? (i = v, d) : i;
  }, d.tickSize = function(v) {
    return arguments.length ? (o = f = +v, d) : o;
  }, d.tickSizeInner = function(v) {
    return arguments.length ? (o = +v, d) : o;
  }, d.tickSizeOuter = function(v) {
    return arguments.length ? (f = +v, d) : f;
  }, d.tickPadding = function(v) {
    return arguments.length ? (s = +v, d) : s;
  }, d.offset = function(v) {
    return arguments.length ? (l = +v, d) : l;
  }, d;
}
function HM(n) {
  return cl(Kf, n);
}
function YM(n) {
  return cl(Zf, n);
}
function XM(n) {
  return cl(o0, n);
}
function KM(n) {
  return cl(Io, n);
}
var ZM = { value: () => {
} };
function Xi() {
  for (var n = 0, e = arguments.length, t = {}, r; n < e; ++n) {
    if (!(r = arguments[n] + "") || r in t || /[\s.]/.test(r))
      throw new Error("illegal type: " + r);
    t[r] = [];
  }
  return new Jf(t);
}
function Jf(n) {
  this._ = n;
}
function JM(n, e) {
  return n.trim().split(/^|\s+/).map(function(t) {
    var r = "", i = t.indexOf(".");
    if (i >= 0 && (r = t.slice(i + 1), t = t.slice(0, i)), t && !e.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    return { type: t, name: r };
  });
}
Jf.prototype = Xi.prototype = {
  constructor: Jf,
  on: function(n, e) {
    var t = this._, r = JM(n + "", t), i, o = -1, f = r.length;
    if (arguments.length < 2) {
      for (; ++o < f; )
        if ((i = (n = r[o]).type) && (i = QM(t[i], n.name)))
          return i;
      return;
    }
    if (e != null && typeof e != "function")
      throw new Error("invalid callback: " + e);
    for (; ++o < f; )
      if (i = (n = r[o]).type)
        t[i] = Pv(t[i], n.name, e);
      else if (e == null)
        for (i in t)
          t[i] = Pv(t[i], n.name, null);
    return this;
  },
  copy: function() {
    var n = {}, e = this._;
    for (var t in e)
      n[t] = e[t].slice();
    return new Jf(n);
  },
  call: function(n, e) {
    if ((i = arguments.length - 2) > 0)
      for (var t = new Array(i), r = 0, i, o; r < i; ++r)
        t[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(n))
      throw new Error("unknown type: " + n);
    for (o = this._[n], r = 0, i = o.length; r < i; ++r)
      o[r].value.apply(e, t);
  },
  apply: function(n, e, t) {
    if (!this._.hasOwnProperty(n))
      throw new Error("unknown type: " + n);
    for (var r = this._[n], i = 0, o = r.length; i < o; ++i)
      r[i].value.apply(e, t);
  }
};
function QM(n, e) {
  for (var t = 0, r = n.length, i; t < r; ++t)
    if ((i = n[t]).name === e)
      return i.value;
}
function Pv(n, e, t) {
  for (var r = 0, i = n.length; r < i; ++r)
    if (n[r].name === e) {
      n[r] = ZM, n = n.slice(0, r).concat(n.slice(r + 1));
      break;
    }
  return t != null && n.push({ name: e, value: t }), n;
}
var u0 = "http://www.w3.org/1999/xhtml";
const f0 = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: u0,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function wu(n) {
  var e = n += "", t = e.indexOf(":");
  return t >= 0 && (e = n.slice(0, t)) !== "xmlns" && (n = n.slice(t + 1)), f0.hasOwnProperty(e) ? { space: f0[e], local: n } : n;
}
function jM(n) {
  return function() {
    var e = this.ownerDocument, t = this.namespaceURI;
    return t === u0 && e.documentElement.namespaceURI === u0 ? e.createElement(n) : e.createElementNS(t, n);
  };
}
function nS(n) {
  return function() {
    return this.ownerDocument.createElementNS(n.space, n.local);
  };
}
function hl(n) {
  var e = wu(n);
  return (e.local ? nS : jM)(e);
}
function eS() {
}
function dl(n) {
  return n == null ? eS : function() {
    return this.querySelector(n);
  };
}
function tS(n) {
  typeof n != "function" && (n = dl(n));
  for (var e = this._groups, t = e.length, r = new Array(t), i = 0; i < t; ++i)
    for (var o = e[i], f = o.length, s = r[i] = new Array(f), l, c, p = 0; p < f; ++p)
      (l = o[p]) && (c = n.call(l, l.__data__, p, o)) && ("__data__" in l && (c.__data__ = l.__data__), s[p] = c);
  return new et(r, this._parents);
}
function U2(n) {
  return n == null ? [] : Array.isArray(n) ? n : Array.from(n);
}
function rS() {
  return [];
}
function vd(n) {
  return n == null ? rS : function() {
    return this.querySelectorAll(n);
  };
}
function iS(n) {
  return function() {
    return U2(n.apply(this, arguments));
  };
}
function aS(n) {
  typeof n == "function" ? n = iS(n) : n = vd(n);
  for (var e = this._groups, t = e.length, r = [], i = [], o = 0; o < t; ++o)
    for (var f = e[o], s = f.length, l, c = 0; c < s; ++c)
      (l = f[c]) && (r.push(n.call(l, l.__data__, c, f)), i.push(l));
  return new et(r, i);
}
function md(n) {
  return function() {
    return this.matches(n);
  };
}
function G2(n) {
  return function(e) {
    return e.matches(n);
  };
}
var oS = Array.prototype.find;
function uS(n) {
  return function() {
    return oS.call(this.children, n);
  };
}
function fS() {
  return this.firstElementChild;
}
function sS(n) {
  return this.select(n == null ? fS : uS(typeof n == "function" ? n : G2(n)));
}
var lS = Array.prototype.filter;
function cS() {
  return Array.from(this.children);
}
function hS(n) {
  return function() {
    return lS.call(this.children, n);
  };
}
function dS(n) {
  return this.selectAll(n == null ? cS : hS(typeof n == "function" ? n : G2(n)));
}
function pS(n) {
  typeof n != "function" && (n = md(n));
  for (var e = this._groups, t = e.length, r = new Array(t), i = 0; i < t; ++i)
    for (var o = e[i], f = o.length, s = r[i] = [], l, c = 0; c < f; ++c)
      (l = o[c]) && n.call(l, l.__data__, c, o) && s.push(l);
  return new et(r, this._parents);
}
function q2(n) {
  return new Array(n.length);
}
function gS() {
  return new et(this._enter || this._groups.map(q2), this._parents);
}
function ms(n, e) {
  this.ownerDocument = n.ownerDocument, this.namespaceURI = n.namespaceURI, this._next = null, this._parent = n, this.__data__ = e;
}
ms.prototype = {
  constructor: ms,
  appendChild: function(n) {
    return this._parent.insertBefore(n, this._next);
  },
  insertBefore: function(n, e) {
    return this._parent.insertBefore(n, e);
  },
  querySelector: function(n) {
    return this._parent.querySelector(n);
  },
  querySelectorAll: function(n) {
    return this._parent.querySelectorAll(n);
  }
};
function vS(n) {
  return function() {
    return n;
  };
}
function mS(n, e, t, r, i, o) {
  for (var f = 0, s, l = e.length, c = o.length; f < c; ++f)
    (s = e[f]) ? (s.__data__ = o[f], r[f] = s) : t[f] = new ms(n, o[f]);
  for (; f < l; ++f)
    (s = e[f]) && (i[f] = s);
}
function yS(n, e, t, r, i, o, f) {
  var s, l, c = /* @__PURE__ */ new Map(), p = e.length, g = o.length, d = new Array(p), v;
  for (s = 0; s < p; ++s)
    (l = e[s]) && (d[s] = v = f.call(l, l.__data__, s, e) + "", c.has(v) ? i[s] = l : c.set(v, l));
  for (s = 0; s < g; ++s)
    v = f.call(n, o[s], s, o) + "", (l = c.get(v)) ? (r[s] = l, l.__data__ = o[s], c.delete(v)) : t[s] = new ms(n, o[s]);
  for (s = 0; s < p; ++s)
    (l = e[s]) && c.get(d[s]) === l && (i[s] = l);
}
function _S(n) {
  return n.__data__;
}
function bS(n, e) {
  if (!arguments.length)
    return Array.from(this, _S);
  var t = e ? yS : mS, r = this._parents, i = this._groups;
  typeof n != "function" && (n = vS(n));
  for (var o = i.length, f = new Array(o), s = new Array(o), l = new Array(o), c = 0; c < o; ++c) {
    var p = r[c], g = i[c], d = g.length, v = wS(n.call(p, p && p.__data__, c, r)), b = v.length, w = s[c] = new Array(b), m = f[c] = new Array(b), _ = l[c] = new Array(d);
    t(p, g, w, m, _, v, e);
    for (var x = 0, A = 0, T, S; x < b; ++x)
      if (T = w[x]) {
        for (x >= A && (A = x + 1); !(S = m[A]) && ++A < b; )
          ;
        T._next = S || null;
      }
  }
  return f = new et(f, r), f._enter = s, f._exit = l, f;
}
function wS(n) {
  return typeof n == "object" && "length" in n ? n : Array.from(n);
}
function xS() {
  return new et(this._exit || this._groups.map(q2), this._parents);
}
function TS(n, e, t) {
  var r = this.enter(), i = this, o = this.exit();
  return typeof n == "function" ? (r = n(r), r && (r = r.selection())) : r = r.append(n + ""), e != null && (i = e(i), i && (i = i.selection())), t == null ? o.remove() : t(o), r && i ? r.merge(i).order() : i;
}
function AS(n) {
  for (var e = n.selection ? n.selection() : n, t = this._groups, r = e._groups, i = t.length, o = r.length, f = Math.min(i, o), s = new Array(i), l = 0; l < f; ++l)
    for (var c = t[l], p = r[l], g = c.length, d = s[l] = new Array(g), v, b = 0; b < g; ++b)
      (v = c[b] || p[b]) && (d[b] = v);
  for (; l < i; ++l)
    s[l] = t[l];
  return new et(s, this._parents);
}
function MS() {
  for (var n = this._groups, e = -1, t = n.length; ++e < t; )
    for (var r = n[e], i = r.length - 1, o = r[i], f; --i >= 0; )
      (f = r[i]) && (o && f.compareDocumentPosition(o) ^ 4 && o.parentNode.insertBefore(f, o), o = f);
  return this;
}
function SS(n) {
  n || (n = ES);
  function e(g, d) {
    return g && d ? n(g.__data__, d.__data__) : !g - !d;
  }
  for (var t = this._groups, r = t.length, i = new Array(r), o = 0; o < r; ++o) {
    for (var f = t[o], s = f.length, l = i[o] = new Array(s), c, p = 0; p < s; ++p)
      (c = f[p]) && (l[p] = c);
    l.sort(e);
  }
  return new et(i, this._parents).order();
}
function ES(n, e) {
  return n < e ? -1 : n > e ? 1 : n >= e ? 0 : NaN;
}
function CS() {
  var n = arguments[0];
  return arguments[0] = this, n.apply(null, arguments), this;
}
function PS() {
  return Array.from(this);
}
function RS() {
  for (var n = this._groups, e = 0, t = n.length; e < t; ++e)
    for (var r = n[e], i = 0, o = r.length; i < o; ++i) {
      var f = r[i];
      if (f)
        return f;
    }
  return null;
}
function NS() {
  let n = 0;
  for (const e of this)
    ++n;
  return n;
}
function $S() {
  return !this.node();
}
function kS(n) {
  for (var e = this._groups, t = 0, r = e.length; t < r; ++t)
    for (var i = e[t], o = 0, f = i.length, s; o < f; ++o)
      (s = i[o]) && n.call(s, s.__data__, o, i);
  return this;
}
function OS(n) {
  return function() {
    this.removeAttribute(n);
  };
}
function IS(n) {
  return function() {
    this.removeAttributeNS(n.space, n.local);
  };
}
function LS(n, e) {
  return function() {
    this.setAttribute(n, e);
  };
}
function DS(n, e) {
  return function() {
    this.setAttributeNS(n.space, n.local, e);
  };
}
function FS(n, e) {
  return function() {
    var t = e.apply(this, arguments);
    t == null ? this.removeAttribute(n) : this.setAttribute(n, t);
  };
}
function BS(n, e) {
  return function() {
    var t = e.apply(this, arguments);
    t == null ? this.removeAttributeNS(n.space, n.local) : this.setAttributeNS(n.space, n.local, t);
  };
}
function zS(n, e) {
  var t = wu(n);
  if (arguments.length < 2) {
    var r = this.node();
    return t.local ? r.getAttributeNS(t.space, t.local) : r.getAttribute(t);
  }
  return this.each((e == null ? t.local ? IS : OS : typeof e == "function" ? t.local ? BS : FS : t.local ? DS : LS)(t, e));
}
function yd(n) {
  return n.ownerDocument && n.ownerDocument.defaultView || n.document && n || n.defaultView;
}
function VS(n) {
  return function() {
    this.style.removeProperty(n);
  };
}
function US(n, e, t) {
  return function() {
    this.style.setProperty(n, e, t);
  };
}
function GS(n, e, t) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.style.removeProperty(n) : this.style.setProperty(n, r, t);
  };
}
function qS(n, e, t) {
  return arguments.length > 1 ? this.each((e == null ? VS : typeof e == "function" ? GS : US)(n, e, t ?? "")) : Bi(this.node(), n);
}
function Bi(n, e) {
  return n.style.getPropertyValue(e) || yd(n).getComputedStyle(n, null).getPropertyValue(e);
}
function WS(n) {
  return function() {
    delete this[n];
  };
}
function HS(n, e) {
  return function() {
    this[n] = e;
  };
}
function YS(n, e) {
  return function() {
    var t = e.apply(this, arguments);
    t == null ? delete this[n] : this[n] = t;
  };
}
function XS(n, e) {
  return arguments.length > 1 ? this.each((e == null ? WS : typeof e == "function" ? YS : HS)(n, e)) : this.node()[n];
}
function W2(n) {
  return n.trim().split(/^|\s+/);
}
function _d(n) {
  return n.classList || new H2(n);
}
function H2(n) {
  this._node = n, this._names = W2(n.getAttribute("class") || "");
}
H2.prototype = {
  add: function(n) {
    var e = this._names.indexOf(n);
    e < 0 && (this._names.push(n), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(n) {
    var e = this._names.indexOf(n);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(n) {
    return this._names.indexOf(n) >= 0;
  }
};
function Y2(n, e) {
  for (var t = _d(n), r = -1, i = e.length; ++r < i; )
    t.add(e[r]);
}
function X2(n, e) {
  for (var t = _d(n), r = -1, i = e.length; ++r < i; )
    t.remove(e[r]);
}
function KS(n) {
  return function() {
    Y2(this, n);
  };
}
function ZS(n) {
  return function() {
    X2(this, n);
  };
}
function JS(n, e) {
  return function() {
    (e.apply(this, arguments) ? Y2 : X2)(this, n);
  };
}
function QS(n, e) {
  var t = W2(n + "");
  if (arguments.length < 2) {
    for (var r = _d(this.node()), i = -1, o = t.length; ++i < o; )
      if (!r.contains(t[i]))
        return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? JS : e ? KS : ZS)(t, e));
}
function jS() {
  this.textContent = "";
}
function nE(n) {
  return function() {
    this.textContent = n;
  };
}
function eE(n) {
  return function() {
    var e = n.apply(this, arguments);
    this.textContent = e ?? "";
  };
}
function tE(n) {
  return arguments.length ? this.each(n == null ? jS : (typeof n == "function" ? eE : nE)(n)) : this.node().textContent;
}
function rE() {
  this.innerHTML = "";
}
function iE(n) {
  return function() {
    this.innerHTML = n;
  };
}
function aE(n) {
  return function() {
    var e = n.apply(this, arguments);
    this.innerHTML = e ?? "";
  };
}
function oE(n) {
  return arguments.length ? this.each(n == null ? rE : (typeof n == "function" ? aE : iE)(n)) : this.node().innerHTML;
}
function uE() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function fE() {
  return this.each(uE);
}
function sE() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function lE() {
  return this.each(sE);
}
function cE(n) {
  var e = typeof n == "function" ? n : hl(n);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function hE() {
  return null;
}
function dE(n, e) {
  var t = typeof n == "function" ? n : hl(n), r = e == null ? hE : typeof e == "function" ? e : dl(e);
  return this.select(function() {
    return this.insertBefore(t.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function pE() {
  var n = this.parentNode;
  n && n.removeChild(this);
}
function gE() {
  return this.each(pE);
}
function vE() {
  var n = this.cloneNode(!1), e = this.parentNode;
  return e ? e.insertBefore(n, this.nextSibling) : n;
}
function mE() {
  var n = this.cloneNode(!0), e = this.parentNode;
  return e ? e.insertBefore(n, this.nextSibling) : n;
}
function yE(n) {
  return this.select(n ? mE : vE);
}
function _E(n) {
  return arguments.length ? this.property("__data__", n) : this.node().__data__;
}
function bE(n) {
  return function(e) {
    n.call(this, e, this.__data__);
  };
}
function wE(n) {
  return n.trim().split(/^|\s+/).map(function(e) {
    var t = "", r = e.indexOf(".");
    return r >= 0 && (t = e.slice(r + 1), e = e.slice(0, r)), { type: e, name: t };
  });
}
function xE(n) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var t = 0, r = -1, i = e.length, o; t < i; ++t)
        o = e[t], (!n.type || o.type === n.type) && o.name === n.name ? this.removeEventListener(o.type, o.listener, o.options) : e[++r] = o;
      ++r ? e.length = r : delete this.__on;
    }
  };
}
function TE(n, e, t) {
  return function() {
    var r = this.__on, i, o = bE(e);
    if (r) {
      for (var f = 0, s = r.length; f < s; ++f)
        if ((i = r[f]).type === n.type && i.name === n.name) {
          this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = o, i.options = t), i.value = e;
          return;
        }
    }
    this.addEventListener(n.type, o, t), i = { type: n.type, name: n.name, value: e, listener: o, options: t }, r ? r.push(i) : this.__on = [i];
  };
}
function AE(n, e, t) {
  var r = wE(n + ""), i, o = r.length, f;
  if (arguments.length < 2) {
    var s = this.node().__on;
    if (s) {
      for (var l = 0, c = s.length, p; l < c; ++l)
        for (i = 0, p = s[l]; i < o; ++i)
          if ((f = r[i]).type === p.type && f.name === p.name)
            return p.value;
    }
    return;
  }
  for (s = e ? TE : xE, i = 0; i < o; ++i)
    this.each(s(r[i], e, t));
  return this;
}
function K2(n, e, t) {
  var r = yd(n), i = r.CustomEvent;
  typeof i == "function" ? i = new i(e, t) : (i = r.document.createEvent("Event"), t ? (i.initEvent(e, t.bubbles, t.cancelable), i.detail = t.detail) : i.initEvent(e, !1, !1)), n.dispatchEvent(i);
}
function ME(n, e) {
  return function() {
    return K2(this, n, e);
  };
}
function SE(n, e) {
  return function() {
    return K2(this, n, e.apply(this, arguments));
  };
}
function EE(n, e) {
  return this.each((typeof e == "function" ? SE : ME)(n, e));
}
function* CE() {
  for (var n = this._groups, e = 0, t = n.length; e < t; ++e)
    for (var r = n[e], i = 0, o = r.length, f; i < o; ++i)
      (f = r[i]) && (yield f);
}
var bd = [null];
function et(n, e) {
  this._groups = n, this._parents = e;
}
function Ki() {
  return new et([[document.documentElement]], bd);
}
function PE() {
  return this;
}
et.prototype = Ki.prototype = {
  constructor: et,
  select: tS,
  selectAll: aS,
  selectChild: sS,
  selectChildren: dS,
  filter: pS,
  data: bS,
  enter: gS,
  exit: xS,
  join: TS,
  merge: AS,
  selection: PE,
  order: MS,
  sort: SS,
  call: CS,
  nodes: PS,
  node: RS,
  size: NS,
  empty: $S,
  each: kS,
  attr: zS,
  style: qS,
  property: XS,
  classed: QS,
  text: tE,
  html: oE,
  raise: fE,
  lower: lE,
  append: cE,
  insert: dE,
  remove: gE,
  clone: yE,
  datum: _E,
  on: AE,
  dispatch: EE,
  [Symbol.iterator]: CE
};
function qe(n) {
  return typeof n == "string" ? new et([[document.querySelector(n)]], [document.documentElement]) : new et([[n]], bd);
}
function RE(n) {
  return qe(hl(n).call(document.documentElement));
}
var NE = 0;
function Z2() {
  return new s0();
}
function s0() {
  this._ = "@" + (++NE).toString(36);
}
s0.prototype = Z2.prototype = {
  constructor: s0,
  get: function(n) {
    for (var e = this._; !(e in n); )
      if (!(n = n.parentNode))
        return;
    return n[e];
  },
  set: function(n, e) {
    return n[this._] = e;
  },
  remove: function(n) {
    return this._ in n && delete n[this._];
  },
  toString: function() {
    return this._;
  }
};
function J2(n) {
  let e;
  for (; e = n.sourceEvent; )
    n = e;
  return n;
}
function bt(n, e) {
  if (n = J2(n), e === void 0 && (e = n.currentTarget), e) {
    var t = e.ownerSVGElement || e;
    if (t.createSVGPoint) {
      var r = t.createSVGPoint();
      return r.x = n.clientX, r.y = n.clientY, r = r.matrixTransform(e.getScreenCTM().inverse()), [r.x, r.y];
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect();
      return [n.clientX - i.left - e.clientLeft, n.clientY - i.top - e.clientTop];
    }
  }
  return [n.pageX, n.pageY];
}
function $E(n, e) {
  return n.target && (n = J2(n), e === void 0 && (e = n.currentTarget), n = n.touches || [n]), Array.from(n, (t) => bt(t, e));
}
function kE(n) {
  return typeof n == "string" ? new et([document.querySelectorAll(n)], [document.documentElement]) : new et([U2(n)], bd);
}
const OE = { passive: !1 }, ru = { capture: !0, passive: !1 };
function gh(n) {
  n.stopImmediatePropagation();
}
function Oa(n) {
  n.preventDefault(), n.stopImmediatePropagation();
}
function pl(n) {
  var e = n.document.documentElement, t = qe(n).on("dragstart.drag", Oa, ru);
  "onselectstart" in e ? t.on("selectstart.drag", Oa, ru) : (e.__noselect = e.style.MozUserSelect, e.style.MozUserSelect = "none");
}
function gl(n, e) {
  var t = n.document.documentElement, r = qe(n).on("dragstart.drag", null);
  e && (r.on("click.drag", Oa, ru), setTimeout(function() {
    r.on("click.drag", null);
  }, 0)), "onselectstart" in t ? r.on("selectstart.drag", null) : (t.style.MozUserSelect = t.__noselect, delete t.__noselect);
}
const Af = (n) => () => n;
function l0(n, {
  sourceEvent: e,
  subject: t,
  target: r,
  identifier: i,
  active: o,
  x: f,
  y: s,
  dx: l,
  dy: c,
  dispatch: p
}) {
  Object.defineProperties(this, {
    type: { value: n, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    subject: { value: t, enumerable: !0, configurable: !0 },
    target: { value: r, enumerable: !0, configurable: !0 },
    identifier: { value: i, enumerable: !0, configurable: !0 },
    active: { value: o, enumerable: !0, configurable: !0 },
    x: { value: f, enumerable: !0, configurable: !0 },
    y: { value: s, enumerable: !0, configurable: !0 },
    dx: { value: l, enumerable: !0, configurable: !0 },
    dy: { value: c, enumerable: !0, configurable: !0 },
    _: { value: p }
  });
}
l0.prototype.on = function() {
  var n = this._.on.apply(this._, arguments);
  return n === this._ ? this : n;
};
function IE(n) {
  return !n.ctrlKey && !n.button;
}
function LE() {
  return this.parentNode;
}
function DE(n, e) {
  return e ?? { x: n.x, y: n.y };
}
function FE() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function BE() {
  var n = IE, e = LE, t = DE, r = FE, i = {}, o = Xi("start", "drag", "end"), f = 0, s, l, c, p, g = 0;
  function d(T) {
    T.on("mousedown.drag", v).filter(r).on("touchstart.drag", m).on("touchmove.drag", _, OE).on("touchend.drag touchcancel.drag", x).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function v(T, S) {
    if (!(p || !n.call(this, T, S))) {
      var R = A(this, e.call(this, T, S), T, S, "mouse");
      R && (qe(T.view).on("mousemove.drag", b, ru).on("mouseup.drag", w, ru), pl(T.view), gh(T), c = !1, s = T.clientX, l = T.clientY, R("start", T));
    }
  }
  function b(T) {
    if (Oa(T), !c) {
      var S = T.clientX - s, R = T.clientY - l;
      c = S * S + R * R > g;
    }
    i.mouse("drag", T);
  }
  function w(T) {
    qe(T.view).on("mousemove.drag mouseup.drag", null), gl(T.view, c), Oa(T), i.mouse("end", T);
  }
  function m(T, S) {
    if (n.call(this, T, S)) {
      var R = T.changedTouches, I = e.call(this, T, S), B = R.length, F, V;
      for (F = 0; F < B; ++F)
        (V = A(this, I, T, S, R[F].identifier, R[F])) && (gh(T), V("start", T, R[F]));
    }
  }
  function _(T) {
    var S = T.changedTouches, R = S.length, I, B;
    for (I = 0; I < R; ++I)
      (B = i[S[I].identifier]) && (Oa(T), B("drag", T, S[I]));
  }
  function x(T) {
    var S = T.changedTouches, R = S.length, I, B;
    for (p && clearTimeout(p), p = setTimeout(function() {
      p = null;
    }, 500), I = 0; I < R; ++I)
      (B = i[S[I].identifier]) && (gh(T), B("end", T, S[I]));
  }
  function A(T, S, R, I, B, F) {
    var V = o.copy(), E = bt(F || R, S), L, $, P;
    if ((P = t.call(T, new l0("beforestart", {
      sourceEvent: R,
      target: d,
      identifier: B,
      active: f,
      x: E[0],
      y: E[1],
      dx: 0,
      dy: 0,
      dispatch: V
    }), I)) != null)
      return L = P.x - E[0] || 0, $ = P.y - E[1] || 0, function k(O, W, K) {
        var Q = E, z;
        switch (O) {
          case "start":
            i[B] = k, z = f++;
            break;
          case "end":
            delete i[B], --f;
          case "drag":
            E = bt(K || W, S), z = f;
            break;
        }
        V.call(
          O,
          T,
          new l0(O, {
            sourceEvent: W,
            subject: P,
            target: d,
            identifier: B,
            active: z,
            x: E[0] + L,
            y: E[1] + $,
            dx: E[0] - Q[0],
            dy: E[1] - Q[1],
            dispatch: V
          }),
          I
        );
      };
  }
  return d.filter = function(T) {
    return arguments.length ? (n = typeof T == "function" ? T : Af(!!T), d) : n;
  }, d.container = function(T) {
    return arguments.length ? (e = typeof T == "function" ? T : Af(T), d) : e;
  }, d.subject = function(T) {
    return arguments.length ? (t = typeof T == "function" ? T : Af(T), d) : t;
  }, d.touchable = function(T) {
    return arguments.length ? (r = typeof T == "function" ? T : Af(!!T), d) : r;
  }, d.on = function() {
    var T = o.on.apply(o, arguments);
    return T === o ? d : T;
  }, d.clickDistance = function(T) {
    return arguments.length ? (g = (T = +T) * T, d) : Math.sqrt(g);
  }, d;
}
function ro(n, e, t) {
  n.prototype = e.prototype = t, t.constructor = n;
}
function xu(n, e) {
  var t = Object.create(n.prototype);
  for (var r in e)
    t[r] = e[r];
  return t;
}
function si() {
}
var zi = 0.7, Va = 1 / zi, Ia = "\\s*([+-]?\\d+)\\s*", iu = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", sr = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", zE = /^#([0-9a-f]{3,8})$/, VE = new RegExp(`^rgb\\(${Ia},${Ia},${Ia}\\)$`), UE = new RegExp(`^rgb\\(${sr},${sr},${sr}\\)$`), GE = new RegExp(`^rgba\\(${Ia},${Ia},${Ia},${iu}\\)$`), qE = new RegExp(`^rgba\\(${sr},${sr},${sr},${iu}\\)$`), WE = new RegExp(`^hsl\\(${iu},${sr},${sr}\\)$`), HE = new RegExp(`^hsla\\(${iu},${sr},${sr},${iu}\\)$`), Rv = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
ro(si, ai, {
  copy(n) {
    return Object.assign(new this.constructor(), this, n);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Nv,
  // Deprecated! Use color.formatHex.
  formatHex: Nv,
  formatHex8: YE,
  formatHsl: XE,
  formatRgb: $v,
  toString: $v
});
function Nv() {
  return this.rgb().formatHex();
}
function YE() {
  return this.rgb().formatHex8();
}
function XE() {
  return Q2(this).formatHsl();
}
function $v() {
  return this.rgb().formatRgb();
}
function ai(n) {
  var e, t;
  return n = (n + "").trim().toLowerCase(), (e = zE.exec(n)) ? (t = e[1].length, e = parseInt(e[1], 16), t === 6 ? kv(e) : t === 3 ? new Ce(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : t === 8 ? Mf(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : t === 4 ? Mf(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = VE.exec(n)) ? new Ce(e[1], e[2], e[3], 1) : (e = UE.exec(n)) ? new Ce(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = GE.exec(n)) ? Mf(e[1], e[2], e[3], e[4]) : (e = qE.exec(n)) ? Mf(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = WE.exec(n)) ? Lv(e[1], e[2] / 100, e[3] / 100, 1) : (e = HE.exec(n)) ? Lv(e[1], e[2] / 100, e[3] / 100, e[4]) : Rv.hasOwnProperty(n) ? kv(Rv[n]) : n === "transparent" ? new Ce(NaN, NaN, NaN, 0) : null;
}
function kv(n) {
  return new Ce(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
}
function Mf(n, e, t, r) {
  return r <= 0 && (n = e = t = NaN), new Ce(n, e, t, r);
}
function wd(n) {
  return n instanceof si || (n = ai(n)), n ? (n = n.rgb(), new Ce(n.r, n.g, n.b, n.opacity)) : new Ce();
}
function Ua(n, e, t, r) {
  return arguments.length === 1 ? wd(n) : new Ce(n, e, t, r ?? 1);
}
function Ce(n, e, t, r) {
  this.r = +n, this.g = +e, this.b = +t, this.opacity = +r;
}
ro(Ce, Ua, xu(si, {
  brighter(n) {
    return n = n == null ? Va : Math.pow(Va, n), new Ce(this.r * n, this.g * n, this.b * n, this.opacity);
  },
  darker(n) {
    return n = n == null ? zi : Math.pow(zi, n), new Ce(this.r * n, this.g * n, this.b * n, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Ce(ki(this.r), ki(this.g), ki(this.b), ys(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Ov,
  // Deprecated! Use color.formatHex.
  formatHex: Ov,
  formatHex8: KE,
  formatRgb: Iv,
  toString: Iv
}));
function Ov() {
  return `#${Ni(this.r)}${Ni(this.g)}${Ni(this.b)}`;
}
function KE() {
  return `#${Ni(this.r)}${Ni(this.g)}${Ni(this.b)}${Ni((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Iv() {
  const n = ys(this.opacity);
  return `${n === 1 ? "rgb(" : "rgba("}${ki(this.r)}, ${ki(this.g)}, ${ki(this.b)}${n === 1 ? ")" : `, ${n})`}`;
}
function ys(n) {
  return isNaN(n) ? 1 : Math.max(0, Math.min(1, n));
}
function ki(n) {
  return Math.max(0, Math.min(255, Math.round(n) || 0));
}
function Ni(n) {
  return n = ki(n), (n < 16 ? "0" : "") + n.toString(16);
}
function Lv(n, e, t, r) {
  return r <= 0 ? n = e = t = NaN : t <= 0 || t >= 1 ? n = e = NaN : e <= 0 && (n = NaN), new Wt(n, e, t, r);
}
function Q2(n) {
  if (n instanceof Wt)
    return new Wt(n.h, n.s, n.l, n.opacity);
  if (n instanceof si || (n = ai(n)), !n)
    return new Wt();
  if (n instanceof Wt)
    return n;
  n = n.rgb();
  var e = n.r / 255, t = n.g / 255, r = n.b / 255, i = Math.min(e, t, r), o = Math.max(e, t, r), f = NaN, s = o - i, l = (o + i) / 2;
  return s ? (e === o ? f = (t - r) / s + (t < r) * 6 : t === o ? f = (r - e) / s + 2 : f = (e - t) / s + 4, s /= l < 0.5 ? o + i : 2 - o - i, f *= 60) : s = l > 0 && l < 1 ? 0 : f, new Wt(f, s, l, n.opacity);
}
function _s(n, e, t, r) {
  return arguments.length === 1 ? Q2(n) : new Wt(n, e, t, r ?? 1);
}
function Wt(n, e, t, r) {
  this.h = +n, this.s = +e, this.l = +t, this.opacity = +r;
}
ro(Wt, _s, xu(si, {
  brighter(n) {
    return n = n == null ? Va : Math.pow(Va, n), new Wt(this.h, this.s, this.l * n, this.opacity);
  },
  darker(n) {
    return n = n == null ? zi : Math.pow(zi, n), new Wt(this.h, this.s, this.l * n, this.opacity);
  },
  rgb() {
    var n = this.h % 360 + (this.h < 0) * 360, e = isNaN(n) || isNaN(this.s) ? 0 : this.s, t = this.l, r = t + (t < 0.5 ? t : 1 - t) * e, i = 2 * t - r;
    return new Ce(
      vh(n >= 240 ? n - 240 : n + 120, i, r),
      vh(n, i, r),
      vh(n < 120 ? n + 240 : n - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new Wt(Dv(this.h), Sf(this.s), Sf(this.l), ys(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const n = ys(this.opacity);
    return `${n === 1 ? "hsl(" : "hsla("}${Dv(this.h)}, ${Sf(this.s) * 100}%, ${Sf(this.l) * 100}%${n === 1 ? ")" : `, ${n})`}`;
  }
}));
function Dv(n) {
  return n = (n || 0) % 360, n < 0 ? n + 360 : n;
}
function Sf(n) {
  return Math.max(0, Math.min(1, n || 0));
}
function vh(n, e, t) {
  return (n < 60 ? e + (t - e) * n / 60 : n < 180 ? t : n < 240 ? e + (t - e) * (240 - n) / 60 : e) * 255;
}
const j2 = Math.PI / 180, n_ = 180 / Math.PI, bs = 18, e_ = 0.96422, t_ = 1, r_ = 0.82521, i_ = 4 / 29, La = 6 / 29, a_ = 3 * La * La, ZE = La * La * La;
function o_(n) {
  if (n instanceof Jt)
    return new Jt(n.l, n.a, n.b, n.opacity);
  if (n instanceof ur)
    return f_(n);
  n instanceof Ce || (n = wd(n));
  var e = bh(n.r), t = bh(n.g), r = bh(n.b), i = mh((0.2225045 * e + 0.7168786 * t + 0.0606169 * r) / t_), o, f;
  return e === t && t === r ? o = f = i : (o = mh((0.4360747 * e + 0.3850649 * t + 0.1430804 * r) / e_), f = mh((0.0139322 * e + 0.0971045 * t + 0.7141733 * r) / r_)), new Jt(116 * i - 16, 500 * (o - i), 200 * (i - f), n.opacity);
}
function JE(n, e) {
  return new Jt(n, 0, 0, e ?? 1);
}
function ws(n, e, t, r) {
  return arguments.length === 1 ? o_(n) : new Jt(n, e, t, r ?? 1);
}
function Jt(n, e, t, r) {
  this.l = +n, this.a = +e, this.b = +t, this.opacity = +r;
}
ro(Jt, ws, xu(si, {
  brighter(n) {
    return new Jt(this.l + bs * (n ?? 1), this.a, this.b, this.opacity);
  },
  darker(n) {
    return new Jt(this.l - bs * (n ?? 1), this.a, this.b, this.opacity);
  },
  rgb() {
    var n = (this.l + 16) / 116, e = isNaN(this.a) ? n : n + this.a / 500, t = isNaN(this.b) ? n : n - this.b / 200;
    return e = e_ * yh(e), n = t_ * yh(n), t = r_ * yh(t), new Ce(
      _h(3.1338561 * e - 1.6168667 * n - 0.4906146 * t),
      _h(-0.9787684 * e + 1.9161415 * n + 0.033454 * t),
      _h(0.0719453 * e - 0.2289914 * n + 1.4052427 * t),
      this.opacity
    );
  }
}));
function mh(n) {
  return n > ZE ? Math.pow(n, 1 / 3) : n / a_ + i_;
}
function yh(n) {
  return n > La ? n * n * n : a_ * (n - i_);
}
function _h(n) {
  return 255 * (n <= 31308e-7 ? 12.92 * n : 1.055 * Math.pow(n, 1 / 2.4) - 0.055);
}
function bh(n) {
  return (n /= 255) <= 0.04045 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
}
function u_(n) {
  if (n instanceof ur)
    return new ur(n.h, n.c, n.l, n.opacity);
  if (n instanceof Jt || (n = o_(n)), n.a === 0 && n.b === 0)
    return new ur(NaN, 0 < n.l && n.l < 100 ? 0 : NaN, n.l, n.opacity);
  var e = Math.atan2(n.b, n.a) * n_;
  return new ur(e < 0 ? e + 360 : e, Math.sqrt(n.a * n.a + n.b * n.b), n.l, n.opacity);
}
function QE(n, e, t, r) {
  return arguments.length === 1 ? u_(n) : new ur(t, e, n, r ?? 1);
}
function xs(n, e, t, r) {
  return arguments.length === 1 ? u_(n) : new ur(n, e, t, r ?? 1);
}
function ur(n, e, t, r) {
  this.h = +n, this.c = +e, this.l = +t, this.opacity = +r;
}
function f_(n) {
  if (isNaN(n.h))
    return new Jt(n.l, 0, 0, n.opacity);
  var e = n.h * j2;
  return new Jt(n.l, Math.cos(e) * n.c, Math.sin(e) * n.c, n.opacity);
}
ro(ur, xs, xu(si, {
  brighter(n) {
    return new ur(this.h, this.c, this.l + bs * (n ?? 1), this.opacity);
  },
  darker(n) {
    return new ur(this.h, this.c, this.l - bs * (n ?? 1), this.opacity);
  },
  rgb() {
    return f_(this).rgb();
  }
}));
var s_ = -0.14861, xd = 1.78277, Td = -0.29227, vl = -0.90649, au = 1.97294, Fv = au * vl, Bv = au * xd, zv = xd * Td - vl * s_;
function jE(n) {
  if (n instanceof Oi)
    return new Oi(n.h, n.s, n.l, n.opacity);
  n instanceof Ce || (n = wd(n));
  var e = n.r / 255, t = n.g / 255, r = n.b / 255, i = (zv * r + Fv * e - Bv * t) / (zv + Fv - Bv), o = r - i, f = (au * (t - i) - Td * o) / vl, s = Math.sqrt(f * f + o * o) / (au * i * (1 - i)), l = s ? Math.atan2(f, o) * n_ - 120 : NaN;
  return new Oi(l < 0 ? l + 360 : l, s, i, n.opacity);
}
function Qt(n, e, t, r) {
  return arguments.length === 1 ? jE(n) : new Oi(n, e, t, r ?? 1);
}
function Oi(n, e, t, r) {
  this.h = +n, this.s = +e, this.l = +t, this.opacity = +r;
}
ro(Oi, Qt, xu(si, {
  brighter(n) {
    return n = n == null ? Va : Math.pow(Va, n), new Oi(this.h, this.s, this.l * n, this.opacity);
  },
  darker(n) {
    return n = n == null ? zi : Math.pow(zi, n), new Oi(this.h, this.s, this.l * n, this.opacity);
  },
  rgb() {
    var n = isNaN(this.h) ? 0 : (this.h + 120) * j2, e = +this.l, t = isNaN(this.s) ? 0 : this.s * e * (1 - e), r = Math.cos(n), i = Math.sin(n);
    return new Ce(
      255 * (e + t * (s_ * r + xd * i)),
      255 * (e + t * (Td * r + vl * i)),
      255 * (e + t * (au * r)),
      this.opacity
    );
  }
}));
function l_(n, e, t, r, i) {
  var o = n * n, f = o * n;
  return ((1 - 3 * n + 3 * o - f) * e + (4 - 6 * o + 3 * f) * t + (1 + 3 * n + 3 * o - 3 * f) * r + f * i) / 6;
}
function c_(n) {
  var e = n.length - 1;
  return function(t) {
    var r = t <= 0 ? t = 0 : t >= 1 ? (t = 1, e - 1) : Math.floor(t * e), i = n[r], o = n[r + 1], f = r > 0 ? n[r - 1] : 2 * i - o, s = r < e - 1 ? n[r + 2] : 2 * o - i;
    return l_((t - r / e) * e, f, i, o, s);
  };
}
function h_(n) {
  var e = n.length;
  return function(t) {
    var r = Math.floor(((t %= 1) < 0 ? ++t : t) * e), i = n[(r + e - 1) % e], o = n[r % e], f = n[(r + 1) % e], s = n[(r + 2) % e];
    return l_((t - r / e) * e, i, o, f, s);
  };
}
const ml = (n) => () => n;
function d_(n, e) {
  return function(t) {
    return n + t * e;
  };
}
function nC(n, e, t) {
  return n = Math.pow(n, t), e = Math.pow(e, t) - n, t = 1 / t, function(r) {
    return Math.pow(n + r * e, t);
  };
}
function yl(n, e) {
  var t = e - n;
  return t ? d_(n, t > 180 || t < -180 ? t - 360 * Math.round(t / 360) : t) : ml(isNaN(n) ? e : n);
}
function eC(n) {
  return (n = +n) == 1 ? Pe : function(e, t) {
    return t - e ? nC(e, t, n) : ml(isNaN(e) ? t : e);
  };
}
function Pe(n, e) {
  var t = e - n;
  return t ? d_(n, t) : ml(isNaN(n) ? e : n);
}
const ou = function n(e) {
  var t = eC(e);
  function r(i, o) {
    var f = t((i = Ua(i)).r, (o = Ua(o)).r), s = t(i.g, o.g), l = t(i.b, o.b), c = Pe(i.opacity, o.opacity);
    return function(p) {
      return i.r = f(p), i.g = s(p), i.b = l(p), i.opacity = c(p), i + "";
    };
  }
  return r.gamma = n, r;
}(1);
function p_(n) {
  return function(e) {
    var t = e.length, r = new Array(t), i = new Array(t), o = new Array(t), f, s;
    for (f = 0; f < t; ++f)
      s = Ua(e[f]), r[f] = s.r || 0, i[f] = s.g || 0, o[f] = s.b || 0;
    return r = n(r), i = n(i), o = n(o), s.opacity = 1, function(l) {
      return s.r = r(l), s.g = i(l), s.b = o(l), s + "";
    };
  };
}
var g_ = p_(c_), tC = p_(h_);
function Ad(n, e) {
  e || (e = []);
  var t = n ? Math.min(e.length, n.length) : 0, r = e.slice(), i;
  return function(o) {
    for (i = 0; i < t; ++i)
      r[i] = n[i] * (1 - o) + e[i] * o;
    return r;
  };
}
function v_(n) {
  return ArrayBuffer.isView(n) && !(n instanceof DataView);
}
function rC(n, e) {
  return (v_(e) ? Ad : m_)(n, e);
}
function m_(n, e) {
  var t = e ? e.length : 0, r = n ? Math.min(t, n.length) : 0, i = new Array(r), o = new Array(t), f;
  for (f = 0; f < r; ++f)
    i[f] = li(n[f], e[f]);
  for (; f < t; ++f)
    o[f] = e[f];
  return function(s) {
    for (f = 0; f < r; ++f)
      o[f] = i[f](s);
    return o;
  };
}
function y_(n, e) {
  var t = /* @__PURE__ */ new Date();
  return n = +n, e = +e, function(r) {
    return t.setTime(n * (1 - r) + e * r), t;
  };
}
function Ot(n, e) {
  return n = +n, e = +e, function(t) {
    return n * (1 - t) + e * t;
  };
}
function __(n, e) {
  var t = {}, r = {}, i;
  (n === null || typeof n != "object") && (n = {}), (e === null || typeof e != "object") && (e = {});
  for (i in e)
    i in n ? t[i] = li(n[i], e[i]) : r[i] = e[i];
  return function(o) {
    for (i in t)
      r[i] = t[i](o);
    return r;
  };
}
var c0 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, wh = new RegExp(c0.source, "g");
function iC(n) {
  return function() {
    return n;
  };
}
function aC(n) {
  return function(e) {
    return n(e) + "";
  };
}
function Md(n, e) {
  var t = c0.lastIndex = wh.lastIndex = 0, r, i, o, f = -1, s = [], l = [];
  for (n = n + "", e = e + ""; (r = c0.exec(n)) && (i = wh.exec(e)); )
    (o = i.index) > t && (o = e.slice(t, o), s[f] ? s[f] += o : s[++f] = o), (r = r[0]) === (i = i[0]) ? s[f] ? s[f] += i : s[++f] = i : (s[++f] = null, l.push({ i: f, x: Ot(r, i) })), t = wh.lastIndex;
  return t < e.length && (o = e.slice(t), s[f] ? s[f] += o : s[++f] = o), s.length < 2 ? l[0] ? aC(l[0].x) : iC(e) : (e = l.length, function(c) {
    for (var p = 0, g; p < e; ++p)
      s[(g = l[p]).i] = g.x(c);
    return s.join("");
  });
}
function li(n, e) {
  var t = typeof e, r;
  return e == null || t === "boolean" ? ml(e) : (t === "number" ? Ot : t === "string" ? (r = ai(e)) ? (e = r, ou) : Md : e instanceof ai ? ou : e instanceof Date ? y_ : v_(e) ? Ad : Array.isArray(e) ? m_ : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? __ : Ot)(n, e);
}
function oC(n) {
  var e = n.length;
  return function(t) {
    return n[Math.max(0, Math.min(e - 1, Math.floor(t * e)))];
  };
}
function uC(n, e) {
  var t = yl(+n, +e);
  return function(r) {
    var i = t(r);
    return i - 360 * Math.floor(i / 360);
  };
}
function _l(n, e) {
  return n = +n, e = +e, function(t) {
    return Math.round(n * (1 - t) + e * t);
  };
}
var Vv = 180 / Math.PI, h0 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function b_(n, e, t, r, i, o) {
  var f, s, l;
  return (f = Math.sqrt(n * n + e * e)) && (n /= f, e /= f), (l = n * t + e * r) && (t -= n * l, r -= e * l), (s = Math.sqrt(t * t + r * r)) && (t /= s, r /= s, l /= s), n * r < e * t && (n = -n, e = -e, l = -l, f = -f), {
    translateX: i,
    translateY: o,
    rotate: Math.atan2(e, n) * Vv,
    skewX: Math.atan(l) * Vv,
    scaleX: f,
    scaleY: s
  };
}
var Ef;
function fC(n) {
  const e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(n + "");
  return e.isIdentity ? h0 : b_(e.a, e.b, e.c, e.d, e.e, e.f);
}
function sC(n) {
  return n == null || (Ef || (Ef = document.createElementNS("http://www.w3.org/2000/svg", "g")), Ef.setAttribute("transform", n), !(n = Ef.transform.baseVal.consolidate())) ? h0 : (n = n.matrix, b_(n.a, n.b, n.c, n.d, n.e, n.f));
}
function w_(n, e, t, r) {
  function i(c) {
    return c.length ? c.pop() + " " : "";
  }
  function o(c, p, g, d, v, b) {
    if (c !== g || p !== d) {
      var w = v.push("translate(", null, e, null, t);
      b.push({ i: w - 4, x: Ot(c, g) }, { i: w - 2, x: Ot(p, d) });
    } else
      (g || d) && v.push("translate(" + g + e + d + t);
  }
  function f(c, p, g, d) {
    c !== p ? (c - p > 180 ? p += 360 : p - c > 180 && (c += 360), d.push({ i: g.push(i(g) + "rotate(", null, r) - 2, x: Ot(c, p) })) : p && g.push(i(g) + "rotate(" + p + r);
  }
  function s(c, p, g, d) {
    c !== p ? d.push({ i: g.push(i(g) + "skewX(", null, r) - 2, x: Ot(c, p) }) : p && g.push(i(g) + "skewX(" + p + r);
  }
  function l(c, p, g, d, v, b) {
    if (c !== g || p !== d) {
      var w = v.push(i(v) + "scale(", null, ",", null, ")");
      b.push({ i: w - 4, x: Ot(c, g) }, { i: w - 2, x: Ot(p, d) });
    } else
      (g !== 1 || d !== 1) && v.push(i(v) + "scale(" + g + "," + d + ")");
  }
  return function(c, p) {
    var g = [], d = [];
    return c = n(c), p = n(p), o(c.translateX, c.translateY, p.translateX, p.translateY, g, d), f(c.rotate, p.rotate, g, d), s(c.skewX, p.skewX, g, d), l(c.scaleX, c.scaleY, p.scaleX, p.scaleY, g, d), c = p = null, function(v) {
      for (var b = -1, w = d.length, m; ++b < w; )
        g[(m = d[b]).i] = m.x(v);
      return g.join("");
    };
  };
}
var x_ = w_(fC, "px, ", "px)", "deg)"), T_ = w_(sC, ", ", ")", ")"), lC = 1e-12;
function Uv(n) {
  return ((n = Math.exp(n)) + 1 / n) / 2;
}
function cC(n) {
  return ((n = Math.exp(n)) - 1 / n) / 2;
}
function hC(n) {
  return ((n = Math.exp(2 * n)) - 1) / (n + 1);
}
const A_ = function n(e, t, r) {
  function i(o, f) {
    var s = o[0], l = o[1], c = o[2], p = f[0], g = f[1], d = f[2], v = p - s, b = g - l, w = v * v + b * b, m, _;
    if (w < lC)
      _ = Math.log(d / c) / e, m = function(I) {
        return [
          s + I * v,
          l + I * b,
          c * Math.exp(e * I * _)
        ];
      };
    else {
      var x = Math.sqrt(w), A = (d * d - c * c + r * w) / (2 * c * t * x), T = (d * d - c * c - r * w) / (2 * d * t * x), S = Math.log(Math.sqrt(A * A + 1) - A), R = Math.log(Math.sqrt(T * T + 1) - T);
      _ = (R - S) / e, m = function(I) {
        var B = I * _, F = Uv(S), V = c / (t * x) * (F * hC(e * B + S) - cC(S));
        return [
          s + V * v,
          l + V * b,
          c * F / Uv(e * B + S)
        ];
      };
    }
    return m.duration = _ * 1e3 * e / Math.SQRT2, m;
  }
  return i.rho = function(o) {
    var f = Math.max(1e-3, +o), s = f * f, l = s * s;
    return n(f, s, l);
  }, i;
}(Math.SQRT2, 2, 4);
function M_(n) {
  return function(e, t) {
    var r = n((e = _s(e)).h, (t = _s(t)).h), i = Pe(e.s, t.s), o = Pe(e.l, t.l), f = Pe(e.opacity, t.opacity);
    return function(s) {
      return e.h = r(s), e.s = i(s), e.l = o(s), e.opacity = f(s), e + "";
    };
  };
}
const dC = M_(yl);
var pC = M_(Pe);
function gC(n, e) {
  var t = Pe((n = ws(n)).l, (e = ws(e)).l), r = Pe(n.a, e.a), i = Pe(n.b, e.b), o = Pe(n.opacity, e.opacity);
  return function(f) {
    return n.l = t(f), n.a = r(f), n.b = i(f), n.opacity = o(f), n + "";
  };
}
function S_(n) {
  return function(e, t) {
    var r = n((e = xs(e)).h, (t = xs(t)).h), i = Pe(e.c, t.c), o = Pe(e.l, t.l), f = Pe(e.opacity, t.opacity);
    return function(s) {
      return e.h = r(s), e.c = i(s), e.l = o(s), e.opacity = f(s), e + "";
    };
  };
}
const vC = S_(yl);
var mC = S_(Pe);
function E_(n) {
  return function e(t) {
    t = +t;
    function r(i, o) {
      var f = n((i = Qt(i)).h, (o = Qt(o)).h), s = Pe(i.s, o.s), l = Pe(i.l, o.l), c = Pe(i.opacity, o.opacity);
      return function(p) {
        return i.h = f(p), i.s = s(p), i.l = l(Math.pow(p, t)), i.opacity = c(p), i + "";
      };
    }
    return r.gamma = e, r;
  }(1);
}
const yC = E_(yl);
var bl = E_(Pe);
function C_(n, e) {
  e === void 0 && (e = n, n = li);
  for (var t = 0, r = e.length - 1, i = e[0], o = new Array(r < 0 ? 0 : r); t < r; )
    o[t] = n(i, i = e[++t]);
  return function(f) {
    var s = Math.max(0, Math.min(r - 1, Math.floor(f *= r)));
    return o[s](f - s);
  };
}
function _C(n, e) {
  for (var t = new Array(e), r = 0; r < e; ++r)
    t[r] = n(r / (e - 1));
  return t;
}
var Ga = 0, Lo = 0, Co = 0, P_ = 1e3, Ts, Do, As = 0, Vi = 0, wl = 0, uu = typeof performance == "object" && performance.now ? performance : Date, R_ = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(n) {
  setTimeout(n, 17);
};
function Tu() {
  return Vi || (R_(bC), Vi = uu.now() + wl);
}
function bC() {
  Vi = 0;
}
function fu() {
  this._call = this._time = this._next = null;
}
fu.prototype = xl.prototype = {
  constructor: fu,
  restart: function(n, e, t) {
    if (typeof n != "function")
      throw new TypeError("callback is not a function");
    t = (t == null ? Tu() : +t) + (e == null ? 0 : +e), !this._next && Do !== this && (Do ? Do._next = this : Ts = this, Do = this), this._call = n, this._time = t, d0();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, d0());
  }
};
function xl(n, e, t) {
  var r = new fu();
  return r.restart(n, e, t), r;
}
function N_() {
  Tu(), ++Ga;
  for (var n = Ts, e; n; )
    (e = Vi - n._time) >= 0 && n._call.call(void 0, e), n = n._next;
  --Ga;
}
function Gv() {
  Vi = (As = uu.now()) + wl, Ga = Lo = 0;
  try {
    N_();
  } finally {
    Ga = 0, xC(), Vi = 0;
  }
}
function wC() {
  var n = uu.now(), e = n - As;
  e > P_ && (wl -= e, As = n);
}
function xC() {
  for (var n, e = Ts, t, r = 1 / 0; e; )
    e._call ? (r > e._time && (r = e._time), n = e, e = e._next) : (t = e._next, e._next = null, e = n ? n._next = t : Ts = t);
  Do = n, d0(r);
}
function d0(n) {
  if (!Ga) {
    Lo && (Lo = clearTimeout(Lo));
    var e = n - Vi;
    e > 24 ? (n < 1 / 0 && (Lo = setTimeout(Gv, n - uu.now() - wl)), Co && (Co = clearInterval(Co))) : (Co || (As = uu.now(), Co = setInterval(wC, P_)), Ga = 1, R_(Gv));
  }
}
function p0(n, e, t) {
  var r = new fu();
  return e = e == null ? 0 : +e, r.restart((i) => {
    r.stop(), n(i + e);
  }, e, t), r;
}
function TC(n, e, t) {
  var r = new fu(), i = e;
  return e == null ? (r.restart(n, e, t), r) : (r._restart = r.restart, r.restart = function(o, f, s) {
    f = +f, s = s == null ? Tu() : +s, r._restart(function l(c) {
      c += i, r._restart(l, i += f, s), o(c);
    }, f, s);
  }, r.restart(n, e, t), r);
}
var AC = Xi("start", "end", "cancel", "interrupt"), MC = [], $_ = 0, g0 = 1, v0 = 2, Qf = 3, qv = 4, m0 = 5, jf = 6;
function Tl(n, e, t, r, i, o) {
  var f = n.__transition;
  if (!f)
    n.__transition = {};
  else if (t in f)
    return;
  SC(n, t, {
    name: e,
    index: r,
    // For context during callback.
    group: i,
    // For context during callback.
    on: AC,
    tween: MC,
    time: o.time,
    delay: o.delay,
    duration: o.duration,
    ease: o.ease,
    timer: null,
    state: $_
  });
}
function Sd(n, e) {
  var t = jt(n, e);
  if (t.state > $_)
    throw new Error("too late; already scheduled");
  return t;
}
function pr(n, e) {
  var t = jt(n, e);
  if (t.state > Qf)
    throw new Error("too late; already running");
  return t;
}
function jt(n, e) {
  var t = n.__transition;
  if (!t || !(t = t[e]))
    throw new Error("transition not found");
  return t;
}
function SC(n, e, t) {
  var r = n.__transition, i;
  r[e] = t, t.timer = xl(o, 0, t.time);
  function o(c) {
    t.state = g0, t.timer.restart(f, t.delay, t.time), t.delay <= c && f(c - t.delay);
  }
  function f(c) {
    var p, g, d, v;
    if (t.state !== g0)
      return l();
    for (p in r)
      if (v = r[p], v.name === t.name) {
        if (v.state === Qf)
          return p0(f);
        v.state === qv ? (v.state = jf, v.timer.stop(), v.on.call("interrupt", n, n.__data__, v.index, v.group), delete r[p]) : +p < e && (v.state = jf, v.timer.stop(), v.on.call("cancel", n, n.__data__, v.index, v.group), delete r[p]);
      }
    if (p0(function() {
      t.state === Qf && (t.state = qv, t.timer.restart(s, t.delay, t.time), s(c));
    }), t.state = v0, t.on.call("start", n, n.__data__, t.index, t.group), t.state === v0) {
      for (t.state = Qf, i = new Array(d = t.tween.length), p = 0, g = -1; p < d; ++p)
        (v = t.tween[p].value.call(n, n.__data__, t.index, t.group)) && (i[++g] = v);
      i.length = g + 1;
    }
  }
  function s(c) {
    for (var p = c < t.duration ? t.ease.call(null, c / t.duration) : (t.timer.restart(l), t.state = m0, 1), g = -1, d = i.length; ++g < d; )
      i[g].call(n, p);
    t.state === m0 && (t.on.call("end", n, n.__data__, t.index, t.group), l());
  }
  function l() {
    t.state = jf, t.timer.stop(), delete r[e];
    for (var c in r)
      return;
    delete n.__transition;
  }
}
function Ii(n, e) {
  var t = n.__transition, r, i, o = !0, f;
  if (t) {
    e = e == null ? null : e + "";
    for (f in t) {
      if ((r = t[f]).name !== e) {
        o = !1;
        continue;
      }
      i = r.state > v0 && r.state < m0, r.state = jf, r.timer.stop(), r.on.call(i ? "interrupt" : "cancel", n, n.__data__, r.index, r.group), delete t[f];
    }
    o && delete n.__transition;
  }
}
function EC(n) {
  return this.each(function() {
    Ii(this, n);
  });
}
function CC(n, e) {
  var t, r;
  return function() {
    var i = pr(this, n), o = i.tween;
    if (o !== t) {
      r = t = o;
      for (var f = 0, s = r.length; f < s; ++f)
        if (r[f].name === e) {
          r = r.slice(), r.splice(f, 1);
          break;
        }
    }
    i.tween = r;
  };
}
function PC(n, e, t) {
  var r, i;
  if (typeof t != "function")
    throw new Error();
  return function() {
    var o = pr(this, n), f = o.tween;
    if (f !== r) {
      i = (r = f).slice();
      for (var s = { name: e, value: t }, l = 0, c = i.length; l < c; ++l)
        if (i[l].name === e) {
          i[l] = s;
          break;
        }
      l === c && i.push(s);
    }
    o.tween = i;
  };
}
function RC(n, e) {
  var t = this._id;
  if (n += "", arguments.length < 2) {
    for (var r = jt(this.node(), t).tween, i = 0, o = r.length, f; i < o; ++i)
      if ((f = r[i]).name === n)
        return f.value;
    return null;
  }
  return this.each((e == null ? CC : PC)(t, n, e));
}
function Ed(n, e, t) {
  var r = n._id;
  return n.each(function() {
    var i = pr(this, r);
    (i.value || (i.value = {}))[e] = t.apply(this, arguments);
  }), function(i) {
    return jt(i, r).value[e];
  };
}
function k_(n, e) {
  var t;
  return (typeof e == "number" ? Ot : e instanceof ai ? ou : (t = ai(e)) ? (e = t, ou) : Md)(n, e);
}
function NC(n) {
  return function() {
    this.removeAttribute(n);
  };
}
function $C(n) {
  return function() {
    this.removeAttributeNS(n.space, n.local);
  };
}
function kC(n, e, t) {
  var r, i = t + "", o;
  return function() {
    var f = this.getAttribute(n);
    return f === i ? null : f === r ? o : o = e(r = f, t);
  };
}
function OC(n, e, t) {
  var r, i = t + "", o;
  return function() {
    var f = this.getAttributeNS(n.space, n.local);
    return f === i ? null : f === r ? o : o = e(r = f, t);
  };
}
function IC(n, e, t) {
  var r, i, o;
  return function() {
    var f, s = t(this), l;
    return s == null ? void this.removeAttribute(n) : (f = this.getAttribute(n), l = s + "", f === l ? null : f === r && l === i ? o : (i = l, o = e(r = f, s)));
  };
}
function LC(n, e, t) {
  var r, i, o;
  return function() {
    var f, s = t(this), l;
    return s == null ? void this.removeAttributeNS(n.space, n.local) : (f = this.getAttributeNS(n.space, n.local), l = s + "", f === l ? null : f === r && l === i ? o : (i = l, o = e(r = f, s)));
  };
}
function DC(n, e) {
  var t = wu(n), r = t === "transform" ? T_ : k_;
  return this.attrTween(n, typeof e == "function" ? (t.local ? LC : IC)(t, r, Ed(this, "attr." + n, e)) : e == null ? (t.local ? $C : NC)(t) : (t.local ? OC : kC)(t, r, e));
}
function FC(n, e) {
  return function(t) {
    this.setAttribute(n, e.call(this, t));
  };
}
function BC(n, e) {
  return function(t) {
    this.setAttributeNS(n.space, n.local, e.call(this, t));
  };
}
function zC(n, e) {
  var t, r;
  function i() {
    var o = e.apply(this, arguments);
    return o !== r && (t = (r = o) && BC(n, o)), t;
  }
  return i._value = e, i;
}
function VC(n, e) {
  var t, r;
  function i() {
    var o = e.apply(this, arguments);
    return o !== r && (t = (r = o) && FC(n, o)), t;
  }
  return i._value = e, i;
}
function UC(n, e) {
  var t = "attr." + n;
  if (arguments.length < 2)
    return (t = this.tween(t)) && t._value;
  if (e == null)
    return this.tween(t, null);
  if (typeof e != "function")
    throw new Error();
  var r = wu(n);
  return this.tween(t, (r.local ? zC : VC)(r, e));
}
function GC(n, e) {
  return function() {
    Sd(this, n).delay = +e.apply(this, arguments);
  };
}
function qC(n, e) {
  return e = +e, function() {
    Sd(this, n).delay = e;
  };
}
function WC(n) {
  var e = this._id;
  return arguments.length ? this.each((typeof n == "function" ? GC : qC)(e, n)) : jt(this.node(), e).delay;
}
function HC(n, e) {
  return function() {
    pr(this, n).duration = +e.apply(this, arguments);
  };
}
function YC(n, e) {
  return e = +e, function() {
    pr(this, n).duration = e;
  };
}
function XC(n) {
  var e = this._id;
  return arguments.length ? this.each((typeof n == "function" ? HC : YC)(e, n)) : jt(this.node(), e).duration;
}
function KC(n, e) {
  if (typeof e != "function")
    throw new Error();
  return function() {
    pr(this, n).ease = e;
  };
}
function ZC(n) {
  var e = this._id;
  return arguments.length ? this.each(KC(e, n)) : jt(this.node(), e).ease;
}
function JC(n, e) {
  return function() {
    var t = e.apply(this, arguments);
    if (typeof t != "function")
      throw new Error();
    pr(this, n).ease = t;
  };
}
function QC(n) {
  if (typeof n != "function")
    throw new Error();
  return this.each(JC(this._id, n));
}
function jC(n) {
  typeof n != "function" && (n = md(n));
  for (var e = this._groups, t = e.length, r = new Array(t), i = 0; i < t; ++i)
    for (var o = e[i], f = o.length, s = r[i] = [], l, c = 0; c < f; ++c)
      (l = o[c]) && n.call(l, l.__data__, c, o) && s.push(l);
  return new lr(r, this._parents, this._name, this._id);
}
function nP(n) {
  if (n._id !== this._id)
    throw new Error();
  for (var e = this._groups, t = n._groups, r = e.length, i = t.length, o = Math.min(r, i), f = new Array(r), s = 0; s < o; ++s)
    for (var l = e[s], c = t[s], p = l.length, g = f[s] = new Array(p), d, v = 0; v < p; ++v)
      (d = l[v] || c[v]) && (g[v] = d);
  for (; s < r; ++s)
    f[s] = e[s];
  return new lr(f, this._parents, this._name, this._id);
}
function eP(n) {
  return (n + "").trim().split(/^|\s+/).every(function(e) {
    var t = e.indexOf(".");
    return t >= 0 && (e = e.slice(0, t)), !e || e === "start";
  });
}
function tP(n, e, t) {
  var r, i, o = eP(e) ? Sd : pr;
  return function() {
    var f = o(this, n), s = f.on;
    s !== r && (i = (r = s).copy()).on(e, t), f.on = i;
  };
}
function rP(n, e) {
  var t = this._id;
  return arguments.length < 2 ? jt(this.node(), t).on.on(n) : this.each(tP(t, n, e));
}
function iP(n) {
  return function() {
    var e = this.parentNode;
    for (var t in this.__transition)
      if (+t !== n)
        return;
    e && e.removeChild(this);
  };
}
function aP() {
  return this.on("end.remove", iP(this._id));
}
function oP(n) {
  var e = this._name, t = this._id;
  typeof n != "function" && (n = dl(n));
  for (var r = this._groups, i = r.length, o = new Array(i), f = 0; f < i; ++f)
    for (var s = r[f], l = s.length, c = o[f] = new Array(l), p, g, d = 0; d < l; ++d)
      (p = s[d]) && (g = n.call(p, p.__data__, d, s)) && ("__data__" in p && (g.__data__ = p.__data__), c[d] = g, Tl(c[d], e, t, d, c, jt(p, t)));
  return new lr(o, this._parents, e, t);
}
function uP(n) {
  var e = this._name, t = this._id;
  typeof n != "function" && (n = vd(n));
  for (var r = this._groups, i = r.length, o = [], f = [], s = 0; s < i; ++s)
    for (var l = r[s], c = l.length, p, g = 0; g < c; ++g)
      if (p = l[g]) {
        for (var d = n.call(p, p.__data__, g, l), v, b = jt(p, t), w = 0, m = d.length; w < m; ++w)
          (v = d[w]) && Tl(v, e, t, w, d, b);
        o.push(d), f.push(p);
      }
  return new lr(o, f, e, t);
}
var fP = Ki.prototype.constructor;
function sP() {
  return new fP(this._groups, this._parents);
}
function lP(n, e) {
  var t, r, i;
  return function() {
    var o = Bi(this, n), f = (this.style.removeProperty(n), Bi(this, n));
    return o === f ? null : o === t && f === r ? i : i = e(t = o, r = f);
  };
}
function O_(n) {
  return function() {
    this.style.removeProperty(n);
  };
}
function cP(n, e, t) {
  var r, i = t + "", o;
  return function() {
    var f = Bi(this, n);
    return f === i ? null : f === r ? o : o = e(r = f, t);
  };
}
function hP(n, e, t) {
  var r, i, o;
  return function() {
    var f = Bi(this, n), s = t(this), l = s + "";
    return s == null && (l = s = (this.style.removeProperty(n), Bi(this, n))), f === l ? null : f === r && l === i ? o : (i = l, o = e(r = f, s));
  };
}
function dP(n, e) {
  var t, r, i, o = "style." + e, f = "end." + o, s;
  return function() {
    var l = pr(this, n), c = l.on, p = l.value[o] == null ? s || (s = O_(e)) : void 0;
    (c !== t || i !== p) && (r = (t = c).copy()).on(f, i = p), l.on = r;
  };
}
function pP(n, e, t) {
  var r = (n += "") == "transform" ? x_ : k_;
  return e == null ? this.styleTween(n, lP(n, r)).on("end.style." + n, O_(n)) : typeof e == "function" ? this.styleTween(n, hP(n, r, Ed(this, "style." + n, e))).each(dP(this._id, n)) : this.styleTween(n, cP(n, r, e), t).on("end.style." + n, null);
}
function gP(n, e, t) {
  return function(r) {
    this.style.setProperty(n, e.call(this, r), t);
  };
}
function vP(n, e, t) {
  var r, i;
  function o() {
    var f = e.apply(this, arguments);
    return f !== i && (r = (i = f) && gP(n, f, t)), r;
  }
  return o._value = e, o;
}
function mP(n, e, t) {
  var r = "style." + (n += "");
  if (arguments.length < 2)
    return (r = this.tween(r)) && r._value;
  if (e == null)
    return this.tween(r, null);
  if (typeof e != "function")
    throw new Error();
  return this.tween(r, vP(n, e, t ?? ""));
}
function yP(n) {
  return function() {
    this.textContent = n;
  };
}
function _P(n) {
  return function() {
    var e = n(this);
    this.textContent = e ?? "";
  };
}
function bP(n) {
  return this.tween("text", typeof n == "function" ? _P(Ed(this, "text", n)) : yP(n == null ? "" : n + ""));
}
function wP(n) {
  return function(e) {
    this.textContent = n.call(this, e);
  };
}
function xP(n) {
  var e, t;
  function r() {
    var i = n.apply(this, arguments);
    return i !== t && (e = (t = i) && wP(i)), e;
  }
  return r._value = n, r;
}
function TP(n) {
  var e = "text";
  if (arguments.length < 1)
    return (e = this.tween(e)) && e._value;
  if (n == null)
    return this.tween(e, null);
  if (typeof n != "function")
    throw new Error();
  return this.tween(e, xP(n));
}
function AP() {
  for (var n = this._name, e = this._id, t = L_(), r = this._groups, i = r.length, o = 0; o < i; ++o)
    for (var f = r[o], s = f.length, l, c = 0; c < s; ++c)
      if (l = f[c]) {
        var p = jt(l, e);
        Tl(l, n, t, c, f, {
          time: p.time + p.delay + p.duration,
          delay: 0,
          duration: p.duration,
          ease: p.ease
        });
      }
  return new lr(r, this._parents, n, t);
}
function MP() {
  var n, e, t = this, r = t._id, i = t.size();
  return new Promise(function(o, f) {
    var s = { value: f }, l = { value: function() {
      --i === 0 && o();
    } };
    t.each(function() {
      var c = pr(this, r), p = c.on;
      p !== n && (e = (n = p).copy(), e._.cancel.push(s), e._.interrupt.push(s), e._.end.push(l)), c.on = e;
    }), i === 0 && o();
  });
}
var SP = 0;
function lr(n, e, t, r) {
  this._groups = n, this._parents = e, this._name = t, this._id = r;
}
function I_(n) {
  return Ki().transition(n);
}
function L_() {
  return ++SP;
}
var Sr = Ki.prototype;
lr.prototype = I_.prototype = {
  constructor: lr,
  select: oP,
  selectAll: uP,
  selectChild: Sr.selectChild,
  selectChildren: Sr.selectChildren,
  filter: jC,
  merge: nP,
  selection: sP,
  transition: AP,
  call: Sr.call,
  nodes: Sr.nodes,
  node: Sr.node,
  size: Sr.size,
  empty: Sr.empty,
  each: Sr.each,
  on: rP,
  attr: DC,
  attrTween: UC,
  style: pP,
  styleTween: mP,
  text: bP,
  textTween: TP,
  remove: aP,
  tween: RC,
  delay: WC,
  duration: XC,
  ease: ZC,
  easeVarying: QC,
  end: MP,
  [Symbol.iterator]: Sr[Symbol.iterator]
};
const EP = (n) => +n;
function CP(n) {
  return n * n;
}
function PP(n) {
  return n * (2 - n);
}
function Wv(n) {
  return ((n *= 2) <= 1 ? n * n : --n * (2 - n) + 1) / 2;
}
function RP(n) {
  return n * n * n;
}
function NP(n) {
  return --n * n * n + 1;
}
function y0(n) {
  return ((n *= 2) <= 1 ? n * n * n : (n -= 2) * n * n + 2) / 2;
}
var Cd = 3, $P = function n(e) {
  e = +e;
  function t(r) {
    return Math.pow(r, e);
  }
  return t.exponent = n, t;
}(Cd), kP = function n(e) {
  e = +e;
  function t(r) {
    return 1 - Math.pow(1 - r, e);
  }
  return t.exponent = n, t;
}(Cd), Hv = function n(e) {
  e = +e;
  function t(r) {
    return ((r *= 2) <= 1 ? Math.pow(r, e) : 2 - Math.pow(2 - r, e)) / 2;
  }
  return t.exponent = n, t;
}(Cd), D_ = Math.PI, F_ = D_ / 2;
function OP(n) {
  return +n == 1 ? 1 : 1 - Math.cos(n * F_);
}
function IP(n) {
  return Math.sin(n * F_);
}
function Yv(n) {
  return (1 - Math.cos(D_ * n)) / 2;
}
function oi(n) {
  return (Math.pow(2, -10 * n) - 9765625e-10) * 1.0009775171065494;
}
function LP(n) {
  return oi(1 - +n);
}
function DP(n) {
  return 1 - oi(n);
}
function Xv(n) {
  return ((n *= 2) <= 1 ? oi(1 - n) : 2 - oi(n - 1)) / 2;
}
function FP(n) {
  return 1 - Math.sqrt(1 - n * n);
}
function BP(n) {
  return Math.sqrt(1 - --n * n);
}
function Kv(n) {
  return ((n *= 2) <= 1 ? 1 - Math.sqrt(1 - n * n) : Math.sqrt(1 - (n -= 2) * n) + 1) / 2;
}
var _0 = 4 / 11, zP = 6 / 11, VP = 8 / 11, UP = 3 / 4, GP = 9 / 11, qP = 10 / 11, WP = 15 / 16, HP = 21 / 22, YP = 63 / 64, Cf = 1 / _0 / _0;
function XP(n) {
  return 1 - su(1 - n);
}
function su(n) {
  return (n = +n) < _0 ? Cf * n * n : n < VP ? Cf * (n -= zP) * n + UP : n < qP ? Cf * (n -= GP) * n + WP : Cf * (n -= HP) * n + YP;
}
function KP(n) {
  return ((n *= 2) <= 1 ? 1 - su(1 - n) : su(n - 1) + 1) / 2;
}
var Pd = 1.70158, ZP = function n(e) {
  e = +e;
  function t(r) {
    return (r = +r) * r * (e * (r - 1) + r);
  }
  return t.overshoot = n, t;
}(Pd), JP = function n(e) {
  e = +e;
  function t(r) {
    return --r * r * ((r + 1) * e + r) + 1;
  }
  return t.overshoot = n, t;
}(Pd), Zv = function n(e) {
  e = +e;
  function t(r) {
    return ((r *= 2) < 1 ? r * r * ((e + 1) * r - e) : (r -= 2) * r * ((e + 1) * r + e) + 2) / 2;
  }
  return t.overshoot = n, t;
}(Pd), qa = 2 * Math.PI, Rd = 1, Nd = 0.3, QP = function n(e, t) {
  var r = Math.asin(1 / (e = Math.max(1, e))) * (t /= qa);
  function i(o) {
    return e * oi(- --o) * Math.sin((r - o) / t);
  }
  return i.amplitude = function(o) {
    return n(o, t * qa);
  }, i.period = function(o) {
    return n(e, o);
  }, i;
}(Rd, Nd), Jv = function n(e, t) {
  var r = Math.asin(1 / (e = Math.max(1, e))) * (t /= qa);
  function i(o) {
    return 1 - e * oi(o = +o) * Math.sin((o + r) / t);
  }
  return i.amplitude = function(o) {
    return n(o, t * qa);
  }, i.period = function(o) {
    return n(e, o);
  }, i;
}(Rd, Nd), jP = function n(e, t) {
  var r = Math.asin(1 / (e = Math.max(1, e))) * (t /= qa);
  function i(o) {
    return ((o = o * 2 - 1) < 0 ? e * oi(-o) * Math.sin((r - o) / t) : 2 - e * oi(o) * Math.sin((r + o) / t)) / 2;
  }
  return i.amplitude = function(o) {
    return n(o, t * qa);
  }, i.period = function(o) {
    return n(e, o);
  }, i;
}(Rd, Nd), nR = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: y0
};
function eR(n, e) {
  for (var t; !(t = n.__transition) || !(t = t[e]); )
    if (!(n = n.parentNode))
      throw new Error(`transition ${e} not found`);
  return t;
}
function tR(n) {
  var e, t;
  n instanceof lr ? (e = n._id, n = n._name) : (e = L_(), (t = nR).time = Tu(), n = n == null ? null : n + "");
  for (var r = this._groups, i = r.length, o = 0; o < i; ++o)
    for (var f = r[o], s = f.length, l, c = 0; c < s; ++c)
      (l = f[c]) && Tl(l, n, e, c, f, t || eR(l, e));
  return new lr(r, this._parents, n, e);
}
Ki.prototype.interrupt = EC;
Ki.prototype.transition = tR;
var rR = [null];
function iR(n, e) {
  var t = n.__transition, r, i;
  if (t) {
    e = e == null ? null : e + "";
    for (i in t)
      if ((r = t[i]).state > g0 && r.name === e)
        return new lr([[n]], rR, e, +i);
  }
  return null;
}
const xh = (n) => () => n;
function aR(n, {
  sourceEvent: e,
  target: t,
  selection: r,
  mode: i,
  dispatch: o
}) {
  Object.defineProperties(this, {
    type: { value: n, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    target: { value: t, enumerable: !0, configurable: !0 },
    selection: { value: r, enumerable: !0, configurable: !0 },
    mode: { value: i, enumerable: !0, configurable: !0 },
    _: { value: o }
  });
}
function oR(n) {
  n.stopImmediatePropagation();
}
function Th(n) {
  n.preventDefault(), n.stopImmediatePropagation();
}
var Qv = { name: "drag" }, Ah = { name: "space" }, ba = { name: "handle" }, wa = { name: "center" };
const { abs: jv, max: Fe, min: Be } = Math;
function nm(n) {
  return [+n[0], +n[1]];
}
function b0(n) {
  return [nm(n[0]), nm(n[1])];
}
var ns = {
  name: "x",
  handles: ["w", "e"].map(lu),
  input: function(n, e) {
    return n == null ? null : [[+n[0], e[0][1]], [+n[1], e[1][1]]];
  },
  output: function(n) {
    return n && [n[0][0], n[1][0]];
  }
}, es = {
  name: "y",
  handles: ["n", "s"].map(lu),
  input: function(n, e) {
    return n == null ? null : [[e[0][0], +n[0]], [e[1][0], +n[1]]];
  },
  output: function(n) {
    return n && [n[0][1], n[1][1]];
  }
}, uR = {
  name: "xy",
  handles: ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(lu),
  input: function(n) {
    return n == null ? null : b0(n);
  },
  output: function(n) {
    return n;
  }
}, Er = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
}, em = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
}, tm = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
}, fR = {
  overlay: 1,
  selection: 1,
  n: null,
  e: 1,
  s: null,
  w: -1,
  nw: -1,
  ne: 1,
  se: 1,
  sw: -1
}, sR = {
  overlay: 1,
  selection: 1,
  n: -1,
  e: null,
  s: 1,
  w: null,
  nw: -1,
  ne: -1,
  se: 1,
  sw: 1
};
function lu(n) {
  return { type: n };
}
function lR(n) {
  return !n.ctrlKey && !n.button;
}
function cR() {
  var n = this.ownerSVGElement || this;
  return n.hasAttribute("viewBox") ? (n = n.viewBox.baseVal, [[n.x, n.y], [n.x + n.width, n.y + n.height]]) : [[0, 0], [n.width.baseVal.value, n.height.baseVal.value]];
}
function hR() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function Mh(n) {
  for (; !n.__brush; )
    if (!(n = n.parentNode))
      return;
  return n.__brush;
}
function dR(n) {
  return n[0][0] === n[1][0] || n[0][1] === n[1][1];
}
function pR(n) {
  var e = n.__brush;
  return e ? e.dim.output(e.selection) : null;
}
function gR() {
  return $d(ns);
}
function vR() {
  return $d(es);
}
function mR() {
  return $d(uR);
}
function $d(n) {
  var e = cR, t = lR, r = hR, i = !0, o = Xi("start", "brush", "end"), f = 6, s;
  function l(m) {
    var _ = m.property("__brush", w).selectAll(".overlay").data([lu("overlay")]);
    _.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", Er.overlay).merge(_).each(function() {
      var A = Mh(this).extent;
      qe(this).attr("x", A[0][0]).attr("y", A[0][1]).attr("width", A[1][0] - A[0][0]).attr("height", A[1][1] - A[0][1]);
    }), m.selectAll(".selection").data([lu("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", Er.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
    var x = m.selectAll(".handle").data(n.handles, function(A) {
      return A.type;
    });
    x.exit().remove(), x.enter().append("rect").attr("class", function(A) {
      return "handle handle--" + A.type;
    }).attr("cursor", function(A) {
      return Er[A.type];
    }), m.each(c).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", d).filter(r).on("touchstart.brush", d).on("touchmove.brush", v).on("touchend.brush touchcancel.brush", b).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  l.move = function(m, _, x) {
    m.tween ? m.on("start.brush", function(A) {
      p(this, arguments).beforestart().start(A);
    }).on("interrupt.brush end.brush", function(A) {
      p(this, arguments).end(A);
    }).tween("brush", function() {
      var A = this, T = A.__brush, S = p(A, arguments), R = T.selection, I = n.input(typeof _ == "function" ? _.apply(this, arguments) : _, T.extent), B = li(R, I);
      function F(V) {
        T.selection = V === 1 && I === null ? null : B(V), c.call(A), S.brush();
      }
      return R !== null && I !== null ? F : F(1);
    }) : m.each(function() {
      var A = this, T = arguments, S = A.__brush, R = n.input(typeof _ == "function" ? _.apply(A, T) : _, S.extent), I = p(A, T).beforestart();
      Ii(A), S.selection = R === null ? null : R, c.call(A), I.start(x).brush(x).end(x);
    });
  }, l.clear = function(m, _) {
    l.move(m, null, _);
  };
  function c() {
    var m = qe(this), _ = Mh(this).selection;
    _ ? (m.selectAll(".selection").style("display", null).attr("x", _[0][0]).attr("y", _[0][1]).attr("width", _[1][0] - _[0][0]).attr("height", _[1][1] - _[0][1]), m.selectAll(".handle").style("display", null).attr("x", function(x) {
      return x.type[x.type.length - 1] === "e" ? _[1][0] - f / 2 : _[0][0] - f / 2;
    }).attr("y", function(x) {
      return x.type[0] === "s" ? _[1][1] - f / 2 : _[0][1] - f / 2;
    }).attr("width", function(x) {
      return x.type === "n" || x.type === "s" ? _[1][0] - _[0][0] + f : f;
    }).attr("height", function(x) {
      return x.type === "e" || x.type === "w" ? _[1][1] - _[0][1] + f : f;
    })) : m.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
  }
  function p(m, _, x) {
    var A = m.__brush.emitter;
    return A && (!x || !A.clean) ? A : new g(m, _, x);
  }
  function g(m, _, x) {
    this.that = m, this.args = _, this.state = m.__brush, this.active = 0, this.clean = x;
  }
  g.prototype = {
    beforestart: function() {
      return ++this.active === 1 && (this.state.emitter = this, this.starting = !0), this;
    },
    start: function(m, _) {
      return this.starting ? (this.starting = !1, this.emit("start", m, _)) : this.emit("brush", m), this;
    },
    brush: function(m, _) {
      return this.emit("brush", m, _), this;
    },
    end: function(m, _) {
      return --this.active === 0 && (delete this.state.emitter, this.emit("end", m, _)), this;
    },
    emit: function(m, _, x) {
      var A = qe(this.that).datum();
      o.call(
        m,
        this.that,
        new aR(m, {
          sourceEvent: _,
          target: l,
          selection: n.output(this.state.selection),
          mode: x,
          dispatch: o
        }),
        A
      );
    }
  };
  function d(m) {
    if (s && !m.touches || !t.apply(this, arguments))
      return;
    var _ = this, x = m.target.__data__.type, A = (i && m.metaKey ? x = "overlay" : x) === "selection" ? Qv : i && m.altKey ? wa : ba, T = n === es ? null : fR[x], S = n === ns ? null : sR[x], R = Mh(_), I = R.extent, B = R.selection, F = I[0][0], V, E, L = I[0][1], $, P, k = I[1][0], O, W, K = I[1][1], Q, z, q = 0, J = 0, en, fn = T && S && i && m.shiftKey, ln, Tn, gn = Array.from(m.touches || [m], (pn) => {
      const Pn = pn.identifier;
      return pn = bt(pn, _), pn.point0 = pn.slice(), pn.identifier = Pn, pn;
    });
    Ii(_);
    var _n = p(_, arguments, !0).beforestart();
    if (x === "overlay") {
      B && (en = !0);
      const pn = [gn[0], gn[1] || gn[0]];
      R.selection = B = [[
        V = n === es ? F : Be(pn[0][0], pn[1][0]),
        $ = n === ns ? L : Be(pn[0][1], pn[1][1])
      ], [
        O = n === es ? k : Fe(pn[0][0], pn[1][0]),
        Q = n === ns ? K : Fe(pn[0][1], pn[1][1])
      ]], gn.length > 1 && xn(m);
    } else
      V = B[0][0], $ = B[0][1], O = B[1][0], Q = B[1][1];
    E = V, P = $, W = O, z = Q;
    var tn = qe(_).attr("pointer-events", "none"), hn = tn.selectAll(".overlay").attr("cursor", Er[x]);
    if (m.touches)
      _n.moved = an, _n.ended = En;
    else {
      var vn = qe(m.view).on("mousemove.brush", an, !0).on("mouseup.brush", En, !0);
      i && vn.on("keydown.brush", In, !0).on("keyup.brush", Ln, !0), pl(m.view);
    }
    c.call(_), _n.start(m, A.name);
    function an(pn) {
      for (const Pn of pn.changedTouches || [pn])
        for (const U of gn)
          U.identifier === Pn.identifier && (U.cur = bt(Pn, _));
      if (fn && !ln && !Tn && gn.length === 1) {
        const Pn = gn[0];
        jv(Pn.cur[0] - Pn[0]) > jv(Pn.cur[1] - Pn[1]) ? Tn = !0 : ln = !0;
      }
      for (const Pn of gn)
        Pn.cur && (Pn[0] = Pn.cur[0], Pn[1] = Pn.cur[1]);
      en = !0, Th(pn), xn(pn);
    }
    function xn(pn) {
      const Pn = gn[0], U = Pn.point0;
      var X;
      switch (q = Pn[0] - U[0], J = Pn[1] - U[1], A) {
        case Ah:
        case Qv: {
          T && (q = Fe(F - V, Be(k - O, q)), E = V + q, W = O + q), S && (J = Fe(L - $, Be(K - Q, J)), P = $ + J, z = Q + J);
          break;
        }
        case ba: {
          gn[1] ? (T && (E = Fe(F, Be(k, gn[0][0])), W = Fe(F, Be(k, gn[1][0])), T = 1), S && (P = Fe(L, Be(K, gn[0][1])), z = Fe(L, Be(K, gn[1][1])), S = 1)) : (T < 0 ? (q = Fe(F - V, Be(k - V, q)), E = V + q, W = O) : T > 0 && (q = Fe(F - O, Be(k - O, q)), E = V, W = O + q), S < 0 ? (J = Fe(L - $, Be(K - $, J)), P = $ + J, z = Q) : S > 0 && (J = Fe(L - Q, Be(K - Q, J)), P = $, z = Q + J));
          break;
        }
        case wa: {
          T && (E = Fe(F, Be(k, V - q * T)), W = Fe(F, Be(k, O + q * T))), S && (P = Fe(L, Be(K, $ - J * S)), z = Fe(L, Be(K, Q + J * S)));
          break;
        }
      }
      W < E && (T *= -1, X = V, V = O, O = X, X = E, E = W, W = X, x in em && hn.attr("cursor", Er[x = em[x]])), z < P && (S *= -1, X = $, $ = Q, Q = X, X = P, P = z, z = X, x in tm && hn.attr("cursor", Er[x = tm[x]])), R.selection && (B = R.selection), ln && (E = B[0][0], W = B[1][0]), Tn && (P = B[0][1], z = B[1][1]), (B[0][0] !== E || B[0][1] !== P || B[1][0] !== W || B[1][1] !== z) && (R.selection = [[E, P], [W, z]], c.call(_), _n.brush(pn, A.name));
    }
    function En(pn) {
      if (oR(pn), pn.touches) {
        if (pn.touches.length)
          return;
        s && clearTimeout(s), s = setTimeout(function() {
          s = null;
        }, 500);
      } else
        gl(pn.view, en), vn.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      tn.attr("pointer-events", "all"), hn.attr("cursor", Er.overlay), R.selection && (B = R.selection), dR(B) && (R.selection = null, c.call(_)), _n.end(pn, A.name);
    }
    function In(pn) {
      switch (pn.keyCode) {
        case 16: {
          fn = T && S;
          break;
        }
        case 18: {
          A === ba && (T && (O = W - q * T, V = E + q * T), S && (Q = z - J * S, $ = P + J * S), A = wa, xn(pn));
          break;
        }
        case 32: {
          (A === ba || A === wa) && (T < 0 ? O = W - q : T > 0 && (V = E - q), S < 0 ? Q = z - J : S > 0 && ($ = P - J), A = Ah, hn.attr("cursor", Er.selection), xn(pn));
          break;
        }
        default:
          return;
      }
      Th(pn);
    }
    function Ln(pn) {
      switch (pn.keyCode) {
        case 16: {
          fn && (ln = Tn = fn = !1, xn(pn));
          break;
        }
        case 18: {
          A === wa && (T < 0 ? O = W : T > 0 && (V = E), S < 0 ? Q = z : S > 0 && ($ = P), A = ba, xn(pn));
          break;
        }
        case 32: {
          A === Ah && (pn.altKey ? (T && (O = W - q * T, V = E + q * T), S && (Q = z - J * S, $ = P + J * S), A = wa) : (T < 0 ? O = W : T > 0 && (V = E), S < 0 ? Q = z : S > 0 && ($ = P), A = ba), hn.attr("cursor", Er[x]), xn(pn));
          break;
        }
        default:
          return;
      }
      Th(pn);
    }
  }
  function v(m) {
    p(this, arguments).moved(m);
  }
  function b(m) {
    p(this, arguments).ended(m);
  }
  function w() {
    var m = this.__brush || { selection: null };
    return m.extent = b0(e.apply(this, arguments)), m.dim = n, m;
  }
  return l.extent = function(m) {
    return arguments.length ? (e = typeof m == "function" ? m : xh(b0(m)), l) : e;
  }, l.filter = function(m) {
    return arguments.length ? (t = typeof m == "function" ? m : xh(!!m), l) : t;
  }, l.touchable = function(m) {
    return arguments.length ? (r = typeof m == "function" ? m : xh(!!m), l) : r;
  }, l.handleSize = function(m) {
    return arguments.length ? (f = +m, l) : f;
  }, l.keyModifiers = function(m) {
    return arguments.length ? (i = !!m, l) : i;
  }, l.on = function() {
    var m = o.on.apply(o, arguments);
    return m === o ? l : m;
  }, l;
}
var rm = Math.abs, xa = Math.cos, Ta = Math.sin, B_ = Math.PI, Pf = B_ / 2, im = B_ * 2, am = Math.max, Sh = 1e-12;
function Eh(n, e) {
  return Array.from({ length: e - n }, (t, r) => n + r);
}
function yR(n) {
  return function(e, t) {
    return n(
      e.source.value + e.target.value,
      t.source.value + t.target.value
    );
  };
}
function _R() {
  return kd(!1, !1);
}
function bR() {
  return kd(!1, !0);
}
function wR() {
  return kd(!0, !1);
}
function kd(n, e) {
  var t = 0, r = null, i = null, o = null;
  function f(s) {
    var l = s.length, c = new Array(l), p = Eh(0, l), g = new Array(l * l), d = new Array(l), v = 0, b;
    s = Float64Array.from({ length: l * l }, e ? (w, m) => s[m % l][m / l | 0] : (w, m) => s[m / l | 0][m % l]);
    for (let w = 0; w < l; ++w) {
      let m = 0;
      for (let _ = 0; _ < l; ++_)
        m += s[w * l + _] + n * s[_ * l + w];
      v += c[w] = m;
    }
    v = am(0, im - t * l) / v, b = v ? t : im / l;
    {
      let w = 0;
      r && p.sort((m, _) => r(c[m], c[_]));
      for (const m of p) {
        const _ = w;
        if (n) {
          const x = Eh(~l + 1, l).filter((A) => A < 0 ? s[~A * l + m] : s[m * l + A]);
          i && x.sort((A, T) => i(A < 0 ? -s[~A * l + m] : s[m * l + A], T < 0 ? -s[~T * l + m] : s[m * l + T]));
          for (const A of x)
            if (A < 0) {
              const T = g[~A * l + m] || (g[~A * l + m] = { source: null, target: null });
              T.target = { index: m, startAngle: w, endAngle: w += s[~A * l + m] * v, value: s[~A * l + m] };
            } else {
              const T = g[m * l + A] || (g[m * l + A] = { source: null, target: null });
              T.source = { index: m, startAngle: w, endAngle: w += s[m * l + A] * v, value: s[m * l + A] };
            }
          d[m] = { index: m, startAngle: _, endAngle: w, value: c[m] };
        } else {
          const x = Eh(0, l).filter((A) => s[m * l + A] || s[A * l + m]);
          i && x.sort((A, T) => i(s[m * l + A], s[m * l + T]));
          for (const A of x) {
            let T;
            if (m < A ? (T = g[m * l + A] || (g[m * l + A] = { source: null, target: null }), T.source = { index: m, startAngle: w, endAngle: w += s[m * l + A] * v, value: s[m * l + A] }) : (T = g[A * l + m] || (g[A * l + m] = { source: null, target: null }), T.target = { index: m, startAngle: w, endAngle: w += s[m * l + A] * v, value: s[m * l + A] }, m === A && (T.source = T.target)), T.source && T.target && T.source.value < T.target.value) {
              const S = T.source;
              T.source = T.target, T.target = S;
            }
          }
          d[m] = { index: m, startAngle: _, endAngle: w, value: c[m] };
        }
        w += b;
      }
    }
    return g = Object.values(g), g.groups = d, o ? g.sort(o) : g;
  }
  return f.padAngle = function(s) {
    return arguments.length ? (t = am(0, s), f) : t;
  }, f.sortGroups = function(s) {
    return arguments.length ? (r = s, f) : r;
  }, f.sortSubgroups = function(s) {
    return arguments.length ? (i = s, f) : i;
  }, f.sortChords = function(s) {
    return arguments.length ? (s == null ? o = null : (o = yR(s))._ = s, f) : o && o._;
  }, f;
}
const w0 = Math.PI, x0 = 2 * w0, Ei = 1e-6, xR = x0 - Ei;
function z_(n) {
  this._ += n[0];
  for (let e = 1, t = n.length; e < t; ++e)
    this._ += arguments[e] + n[e];
}
function TR(n) {
  let e = Math.floor(n);
  if (!(e >= 0))
    throw new Error(`invalid digits: ${n}`);
  if (e > 15)
    return z_;
  const t = 10 ** e;
  return function(r) {
    this._ += r[0];
    for (let i = 1, o = r.length; i < o; ++i)
      this._ += Math.round(arguments[i] * t) / t + r[i];
  };
}
let Au = class {
  constructor(e) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = e == null ? z_ : TR(e);
  }
  moveTo(e, t) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +t}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(e, t) {
    this._append`L${this._x1 = +e},${this._y1 = +t}`;
  }
  quadraticCurveTo(e, t, r, i) {
    this._append`Q${+e},${+t},${this._x1 = +r},${this._y1 = +i}`;
  }
  bezierCurveTo(e, t, r, i, o, f) {
    this._append`C${+e},${+t},${+r},${+i},${this._x1 = +o},${this._y1 = +f}`;
  }
  arcTo(e, t, r, i, o) {
    if (e = +e, t = +t, r = +r, i = +i, o = +o, o < 0)
      throw new Error(`negative radius: ${o}`);
    let f = this._x1, s = this._y1, l = r - e, c = i - t, p = f - e, g = s - t, d = p * p + g * g;
    if (this._x1 === null)
      this._append`M${this._x1 = e},${this._y1 = t}`;
    else if (d > Ei)
      if (!(Math.abs(g * l - c * p) > Ei) || !o)
        this._append`L${this._x1 = e},${this._y1 = t}`;
      else {
        let v = r - f, b = i - s, w = l * l + c * c, m = v * v + b * b, _ = Math.sqrt(w), x = Math.sqrt(d), A = o * Math.tan((w0 - Math.acos((w + d - m) / (2 * _ * x))) / 2), T = A / x, S = A / _;
        Math.abs(T - 1) > Ei && this._append`L${e + T * p},${t + T * g}`, this._append`A${o},${o},0,0,${+(g * v > p * b)},${this._x1 = e + S * l},${this._y1 = t + S * c}`;
      }
  }
  arc(e, t, r, i, o, f) {
    if (e = +e, t = +t, r = +r, f = !!f, r < 0)
      throw new Error(`negative radius: ${r}`);
    let s = r * Math.cos(i), l = r * Math.sin(i), c = e + s, p = t + l, g = 1 ^ f, d = f ? i - o : o - i;
    this._x1 === null ? this._append`M${c},${p}` : (Math.abs(this._x1 - c) > Ei || Math.abs(this._y1 - p) > Ei) && this._append`L${c},${p}`, r && (d < 0 && (d = d % x0 + x0), d > xR ? this._append`A${r},${r},0,1,${g},${e - s},${t - l}A${r},${r},0,1,${g},${this._x1 = c},${this._y1 = p}` : d > Ei && this._append`A${r},${r},0,${+(d >= w0)},${g},${this._x1 = e + r * Math.cos(o)},${this._y1 = t + r * Math.sin(o)}`);
  }
  rect(e, t, r, i) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +t}h${r = +r}v${+i}h${-r}Z`;
  }
  toString() {
    return this._;
  }
};
function Od() {
  return new Au();
}
Od.prototype = Au.prototype;
function AR(n = 3) {
  return new Au(+n);
}
var MR = Array.prototype.slice;
function Mi(n) {
  return function() {
    return n;
  };
}
function SR(n) {
  return n.source;
}
function ER(n) {
  return n.target;
}
function om(n) {
  return n.radius;
}
function CR(n) {
  return n.startAngle;
}
function PR(n) {
  return n.endAngle;
}
function RR() {
  return 0;
}
function NR() {
  return 10;
}
function V_(n) {
  var e = SR, t = ER, r = om, i = om, o = CR, f = PR, s = RR, l = null;
  function c() {
    var p, g = e.apply(this, arguments), d = t.apply(this, arguments), v = s.apply(this, arguments) / 2, b = MR.call(arguments), w = +r.apply(this, (b[0] = g, b)), m = o.apply(this, b) - Pf, _ = f.apply(this, b) - Pf, x = +i.apply(this, (b[0] = d, b)), A = o.apply(this, b) - Pf, T = f.apply(this, b) - Pf;
    if (l || (l = p = Od()), v > Sh && (rm(_ - m) > v * 2 + Sh ? _ > m ? (m += v, _ -= v) : (m -= v, _ += v) : m = _ = (m + _) / 2, rm(T - A) > v * 2 + Sh ? T > A ? (A += v, T -= v) : (A -= v, T += v) : A = T = (A + T) / 2), l.moveTo(w * xa(m), w * Ta(m)), l.arc(0, 0, w, m, _), m !== A || _ !== T)
      if (n) {
        var S = +n.apply(this, arguments), R = x - S, I = (A + T) / 2;
        l.quadraticCurveTo(0, 0, R * xa(A), R * Ta(A)), l.lineTo(x * xa(I), x * Ta(I)), l.lineTo(R * xa(T), R * Ta(T));
      } else
        l.quadraticCurveTo(0, 0, x * xa(A), x * Ta(A)), l.arc(0, 0, x, A, T);
    if (l.quadraticCurveTo(0, 0, w * xa(m), w * Ta(m)), l.closePath(), p)
      return l = null, p + "" || null;
  }
  return n && (c.headRadius = function(p) {
    return arguments.length ? (n = typeof p == "function" ? p : Mi(+p), c) : n;
  }), c.radius = function(p) {
    return arguments.length ? (r = i = typeof p == "function" ? p : Mi(+p), c) : r;
  }, c.sourceRadius = function(p) {
    return arguments.length ? (r = typeof p == "function" ? p : Mi(+p), c) : r;
  }, c.targetRadius = function(p) {
    return arguments.length ? (i = typeof p == "function" ? p : Mi(+p), c) : i;
  }, c.startAngle = function(p) {
    return arguments.length ? (o = typeof p == "function" ? p : Mi(+p), c) : o;
  }, c.endAngle = function(p) {
    return arguments.length ? (f = typeof p == "function" ? p : Mi(+p), c) : f;
  }, c.padAngle = function(p) {
    return arguments.length ? (s = typeof p == "function" ? p : Mi(+p), c) : s;
  }, c.source = function(p) {
    return arguments.length ? (e = p, c) : e;
  }, c.target = function(p) {
    return arguments.length ? (t = p, c) : t;
  }, c.context = function(p) {
    return arguments.length ? (l = p ?? null, c) : l;
  }, c;
}
function $R() {
  return V_();
}
function kR() {
  return V_(NR);
}
var OR = Array.prototype, U_ = OR.slice;
function IR(n, e) {
  return n - e;
}
function LR(n) {
  for (var e = 0, t = n.length, r = n[t - 1][1] * n[0][0] - n[t - 1][0] * n[0][1]; ++e < t; )
    r += n[e - 1][1] * n[e][0] - n[e - 1][0] * n[e][1];
  return r;
}
const Zr = (n) => () => n;
function DR(n, e) {
  for (var t = -1, r = e.length, i; ++t < r; )
    if (i = FR(n, e[t]))
      return i;
  return 0;
}
function FR(n, e) {
  for (var t = e[0], r = e[1], i = -1, o = 0, f = n.length, s = f - 1; o < f; s = o++) {
    var l = n[o], c = l[0], p = l[1], g = n[s], d = g[0], v = g[1];
    if (BR(l, g, e))
      return 0;
    p > r != v > r && t < (d - c) * (r - p) / (v - p) + c && (i = -i);
  }
  return i;
}
function BR(n, e, t) {
  var r;
  return zR(n, e, t) && VR(n[r = +(n[0] === e[0])], t[r], e[r]);
}
function zR(n, e, t) {
  return (e[0] - n[0]) * (t[1] - n[1]) === (t[0] - n[0]) * (e[1] - n[1]);
}
function VR(n, e, t) {
  return n <= e && e <= t || t <= e && e <= n;
}
function UR() {
}
var Cr = [
  [],
  [[[1, 1.5], [0.5, 1]]],
  [[[1.5, 1], [1, 1.5]]],
  [[[1.5, 1], [0.5, 1]]],
  [[[1, 0.5], [1.5, 1]]],
  [[[1, 1.5], [0.5, 1]], [[1, 0.5], [1.5, 1]]],
  [[[1, 0.5], [1, 1.5]]],
  [[[1, 0.5], [0.5, 1]]],
  [[[0.5, 1], [1, 0.5]]],
  [[[1, 1.5], [1, 0.5]]],
  [[[0.5, 1], [1, 0.5]], [[1.5, 1], [1, 1.5]]],
  [[[1.5, 1], [1, 0.5]]],
  [[[0.5, 1], [1.5, 1]]],
  [[[1, 1.5], [1.5, 1]]],
  [[[0.5, 1], [1, 1.5]]],
  []
];
function T0() {
  var n = 1, e = 1, t = hd, r = l;
  function i(c) {
    var p = t(c);
    if (Array.isArray(p))
      p = p.slice().sort(IR);
    else {
      const g = Yo(c, GR);
      for (p = Di(...cd(g[0], g[1], p), p); p[p.length - 1] >= g[1]; )
        p.pop();
      for (; p[1] < g[0]; )
        p.shift();
    }
    return p.map((g) => o(c, g));
  }
  function o(c, p) {
    const g = p == null ? NaN : +p;
    if (isNaN(g))
      throw new Error(`invalid value: ${p}`);
    var d = [], v = [];
    return f(c, g, function(b) {
      r(b, c, g), LR(b) > 0 ? d.push([b]) : v.push(b);
    }), v.forEach(function(b) {
      for (var w = 0, m = d.length, _; w < m; ++w)
        if (DR((_ = d[w])[0], b) !== -1) {
          _.push(b);
          return;
        }
    }), {
      type: "MultiPolygon",
      value: p,
      coordinates: d
    };
  }
  function f(c, p, g) {
    var d = new Array(), v = new Array(), b, w, m, _, x, A;
    for (b = w = -1, _ = Si(c[0], p), Cr[_ << 1].forEach(T); ++b < n - 1; )
      m = _, _ = Si(c[b + 1], p), Cr[m | _ << 1].forEach(T);
    for (Cr[_ << 0].forEach(T); ++w < e - 1; ) {
      for (b = -1, _ = Si(c[w * n + n], p), x = Si(c[w * n], p), Cr[_ << 1 | x << 2].forEach(T); ++b < n - 1; )
        m = _, _ = Si(c[w * n + n + b + 1], p), A = x, x = Si(c[w * n + b + 1], p), Cr[m | _ << 1 | x << 2 | A << 3].forEach(T);
      Cr[_ | x << 3].forEach(T);
    }
    for (b = -1, x = c[w * n] >= p, Cr[x << 2].forEach(T); ++b < n - 1; )
      A = x, x = Si(c[w * n + b + 1], p), Cr[x << 2 | A << 3].forEach(T);
    Cr[x << 3].forEach(T);
    function T(S) {
      var R = [S[0][0] + b, S[0][1] + w], I = [S[1][0] + b, S[1][1] + w], B = s(R), F = s(I), V, E;
      (V = v[B]) ? (E = d[F]) ? (delete v[V.end], delete d[E.start], V === E ? (V.ring.push(I), g(V.ring)) : d[V.start] = v[E.end] = { start: V.start, end: E.end, ring: V.ring.concat(E.ring) }) : (delete v[V.end], V.ring.push(I), v[V.end = F] = V) : (V = d[F]) ? (E = v[B]) ? (delete d[V.start], delete v[E.end], V === E ? (V.ring.push(I), g(V.ring)) : d[E.start] = v[V.end] = { start: E.start, end: V.end, ring: E.ring.concat(V.ring) }) : (delete d[V.start], V.ring.unshift(R), d[V.start = B] = V) : d[B] = v[F] = { start: B, end: F, ring: [R, I] };
    }
  }
  function s(c) {
    return c[0] * 2 + c[1] * (n + 1) * 4;
  }
  function l(c, p, g) {
    c.forEach(function(d) {
      var v = d[0], b = d[1], w = v | 0, m = b | 0, _ = Ch(p[m * n + w]);
      v > 0 && v < n && w === v && (d[0] = um(v, Ch(p[m * n + w - 1]), _, g)), b > 0 && b < e && m === b && (d[1] = um(b, Ch(p[(m - 1) * n + w]), _, g));
    });
  }
  return i.contour = o, i.size = function(c) {
    if (!arguments.length)
      return [n, e];
    var p = Math.floor(c[0]), g = Math.floor(c[1]);
    if (!(p >= 0 && g >= 0))
      throw new Error("invalid size");
    return n = p, e = g, i;
  }, i.thresholds = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : Array.isArray(c) ? Zr(U_.call(c)) : Zr(c), i) : t;
  }, i.smooth = function(c) {
    return arguments.length ? (r = c ? l : UR, i) : r === l;
  }, i;
}
function GR(n) {
  return isFinite(n) ? n : NaN;
}
function Si(n, e) {
  return n == null ? !1 : +n >= e;
}
function Ch(n) {
  return n == null || isNaN(n = +n) ? -1 / 0 : n;
}
function um(n, e, t, r) {
  const i = r - e, o = t - e, f = isFinite(i) || isFinite(o) ? i / o : Math.sign(i) / Math.sign(o);
  return isNaN(f) ? n : n + f - 0.5;
}
function qR(n) {
  return n[0];
}
function WR(n) {
  return n[1];
}
function HR() {
  return 1;
}
function YR() {
  var n = qR, e = WR, t = HR, r = 960, i = 500, o = 20, f = 2, s = o * 3, l = r + s * 2 >> f, c = i + s * 2 >> f, p = Zr(20);
  function g(x) {
    var A = new Float32Array(l * c), T = Math.pow(2, -f), S = -1;
    for (const $ of x) {
      var R = (n($, ++S, x) + s) * T, I = (e($, S, x) + s) * T, B = +t($, S, x);
      if (B && R >= 0 && R < l && I >= 0 && I < c) {
        var F = Math.floor(R), V = Math.floor(I), E = R - F - 0.5, L = I - V - 0.5;
        A[F + V * l] += (1 - E) * (1 - L) * B, A[F + 1 + V * l] += E * (1 - L) * B, A[F + 1 + (V + 1) * l] += E * L * B, A[F + (V + 1) * l] += (1 - E) * L * B;
      }
    }
    return w2({ data: A, width: l, height: c }, o * T), A;
  }
  function d(x) {
    var A = g(x), T = p(A), S = Math.pow(2, 2 * f);
    return Array.isArray(T) || (T = Di(Number.MIN_VALUE, eu(A) / S, T)), T0().size([l, c]).thresholds(T.map((R) => R * S))(A).map((R, I) => (R.value = +T[I], v(R)));
  }
  d.contours = function(x) {
    var A = g(x), T = T0().size([l, c]), S = Math.pow(2, 2 * f), R = (I) => {
      I = +I;
      var B = v(T.contour(A, I * S));
      return B.value = I, B;
    };
    return Object.defineProperty(R, "max", { get: () => eu(A) / S }), R;
  };
  function v(x) {
    return x.coordinates.forEach(b), x;
  }
  function b(x) {
    x.forEach(w);
  }
  function w(x) {
    x.forEach(m);
  }
  function m(x) {
    x[0] = x[0] * Math.pow(2, f) - s, x[1] = x[1] * Math.pow(2, f) - s;
  }
  function _() {
    return s = o * 3, l = r + s * 2 >> f, c = i + s * 2 >> f, d;
  }
  return d.x = function(x) {
    return arguments.length ? (n = typeof x == "function" ? x : Zr(+x), d) : n;
  }, d.y = function(x) {
    return arguments.length ? (e = typeof x == "function" ? x : Zr(+x), d) : e;
  }, d.weight = function(x) {
    return arguments.length ? (t = typeof x == "function" ? x : Zr(+x), d) : t;
  }, d.size = function(x) {
    if (!arguments.length)
      return [r, i];
    var A = +x[0], T = +x[1];
    if (!(A >= 0 && T >= 0))
      throw new Error("invalid size");
    return r = A, i = T, _();
  }, d.cellSize = function(x) {
    if (!arguments.length)
      return 1 << f;
    if (!((x = +x) >= 1))
      throw new Error("invalid cell size");
    return f = Math.floor(Math.log(x) / Math.LN2), _();
  }, d.thresholds = function(x) {
    return arguments.length ? (p = typeof x == "function" ? x : Array.isArray(x) ? Zr(U_.call(x)) : Zr(x), d) : p;
  }, d.bandwidth = function(x) {
    if (!arguments.length)
      return Math.sqrt(o * (o + 1));
    if (!((x = +x) >= 0))
      throw new Error("invalid bandwidth");
    return o = (Math.sqrt(4 * x * x + 1) - 1) / 2, _();
  }, d;
}
const Lr = 11102230246251565e-32, ze = 134217729, XR = (3 + 8 * Lr) * Lr;
function Ph(n, e, t, r, i) {
  let o, f, s, l, c = e[0], p = r[0], g = 0, d = 0;
  p > c == p > -c ? (o = c, c = e[++g]) : (o = p, p = r[++d]);
  let v = 0;
  if (g < n && d < t)
    for (p > c == p > -c ? (f = c + o, s = o - (f - c), c = e[++g]) : (f = p + o, s = o - (f - p), p = r[++d]), o = f, s !== 0 && (i[v++] = s); g < n && d < t; )
      p > c == p > -c ? (f = o + c, l = f - o, s = o - (f - l) + (c - l), c = e[++g]) : (f = o + p, l = f - o, s = o - (f - l) + (p - l), p = r[++d]), o = f, s !== 0 && (i[v++] = s);
  for (; g < n; )
    f = o + c, l = f - o, s = o - (f - l) + (c - l), c = e[++g], o = f, s !== 0 && (i[v++] = s);
  for (; d < t; )
    f = o + p, l = f - o, s = o - (f - l) + (p - l), p = r[++d], o = f, s !== 0 && (i[v++] = s);
  return (o !== 0 || v === 0) && (i[v++] = o), v;
}
function KR(n, e) {
  let t = e[0];
  for (let r = 1; r < n; r++)
    t += e[r];
  return t;
}
function Mu(n) {
  return new Float64Array(n);
}
const ZR = (3 + 16 * Lr) * Lr, JR = (2 + 12 * Lr) * Lr, QR = (9 + 64 * Lr) * Lr * Lr, Aa = Mu(4), fm = Mu(8), sm = Mu(12), lm = Mu(16), Xe = Mu(4);
function jR(n, e, t, r, i, o, f) {
  let s, l, c, p, g, d, v, b, w, m, _, x, A, T, S, R, I, B;
  const F = n - i, V = t - i, E = e - o, L = r - o;
  T = F * L, d = ze * F, v = d - (d - F), b = F - v, d = ze * L, w = d - (d - L), m = L - w, S = b * m - (T - v * w - b * w - v * m), R = E * V, d = ze * E, v = d - (d - E), b = E - v, d = ze * V, w = d - (d - V), m = V - w, I = b * m - (R - v * w - b * w - v * m), _ = S - I, g = S - _, Aa[0] = S - (_ + g) + (g - I), x = T + _, g = x - T, A = T - (x - g) + (_ - g), _ = A - R, g = A - _, Aa[1] = A - (_ + g) + (g - R), B = x + _, g = B - x, Aa[2] = x - (B - g) + (_ - g), Aa[3] = B;
  let $ = KR(4, Aa), P = JR * f;
  if ($ >= P || -$ >= P || (g = n - F, s = n - (F + g) + (g - i), g = t - V, c = t - (V + g) + (g - i), g = e - E, l = e - (E + g) + (g - o), g = r - L, p = r - (L + g) + (g - o), s === 0 && l === 0 && c === 0 && p === 0) || (P = QR * f + XR * Math.abs($), $ += F * p + L * s - (E * c + V * l), $ >= P || -$ >= P))
    return $;
  T = s * L, d = ze * s, v = d - (d - s), b = s - v, d = ze * L, w = d - (d - L), m = L - w, S = b * m - (T - v * w - b * w - v * m), R = l * V, d = ze * l, v = d - (d - l), b = l - v, d = ze * V, w = d - (d - V), m = V - w, I = b * m - (R - v * w - b * w - v * m), _ = S - I, g = S - _, Xe[0] = S - (_ + g) + (g - I), x = T + _, g = x - T, A = T - (x - g) + (_ - g), _ = A - R, g = A - _, Xe[1] = A - (_ + g) + (g - R), B = x + _, g = B - x, Xe[2] = x - (B - g) + (_ - g), Xe[3] = B;
  const k = Ph(4, Aa, 4, Xe, fm);
  T = F * p, d = ze * F, v = d - (d - F), b = F - v, d = ze * p, w = d - (d - p), m = p - w, S = b * m - (T - v * w - b * w - v * m), R = E * c, d = ze * E, v = d - (d - E), b = E - v, d = ze * c, w = d - (d - c), m = c - w, I = b * m - (R - v * w - b * w - v * m), _ = S - I, g = S - _, Xe[0] = S - (_ + g) + (g - I), x = T + _, g = x - T, A = T - (x - g) + (_ - g), _ = A - R, g = A - _, Xe[1] = A - (_ + g) + (g - R), B = x + _, g = B - x, Xe[2] = x - (B - g) + (_ - g), Xe[3] = B;
  const O = Ph(k, fm, 4, Xe, sm);
  T = s * p, d = ze * s, v = d - (d - s), b = s - v, d = ze * p, w = d - (d - p), m = p - w, S = b * m - (T - v * w - b * w - v * m), R = l * c, d = ze * l, v = d - (d - l), b = l - v, d = ze * c, w = d - (d - c), m = c - w, I = b * m - (R - v * w - b * w - v * m), _ = S - I, g = S - _, Xe[0] = S - (_ + g) + (g - I), x = T + _, g = x - T, A = T - (x - g) + (_ - g), _ = A - R, g = A - _, Xe[1] = A - (_ + g) + (g - R), B = x + _, g = B - x, Xe[2] = x - (B - g) + (_ - g), Xe[3] = B;
  const W = Ph(O, sm, 4, Xe, lm);
  return lm[W - 1];
}
function Rf(n, e, t, r, i, o) {
  const f = (e - o) * (t - i), s = (n - i) * (r - o), l = f - s, c = Math.abs(f + s);
  return Math.abs(l) >= ZR * c ? l : -jR(n, e, t, r, i, o, c);
}
const cm = Math.pow(2, -52), Nf = new Uint32Array(512);
class Ms {
  static from(e, t = iN, r = aN) {
    const i = e.length, o = new Float64Array(i * 2);
    for (let f = 0; f < i; f++) {
      const s = e[f];
      o[2 * f] = t(s), o[2 * f + 1] = r(s);
    }
    return new Ms(o);
  }
  constructor(e) {
    const t = e.length >> 1;
    if (t > 0 && typeof e[0] != "number")
      throw new Error("Expected coords to contain numbers.");
    this.coords = e;
    const r = Math.max(2 * t - 5, 0);
    this._triangles = new Uint32Array(r * 3), this._halfedges = new Int32Array(r * 3), this._hashSize = Math.ceil(Math.sqrt(t)), this._hullPrev = new Uint32Array(t), this._hullNext = new Uint32Array(t), this._hullTri = new Uint32Array(t), this._hullHash = new Int32Array(this._hashSize), this._ids = new Uint32Array(t), this._dists = new Float64Array(t), this.update();
  }
  update() {
    const { coords: e, _hullPrev: t, _hullNext: r, _hullTri: i, _hullHash: o } = this, f = e.length >> 1;
    let s = 1 / 0, l = 1 / 0, c = -1 / 0, p = -1 / 0;
    for (let F = 0; F < f; F++) {
      const V = e[2 * F], E = e[2 * F + 1];
      V < s && (s = V), E < l && (l = E), V > c && (c = V), E > p && (p = E), this._ids[F] = F;
    }
    const g = (s + c) / 2, d = (l + p) / 2;
    let v, b, w;
    for (let F = 0, V = 1 / 0; F < f; F++) {
      const E = Rh(g, d, e[2 * F], e[2 * F + 1]);
      E < V && (v = F, V = E);
    }
    const m = e[2 * v], _ = e[2 * v + 1];
    for (let F = 0, V = 1 / 0; F < f; F++) {
      if (F === v)
        continue;
      const E = Rh(m, _, e[2 * F], e[2 * F + 1]);
      E < V && E > 0 && (b = F, V = E);
    }
    let x = e[2 * b], A = e[2 * b + 1], T = 1 / 0;
    for (let F = 0; F < f; F++) {
      if (F === v || F === b)
        continue;
      const V = tN(m, _, x, A, e[2 * F], e[2 * F + 1]);
      V < T && (w = F, T = V);
    }
    let S = e[2 * w], R = e[2 * w + 1];
    if (T === 1 / 0) {
      for (let E = 0; E < f; E++)
        this._dists[E] = e[2 * E] - e[0] || e[2 * E + 1] - e[1];
      Na(this._ids, this._dists, 0, f - 1);
      const F = new Uint32Array(f);
      let V = 0;
      for (let E = 0, L = -1 / 0; E < f; E++) {
        const $ = this._ids[E], P = this._dists[$];
        P > L && (F[V++] = $, L = P);
      }
      this.hull = F.subarray(0, V), this.triangles = new Uint32Array(0), this.halfedges = new Uint32Array(0);
      return;
    }
    if (Rf(m, _, x, A, S, R) < 0) {
      const F = b, V = x, E = A;
      b = w, x = S, A = R, w = F, S = V, R = E;
    }
    const I = rN(m, _, x, A, S, R);
    this._cx = I.x, this._cy = I.y;
    for (let F = 0; F < f; F++)
      this._dists[F] = Rh(e[2 * F], e[2 * F + 1], I.x, I.y);
    Na(this._ids, this._dists, 0, f - 1), this._hullStart = v;
    let B = 3;
    r[v] = t[w] = b, r[b] = t[v] = w, r[w] = t[b] = v, i[v] = 0, i[b] = 1, i[w] = 2, o.fill(-1), o[this._hashKey(m, _)] = v, o[this._hashKey(x, A)] = b, o[this._hashKey(S, R)] = w, this.trianglesLen = 0, this._addTriangle(v, b, w, -1, -1, -1);
    for (let F = 0, V, E; F < this._ids.length; F++) {
      const L = this._ids[F], $ = e[2 * L], P = e[2 * L + 1];
      if (F > 0 && Math.abs($ - V) <= cm && Math.abs(P - E) <= cm || (V = $, E = P, L === v || L === b || L === w))
        continue;
      let k = 0;
      for (let z = 0, q = this._hashKey($, P); z < this._hashSize && (k = o[(q + z) % this._hashSize], !(k !== -1 && k !== r[k])); z++)
        ;
      k = t[k];
      let O = k, W;
      for (; W = r[O], Rf($, P, e[2 * O], e[2 * O + 1], e[2 * W], e[2 * W + 1]) >= 0; )
        if (O = W, O === k) {
          O = -1;
          break;
        }
      if (O === -1)
        continue;
      let K = this._addTriangle(O, L, r[O], -1, -1, i[O]);
      i[L] = this._legalize(K + 2), i[O] = K, B++;
      let Q = r[O];
      for (; W = r[Q], Rf($, P, e[2 * Q], e[2 * Q + 1], e[2 * W], e[2 * W + 1]) < 0; )
        K = this._addTriangle(Q, L, W, i[L], -1, i[Q]), i[L] = this._legalize(K + 2), r[Q] = Q, B--, Q = W;
      if (O === k)
        for (; W = t[O], Rf($, P, e[2 * W], e[2 * W + 1], e[2 * O], e[2 * O + 1]) < 0; )
          K = this._addTriangle(W, L, O, -1, i[O], i[W]), this._legalize(K + 2), i[W] = K, r[O] = O, B--, O = W;
      this._hullStart = t[L] = O, r[O] = t[Q] = L, r[L] = Q, o[this._hashKey($, P)] = L, o[this._hashKey(e[2 * O], e[2 * O + 1])] = O;
    }
    this.hull = new Uint32Array(B);
    for (let F = 0, V = this._hullStart; F < B; F++)
      this.hull[F] = V, V = r[V];
    this.triangles = this._triangles.subarray(0, this.trianglesLen), this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
  }
  _hashKey(e, t) {
    return Math.floor(nN(e - this._cx, t - this._cy) * this._hashSize) % this._hashSize;
  }
  _legalize(e) {
    const { _triangles: t, _halfedges: r, coords: i } = this;
    let o = 0, f = 0;
    for (; ; ) {
      const s = r[e], l = e - e % 3;
      if (f = l + (e + 2) % 3, s === -1) {
        if (o === 0)
          break;
        e = Nf[--o];
        continue;
      }
      const c = s - s % 3, p = l + (e + 1) % 3, g = c + (s + 2) % 3, d = t[f], v = t[e], b = t[p], w = t[g];
      if (eN(
        i[2 * d],
        i[2 * d + 1],
        i[2 * v],
        i[2 * v + 1],
        i[2 * b],
        i[2 * b + 1],
        i[2 * w],
        i[2 * w + 1]
      )) {
        t[e] = w, t[s] = d;
        const _ = r[g];
        if (_ === -1) {
          let A = this._hullStart;
          do {
            if (this._hullTri[A] === g) {
              this._hullTri[A] = e;
              break;
            }
            A = this._hullPrev[A];
          } while (A !== this._hullStart);
        }
        this._link(e, _), this._link(s, r[f]), this._link(f, g);
        const x = c + (s + 1) % 3;
        o < Nf.length && (Nf[o++] = x);
      } else {
        if (o === 0)
          break;
        e = Nf[--o];
      }
    }
    return f;
  }
  _link(e, t) {
    this._halfedges[e] = t, t !== -1 && (this._halfedges[t] = e);
  }
  // add a new triangle given vertex indices and adjacent half-edge ids
  _addTriangle(e, t, r, i, o, f) {
    const s = this.trianglesLen;
    return this._triangles[s] = e, this._triangles[s + 1] = t, this._triangles[s + 2] = r, this._link(s, i), this._link(s + 1, o), this._link(s + 2, f), this.trianglesLen += 3, s;
  }
}
function nN(n, e) {
  const t = n / (Math.abs(n) + Math.abs(e));
  return (e > 0 ? 3 - t : 1 + t) / 4;
}
function Rh(n, e, t, r) {
  const i = n - t, o = e - r;
  return i * i + o * o;
}
function eN(n, e, t, r, i, o, f, s) {
  const l = n - f, c = e - s, p = t - f, g = r - s, d = i - f, v = o - s, b = l * l + c * c, w = p * p + g * g, m = d * d + v * v;
  return l * (g * m - w * v) - c * (p * m - w * d) + b * (p * v - g * d) < 0;
}
function tN(n, e, t, r, i, o) {
  const f = t - n, s = r - e, l = i - n, c = o - e, p = f * f + s * s, g = l * l + c * c, d = 0.5 / (f * c - s * l), v = (c * p - s * g) * d, b = (f * g - l * p) * d;
  return v * v + b * b;
}
function rN(n, e, t, r, i, o) {
  const f = t - n, s = r - e, l = i - n, c = o - e, p = f * f + s * s, g = l * l + c * c, d = 0.5 / (f * c - s * l), v = n + (c * p - s * g) * d, b = e + (f * g - l * p) * d;
  return { x: v, y: b };
}
function Na(n, e, t, r) {
  if (r - t <= 20)
    for (let i = t + 1; i <= r; i++) {
      const o = n[i], f = e[o];
      let s = i - 1;
      for (; s >= t && e[n[s]] > f; )
        n[s + 1] = n[s--];
      n[s + 1] = o;
    }
  else {
    const i = t + r >> 1;
    let o = t + 1, f = r;
    Po(n, i, o), e[n[t]] > e[n[r]] && Po(n, t, r), e[n[o]] > e[n[r]] && Po(n, o, r), e[n[t]] > e[n[o]] && Po(n, t, o);
    const s = n[o], l = e[s];
    for (; ; ) {
      do
        o++;
      while (e[n[o]] < l);
      do
        f--;
      while (e[n[f]] > l);
      if (f < o)
        break;
      Po(n, o, f);
    }
    n[t + 1] = n[f], n[f] = s, r - o + 1 >= f - t ? (Na(n, e, o, r), Na(n, e, t, f - 1)) : (Na(n, e, t, f - 1), Na(n, e, o, r));
  }
}
function Po(n, e, t) {
  const r = n[e];
  n[e] = n[t], n[t] = r;
}
function iN(n) {
  return n[0];
}
function aN(n) {
  return n[1];
}
const hm = 1e-6;
class $i {
  constructor() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "";
  }
  moveTo(e, t) {
    this._ += `M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +t}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  }
  lineTo(e, t) {
    this._ += `L${this._x1 = +e},${this._y1 = +t}`;
  }
  arc(e, t, r) {
    e = +e, t = +t, r = +r;
    const i = e + r, o = t;
    if (r < 0)
      throw new Error("negative radius");
    this._x1 === null ? this._ += `M${i},${o}` : (Math.abs(this._x1 - i) > hm || Math.abs(this._y1 - o) > hm) && (this._ += "L" + i + "," + o), r && (this._ += `A${r},${r},0,1,1,${e - r},${t}A${r},${r},0,1,1,${this._x1 = i},${this._y1 = o}`);
  }
  rect(e, t, r, i) {
    this._ += `M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +t}h${+r}v${+i}h${-r}Z`;
  }
  value() {
    return this._ || null;
  }
}
class A0 {
  constructor() {
    this._ = [];
  }
  moveTo(e, t) {
    this._.push([e, t]);
  }
  closePath() {
    this._.push(this._[0].slice());
  }
  lineTo(e, t) {
    this._.push([e, t]);
  }
  value() {
    return this._.length ? this._ : null;
  }
}
class G_ {
  constructor(e, [t, r, i, o] = [0, 0, 960, 500]) {
    if (!((i = +i) >= (t = +t)) || !((o = +o) >= (r = +r)))
      throw new Error("invalid bounds");
    this.delaunay = e, this._circumcenters = new Float64Array(e.points.length * 2), this.vectors = new Float64Array(e.points.length * 2), this.xmax = i, this.xmin = t, this.ymax = o, this.ymin = r, this._init();
  }
  update() {
    return this.delaunay.update(), this._init(), this;
  }
  _init() {
    const { delaunay: { points: e, hull: t, triangles: r }, vectors: i } = this;
    let o, f;
    const s = this.circumcenters = this._circumcenters.subarray(0, r.length / 3 * 2);
    for (let w = 0, m = 0, _ = r.length, x, A; w < _; w += 3, m += 2) {
      const T = r[w] * 2, S = r[w + 1] * 2, R = r[w + 2] * 2, I = e[T], B = e[T + 1], F = e[S], V = e[S + 1], E = e[R], L = e[R + 1], $ = F - I, P = V - B, k = E - I, O = L - B, W = ($ * O - P * k) * 2;
      if (Math.abs(W) < 1e-9) {
        if (o === void 0) {
          o = f = 0;
          for (const Q of t)
            o += e[Q * 2], f += e[Q * 2 + 1];
          o /= t.length, f /= t.length;
        }
        const K = 1e9 * Math.sign((o - I) * O - (f - B) * k);
        x = (I + E) / 2 - K * O, A = (B + L) / 2 + K * k;
      } else {
        const K = 1 / W, Q = $ * $ + P * P, z = k * k + O * O;
        x = I + (O * Q - P * z) * K, A = B + ($ * z - k * Q) * K;
      }
      s[m] = x, s[m + 1] = A;
    }
    let l = t[t.length - 1], c, p = l * 4, g, d = e[2 * l], v, b = e[2 * l + 1];
    i.fill(0);
    for (let w = 0; w < t.length; ++w)
      l = t[w], c = p, g = d, v = b, p = l * 4, d = e[2 * l], b = e[2 * l + 1], i[c + 2] = i[p] = v - b, i[c + 3] = i[p + 1] = d - g;
  }
  render(e) {
    const t = e == null ? e = new $i() : void 0, { delaunay: { halfedges: r, inedges: i, hull: o }, circumcenters: f, vectors: s } = this;
    if (o.length <= 1)
      return null;
    for (let p = 0, g = r.length; p < g; ++p) {
      const d = r[p];
      if (d < p)
        continue;
      const v = Math.floor(p / 3) * 2, b = Math.floor(d / 3) * 2, w = f[v], m = f[v + 1], _ = f[b], x = f[b + 1];
      this._renderSegment(w, m, _, x, e);
    }
    let l, c = o[o.length - 1];
    for (let p = 0; p < o.length; ++p) {
      l = c, c = o[p];
      const g = Math.floor(i[c] / 3) * 2, d = f[g], v = f[g + 1], b = l * 4, w = this._project(d, v, s[b + 2], s[b + 3]);
      w && this._renderSegment(d, v, w[0], w[1], e);
    }
    return t && t.value();
  }
  renderBounds(e) {
    const t = e == null ? e = new $i() : void 0;
    return e.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin), t && t.value();
  }
  renderCell(e, t) {
    const r = t == null ? t = new $i() : void 0, i = this._clip(e);
    if (i === null || !i.length)
      return;
    t.moveTo(i[0], i[1]);
    let o = i.length;
    for (; i[0] === i[o - 2] && i[1] === i[o - 1] && o > 1; )
      o -= 2;
    for (let f = 2; f < o; f += 2)
      (i[f] !== i[f - 2] || i[f + 1] !== i[f - 1]) && t.lineTo(i[f], i[f + 1]);
    return t.closePath(), r && r.value();
  }
  *cellPolygons() {
    const { delaunay: { points: e } } = this;
    for (let t = 0, r = e.length / 2; t < r; ++t) {
      const i = this.cellPolygon(t);
      i && (i.index = t, yield i);
    }
  }
  cellPolygon(e) {
    const t = new A0();
    return this.renderCell(e, t), t.value();
  }
  _renderSegment(e, t, r, i, o) {
    let f;
    const s = this._regioncode(e, t), l = this._regioncode(r, i);
    s === 0 && l === 0 ? (o.moveTo(e, t), o.lineTo(r, i)) : (f = this._clipSegment(e, t, r, i, s, l)) && (o.moveTo(f[0], f[1]), o.lineTo(f[2], f[3]));
  }
  contains(e, t, r) {
    return t = +t, t !== t || (r = +r, r !== r) ? !1 : this.delaunay._step(e, t, r) === e;
  }
  *neighbors(e) {
    const t = this._clip(e);
    if (t)
      for (const r of this.delaunay.neighbors(e)) {
        const i = this._clip(r);
        if (i) {
          n:
            for (let o = 0, f = t.length; o < f; o += 2)
              for (let s = 0, l = i.length; s < l; s += 2)
                if (t[o] === i[s] && t[o + 1] === i[s + 1] && t[(o + 2) % f] === i[(s + l - 2) % l] && t[(o + 3) % f] === i[(s + l - 1) % l]) {
                  yield r;
                  break n;
                }
        }
      }
  }
  _cell(e) {
    const { circumcenters: t, delaunay: { inedges: r, halfedges: i, triangles: o } } = this, f = r[e];
    if (f === -1)
      return null;
    const s = [];
    let l = f;
    do {
      const c = Math.floor(l / 3);
      if (s.push(t[c * 2], t[c * 2 + 1]), l = l % 3 === 2 ? l - 2 : l + 1, o[l] !== e)
        break;
      l = i[l];
    } while (l !== f && l !== -1);
    return s;
  }
  _clip(e) {
    if (e === 0 && this.delaunay.hull.length === 1)
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    const t = this._cell(e);
    if (t === null)
      return null;
    const { vectors: r } = this, i = e * 4;
    return this._simplify(r[i] || r[i + 1] ? this._clipInfinite(e, t, r[i], r[i + 1], r[i + 2], r[i + 3]) : this._clipFinite(e, t));
  }
  _clipFinite(e, t) {
    const r = t.length;
    let i = null, o, f, s = t[r - 2], l = t[r - 1], c, p = this._regioncode(s, l), g, d = 0;
    for (let v = 0; v < r; v += 2)
      if (o = s, f = l, s = t[v], l = t[v + 1], c = p, p = this._regioncode(s, l), c === 0 && p === 0)
        g = d, d = 0, i ? i.push(s, l) : i = [s, l];
      else {
        let b, w, m, _, x;
        if (c === 0) {
          if ((b = this._clipSegment(o, f, s, l, c, p)) === null)
            continue;
          [w, m, _, x] = b;
        } else {
          if ((b = this._clipSegment(s, l, o, f, p, c)) === null)
            continue;
          [_, x, w, m] = b, g = d, d = this._edgecode(w, m), g && d && this._edge(e, g, d, i, i.length), i ? i.push(w, m) : i = [w, m];
        }
        g = d, d = this._edgecode(_, x), g && d && this._edge(e, g, d, i, i.length), i ? i.push(_, x) : i = [_, x];
      }
    if (i)
      g = d, d = this._edgecode(i[0], i[1]), g && d && this._edge(e, g, d, i, i.length);
    else if (this.contains(e, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2))
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    return i;
  }
  _clipSegment(e, t, r, i, o, f) {
    const s = o < f;
    for (s && ([e, t, r, i, o, f] = [r, i, e, t, f, o]); ; ) {
      if (o === 0 && f === 0)
        return s ? [r, i, e, t] : [e, t, r, i];
      if (o & f)
        return null;
      let l, c, p = o || f;
      p & 8 ? (l = e + (r - e) * (this.ymax - t) / (i - t), c = this.ymax) : p & 4 ? (l = e + (r - e) * (this.ymin - t) / (i - t), c = this.ymin) : p & 2 ? (c = t + (i - t) * (this.xmax - e) / (r - e), l = this.xmax) : (c = t + (i - t) * (this.xmin - e) / (r - e), l = this.xmin), o ? (e = l, t = c, o = this._regioncode(e, t)) : (r = l, i = c, f = this._regioncode(r, i));
    }
  }
  _clipInfinite(e, t, r, i, o, f) {
    let s = Array.from(t), l;
    if ((l = this._project(s[0], s[1], r, i)) && s.unshift(l[0], l[1]), (l = this._project(s[s.length - 2], s[s.length - 1], o, f)) && s.push(l[0], l[1]), s = this._clipFinite(e, s))
      for (let c = 0, p = s.length, g, d = this._edgecode(s[p - 2], s[p - 1]); c < p; c += 2)
        g = d, d = this._edgecode(s[c], s[c + 1]), g && d && (c = this._edge(e, g, d, s, c), p = s.length);
    else
      this.contains(e, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2) && (s = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax]);
    return s;
  }
  _edge(e, t, r, i, o) {
    for (; t !== r; ) {
      let f, s;
      switch (t) {
        case 5:
          t = 4;
          continue;
        case 4:
          t = 6, f = this.xmax, s = this.ymin;
          break;
        case 6:
          t = 2;
          continue;
        case 2:
          t = 10, f = this.xmax, s = this.ymax;
          break;
        case 10:
          t = 8;
          continue;
        case 8:
          t = 9, f = this.xmin, s = this.ymax;
          break;
        case 9:
          t = 1;
          continue;
        case 1:
          t = 5, f = this.xmin, s = this.ymin;
          break;
      }
      (i[o] !== f || i[o + 1] !== s) && this.contains(e, f, s) && (i.splice(o, 0, f, s), o += 2);
    }
    return o;
  }
  _project(e, t, r, i) {
    let o = 1 / 0, f, s, l;
    if (i < 0) {
      if (t <= this.ymin)
        return null;
      (f = (this.ymin - t) / i) < o && (l = this.ymin, s = e + (o = f) * r);
    } else if (i > 0) {
      if (t >= this.ymax)
        return null;
      (f = (this.ymax - t) / i) < o && (l = this.ymax, s = e + (o = f) * r);
    }
    if (r > 0) {
      if (e >= this.xmax)
        return null;
      (f = (this.xmax - e) / r) < o && (s = this.xmax, l = t + (o = f) * i);
    } else if (r < 0) {
      if (e <= this.xmin)
        return null;
      (f = (this.xmin - e) / r) < o && (s = this.xmin, l = t + (o = f) * i);
    }
    return [s, l];
  }
  _edgecode(e, t) {
    return (e === this.xmin ? 1 : e === this.xmax ? 2 : 0) | (t === this.ymin ? 4 : t === this.ymax ? 8 : 0);
  }
  _regioncode(e, t) {
    return (e < this.xmin ? 1 : e > this.xmax ? 2 : 0) | (t < this.ymin ? 4 : t > this.ymax ? 8 : 0);
  }
  _simplify(e) {
    if (e && e.length > 4) {
      for (let t = 0; t < e.length; t += 2) {
        const r = (t + 2) % e.length, i = (t + 4) % e.length;
        (e[t] === e[r] && e[r] === e[i] || e[t + 1] === e[r + 1] && e[r + 1] === e[i + 1]) && (e.splice(r, 2), t -= 2);
      }
      e.length || (e = null);
    }
    return e;
  }
}
const oN = 2 * Math.PI, Ma = Math.pow;
function uN(n) {
  return n[0];
}
function fN(n) {
  return n[1];
}
function sN(n) {
  const { triangles: e, coords: t } = n;
  for (let r = 0; r < e.length; r += 3) {
    const i = 2 * e[r], o = 2 * e[r + 1], f = 2 * e[r + 2];
    if ((t[f] - t[i]) * (t[o + 1] - t[i + 1]) - (t[o] - t[i]) * (t[f + 1] - t[i + 1]) > 1e-10)
      return !1;
  }
  return !0;
}
function lN(n, e, t) {
  return [n + Math.sin(n + e) * t, e + Math.cos(n - e) * t];
}
class Id {
  static from(e, t = uN, r = fN, i) {
    return new Id("length" in e ? cN(e, t, r, i) : Float64Array.from(hN(e, t, r, i)));
  }
  constructor(e) {
    this._delaunator = new Ms(e), this.inedges = new Int32Array(e.length / 2), this._hullIndex = new Int32Array(e.length / 2), this.points = this._delaunator.coords, this._init();
  }
  update() {
    return this._delaunator.update(), this._init(), this;
  }
  _init() {
    const e = this._delaunator, t = this.points;
    if (e.hull && e.hull.length > 2 && sN(e)) {
      this.collinear = Int32Array.from({ length: t.length / 2 }, (d, v) => v).sort((d, v) => t[2 * d] - t[2 * v] || t[2 * d + 1] - t[2 * v + 1]);
      const l = this.collinear[0], c = this.collinear[this.collinear.length - 1], p = [t[2 * l], t[2 * l + 1], t[2 * c], t[2 * c + 1]], g = 1e-8 * Math.hypot(p[3] - p[1], p[2] - p[0]);
      for (let d = 0, v = t.length / 2; d < v; ++d) {
        const b = lN(t[2 * d], t[2 * d + 1], g);
        t[2 * d] = b[0], t[2 * d + 1] = b[1];
      }
      this._delaunator = new Ms(t);
    } else
      delete this.collinear;
    const r = this.halfedges = this._delaunator.halfedges, i = this.hull = this._delaunator.hull, o = this.triangles = this._delaunator.triangles, f = this.inedges.fill(-1), s = this._hullIndex.fill(-1);
    for (let l = 0, c = r.length; l < c; ++l) {
      const p = o[l % 3 === 2 ? l - 2 : l + 1];
      (r[l] === -1 || f[p] === -1) && (f[p] = l);
    }
    for (let l = 0, c = i.length; l < c; ++l)
      s[i[l]] = l;
    i.length <= 2 && i.length > 0 && (this.triangles = new Int32Array(3).fill(-1), this.halfedges = new Int32Array(3).fill(-1), this.triangles[0] = i[0], f[i[0]] = 1, i.length === 2 && (f[i[1]] = 0, this.triangles[1] = i[1], this.triangles[2] = i[1]));
  }
  voronoi(e) {
    return new G_(this, e);
  }
  *neighbors(e) {
    const { inedges: t, hull: r, _hullIndex: i, halfedges: o, triangles: f, collinear: s } = this;
    if (s) {
      const g = s.indexOf(e);
      g > 0 && (yield s[g - 1]), g < s.length - 1 && (yield s[g + 1]);
      return;
    }
    const l = t[e];
    if (l === -1)
      return;
    let c = l, p = -1;
    do {
      if (yield p = f[c], c = c % 3 === 2 ? c - 2 : c + 1, f[c] !== e)
        return;
      if (c = o[c], c === -1) {
        const g = r[(i[e] + 1) % r.length];
        g !== p && (yield g);
        return;
      }
    } while (c !== l);
  }
  find(e, t, r = 0) {
    if (e = +e, e !== e || (t = +t, t !== t))
      return -1;
    const i = r;
    let o;
    for (; (o = this._step(r, e, t)) >= 0 && o !== r && o !== i; )
      r = o;
    return o;
  }
  _step(e, t, r) {
    const { inedges: i, hull: o, _hullIndex: f, halfedges: s, triangles: l, points: c } = this;
    if (i[e] === -1 || !c.length)
      return (e + 1) % (c.length >> 1);
    let p = e, g = Ma(t - c[e * 2], 2) + Ma(r - c[e * 2 + 1], 2);
    const d = i[e];
    let v = d;
    do {
      let b = l[v];
      const w = Ma(t - c[b * 2], 2) + Ma(r - c[b * 2 + 1], 2);
      if (w < g && (g = w, p = b), v = v % 3 === 2 ? v - 2 : v + 1, l[v] !== e)
        break;
      if (v = s[v], v === -1) {
        if (v = o[(f[e] + 1) % o.length], v !== b && Ma(t - c[v * 2], 2) + Ma(r - c[v * 2 + 1], 2) < g)
          return v;
        break;
      }
    } while (v !== d);
    return p;
  }
  render(e) {
    const t = e == null ? e = new $i() : void 0, { points: r, halfedges: i, triangles: o } = this;
    for (let f = 0, s = i.length; f < s; ++f) {
      const l = i[f];
      if (l < f)
        continue;
      const c = o[f] * 2, p = o[l] * 2;
      e.moveTo(r[c], r[c + 1]), e.lineTo(r[p], r[p + 1]);
    }
    return this.renderHull(e), t && t.value();
  }
  renderPoints(e, t) {
    t === void 0 && (!e || typeof e.moveTo != "function") && (t = e, e = null), t = t == null ? 2 : +t;
    const r = e == null ? e = new $i() : void 0, { points: i } = this;
    for (let o = 0, f = i.length; o < f; o += 2) {
      const s = i[o], l = i[o + 1];
      e.moveTo(s + t, l), e.arc(s, l, t, 0, oN);
    }
    return r && r.value();
  }
  renderHull(e) {
    const t = e == null ? e = new $i() : void 0, { hull: r, points: i } = this, o = r[0] * 2, f = r.length;
    e.moveTo(i[o], i[o + 1]);
    for (let s = 1; s < f; ++s) {
      const l = 2 * r[s];
      e.lineTo(i[l], i[l + 1]);
    }
    return e.closePath(), t && t.value();
  }
  hullPolygon() {
    const e = new A0();
    return this.renderHull(e), e.value();
  }
  renderTriangle(e, t) {
    const r = t == null ? t = new $i() : void 0, { points: i, triangles: o } = this, f = o[e *= 3] * 2, s = o[e + 1] * 2, l = o[e + 2] * 2;
    return t.moveTo(i[f], i[f + 1]), t.lineTo(i[s], i[s + 1]), t.lineTo(i[l], i[l + 1]), t.closePath(), r && r.value();
  }
  *trianglePolygons() {
    const { triangles: e } = this;
    for (let t = 0, r = e.length / 3; t < r; ++t)
      yield this.trianglePolygon(t);
  }
  trianglePolygon(e) {
    const t = new A0();
    return this.renderTriangle(e, t), t.value();
  }
}
function cN(n, e, t, r) {
  const i = n.length, o = new Float64Array(i * 2);
  for (let f = 0; f < i; ++f) {
    const s = n[f];
    o[f * 2] = e.call(r, s, f, n), o[f * 2 + 1] = t.call(r, s, f, n);
  }
  return o;
}
function* hN(n, e, t, r) {
  let i = 0;
  for (const o of n)
    yield e.call(r, o, i, n), yield t.call(r, o, i, n), ++i;
}
var dm = {}, Nh = {}, $h = 34, Ro = 10, kh = 13;
function q_(n) {
  return new Function("d", "return {" + n.map(function(e, t) {
    return JSON.stringify(e) + ": d[" + t + '] || ""';
  }).join(",") + "}");
}
function dN(n, e) {
  var t = q_(n);
  return function(r, i) {
    return e(t(r), i, n);
  };
}
function pm(n) {
  var e = /* @__PURE__ */ Object.create(null), t = [];
  return n.forEach(function(r) {
    for (var i in r)
      i in e || t.push(e[i] = i);
  }), t;
}
function lt(n, e) {
  var t = n + "", r = t.length;
  return r < e ? new Array(e - r + 1).join(0) + t : t;
}
function pN(n) {
  return n < 0 ? "-" + lt(-n, 6) : n > 9999 ? "+" + lt(n, 6) : lt(n, 4);
}
function gN(n) {
  var e = n.getUTCHours(), t = n.getUTCMinutes(), r = n.getUTCSeconds(), i = n.getUTCMilliseconds();
  return isNaN(n) ? "Invalid Date" : pN(n.getUTCFullYear()) + "-" + lt(n.getUTCMonth() + 1, 2) + "-" + lt(n.getUTCDate(), 2) + (i ? "T" + lt(e, 2) + ":" + lt(t, 2) + ":" + lt(r, 2) + "." + lt(i, 3) + "Z" : r ? "T" + lt(e, 2) + ":" + lt(t, 2) + ":" + lt(r, 2) + "Z" : t || e ? "T" + lt(e, 2) + ":" + lt(t, 2) + "Z" : "");
}
function Al(n) {
  var e = new RegExp('["' + n + `
\r]`), t = n.charCodeAt(0);
  function r(g, d) {
    var v, b, w = i(g, function(m, _) {
      if (v)
        return v(m, _ - 1);
      b = m, v = d ? dN(m, d) : q_(m);
    });
    return w.columns = b || [], w;
  }
  function i(g, d) {
    var v = [], b = g.length, w = 0, m = 0, _, x = b <= 0, A = !1;
    g.charCodeAt(b - 1) === Ro && --b, g.charCodeAt(b - 1) === kh && --b;
    function T() {
      if (x)
        return Nh;
      if (A)
        return A = !1, dm;
      var R, I = w, B;
      if (g.charCodeAt(I) === $h) {
        for (; w++ < b && g.charCodeAt(w) !== $h || g.charCodeAt(++w) === $h; )
          ;
        return (R = w) >= b ? x = !0 : (B = g.charCodeAt(w++)) === Ro ? A = !0 : B === kh && (A = !0, g.charCodeAt(w) === Ro && ++w), g.slice(I + 1, R - 1).replace(/""/g, '"');
      }
      for (; w < b; ) {
        if ((B = g.charCodeAt(R = w++)) === Ro)
          A = !0;
        else if (B === kh)
          A = !0, g.charCodeAt(w) === Ro && ++w;
        else if (B !== t)
          continue;
        return g.slice(I, R);
      }
      return x = !0, g.slice(I, b);
    }
    for (; (_ = T()) !== Nh; ) {
      for (var S = []; _ !== dm && _ !== Nh; )
        S.push(_), _ = T();
      d && (S = d(S, m++)) == null || v.push(S);
    }
    return v;
  }
  function o(g, d) {
    return g.map(function(v) {
      return d.map(function(b) {
        return p(v[b]);
      }).join(n);
    });
  }
  function f(g, d) {
    return d == null && (d = pm(g)), [d.map(p).join(n)].concat(o(g, d)).join(`
`);
  }
  function s(g, d) {
    return d == null && (d = pm(g)), o(g, d).join(`
`);
  }
  function l(g) {
    return g.map(c).join(`
`);
  }
  function c(g) {
    return g.map(p).join(n);
  }
  function p(g) {
    return g == null ? "" : g instanceof Date ? gN(g) : e.test(g += "") ? '"' + g.replace(/"/g, '""') + '"' : g;
  }
  return {
    parse: r,
    parseRows: i,
    format: f,
    formatBody: s,
    formatRows: l,
    formatRow: c,
    formatValue: p
  };
}
var Zi = Al(","), W_ = Zi.parse, vN = Zi.parseRows, mN = Zi.format, yN = Zi.formatBody, _N = Zi.formatRows, bN = Zi.formatRow, wN = Zi.formatValue, Ji = Al("	"), H_ = Ji.parse, xN = Ji.parseRows, TN = Ji.format, AN = Ji.formatBody, MN = Ji.formatRows, SN = Ji.formatRow, EN = Ji.formatValue;
function CN(n) {
  for (var e in n) {
    var t = n[e].trim(), r, i;
    if (!t)
      t = null;
    else if (t === "true")
      t = !0;
    else if (t === "false")
      t = !1;
    else if (t === "NaN")
      t = NaN;
    else if (!isNaN(r = +t))
      t = r;
    else if (i = t.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/))
      PN && i[4] && !i[7] && (t = t.replace(/-/g, "/").replace(/T/, " ")), t = new Date(t);
    else
      continue;
    n[e] = t;
  }
  return n;
}
const PN = (/* @__PURE__ */ new Date("2019-01-01T00:00")).getHours() || (/* @__PURE__ */ new Date("2019-07-01T00:00")).getHours();
function RN(n) {
  if (!n.ok)
    throw new Error(n.status + " " + n.statusText);
  return n.blob();
}
function NN(n, e) {
  return fetch(n, e).then(RN);
}
function $N(n) {
  if (!n.ok)
    throw new Error(n.status + " " + n.statusText);
  return n.arrayBuffer();
}
function kN(n, e) {
  return fetch(n, e).then($N);
}
function ON(n) {
  if (!n.ok)
    throw new Error(n.status + " " + n.statusText);
  return n.text();
}
function Ml(n, e) {
  return fetch(n, e).then(ON);
}
function Y_(n) {
  return function(e, t, r) {
    return arguments.length === 2 && typeof t == "function" && (r = t, t = void 0), Ml(e, t).then(function(i) {
      return n(i, r);
    });
  };
}
function IN(n, e, t, r) {
  arguments.length === 3 && typeof t == "function" && (r = t, t = void 0);
  var i = Al(n);
  return Ml(e, t).then(function(o) {
    return i.parse(o, r);
  });
}
var LN = Y_(W_), DN = Y_(H_);
function FN(n, e) {
  return new Promise(function(t, r) {
    var i = new Image();
    for (var o in e)
      i[o] = e[o];
    i.onerror = r, i.onload = function() {
      t(i);
    }, i.src = n;
  });
}
function BN(n) {
  if (!n.ok)
    throw new Error(n.status + " " + n.statusText);
  if (!(n.status === 204 || n.status === 205))
    return n.json();
}
function zN(n, e) {
  return fetch(n, e).then(BN);
}
function Ld(n) {
  return (e, t) => Ml(e, t).then((r) => new DOMParser().parseFromString(r, n));
}
const VN = Ld("application/xml");
var UN = Ld("text/html"), GN = Ld("image/svg+xml");
function qN(n, e) {
  var t, r = 1;
  n == null && (n = 0), e == null && (e = 0);
  function i() {
    var o, f = t.length, s, l = 0, c = 0;
    for (o = 0; o < f; ++o)
      s = t[o], l += s.x, c += s.y;
    for (l = (l / f - n) * r, c = (c / f - e) * r, o = 0; o < f; ++o)
      s = t[o], s.x -= l, s.y -= c;
  }
  return i.initialize = function(o) {
    t = o;
  }, i.x = function(o) {
    return arguments.length ? (n = +o, i) : n;
  }, i.y = function(o) {
    return arguments.length ? (e = +o, i) : e;
  }, i.strength = function(o) {
    return arguments.length ? (r = +o, i) : r;
  }, i;
}
function WN(n) {
  const e = +this._x.call(null, n), t = +this._y.call(null, n);
  return X_(this.cover(e, t), e, t, n);
}
function X_(n, e, t, r) {
  if (isNaN(e) || isNaN(t))
    return n;
  var i, o = n._root, f = { data: r }, s = n._x0, l = n._y0, c = n._x1, p = n._y1, g, d, v, b, w, m, _, x;
  if (!o)
    return n._root = f, n;
  for (; o.length; )
    if ((w = e >= (g = (s + c) / 2)) ? s = g : c = g, (m = t >= (d = (l + p) / 2)) ? l = d : p = d, i = o, !(o = o[_ = m << 1 | w]))
      return i[_] = f, n;
  if (v = +n._x.call(null, o.data), b = +n._y.call(null, o.data), e === v && t === b)
    return f.next = o, i ? i[_] = f : n._root = f, n;
  do
    i = i ? i[_] = new Array(4) : n._root = new Array(4), (w = e >= (g = (s + c) / 2)) ? s = g : c = g, (m = t >= (d = (l + p) / 2)) ? l = d : p = d;
  while ((_ = m << 1 | w) === (x = (b >= d) << 1 | v >= g));
  return i[x] = o, i[_] = f, n;
}
function HN(n) {
  var e, t, r = n.length, i, o, f = new Array(r), s = new Array(r), l = 1 / 0, c = 1 / 0, p = -1 / 0, g = -1 / 0;
  for (t = 0; t < r; ++t)
    isNaN(i = +this._x.call(null, e = n[t])) || isNaN(o = +this._y.call(null, e)) || (f[t] = i, s[t] = o, i < l && (l = i), i > p && (p = i), o < c && (c = o), o > g && (g = o));
  if (l > p || c > g)
    return this;
  for (this.cover(l, c).cover(p, g), t = 0; t < r; ++t)
    X_(this, f[t], s[t], n[t]);
  return this;
}
function YN(n, e) {
  if (isNaN(n = +n) || isNaN(e = +e))
    return this;
  var t = this._x0, r = this._y0, i = this._x1, o = this._y1;
  if (isNaN(t))
    i = (t = Math.floor(n)) + 1, o = (r = Math.floor(e)) + 1;
  else {
    for (var f = i - t || 1, s = this._root, l, c; t > n || n >= i || r > e || e >= o; )
      switch (c = (e < r) << 1 | n < t, l = new Array(4), l[c] = s, s = l, f *= 2, c) {
        case 0:
          i = t + f, o = r + f;
          break;
        case 1:
          t = i - f, o = r + f;
          break;
        case 2:
          i = t + f, r = o - f;
          break;
        case 3:
          t = i - f, r = o - f;
          break;
      }
    this._root && this._root.length && (this._root = s);
  }
  return this._x0 = t, this._y0 = r, this._x1 = i, this._y1 = o, this;
}
function XN() {
  var n = [];
  return this.visit(function(e) {
    if (!e.length)
      do
        n.push(e.data);
      while (e = e.next);
  }), n;
}
function KN(n) {
  return arguments.length ? this.cover(+n[0][0], +n[0][1]).cover(+n[1][0], +n[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function je(n, e, t, r, i) {
  this.node = n, this.x0 = e, this.y0 = t, this.x1 = r, this.y1 = i;
}
function ZN(n, e, t) {
  var r, i = this._x0, o = this._y0, f, s, l, c, p = this._x1, g = this._y1, d = [], v = this._root, b, w;
  for (v && d.push(new je(v, i, o, p, g)), t == null ? t = 1 / 0 : (i = n - t, o = e - t, p = n + t, g = e + t, t *= t); b = d.pop(); )
    if (!(!(v = b.node) || (f = b.x0) > p || (s = b.y0) > g || (l = b.x1) < i || (c = b.y1) < o))
      if (v.length) {
        var m = (f + l) / 2, _ = (s + c) / 2;
        d.push(
          new je(v[3], m, _, l, c),
          new je(v[2], f, _, m, c),
          new je(v[1], m, s, l, _),
          new je(v[0], f, s, m, _)
        ), (w = (e >= _) << 1 | n >= m) && (b = d[d.length - 1], d[d.length - 1] = d[d.length - 1 - w], d[d.length - 1 - w] = b);
      } else {
        var x = n - +this._x.call(null, v.data), A = e - +this._y.call(null, v.data), T = x * x + A * A;
        if (T < t) {
          var S = Math.sqrt(t = T);
          i = n - S, o = e - S, p = n + S, g = e + S, r = v.data;
        }
      }
  return r;
}
function JN(n) {
  if (isNaN(p = +this._x.call(null, n)) || isNaN(g = +this._y.call(null, n)))
    return this;
  var e, t = this._root, r, i, o, f = this._x0, s = this._y0, l = this._x1, c = this._y1, p, g, d, v, b, w, m, _;
  if (!t)
    return this;
  if (t.length)
    for (; ; ) {
      if ((b = p >= (d = (f + l) / 2)) ? f = d : l = d, (w = g >= (v = (s + c) / 2)) ? s = v : c = v, e = t, !(t = t[m = w << 1 | b]))
        return this;
      if (!t.length)
        break;
      (e[m + 1 & 3] || e[m + 2 & 3] || e[m + 3 & 3]) && (r = e, _ = m);
    }
  for (; t.data !== n; )
    if (i = t, !(t = t.next))
      return this;
  return (o = t.next) && delete t.next, i ? (o ? i.next = o : delete i.next, this) : e ? (o ? e[m] = o : delete e[m], (t = e[0] || e[1] || e[2] || e[3]) && t === (e[3] || e[2] || e[1] || e[0]) && !t.length && (r ? r[_] = t : this._root = t), this) : (this._root = o, this);
}
function QN(n) {
  for (var e = 0, t = n.length; e < t; ++e)
    this.remove(n[e]);
  return this;
}
function jN() {
  return this._root;
}
function n$() {
  var n = 0;
  return this.visit(function(e) {
    if (!e.length)
      do
        ++n;
      while (e = e.next);
  }), n;
}
function e$(n) {
  var e = [], t, r = this._root, i, o, f, s, l;
  for (r && e.push(new je(r, this._x0, this._y0, this._x1, this._y1)); t = e.pop(); )
    if (!n(r = t.node, o = t.x0, f = t.y0, s = t.x1, l = t.y1) && r.length) {
      var c = (o + s) / 2, p = (f + l) / 2;
      (i = r[3]) && e.push(new je(i, c, p, s, l)), (i = r[2]) && e.push(new je(i, o, p, c, l)), (i = r[1]) && e.push(new je(i, c, f, s, p)), (i = r[0]) && e.push(new je(i, o, f, c, p));
    }
  return this;
}
function t$(n) {
  var e = [], t = [], r;
  for (this._root && e.push(new je(this._root, this._x0, this._y0, this._x1, this._y1)); r = e.pop(); ) {
    var i = r.node;
    if (i.length) {
      var o, f = r.x0, s = r.y0, l = r.x1, c = r.y1, p = (f + l) / 2, g = (s + c) / 2;
      (o = i[0]) && e.push(new je(o, f, s, p, g)), (o = i[1]) && e.push(new je(o, p, s, l, g)), (o = i[2]) && e.push(new je(o, f, g, p, c)), (o = i[3]) && e.push(new je(o, p, g, l, c));
    }
    t.push(r);
  }
  for (; r = t.pop(); )
    n(r.node, r.x0, r.y0, r.x1, r.y1);
  return this;
}
function r$(n) {
  return n[0];
}
function i$(n) {
  return arguments.length ? (this._x = n, this) : this._x;
}
function a$(n) {
  return n[1];
}
function o$(n) {
  return arguments.length ? (this._y = n, this) : this._y;
}
function Sl(n, e, t) {
  var r = new Dd(e ?? r$, t ?? a$, NaN, NaN, NaN, NaN);
  return n == null ? r : r.addAll(n);
}
function Dd(n, e, t, r, i, o) {
  this._x = n, this._y = e, this._x0 = t, this._y0 = r, this._x1 = i, this._y1 = o, this._root = void 0;
}
function gm(n) {
  for (var e = { data: n.data }, t = e; n = n.next; )
    t = t.next = { data: n.data };
  return e;
}
var at = Sl.prototype = Dd.prototype;
at.copy = function() {
  var n = new Dd(this._x, this._y, this._x0, this._y0, this._x1, this._y1), e = this._root, t, r;
  if (!e)
    return n;
  if (!e.length)
    return n._root = gm(e), n;
  for (t = [{ source: e, target: n._root = new Array(4) }]; e = t.pop(); )
    for (var i = 0; i < 4; ++i)
      (r = e.source[i]) && (r.length ? t.push({ source: r, target: e.target[i] = new Array(4) }) : e.target[i] = gm(r));
  return n;
};
at.add = WN;
at.addAll = HN;
at.cover = YN;
at.data = XN;
at.extent = KN;
at.find = ZN;
at.remove = JN;
at.removeAll = QN;
at.root = jN;
at.size = n$;
at.visit = e$;
at.visitAfter = t$;
at.x = i$;
at.y = o$;
function Te(n) {
  return function() {
    return n;
  };
}
function ri(n) {
  return (n() - 0.5) * 1e-6;
}
function u$(n) {
  return n.x + n.vx;
}
function f$(n) {
  return n.y + n.vy;
}
function s$(n) {
  var e, t, r, i = 1, o = 1;
  typeof n != "function" && (n = Te(n == null ? 1 : +n));
  function f() {
    for (var c, p = e.length, g, d, v, b, w, m, _ = 0; _ < o; ++_)
      for (g = Sl(e, u$, f$).visitAfter(s), c = 0; c < p; ++c)
        d = e[c], w = t[d.index], m = w * w, v = d.x + d.vx, b = d.y + d.vy, g.visit(x);
    function x(A, T, S, R, I) {
      var B = A.data, F = A.r, V = w + F;
      if (B) {
        if (B.index > d.index) {
          var E = v - B.x - B.vx, L = b - B.y - B.vy, $ = E * E + L * L;
          $ < V * V && (E === 0 && (E = ri(r), $ += E * E), L === 0 && (L = ri(r), $ += L * L), $ = (V - ($ = Math.sqrt($))) / $ * i, d.vx += (E *= $) * (V = (F *= F) / (m + F)), d.vy += (L *= $) * V, B.vx -= E * (V = 1 - V), B.vy -= L * V);
        }
        return;
      }
      return T > v + V || R < v - V || S > b + V || I < b - V;
    }
  }
  function s(c) {
    if (c.data)
      return c.r = t[c.data.index];
    for (var p = c.r = 0; p < 4; ++p)
      c[p] && c[p].r > c.r && (c.r = c[p].r);
  }
  function l() {
    if (e) {
      var c, p = e.length, g;
      for (t = new Array(p), c = 0; c < p; ++c)
        g = e[c], t[g.index] = +n(g, c, e);
    }
  }
  return f.initialize = function(c, p) {
    e = c, r = p, l();
  }, f.iterations = function(c) {
    return arguments.length ? (o = +c, f) : o;
  }, f.strength = function(c) {
    return arguments.length ? (i = +c, f) : i;
  }, f.radius = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : Te(+c), l(), f) : n;
  }, f;
}
function l$(n) {
  return n.index;
}
function vm(n, e) {
  var t = n.get(e);
  if (!t)
    throw new Error("node not found: " + e);
  return t;
}
function c$(n) {
  var e = l$, t = g, r, i = Te(30), o, f, s, l, c, p = 1;
  n == null && (n = []);
  function g(m) {
    return 1 / Math.min(s[m.source.index], s[m.target.index]);
  }
  function d(m) {
    for (var _ = 0, x = n.length; _ < p; ++_)
      for (var A = 0, T, S, R, I, B, F, V; A < x; ++A)
        T = n[A], S = T.source, R = T.target, I = R.x + R.vx - S.x - S.vx || ri(c), B = R.y + R.vy - S.y - S.vy || ri(c), F = Math.sqrt(I * I + B * B), F = (F - o[A]) / F * m * r[A], I *= F, B *= F, R.vx -= I * (V = l[A]), R.vy -= B * V, S.vx += I * (V = 1 - V), S.vy += B * V;
  }
  function v() {
    if (f) {
      var m, _ = f.length, x = n.length, A = new Map(f.map((S, R) => [e(S, R, f), S])), T;
      for (m = 0, s = new Array(_); m < x; ++m)
        T = n[m], T.index = m, typeof T.source != "object" && (T.source = vm(A, T.source)), typeof T.target != "object" && (T.target = vm(A, T.target)), s[T.source.index] = (s[T.source.index] || 0) + 1, s[T.target.index] = (s[T.target.index] || 0) + 1;
      for (m = 0, l = new Array(x); m < x; ++m)
        T = n[m], l[m] = s[T.source.index] / (s[T.source.index] + s[T.target.index]);
      r = new Array(x), b(), o = new Array(x), w();
    }
  }
  function b() {
    if (f)
      for (var m = 0, _ = n.length; m < _; ++m)
        r[m] = +t(n[m], m, n);
  }
  function w() {
    if (f)
      for (var m = 0, _ = n.length; m < _; ++m)
        o[m] = +i(n[m], m, n);
  }
  return d.initialize = function(m, _) {
    f = m, c = _, v();
  }, d.links = function(m) {
    return arguments.length ? (n = m, v(), d) : n;
  }, d.id = function(m) {
    return arguments.length ? (e = m, d) : e;
  }, d.iterations = function(m) {
    return arguments.length ? (p = +m, d) : p;
  }, d.strength = function(m) {
    return arguments.length ? (t = typeof m == "function" ? m : Te(+m), b(), d) : t;
  }, d.distance = function(m) {
    return arguments.length ? (i = typeof m == "function" ? m : Te(+m), w(), d) : i;
  }, d;
}
const h$ = 1664525, d$ = 1013904223, mm = 4294967296;
function p$() {
  let n = 1;
  return () => (n = (h$ * n + d$) % mm) / mm;
}
function g$(n) {
  return n.x;
}
function v$(n) {
  return n.y;
}
var m$ = 10, y$ = Math.PI * (3 - Math.sqrt(5));
function _$(n) {
  var e, t = 1, r = 1e-3, i = 1 - Math.pow(r, 1 / 300), o = 0, f = 0.6, s = /* @__PURE__ */ new Map(), l = xl(g), c = Xi("tick", "end"), p = p$();
  n == null && (n = []);
  function g() {
    d(), c.call("tick", e), t < r && (l.stop(), c.call("end", e));
  }
  function d(w) {
    var m, _ = n.length, x;
    w === void 0 && (w = 1);
    for (var A = 0; A < w; ++A)
      for (t += (o - t) * i, s.forEach(function(T) {
        T(t);
      }), m = 0; m < _; ++m)
        x = n[m], x.fx == null ? x.x += x.vx *= f : (x.x = x.fx, x.vx = 0), x.fy == null ? x.y += x.vy *= f : (x.y = x.fy, x.vy = 0);
    return e;
  }
  function v() {
    for (var w = 0, m = n.length, _; w < m; ++w) {
      if (_ = n[w], _.index = w, _.fx != null && (_.x = _.fx), _.fy != null && (_.y = _.fy), isNaN(_.x) || isNaN(_.y)) {
        var x = m$ * Math.sqrt(0.5 + w), A = w * y$;
        _.x = x * Math.cos(A), _.y = x * Math.sin(A);
      }
      (isNaN(_.vx) || isNaN(_.vy)) && (_.vx = _.vy = 0);
    }
  }
  function b(w) {
    return w.initialize && w.initialize(n, p), w;
  }
  return v(), e = {
    tick: d,
    restart: function() {
      return l.restart(g), e;
    },
    stop: function() {
      return l.stop(), e;
    },
    nodes: function(w) {
      return arguments.length ? (n = w, v(), s.forEach(b), e) : n;
    },
    alpha: function(w) {
      return arguments.length ? (t = +w, e) : t;
    },
    alphaMin: function(w) {
      return arguments.length ? (r = +w, e) : r;
    },
    alphaDecay: function(w) {
      return arguments.length ? (i = +w, e) : +i;
    },
    alphaTarget: function(w) {
      return arguments.length ? (o = +w, e) : o;
    },
    velocityDecay: function(w) {
      return arguments.length ? (f = 1 - w, e) : 1 - f;
    },
    randomSource: function(w) {
      return arguments.length ? (p = w, s.forEach(b), e) : p;
    },
    force: function(w, m) {
      return arguments.length > 1 ? (m == null ? s.delete(w) : s.set(w, b(m)), e) : s.get(w);
    },
    find: function(w, m, _) {
      var x = 0, A = n.length, T, S, R, I, B;
      for (_ == null ? _ = 1 / 0 : _ *= _, x = 0; x < A; ++x)
        I = n[x], T = w - I.x, S = m - I.y, R = T * T + S * S, R < _ && (B = I, _ = R);
      return B;
    },
    on: function(w, m) {
      return arguments.length > 1 ? (c.on(w, m), e) : c.on(w);
    }
  };
}
function b$() {
  var n, e, t, r, i = Te(-30), o, f = 1, s = 1 / 0, l = 0.81;
  function c(v) {
    var b, w = n.length, m = Sl(n, g$, v$).visitAfter(g);
    for (r = v, b = 0; b < w; ++b)
      e = n[b], m.visit(d);
  }
  function p() {
    if (n) {
      var v, b = n.length, w;
      for (o = new Array(b), v = 0; v < b; ++v)
        w = n[v], o[w.index] = +i(w, v, n);
    }
  }
  function g(v) {
    var b = 0, w, m, _ = 0, x, A, T;
    if (v.length) {
      for (x = A = T = 0; T < 4; ++T)
        (w = v[T]) && (m = Math.abs(w.value)) && (b += w.value, _ += m, x += m * w.x, A += m * w.y);
      v.x = x / _, v.y = A / _;
    } else {
      w = v, w.x = w.data.x, w.y = w.data.y;
      do
        b += o[w.data.index];
      while (w = w.next);
    }
    v.value = b;
  }
  function d(v, b, w, m) {
    if (!v.value)
      return !0;
    var _ = v.x - e.x, x = v.y - e.y, A = m - b, T = _ * _ + x * x;
    if (A * A / l < T)
      return T < s && (_ === 0 && (_ = ri(t), T += _ * _), x === 0 && (x = ri(t), T += x * x), T < f && (T = Math.sqrt(f * T)), e.vx += _ * v.value * r / T, e.vy += x * v.value * r / T), !0;
    if (v.length || T >= s)
      return;
    (v.data !== e || v.next) && (_ === 0 && (_ = ri(t), T += _ * _), x === 0 && (x = ri(t), T += x * x), T < f && (T = Math.sqrt(f * T)));
    do
      v.data !== e && (A = o[v.data.index] * r / T, e.vx += _ * A, e.vy += x * A);
    while (v = v.next);
  }
  return c.initialize = function(v, b) {
    n = v, t = b, p();
  }, c.strength = function(v) {
    return arguments.length ? (i = typeof v == "function" ? v : Te(+v), p(), c) : i;
  }, c.distanceMin = function(v) {
    return arguments.length ? (f = v * v, c) : Math.sqrt(f);
  }, c.distanceMax = function(v) {
    return arguments.length ? (s = v * v, c) : Math.sqrt(s);
  }, c.theta = function(v) {
    return arguments.length ? (l = v * v, c) : Math.sqrt(l);
  }, c;
}
function w$(n, e, t) {
  var r, i = Te(0.1), o, f;
  typeof n != "function" && (n = Te(+n)), e == null && (e = 0), t == null && (t = 0);
  function s(c) {
    for (var p = 0, g = r.length; p < g; ++p) {
      var d = r[p], v = d.x - e || 1e-6, b = d.y - t || 1e-6, w = Math.sqrt(v * v + b * b), m = (f[p] - w) * o[p] * c / w;
      d.vx += v * m, d.vy += b * m;
    }
  }
  function l() {
    if (r) {
      var c, p = r.length;
      for (o = new Array(p), f = new Array(p), c = 0; c < p; ++c)
        f[c] = +n(r[c], c, r), o[c] = isNaN(f[c]) ? 0 : +i(r[c], c, r);
    }
  }
  return s.initialize = function(c) {
    r = c, l();
  }, s.strength = function(c) {
    return arguments.length ? (i = typeof c == "function" ? c : Te(+c), l(), s) : i;
  }, s.radius = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : Te(+c), l(), s) : n;
  }, s.x = function(c) {
    return arguments.length ? (e = +c, s) : e;
  }, s.y = function(c) {
    return arguments.length ? (t = +c, s) : t;
  }, s;
}
function x$(n) {
  var e = Te(0.1), t, r, i;
  typeof n != "function" && (n = Te(n == null ? 0 : +n));
  function o(s) {
    for (var l = 0, c = t.length, p; l < c; ++l)
      p = t[l], p.vx += (i[l] - p.x) * r[l] * s;
  }
  function f() {
    if (t) {
      var s, l = t.length;
      for (r = new Array(l), i = new Array(l), s = 0; s < l; ++s)
        r[s] = isNaN(i[s] = +n(t[s], s, t)) ? 0 : +e(t[s], s, t);
    }
  }
  return o.initialize = function(s) {
    t = s, f();
  }, o.strength = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Te(+s), f(), o) : e;
  }, o.x = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : Te(+s), f(), o) : n;
  }, o;
}
function T$(n) {
  var e = Te(0.1), t, r, i;
  typeof n != "function" && (n = Te(n == null ? 0 : +n));
  function o(s) {
    for (var l = 0, c = t.length, p; l < c; ++l)
      p = t[l], p.vy += (i[l] - p.y) * r[l] * s;
  }
  function f() {
    if (t) {
      var s, l = t.length;
      for (r = new Array(l), i = new Array(l), s = 0; s < l; ++s)
        r[s] = isNaN(i[s] = +n(t[s], s, t)) ? 0 : +e(t[s], s, t);
    }
  }
  return o.initialize = function(s) {
    t = s, f();
  }, o.strength = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Te(+s), f(), o) : e;
  }, o.y = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : Te(+s), f(), o) : n;
  }, o;
}
function A$(n) {
  return Math.abs(n = Math.round(n)) >= 1e21 ? n.toLocaleString("en").replace(/,/g, "") : n.toString(10);
}
function Ss(n, e) {
  if ((t = (n = e ? n.toExponential(e - 1) : n.toExponential()).indexOf("e")) < 0)
    return null;
  var t, r = n.slice(0, t);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +n.slice(t + 1)
  ];
}
function Wa(n) {
  return n = Ss(Math.abs(n)), n ? n[1] : NaN;
}
function M$(n, e) {
  return function(t, r) {
    for (var i = t.length, o = [], f = 0, s = n[0], l = 0; i > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), o.push(t.substring(i -= s, i + s)), !((l += s + 1) > r)); )
      s = n[f = (f + 1) % n.length];
    return o.reverse().join(e);
  };
}
function S$(n) {
  return function(e) {
    return e.replace(/[0-9]/g, function(t) {
      return n[+t];
    });
  };
}
var E$ = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Ha(n) {
  if (!(e = E$.exec(n)))
    throw new Error("invalid format: " + n);
  var e;
  return new El({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
Ha.prototype = El.prototype;
function El(n) {
  this.fill = n.fill === void 0 ? " " : n.fill + "", this.align = n.align === void 0 ? ">" : n.align + "", this.sign = n.sign === void 0 ? "-" : n.sign + "", this.symbol = n.symbol === void 0 ? "" : n.symbol + "", this.zero = !!n.zero, this.width = n.width === void 0 ? void 0 : +n.width, this.comma = !!n.comma, this.precision = n.precision === void 0 ? void 0 : +n.precision, this.trim = !!n.trim, this.type = n.type === void 0 ? "" : n.type + "";
}
El.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function C$(n) {
  n:
    for (var e = n.length, t = 1, r = -1, i; t < e; ++t)
      switch (n[t]) {
        case ".":
          r = i = t;
          break;
        case "0":
          r === 0 && (r = t), i = t;
          break;
        default:
          if (!+n[t])
            break n;
          r > 0 && (r = 0);
          break;
      }
  return r > 0 ? n.slice(0, r) + n.slice(i + 1) : n;
}
var K_;
function P$(n, e) {
  var t = Ss(n, e);
  if (!t)
    return n + "";
  var r = t[0], i = t[1], o = i - (K_ = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, f = r.length;
  return o === f ? r : o > f ? r + new Array(o - f + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + Ss(n, Math.max(0, e + o - 1))[0];
}
function ym(n, e) {
  var t = Ss(n, e);
  if (!t)
    return n + "";
  var r = t[0], i = t[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const _m = {
  "%": (n, e) => (n * 100).toFixed(e),
  b: (n) => Math.round(n).toString(2),
  c: (n) => n + "",
  d: A$,
  e: (n, e) => n.toExponential(e),
  f: (n, e) => n.toFixed(e),
  g: (n, e) => n.toPrecision(e),
  o: (n) => Math.round(n).toString(8),
  p: (n, e) => ym(n * 100, e),
  r: ym,
  s: P$,
  X: (n) => Math.round(n).toString(16).toUpperCase(),
  x: (n) => Math.round(n).toString(16)
};
function bm(n) {
  return n;
}
var wm = Array.prototype.map, xm = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Z_(n) {
  var e = n.grouping === void 0 || n.thousands === void 0 ? bm : M$(wm.call(n.grouping, Number), n.thousands + ""), t = n.currency === void 0 ? "" : n.currency[0] + "", r = n.currency === void 0 ? "" : n.currency[1] + "", i = n.decimal === void 0 ? "." : n.decimal + "", o = n.numerals === void 0 ? bm : S$(wm.call(n.numerals, String)), f = n.percent === void 0 ? "%" : n.percent + "", s = n.minus === void 0 ? "−" : n.minus + "", l = n.nan === void 0 ? "NaN" : n.nan + "";
  function c(g) {
    g = Ha(g);
    var d = g.fill, v = g.align, b = g.sign, w = g.symbol, m = g.zero, _ = g.width, x = g.comma, A = g.precision, T = g.trim, S = g.type;
    S === "n" ? (x = !0, S = "g") : _m[S] || (A === void 0 && (A = 12), T = !0, S = "g"), (m || d === "0" && v === "=") && (m = !0, d = "0", v = "=");
    var R = w === "$" ? t : w === "#" && /[boxX]/.test(S) ? "0" + S.toLowerCase() : "", I = w === "$" ? r : /[%p]/.test(S) ? f : "", B = _m[S], F = /[defgprs%]/.test(S);
    A = A === void 0 ? 6 : /[gprs]/.test(S) ? Math.max(1, Math.min(21, A)) : Math.max(0, Math.min(20, A));
    function V(E) {
      var L = R, $ = I, P, k, O;
      if (S === "c")
        $ = B(E) + $, E = "";
      else {
        E = +E;
        var W = E < 0 || 1 / E < 0;
        if (E = isNaN(E) ? l : B(Math.abs(E), A), T && (E = C$(E)), W && +E == 0 && b !== "+" && (W = !1), L = (W ? b === "(" ? b : s : b === "-" || b === "(" ? "" : b) + L, $ = (S === "s" ? xm[8 + K_ / 3] : "") + $ + (W && b === "(" ? ")" : ""), F) {
          for (P = -1, k = E.length; ++P < k; )
            if (O = E.charCodeAt(P), 48 > O || O > 57) {
              $ = (O === 46 ? i + E.slice(P + 1) : E.slice(P)) + $, E = E.slice(0, P);
              break;
            }
        }
      }
      x && !m && (E = e(E, 1 / 0));
      var K = L.length + E.length + $.length, Q = K < _ ? new Array(_ - K + 1).join(d) : "";
      switch (x && m && (E = e(Q + E, Q.length ? _ - $.length : 1 / 0), Q = ""), v) {
        case "<":
          E = L + E + $ + Q;
          break;
        case "=":
          E = L + Q + E + $;
          break;
        case "^":
          E = Q.slice(0, K = Q.length >> 1) + L + E + $ + Q.slice(K);
          break;
        default:
          E = Q + L + E + $;
          break;
      }
      return o(E);
    }
    return V.toString = function() {
      return g + "";
    }, V;
  }
  function p(g, d) {
    var v = c((g = Ha(g), g.type = "f", g)), b = Math.max(-8, Math.min(8, Math.floor(Wa(d) / 3))) * 3, w = Math.pow(10, -b), m = xm[8 + b / 3];
    return function(_) {
      return v(w * _) + m;
    };
  }
  return {
    format: c,
    formatPrefix: p
  };
}
var $f, Cl, Fd;
J_({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function J_(n) {
  return $f = Z_(n), Cl = $f.format, Fd = $f.formatPrefix, $f;
}
function Q_(n) {
  return Math.max(0, -Wa(Math.abs(n)));
}
function j_(n, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Wa(e) / 3))) * 3 - Wa(Math.abs(n)));
}
function nb(n, e) {
  return n = Math.abs(n), e = Math.abs(e) - n, Math.max(0, Wa(e) - Wa(n)) + 1;
}
var Rn = 1e-6, cu = 1e-12, Wn = Math.PI, ve = Wn / 2, Es = Wn / 4, tt = Wn * 2, te = 180 / Wn, Nn = Wn / 180, Xn = Math.abs, io = Math.atan, rt = Math.atan2, Sn = Math.cos, kf = Math.ceil, eb = Math.exp, M0 = Math.hypot, Cs = Math.log, Oh = Math.pow, wn = Math.sin, It = Math.sign || function(n) {
  return n > 0 ? 1 : n < 0 ? -1 : 0;
}, Re = Math.sqrt, Bd = Math.tan;
function tb(n) {
  return n > 1 ? 0 : n < -1 ? Wn : Math.acos(n);
}
function it(n) {
  return n > 1 ? ve : n < -1 ? -ve : Math.asin(n);
}
function Tm(n) {
  return (n = wn(n / 2)) * n;
}
function he() {
}
function Ps(n, e) {
  n && Mm.hasOwnProperty(n.type) && Mm[n.type](n, e);
}
var Am = {
  Feature: function(n, e) {
    Ps(n.geometry, e);
  },
  FeatureCollection: function(n, e) {
    for (var t = n.features, r = -1, i = t.length; ++r < i; )
      Ps(t[r].geometry, e);
  }
}, Mm = {
  Sphere: function(n, e) {
    e.sphere();
  },
  Point: function(n, e) {
    n = n.coordinates, e.point(n[0], n[1], n[2]);
  },
  MultiPoint: function(n, e) {
    for (var t = n.coordinates, r = -1, i = t.length; ++r < i; )
      n = t[r], e.point(n[0], n[1], n[2]);
  },
  LineString: function(n, e) {
    S0(n.coordinates, e, 0);
  },
  MultiLineString: function(n, e) {
    for (var t = n.coordinates, r = -1, i = t.length; ++r < i; )
      S0(t[r], e, 0);
  },
  Polygon: function(n, e) {
    Sm(n.coordinates, e);
  },
  MultiPolygon: function(n, e) {
    for (var t = n.coordinates, r = -1, i = t.length; ++r < i; )
      Sm(t[r], e);
  },
  GeometryCollection: function(n, e) {
    for (var t = n.geometries, r = -1, i = t.length; ++r < i; )
      Ps(t[r], e);
  }
};
function S0(n, e, t) {
  var r = -1, i = n.length - t, o;
  for (e.lineStart(); ++r < i; )
    o = n[r], e.point(o[0], o[1], o[2]);
  e.lineEnd();
}
function Sm(n, e) {
  var t = -1, r = n.length;
  for (e.polygonStart(); ++t < r; )
    S0(n[t], e, 1);
  e.polygonEnd();
}
function Ht(n, e) {
  n && Am.hasOwnProperty(n.type) ? Am[n.type](n, e) : Ps(n, e);
}
var Rs = new Ae(), Ns = new Ae(), rb, ib, E0, C0, P0, cr = {
  point: he,
  lineStart: he,
  lineEnd: he,
  polygonStart: function() {
    Rs = new Ae(), cr.lineStart = R$, cr.lineEnd = N$;
  },
  polygonEnd: function() {
    var n = +Rs;
    Ns.add(n < 0 ? tt + n : n), this.lineStart = this.lineEnd = this.point = he;
  },
  sphere: function() {
    Ns.add(tt);
  }
};
function R$() {
  cr.point = $$;
}
function N$() {
  ab(rb, ib);
}
function $$(n, e) {
  cr.point = ab, rb = n, ib = e, n *= Nn, e *= Nn, E0 = n, C0 = Sn(e = e / 2 + Es), P0 = wn(e);
}
function ab(n, e) {
  n *= Nn, e *= Nn, e = e / 2 + Es;
  var t = n - E0, r = t >= 0 ? 1 : -1, i = r * t, o = Sn(e), f = wn(e), s = P0 * f, l = C0 * o + s * Sn(i), c = s * r * wn(i);
  Rs.add(rt(c, l)), E0 = n, C0 = o, P0 = f;
}
function k$(n) {
  return Ns = new Ae(), Ht(n, cr), Ns * 2;
}
function $s(n) {
  return [rt(n[1], n[0]), it(n[2])];
}
function Ui(n) {
  var e = n[0], t = n[1], r = Sn(t);
  return [r * Sn(e), r * wn(e), wn(t)];
}
function Of(n, e) {
  return n[0] * e[0] + n[1] * e[1] + n[2] * e[2];
}
function Ya(n, e) {
  return [n[1] * e[2] - n[2] * e[1], n[2] * e[0] - n[0] * e[2], n[0] * e[1] - n[1] * e[0]];
}
function Ih(n, e) {
  n[0] += e[0], n[1] += e[1], n[2] += e[2];
}
function If(n, e) {
  return [n[0] * e, n[1] * e, n[2] * e];
}
function ks(n) {
  var e = Re(n[0] * n[0] + n[1] * n[1] + n[2] * n[2]);
  n[0] /= e, n[1] /= e, n[2] /= e;
}
var ce, ht, ge, wt, Ci, ob, ub, Da, Xo, Jr, Dr, $r = {
  point: R0,
  lineStart: Em,
  lineEnd: Cm,
  polygonStart: function() {
    $r.point = sb, $r.lineStart = O$, $r.lineEnd = I$, Xo = new Ae(), cr.polygonStart();
  },
  polygonEnd: function() {
    cr.polygonEnd(), $r.point = R0, $r.lineStart = Em, $r.lineEnd = Cm, Rs < 0 ? (ce = -(ge = 180), ht = -(wt = 90)) : Xo > Rn ? wt = 90 : Xo < -Rn && (ht = -90), Dr[0] = ce, Dr[1] = ge;
  },
  sphere: function() {
    ce = -(ge = 180), ht = -(wt = 90);
  }
};
function R0(n, e) {
  Jr.push(Dr = [ce = n, ge = n]), e < ht && (ht = e), e > wt && (wt = e);
}
function fb(n, e) {
  var t = Ui([n * Nn, e * Nn]);
  if (Da) {
    var r = Ya(Da, t), i = [r[1], -r[0], 0], o = Ya(i, r);
    ks(o), o = $s(o);
    var f = n - Ci, s = f > 0 ? 1 : -1, l = o[0] * te * s, c, p = Xn(f) > 180;
    p ^ (s * Ci < l && l < s * n) ? (c = o[1] * te, c > wt && (wt = c)) : (l = (l + 360) % 360 - 180, p ^ (s * Ci < l && l < s * n) ? (c = -o[1] * te, c < ht && (ht = c)) : (e < ht && (ht = e), e > wt && (wt = e))), p ? n < Ci ? _t(ce, n) > _t(ce, ge) && (ge = n) : _t(n, ge) > _t(ce, ge) && (ce = n) : ge >= ce ? (n < ce && (ce = n), n > ge && (ge = n)) : n > Ci ? _t(ce, n) > _t(ce, ge) && (ge = n) : _t(n, ge) > _t(ce, ge) && (ce = n);
  } else
    Jr.push(Dr = [ce = n, ge = n]);
  e < ht && (ht = e), e > wt && (wt = e), Da = t, Ci = n;
}
function Em() {
  $r.point = fb;
}
function Cm() {
  Dr[0] = ce, Dr[1] = ge, $r.point = R0, Da = null;
}
function sb(n, e) {
  if (Da) {
    var t = n - Ci;
    Xo.add(Xn(t) > 180 ? t + (t > 0 ? 360 : -360) : t);
  } else
    ob = n, ub = e;
  cr.point(n, e), fb(n, e);
}
function O$() {
  cr.lineStart();
}
function I$() {
  sb(ob, ub), cr.lineEnd(), Xn(Xo) > Rn && (ce = -(ge = 180)), Dr[0] = ce, Dr[1] = ge, Da = null;
}
function _t(n, e) {
  return (e -= n) < 0 ? e + 360 : e;
}
function L$(n, e) {
  return n[0] - e[0];
}
function Pm(n, e) {
  return n[0] <= n[1] ? n[0] <= e && e <= n[1] : e < n[0] || n[1] < e;
}
function D$(n) {
  var e, t, r, i, o, f, s;
  if (wt = ge = -(ce = ht = 1 / 0), Jr = [], Ht(n, $r), t = Jr.length) {
    for (Jr.sort(L$), e = 1, r = Jr[0], o = [r]; e < t; ++e)
      i = Jr[e], Pm(r, i[0]) || Pm(r, i[1]) ? (_t(r[0], i[1]) > _t(r[0], r[1]) && (r[1] = i[1]), _t(i[0], r[1]) > _t(r[0], r[1]) && (r[0] = i[0])) : o.push(r = i);
    for (f = -1 / 0, t = o.length - 1, e = 0, r = o[t]; e <= t; r = i, ++e)
      i = o[e], (s = _t(r[1], i[0])) > f && (f = s, ce = i[0], ge = r[1]);
  }
  return Jr = Dr = null, ce === 1 / 0 || ht === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[ce, ht], [ge, wt]];
}
var Fo, Os, Is, Ls, Ds, Fs, Bs, zs, N0, $0, k0, lb, cb, Ze, Je, Qe, Kt = {
  sphere: he,
  point: zd,
  lineStart: Rm,
  lineEnd: Nm,
  polygonStart: function() {
    Kt.lineStart = z$, Kt.lineEnd = V$;
  },
  polygonEnd: function() {
    Kt.lineStart = Rm, Kt.lineEnd = Nm;
  }
};
function zd(n, e) {
  n *= Nn, e *= Nn;
  var t = Sn(e);
  Su(t * Sn(n), t * wn(n), wn(e));
}
function Su(n, e, t) {
  ++Fo, Is += (n - Is) / Fo, Ls += (e - Ls) / Fo, Ds += (t - Ds) / Fo;
}
function Rm() {
  Kt.point = F$;
}
function F$(n, e) {
  n *= Nn, e *= Nn;
  var t = Sn(e);
  Ze = t * Sn(n), Je = t * wn(n), Qe = wn(e), Kt.point = B$, Su(Ze, Je, Qe);
}
function B$(n, e) {
  n *= Nn, e *= Nn;
  var t = Sn(e), r = t * Sn(n), i = t * wn(n), o = wn(e), f = rt(Re((f = Je * o - Qe * i) * f + (f = Qe * r - Ze * o) * f + (f = Ze * i - Je * r) * f), Ze * r + Je * i + Qe * o);
  Os += f, Fs += f * (Ze + (Ze = r)), Bs += f * (Je + (Je = i)), zs += f * (Qe + (Qe = o)), Su(Ze, Je, Qe);
}
function Nm() {
  Kt.point = zd;
}
function z$() {
  Kt.point = U$;
}
function V$() {
  hb(lb, cb), Kt.point = zd;
}
function U$(n, e) {
  lb = n, cb = e, n *= Nn, e *= Nn, Kt.point = hb;
  var t = Sn(e);
  Ze = t * Sn(n), Je = t * wn(n), Qe = wn(e), Su(Ze, Je, Qe);
}
function hb(n, e) {
  n *= Nn, e *= Nn;
  var t = Sn(e), r = t * Sn(n), i = t * wn(n), o = wn(e), f = Je * o - Qe * i, s = Qe * r - Ze * o, l = Ze * i - Je * r, c = M0(f, s, l), p = it(c), g = c && -p / c;
  N0.add(g * f), $0.add(g * s), k0.add(g * l), Os += p, Fs += p * (Ze + (Ze = r)), Bs += p * (Je + (Je = i)), zs += p * (Qe + (Qe = o)), Su(Ze, Je, Qe);
}
function G$(n) {
  Fo = Os = Is = Ls = Ds = Fs = Bs = zs = 0, N0 = new Ae(), $0 = new Ae(), k0 = new Ae(), Ht(n, Kt);
  var e = +N0, t = +$0, r = +k0, i = M0(e, t, r);
  return i < cu && (e = Fs, t = Bs, r = zs, Os < Rn && (e = Is, t = Ls, r = Ds), i = M0(e, t, r), i < cu) ? [NaN, NaN] : [rt(t, e) * te, it(r / i) * te];
}
function Sa(n) {
  return function() {
    return n;
  };
}
function O0(n, e) {
  function t(r, i) {
    return r = n(r, i), e(r[0], r[1]);
  }
  return n.invert && e.invert && (t.invert = function(r, i) {
    return r = e.invert(r, i), r && n.invert(r[0], r[1]);
  }), t;
}
function I0(n, e) {
  return Xn(n) > Wn && (n -= Math.round(n / tt) * tt), [n, e];
}
I0.invert = I0;
function Vd(n, e, t) {
  return (n %= tt) ? e || t ? O0(km(n), Om(e, t)) : km(n) : e || t ? Om(e, t) : I0;
}
function $m(n) {
  return function(e, t) {
    return e += n, Xn(e) > Wn && (e -= Math.round(e / tt) * tt), [e, t];
  };
}
function km(n) {
  var e = $m(n);
  return e.invert = $m(-n), e;
}
function Om(n, e) {
  var t = Sn(n), r = wn(n), i = Sn(e), o = wn(e);
  function f(s, l) {
    var c = Sn(l), p = Sn(s) * c, g = wn(s) * c, d = wn(l), v = d * t + p * r;
    return [
      rt(g * i - v * o, p * t - d * r),
      it(v * i + g * o)
    ];
  }
  return f.invert = function(s, l) {
    var c = Sn(l), p = Sn(s) * c, g = wn(s) * c, d = wn(l), v = d * i - g * o;
    return [
      rt(g * i + d * o, p * t + v * r),
      it(v * t - p * r)
    ];
  }, f;
}
function db(n) {
  n = Vd(n[0] * Nn, n[1] * Nn, n.length > 2 ? n[2] * Nn : 0);
  function e(t) {
    return t = n(t[0] * Nn, t[1] * Nn), t[0] *= te, t[1] *= te, t;
  }
  return e.invert = function(t) {
    return t = n.invert(t[0] * Nn, t[1] * Nn), t[0] *= te, t[1] *= te, t;
  }, e;
}
function pb(n, e, t, r, i, o) {
  if (t) {
    var f = Sn(e), s = wn(e), l = r * t;
    i == null ? (i = e + r * tt, o = e - l / 2) : (i = Im(f, i), o = Im(f, o), (r > 0 ? i < o : i > o) && (i += r * tt));
    for (var c, p = i; r > 0 ? p > o : p < o; p -= l)
      c = $s([f, -s * Sn(p), -s * wn(p)]), n.point(c[0], c[1]);
  }
}
function Im(n, e) {
  e = Ui(e), e[0] -= n, ks(e);
  var t = tb(-e[1]);
  return ((-e[2] < 0 ? -t : t) + tt - Rn) % tt;
}
function q$() {
  var n = Sa([0, 0]), e = Sa(90), t = Sa(2), r, i, o = { point: f };
  function f(l, c) {
    r.push(l = i(l, c)), l[0] *= te, l[1] *= te;
  }
  function s() {
    var l = n.apply(this, arguments), c = e.apply(this, arguments) * Nn, p = t.apply(this, arguments) * Nn;
    return r = [], i = Vd(-l[0] * Nn, -l[1] * Nn, 0).invert, pb(o, c, p, 1), l = { type: "Polygon", coordinates: [r] }, r = i = null, l;
  }
  return s.center = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : Sa([+l[0], +l[1]]), s) : n;
  }, s.radius = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : Sa(+l), s) : e;
  }, s.precision = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : Sa(+l), s) : t;
  }, s;
}
function gb() {
  var n = [], e;
  return {
    point: function(t, r, i) {
      e.push([t, r, i]);
    },
    lineStart: function() {
      n.push(e = []);
    },
    lineEnd: he,
    rejoin: function() {
      n.length > 1 && n.push(n.pop().concat(n.shift()));
    },
    result: function() {
      var t = n;
      return n = [], e = null, t;
    }
  };
}
function ts(n, e) {
  return Xn(n[0] - e[0]) < Rn && Xn(n[1] - e[1]) < Rn;
}
function Lf(n, e, t, r) {
  this.x = n, this.z = e, this.o = t, this.e = r, this.v = !1, this.n = this.p = null;
}
function vb(n, e, t, r, i) {
  var o = [], f = [], s, l;
  if (n.forEach(function(b) {
    if (!((w = b.length - 1) <= 0)) {
      var w, m = b[0], _ = b[w], x;
      if (ts(m, _)) {
        if (!m[2] && !_[2]) {
          for (i.lineStart(), s = 0; s < w; ++s)
            i.point((m = b[s])[0], m[1]);
          i.lineEnd();
          return;
        }
        _[0] += 2 * Rn;
      }
      o.push(x = new Lf(m, b, null, !0)), f.push(x.o = new Lf(m, null, x, !1)), o.push(x = new Lf(_, b, null, !1)), f.push(x.o = new Lf(_, null, x, !0));
    }
  }), !!o.length) {
    for (f.sort(e), Lm(o), Lm(f), s = 0, l = f.length; s < l; ++s)
      f[s].e = t = !t;
    for (var c = o[0], p, g; ; ) {
      for (var d = c, v = !0; d.v; )
        if ((d = d.n) === c)
          return;
      p = d.z, i.lineStart();
      do {
        if (d.v = d.o.v = !0, d.e) {
          if (v)
            for (s = 0, l = p.length; s < l; ++s)
              i.point((g = p[s])[0], g[1]);
          else
            r(d.x, d.n.x, 1, i);
          d = d.n;
        } else {
          if (v)
            for (p = d.p.z, s = p.length - 1; s >= 0; --s)
              i.point((g = p[s])[0], g[1]);
          else
            r(d.x, d.p.x, -1, i);
          d = d.p;
        }
        d = d.o, p = d.z, v = !v;
      } while (!d.v);
      i.lineEnd();
    }
  }
}
function Lm(n) {
  if (e = n.length) {
    for (var e, t = 0, r = n[0], i; ++t < e; )
      r.n = i = n[t], i.p = r, r = i;
    r.n = i = n[0], i.p = r;
  }
}
function Lh(n) {
  return Xn(n[0]) <= Wn ? n[0] : It(n[0]) * ((Xn(n[0]) + Wn) % tt - Wn);
}
function mb(n, e) {
  var t = Lh(e), r = e[1], i = wn(r), o = [wn(t), -Sn(t), 0], f = 0, s = 0, l = new Ae();
  i === 1 ? r = ve + Rn : i === -1 && (r = -ve - Rn);
  for (var c = 0, p = n.length; c < p; ++c)
    if (d = (g = n[c]).length)
      for (var g, d, v = g[d - 1], b = Lh(v), w = v[1] / 2 + Es, m = wn(w), _ = Sn(w), x = 0; x < d; ++x, b = T, m = R, _ = I, v = A) {
        var A = g[x], T = Lh(A), S = A[1] / 2 + Es, R = wn(S), I = Sn(S), B = T - b, F = B >= 0 ? 1 : -1, V = F * B, E = V > Wn, L = m * R;
        if (l.add(rt(L * F * wn(V), _ * I + L * Sn(V))), f += E ? B + F * tt : B, E ^ b >= t ^ T >= t) {
          var $ = Ya(Ui(v), Ui(A));
          ks($);
          var P = Ya(o, $);
          ks(P);
          var k = (E ^ B >= 0 ? -1 : 1) * it(P[2]);
          (r > k || r === k && ($[0] || $[1])) && (s += E ^ B >= 0 ? 1 : -1);
        }
      }
  return (f < -Rn || f < Rn && l < -cu) ^ s & 1;
}
function yb(n, e, t, r) {
  return function(i) {
    var o = e(i), f = gb(), s = e(f), l = !1, c, p, g, d = {
      point: v,
      lineStart: w,
      lineEnd: m,
      polygonStart: function() {
        d.point = _, d.lineStart = x, d.lineEnd = A, p = [], c = [];
      },
      polygonEnd: function() {
        d.point = v, d.lineStart = w, d.lineEnd = m, p = gd(p);
        var T = mb(c, r);
        p.length ? (l || (i.polygonStart(), l = !0), vb(p, H$, T, t, i)) : T && (l || (i.polygonStart(), l = !0), i.lineStart(), t(null, null, 1, i), i.lineEnd()), l && (i.polygonEnd(), l = !1), p = c = null;
      },
      sphere: function() {
        i.polygonStart(), i.lineStart(), t(null, null, 1, i), i.lineEnd(), i.polygonEnd();
      }
    };
    function v(T, S) {
      n(T, S) && i.point(T, S);
    }
    function b(T, S) {
      o.point(T, S);
    }
    function w() {
      d.point = b, o.lineStart();
    }
    function m() {
      d.point = v, o.lineEnd();
    }
    function _(T, S) {
      g.push([T, S]), s.point(T, S);
    }
    function x() {
      s.lineStart(), g = [];
    }
    function A() {
      _(g[0][0], g[0][1]), s.lineEnd();
      var T = s.clean(), S = f.result(), R, I = S.length, B, F, V;
      if (g.pop(), c.push(g), g = null, !!I) {
        if (T & 1) {
          if (F = S[0], (B = F.length - 1) > 0) {
            for (l || (i.polygonStart(), l = !0), i.lineStart(), R = 0; R < B; ++R)
              i.point((V = F[R])[0], V[1]);
            i.lineEnd();
          }
          return;
        }
        I > 1 && T & 2 && S.push(S.pop().concat(S.shift())), p.push(S.filter(W$));
      }
    }
    return d;
  };
}
function W$(n) {
  return n.length > 1;
}
function H$(n, e) {
  return ((n = n.x)[0] < 0 ? n[1] - ve - Rn : ve - n[1]) - ((e = e.x)[0] < 0 ? e[1] - ve - Rn : ve - e[1]);
}
const L0 = yb(
  function() {
    return !0;
  },
  Y$,
  K$,
  [-Wn, -ve]
);
function Y$(n) {
  var e = NaN, t = NaN, r = NaN, i;
  return {
    lineStart: function() {
      n.lineStart(), i = 1;
    },
    point: function(o, f) {
      var s = o > 0 ? Wn : -Wn, l = Xn(o - e);
      Xn(l - Wn) < Rn ? (n.point(e, t = (t + f) / 2 > 0 ? ve : -ve), n.point(r, t), n.lineEnd(), n.lineStart(), n.point(s, t), n.point(o, t), i = 0) : r !== s && l >= Wn && (Xn(e - r) < Rn && (e -= r * Rn), Xn(o - s) < Rn && (o -= s * Rn), t = X$(e, t, o, f), n.point(r, t), n.lineEnd(), n.lineStart(), n.point(s, t), i = 0), n.point(e = o, t = f), r = s;
    },
    lineEnd: function() {
      n.lineEnd(), e = t = NaN;
    },
    clean: function() {
      return 2 - i;
    }
  };
}
function X$(n, e, t, r) {
  var i, o, f = wn(n - t);
  return Xn(f) > Rn ? io((wn(e) * (o = Sn(r)) * wn(t) - wn(r) * (i = Sn(e)) * wn(n)) / (i * o * f)) : (e + r) / 2;
}
function K$(n, e, t, r) {
  var i;
  if (n == null)
    i = t * ve, r.point(-Wn, i), r.point(0, i), r.point(Wn, i), r.point(Wn, 0), r.point(Wn, -i), r.point(0, -i), r.point(-Wn, -i), r.point(-Wn, 0), r.point(-Wn, i);
  else if (Xn(n[0] - e[0]) > Rn) {
    var o = n[0] < e[0] ? Wn : -Wn;
    i = t * o / 2, r.point(-o, i), r.point(0, i), r.point(o, i);
  } else
    r.point(e[0], e[1]);
}
function _b(n) {
  var e = Sn(n), t = 2 * Nn, r = e > 0, i = Xn(e) > Rn;
  function o(p, g, d, v) {
    pb(v, n, t, d, p, g);
  }
  function f(p, g) {
    return Sn(p) * Sn(g) > e;
  }
  function s(p) {
    var g, d, v, b, w;
    return {
      lineStart: function() {
        b = v = !1, w = 1;
      },
      point: function(m, _) {
        var x = [m, _], A, T = f(m, _), S = r ? T ? 0 : c(m, _) : T ? c(m + (m < 0 ? Wn : -Wn), _) : 0;
        if (!g && (b = v = T) && p.lineStart(), T !== v && (A = l(g, x), (!A || ts(g, A) || ts(x, A)) && (x[2] = 1)), T !== v)
          w = 0, T ? (p.lineStart(), A = l(x, g), p.point(A[0], A[1])) : (A = l(g, x), p.point(A[0], A[1], 2), p.lineEnd()), g = A;
        else if (i && g && r ^ T) {
          var R;
          !(S & d) && (R = l(x, g, !0)) && (w = 0, r ? (p.lineStart(), p.point(R[0][0], R[0][1]), p.point(R[1][0], R[1][1]), p.lineEnd()) : (p.point(R[1][0], R[1][1]), p.lineEnd(), p.lineStart(), p.point(R[0][0], R[0][1], 3)));
        }
        T && (!g || !ts(g, x)) && p.point(x[0], x[1]), g = x, v = T, d = S;
      },
      lineEnd: function() {
        v && p.lineEnd(), g = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return w | (b && v) << 1;
      }
    };
  }
  function l(p, g, d) {
    var v = Ui(p), b = Ui(g), w = [1, 0, 0], m = Ya(v, b), _ = Of(m, m), x = m[0], A = _ - x * x;
    if (!A)
      return !d && p;
    var T = e * _ / A, S = -e * x / A, R = Ya(w, m), I = If(w, T), B = If(m, S);
    Ih(I, B);
    var F = R, V = Of(I, F), E = Of(F, F), L = V * V - E * (Of(I, I) - 1);
    if (!(L < 0)) {
      var $ = Re(L), P = If(F, (-V - $) / E);
      if (Ih(P, I), P = $s(P), !d)
        return P;
      var k = p[0], O = g[0], W = p[1], K = g[1], Q;
      O < k && (Q = k, k = O, O = Q);
      var z = O - k, q = Xn(z - Wn) < Rn, J = q || z < Rn;
      if (!q && K < W && (Q = W, W = K, K = Q), J ? q ? W + K > 0 ^ P[1] < (Xn(P[0] - k) < Rn ? W : K) : W <= P[1] && P[1] <= K : z > Wn ^ (k <= P[0] && P[0] <= O)) {
        var en = If(F, (-V + $) / E);
        return Ih(en, I), [P, $s(en)];
      }
    }
  }
  function c(p, g) {
    var d = r ? n : Wn - n, v = 0;
    return p < -d ? v |= 1 : p > d && (v |= 2), g < -d ? v |= 4 : g > d && (v |= 8), v;
  }
  return yb(f, s, o, r ? [0, -n] : [-Wn, n - Wn]);
}
function Z$(n, e, t, r, i, o) {
  var f = n[0], s = n[1], l = e[0], c = e[1], p = 0, g = 1, d = l - f, v = c - s, b;
  if (b = t - f, !(!d && b > 0)) {
    if (b /= d, d < 0) {
      if (b < p)
        return;
      b < g && (g = b);
    } else if (d > 0) {
      if (b > g)
        return;
      b > p && (p = b);
    }
    if (b = i - f, !(!d && b < 0)) {
      if (b /= d, d < 0) {
        if (b > g)
          return;
        b > p && (p = b);
      } else if (d > 0) {
        if (b < p)
          return;
        b < g && (g = b);
      }
      if (b = r - s, !(!v && b > 0)) {
        if (b /= v, v < 0) {
          if (b < p)
            return;
          b < g && (g = b);
        } else if (v > 0) {
          if (b > g)
            return;
          b > p && (p = b);
        }
        if (b = o - s, !(!v && b < 0)) {
          if (b /= v, v < 0) {
            if (b > g)
              return;
            b > p && (p = b);
          } else if (v > 0) {
            if (b < p)
              return;
            b < g && (g = b);
          }
          return p > 0 && (n[0] = f + p * d, n[1] = s + p * v), g < 1 && (e[0] = f + g * d, e[1] = s + g * v), !0;
        }
      }
    }
  }
}
var Bo = 1e9, Df = -Bo;
function Pl(n, e, t, r) {
  function i(c, p) {
    return n <= c && c <= t && e <= p && p <= r;
  }
  function o(c, p, g, d) {
    var v = 0, b = 0;
    if (c == null || (v = f(c, g)) !== (b = f(p, g)) || l(c, p) < 0 ^ g > 0)
      do
        d.point(v === 0 || v === 3 ? n : t, v > 1 ? r : e);
      while ((v = (v + g + 4) % 4) !== b);
    else
      d.point(p[0], p[1]);
  }
  function f(c, p) {
    return Xn(c[0] - n) < Rn ? p > 0 ? 0 : 3 : Xn(c[0] - t) < Rn ? p > 0 ? 2 : 1 : Xn(c[1] - e) < Rn ? p > 0 ? 1 : 0 : p > 0 ? 3 : 2;
  }
  function s(c, p) {
    return l(c.x, p.x);
  }
  function l(c, p) {
    var g = f(c, 1), d = f(p, 1);
    return g !== d ? g - d : g === 0 ? p[1] - c[1] : g === 1 ? c[0] - p[0] : g === 2 ? c[1] - p[1] : p[0] - c[0];
  }
  return function(c) {
    var p = c, g = gb(), d, v, b, w, m, _, x, A, T, S, R, I = {
      point: B,
      lineStart: L,
      lineEnd: $,
      polygonStart: V,
      polygonEnd: E
    };
    function B(k, O) {
      i(k, O) && p.point(k, O);
    }
    function F() {
      for (var k = 0, O = 0, W = v.length; O < W; ++O)
        for (var K = v[O], Q = 1, z = K.length, q = K[0], J, en, fn = q[0], ln = q[1]; Q < z; ++Q)
          J = fn, en = ln, q = K[Q], fn = q[0], ln = q[1], en <= r ? ln > r && (fn - J) * (r - en) > (ln - en) * (n - J) && ++k : ln <= r && (fn - J) * (r - en) < (ln - en) * (n - J) && --k;
      return k;
    }
    function V() {
      p = g, d = [], v = [], R = !0;
    }
    function E() {
      var k = F(), O = R && k, W = (d = gd(d)).length;
      (O || W) && (c.polygonStart(), O && (c.lineStart(), o(null, null, 1, c), c.lineEnd()), W && vb(d, s, k, o, c), c.polygonEnd()), p = c, d = v = b = null;
    }
    function L() {
      I.point = P, v && v.push(b = []), S = !0, T = !1, x = A = NaN;
    }
    function $() {
      d && (P(w, m), _ && T && g.rejoin(), d.push(g.result())), I.point = B, T && p.lineEnd();
    }
    function P(k, O) {
      var W = i(k, O);
      if (v && b.push([k, O]), S)
        w = k, m = O, _ = W, S = !1, W && (p.lineStart(), p.point(k, O));
      else if (W && T)
        p.point(k, O);
      else {
        var K = [x = Math.max(Df, Math.min(Bo, x)), A = Math.max(Df, Math.min(Bo, A))], Q = [k = Math.max(Df, Math.min(Bo, k)), O = Math.max(Df, Math.min(Bo, O))];
        Z$(K, Q, n, e, t, r) ? (T || (p.lineStart(), p.point(K[0], K[1])), p.point(Q[0], Q[1]), W || p.lineEnd(), R = !1) : W && (p.lineStart(), p.point(k, O), R = !1);
      }
      x = k, A = O, T = W;
    }
    return I;
  };
}
function J$() {
  var n = 0, e = 0, t = 960, r = 500, i, o, f;
  return f = {
    stream: function(s) {
      return i && o === s ? i : i = Pl(n, e, t, r)(o = s);
    },
    extent: function(s) {
      return arguments.length ? (n = +s[0][0], e = +s[0][1], t = +s[1][0], r = +s[1][1], i = o = null, f) : [[n, e], [t, r]];
    }
  };
}
var D0, F0, rs, is, Xa = {
  sphere: he,
  point: he,
  lineStart: Q$,
  lineEnd: he,
  polygonStart: he,
  polygonEnd: he
};
function Q$() {
  Xa.point = nk, Xa.lineEnd = j$;
}
function j$() {
  Xa.point = Xa.lineEnd = he;
}
function nk(n, e) {
  n *= Nn, e *= Nn, F0 = n, rs = wn(e), is = Sn(e), Xa.point = ek;
}
function ek(n, e) {
  n *= Nn, e *= Nn;
  var t = wn(e), r = Sn(e), i = Xn(n - F0), o = Sn(i), f = wn(i), s = r * f, l = is * t - rs * r * o, c = rs * t + is * r * o;
  D0.add(rt(Re(s * s + l * l), c)), F0 = n, rs = t, is = r;
}
function bb(n) {
  return D0 = new Ae(), Ht(n, Xa), +D0;
}
var B0 = [null, null], tk = { type: "LineString", coordinates: B0 };
function Vs(n, e) {
  return B0[0] = n, B0[1] = e, bb(tk);
}
var Dm = {
  Feature: function(n, e) {
    return Us(n.geometry, e);
  },
  FeatureCollection: function(n, e) {
    for (var t = n.features, r = -1, i = t.length; ++r < i; )
      if (Us(t[r].geometry, e))
        return !0;
    return !1;
  }
}, Fm = {
  Sphere: function() {
    return !0;
  },
  Point: function(n, e) {
    return Bm(n.coordinates, e);
  },
  MultiPoint: function(n, e) {
    for (var t = n.coordinates, r = -1, i = t.length; ++r < i; )
      if (Bm(t[r], e))
        return !0;
    return !1;
  },
  LineString: function(n, e) {
    return zm(n.coordinates, e);
  },
  MultiLineString: function(n, e) {
    for (var t = n.coordinates, r = -1, i = t.length; ++r < i; )
      if (zm(t[r], e))
        return !0;
    return !1;
  },
  Polygon: function(n, e) {
    return Vm(n.coordinates, e);
  },
  MultiPolygon: function(n, e) {
    for (var t = n.coordinates, r = -1, i = t.length; ++r < i; )
      if (Vm(t[r], e))
        return !0;
    return !1;
  },
  GeometryCollection: function(n, e) {
    for (var t = n.geometries, r = -1, i = t.length; ++r < i; )
      if (Us(t[r], e))
        return !0;
    return !1;
  }
};
function Us(n, e) {
  return n && Fm.hasOwnProperty(n.type) ? Fm[n.type](n, e) : !1;
}
function Bm(n, e) {
  return Vs(n, e) === 0;
}
function zm(n, e) {
  for (var t, r, i, o = 0, f = n.length; o < f; o++) {
    if (r = Vs(n[o], e), r === 0 || o > 0 && (i = Vs(n[o], n[o - 1]), i > 0 && t <= i && r <= i && (t + r - i) * (1 - Math.pow((t - r) / i, 2)) < cu * i))
      return !0;
    t = r;
  }
  return !1;
}
function Vm(n, e) {
  return !!mb(n.map(rk), wb(e));
}
function rk(n) {
  return n = n.map(wb), n.pop(), n;
}
function wb(n) {
  return [n[0] * Nn, n[1] * Nn];
}
function ik(n, e) {
  return (n && Dm.hasOwnProperty(n.type) ? Dm[n.type] : Us)(n, e);
}
function Um(n, e, t) {
  var r = ti(n, e - Rn, t).concat(e);
  return function(i) {
    return r.map(function(o) {
      return [i, o];
    });
  };
}
function Gm(n, e, t) {
  var r = ti(n, e - Rn, t).concat(e);
  return function(i) {
    return r.map(function(o) {
      return [o, i];
    });
  };
}
function xb() {
  var n, e, t, r, i, o, f, s, l = 10, c = l, p = 90, g = 360, d, v, b, w, m = 2.5;
  function _() {
    return { type: "MultiLineString", coordinates: x() };
  }
  function x() {
    return ti(kf(r / p) * p, t, p).map(b).concat(ti(kf(s / g) * g, f, g).map(w)).concat(ti(kf(e / l) * l, n, l).filter(function(A) {
      return Xn(A % p) > Rn;
    }).map(d)).concat(ti(kf(o / c) * c, i, c).filter(function(A) {
      return Xn(A % g) > Rn;
    }).map(v));
  }
  return _.lines = function() {
    return x().map(function(A) {
      return { type: "LineString", coordinates: A };
    });
  }, _.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        b(r).concat(
          w(f).slice(1),
          b(t).reverse().slice(1),
          w(s).reverse().slice(1)
        )
      ]
    };
  }, _.extent = function(A) {
    return arguments.length ? _.extentMajor(A).extentMinor(A) : _.extentMinor();
  }, _.extentMajor = function(A) {
    return arguments.length ? (r = +A[0][0], t = +A[1][0], s = +A[0][1], f = +A[1][1], r > t && (A = r, r = t, t = A), s > f && (A = s, s = f, f = A), _.precision(m)) : [[r, s], [t, f]];
  }, _.extentMinor = function(A) {
    return arguments.length ? (e = +A[0][0], n = +A[1][0], o = +A[0][1], i = +A[1][1], e > n && (A = e, e = n, n = A), o > i && (A = o, o = i, i = A), _.precision(m)) : [[e, o], [n, i]];
  }, _.step = function(A) {
    return arguments.length ? _.stepMajor(A).stepMinor(A) : _.stepMinor();
  }, _.stepMajor = function(A) {
    return arguments.length ? (p = +A[0], g = +A[1], _) : [p, g];
  }, _.stepMinor = function(A) {
    return arguments.length ? (l = +A[0], c = +A[1], _) : [l, c];
  }, _.precision = function(A) {
    return arguments.length ? (m = +A, d = Um(o, i, 90), v = Gm(e, n, m), b = Um(s, f, 90), w = Gm(r, t, m), _) : m;
  }, _.extentMajor([[-180, -90 + Rn], [180, 90 - Rn]]).extentMinor([[-180, -80 - Rn], [180, 80 + Rn]]);
}
function ak() {
  return xb()();
}
function ok(n, e) {
  var t = n[0] * Nn, r = n[1] * Nn, i = e[0] * Nn, o = e[1] * Nn, f = Sn(r), s = wn(r), l = Sn(o), c = wn(o), p = f * Sn(t), g = f * wn(t), d = l * Sn(i), v = l * wn(i), b = 2 * it(Re(Tm(o - r) + f * l * Tm(i - t))), w = wn(b), m = b ? function(_) {
    var x = wn(_ *= b) / w, A = wn(b - _) / w, T = A * p + x * d, S = A * g + x * v, R = A * s + x * c;
    return [
      rt(S, T) * te,
      rt(R, Re(T * T + S * S)) * te
    ];
  } : function() {
    return [t * te, r * te];
  };
  return m.distance = b, m;
}
const hu = (n) => n;
var Dh = new Ae(), z0 = new Ae(), Tb, Ab, V0, U0, jr = {
  point: he,
  lineStart: he,
  lineEnd: he,
  polygonStart: function() {
    jr.lineStart = uk, jr.lineEnd = sk;
  },
  polygonEnd: function() {
    jr.lineStart = jr.lineEnd = jr.point = he, Dh.add(Xn(z0)), z0 = new Ae();
  },
  result: function() {
    var n = Dh / 2;
    return Dh = new Ae(), n;
  }
};
function uk() {
  jr.point = fk;
}
function fk(n, e) {
  jr.point = Mb, Tb = V0 = n, Ab = U0 = e;
}
function Mb(n, e) {
  z0.add(U0 * n - V0 * e), V0 = n, U0 = e;
}
function sk() {
  Mb(Tb, Ab);
}
const qm = jr;
var Ka = 1 / 0, Gs = Ka, du = -Ka, qs = du, lk = {
  point: ck,
  lineStart: he,
  lineEnd: he,
  polygonStart: he,
  polygonEnd: he,
  result: function() {
    var n = [[Ka, Gs], [du, qs]];
    return du = qs = -(Gs = Ka = 1 / 0), n;
  }
};
function ck(n, e) {
  n < Ka && (Ka = n), n > du && (du = n), e < Gs && (Gs = e), e > qs && (qs = e);
}
const Ws = lk;
var G0 = 0, q0 = 0, zo = 0, Hs = 0, Ys = 0, $a = 0, W0 = 0, H0 = 0, Vo = 0, Sb, Eb, ir, ar, Yt = {
  point: Gi,
  lineStart: Wm,
  lineEnd: Hm,
  polygonStart: function() {
    Yt.lineStart = pk, Yt.lineEnd = gk;
  },
  polygonEnd: function() {
    Yt.point = Gi, Yt.lineStart = Wm, Yt.lineEnd = Hm;
  },
  result: function() {
    var n = Vo ? [W0 / Vo, H0 / Vo] : $a ? [Hs / $a, Ys / $a] : zo ? [G0 / zo, q0 / zo] : [NaN, NaN];
    return G0 = q0 = zo = Hs = Ys = $a = W0 = H0 = Vo = 0, n;
  }
};
function Gi(n, e) {
  G0 += n, q0 += e, ++zo;
}
function Wm() {
  Yt.point = hk;
}
function hk(n, e) {
  Yt.point = dk, Gi(ir = n, ar = e);
}
function dk(n, e) {
  var t = n - ir, r = e - ar, i = Re(t * t + r * r);
  Hs += i * (ir + n) / 2, Ys += i * (ar + e) / 2, $a += i, Gi(ir = n, ar = e);
}
function Hm() {
  Yt.point = Gi;
}
function pk() {
  Yt.point = vk;
}
function gk() {
  Cb(Sb, Eb);
}
function vk(n, e) {
  Yt.point = Cb, Gi(Sb = ir = n, Eb = ar = e);
}
function Cb(n, e) {
  var t = n - ir, r = e - ar, i = Re(t * t + r * r);
  Hs += i * (ir + n) / 2, Ys += i * (ar + e) / 2, $a += i, i = ar * n - ir * e, W0 += i * (ir + n), H0 += i * (ar + e), Vo += i * 3, Gi(ir = n, ar = e);
}
const Ym = Yt;
function Pb(n) {
  this._context = n;
}
Pb.prototype = {
  _radius: 4.5,
  pointRadius: function(n) {
    return this._radius = n, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._context.closePath(), this._point = NaN;
  },
  point: function(n, e) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(n, e), this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(n, e);
        break;
      }
      default: {
        this._context.moveTo(n + this._radius, e), this._context.arc(n, e, this._radius, 0, tt);
        break;
      }
    }
  },
  result: he
};
var Y0 = new Ae(), Fh, Rb, Nb, Uo, Go, Xs = {
  point: he,
  lineStart: function() {
    Xs.point = mk;
  },
  lineEnd: function() {
    Fh && $b(Rb, Nb), Xs.point = he;
  },
  polygonStart: function() {
    Fh = !0;
  },
  polygonEnd: function() {
    Fh = null;
  },
  result: function() {
    var n = +Y0;
    return Y0 = new Ae(), n;
  }
};
function mk(n, e) {
  Xs.point = $b, Rb = Uo = n, Nb = Go = e;
}
function $b(n, e) {
  Uo -= n, Go -= e, Y0.add(Re(Uo * Uo + Go * Go)), Uo = n, Go = e;
}
const Xm = Xs;
let Km, Ks, Zm, Jm;
class Qm {
  constructor(e) {
    this._append = e == null ? kb : yk(e), this._radius = 4.5, this._ = "";
  }
  pointRadius(e) {
    return this._radius = +e, this;
  }
  polygonStart() {
    this._line = 0;
  }
  polygonEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    this._line === 0 && (this._ += "Z"), this._point = NaN;
  }
  point(e, t) {
    switch (this._point) {
      case 0: {
        this._append`M${e},${t}`, this._point = 1;
        break;
      }
      case 1: {
        this._append`L${e},${t}`;
        break;
      }
      default: {
        if (this._append`M${e},${t}`, this._radius !== Zm || this._append !== Ks) {
          const r = this._radius, i = this._;
          this._ = "", this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`, Zm = r, Ks = this._append, Jm = this._, this._ = i;
        }
        this._ += Jm;
        break;
      }
    }
  }
  result() {
    const e = this._;
    return this._ = "", e.length ? e : null;
  }
}
function kb(n) {
  let e = 1;
  this._ += n[0];
  for (const t = n.length; e < t; ++e)
    this._ += arguments[e] + n[e];
}
function yk(n) {
  const e = Math.floor(n);
  if (!(e >= 0))
    throw new RangeError(`invalid digits: ${n}`);
  if (e > 15)
    return kb;
  if (e !== Km) {
    const t = 10 ** e;
    Km = e, Ks = function(i) {
      let o = 1;
      this._ += i[0];
      for (const f = i.length; o < f; ++o)
        this._ += Math.round(arguments[o] * t) / t + i[o];
    };
  }
  return Ks;
}
function _k(n, e) {
  let t = 3, r = 4.5, i, o;
  function f(s) {
    return s && (typeof r == "function" && o.pointRadius(+r.apply(this, arguments)), Ht(s, i(o))), o.result();
  }
  return f.area = function(s) {
    return Ht(s, i(qm)), qm.result();
  }, f.measure = function(s) {
    return Ht(s, i(Xm)), Xm.result();
  }, f.bounds = function(s) {
    return Ht(s, i(Ws)), Ws.result();
  }, f.centroid = function(s) {
    return Ht(s, i(Ym)), Ym.result();
  }, f.projection = function(s) {
    return arguments.length ? (i = s == null ? (n = null, hu) : (n = s).stream, f) : n;
  }, f.context = function(s) {
    return arguments.length ? (o = s == null ? (e = null, new Qm(t)) : new Pb(e = s), typeof r != "function" && o.pointRadius(r), f) : e;
  }, f.pointRadius = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : (o.pointRadius(+s), +s), f) : r;
  }, f.digits = function(s) {
    if (!arguments.length)
      return t;
    if (s == null)
      t = null;
    else {
      const l = Math.floor(s);
      if (!(l >= 0))
        throw new RangeError(`invalid digits: ${s}`);
      t = l;
    }
    return e === null && (o = new Qm(t)), f;
  }, f.projection(n).digits(t).context(e);
}
function bk(n) {
  return {
    stream: Eu(n)
  };
}
function Eu(n) {
  return function(e) {
    var t = new X0();
    for (var r in n)
      t[r] = n[r];
    return t.stream = e, t;
  };
}
function X0() {
}
X0.prototype = {
  constructor: X0,
  point: function(n, e) {
    this.stream.point(n, e);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function Ud(n, e, t) {
  var r = n.clipExtent && n.clipExtent();
  return n.scale(150).translate([0, 0]), r != null && n.clipExtent(null), Ht(t, n.stream(Ws)), e(Ws.result()), r != null && n.clipExtent(r), n;
}
function Rl(n, e, t) {
  return Ud(n, function(r) {
    var i = e[1][0] - e[0][0], o = e[1][1] - e[0][1], f = Math.min(i / (r[1][0] - r[0][0]), o / (r[1][1] - r[0][1])), s = +e[0][0] + (i - f * (r[1][0] + r[0][0])) / 2, l = +e[0][1] + (o - f * (r[1][1] + r[0][1])) / 2;
    n.scale(150 * f).translate([s, l]);
  }, t);
}
function Gd(n, e, t) {
  return Rl(n, [[0, 0], e], t);
}
function qd(n, e, t) {
  return Ud(n, function(r) {
    var i = +e, o = i / (r[1][0] - r[0][0]), f = (i - o * (r[1][0] + r[0][0])) / 2, s = -o * r[0][1];
    n.scale(150 * o).translate([f, s]);
  }, t);
}
function Wd(n, e, t) {
  return Ud(n, function(r) {
    var i = +e, o = i / (r[1][1] - r[0][1]), f = -o * r[0][0], s = (i - o * (r[1][1] + r[0][1])) / 2;
    n.scale(150 * o).translate([f, s]);
  }, t);
}
var jm = 16, wk = Sn(30 * Nn);
function ny(n, e) {
  return +e ? Tk(n, e) : xk(n);
}
function xk(n) {
  return Eu({
    point: function(e, t) {
      e = n(e, t), this.stream.point(e[0], e[1]);
    }
  });
}
function Tk(n, e) {
  function t(r, i, o, f, s, l, c, p, g, d, v, b, w, m) {
    var _ = c - r, x = p - i, A = _ * _ + x * x;
    if (A > 4 * e && w--) {
      var T = f + d, S = s + v, R = l + b, I = Re(T * T + S * S + R * R), B = it(R /= I), F = Xn(Xn(R) - 1) < Rn || Xn(o - g) < Rn ? (o + g) / 2 : rt(S, T), V = n(F, B), E = V[0], L = V[1], $ = E - r, P = L - i, k = x * $ - _ * P;
      (k * k / A > e || Xn((_ * $ + x * P) / A - 0.5) > 0.3 || f * d + s * v + l * b < wk) && (t(r, i, o, f, s, l, E, L, F, T /= I, S /= I, R, w, m), m.point(E, L), t(E, L, F, T, S, R, c, p, g, d, v, b, w, m));
    }
  }
  return function(r) {
    var i, o, f, s, l, c, p, g, d, v, b, w, m = {
      point: _,
      lineStart: x,
      lineEnd: T,
      polygonStart: function() {
        r.polygonStart(), m.lineStart = S;
      },
      polygonEnd: function() {
        r.polygonEnd(), m.lineStart = x;
      }
    };
    function _(B, F) {
      B = n(B, F), r.point(B[0], B[1]);
    }
    function x() {
      g = NaN, m.point = A, r.lineStart();
    }
    function A(B, F) {
      var V = Ui([B, F]), E = n(B, F);
      t(g, d, p, v, b, w, g = E[0], d = E[1], p = B, v = V[0], b = V[1], w = V[2], jm, r), r.point(g, d);
    }
    function T() {
      m.point = _, r.lineEnd();
    }
    function S() {
      x(), m.point = R, m.lineEnd = I;
    }
    function R(B, F) {
      A(i = B, F), o = g, f = d, s = v, l = b, c = w, m.point = A;
    }
    function I() {
      t(g, d, p, v, b, w, o, f, i, s, l, c, jm, r), m.lineEnd = T, T();
    }
    return m;
  };
}
var Ak = Eu({
  point: function(n, e) {
    this.stream.point(n * Nn, e * Nn);
  }
});
function Mk(n) {
  return Eu({
    point: function(e, t) {
      var r = n(e, t);
      return this.stream.point(r[0], r[1]);
    }
  });
}
function Sk(n, e, t, r, i) {
  function o(f, s) {
    return f *= r, s *= i, [e + n * f, t - n * s];
  }
  return o.invert = function(f, s) {
    return [(f - e) / n * r, (t - s) / n * i];
  }, o;
}
function ey(n, e, t, r, i, o) {
  if (!o)
    return Sk(n, e, t, r, i);
  var f = Sn(o), s = wn(o), l = f * n, c = s * n, p = f / n, g = s / n, d = (s * t - f * e) / n, v = (s * e + f * t) / n;
  function b(w, m) {
    return w *= r, m *= i, [l * w - c * m + e, t - c * w - l * m];
  }
  return b.invert = function(w, m) {
    return [r * (p * w - g * m + d), i * (v - g * w - p * m)];
  }, b;
}
function gr(n) {
  return Hd(function() {
    return n;
  })();
}
function Hd(n) {
  var e, t = 150, r = 480, i = 250, o = 0, f = 0, s = 0, l = 0, c = 0, p, g = 0, d = 1, v = 1, b = null, w = L0, m = null, _, x, A, T = hu, S = 0.5, R, I, B, F, V;
  function E(k) {
    return B(k[0] * Nn, k[1] * Nn);
  }
  function L(k) {
    return k = B.invert(k[0], k[1]), k && [k[0] * te, k[1] * te];
  }
  E.stream = function(k) {
    return F && V === k ? F : F = Ak(Mk(p)(w(R(T(V = k)))));
  }, E.preclip = function(k) {
    return arguments.length ? (w = k, b = void 0, P()) : w;
  }, E.postclip = function(k) {
    return arguments.length ? (T = k, m = _ = x = A = null, P()) : T;
  }, E.clipAngle = function(k) {
    return arguments.length ? (w = +k ? _b(b = k * Nn) : (b = null, L0), P()) : b * te;
  }, E.clipExtent = function(k) {
    return arguments.length ? (T = k == null ? (m = _ = x = A = null, hu) : Pl(m = +k[0][0], _ = +k[0][1], x = +k[1][0], A = +k[1][1]), P()) : m == null ? null : [[m, _], [x, A]];
  }, E.scale = function(k) {
    return arguments.length ? (t = +k, $()) : t;
  }, E.translate = function(k) {
    return arguments.length ? (r = +k[0], i = +k[1], $()) : [r, i];
  }, E.center = function(k) {
    return arguments.length ? (o = k[0] % 360 * Nn, f = k[1] % 360 * Nn, $()) : [o * te, f * te];
  }, E.rotate = function(k) {
    return arguments.length ? (s = k[0] % 360 * Nn, l = k[1] % 360 * Nn, c = k.length > 2 ? k[2] % 360 * Nn : 0, $()) : [s * te, l * te, c * te];
  }, E.angle = function(k) {
    return arguments.length ? (g = k % 360 * Nn, $()) : g * te;
  }, E.reflectX = function(k) {
    return arguments.length ? (d = k ? -1 : 1, $()) : d < 0;
  }, E.reflectY = function(k) {
    return arguments.length ? (v = k ? -1 : 1, $()) : v < 0;
  }, E.precision = function(k) {
    return arguments.length ? (R = ny(I, S = k * k), P()) : Re(S);
  }, E.fitExtent = function(k, O) {
    return Rl(E, k, O);
  }, E.fitSize = function(k, O) {
    return Gd(E, k, O);
  }, E.fitWidth = function(k, O) {
    return qd(E, k, O);
  }, E.fitHeight = function(k, O) {
    return Wd(E, k, O);
  };
  function $() {
    var k = ey(t, 0, 0, d, v, g).apply(null, e(o, f)), O = ey(t, r - k[0], i - k[1], d, v, g);
    return p = Vd(s, l, c), I = O0(e, O), B = O0(p, I), R = ny(I, S), P();
  }
  function P() {
    return F = V = null, E;
  }
  return function() {
    return e = n.apply(this, arguments), E.invert = e.invert && L, $();
  };
}
function Yd(n) {
  var e = 0, t = Wn / 3, r = Hd(n), i = r(e, t);
  return i.parallels = function(o) {
    return arguments.length ? r(e = o[0] * Nn, t = o[1] * Nn) : [e * te, t * te];
  }, i;
}
function Ek(n) {
  var e = Sn(n);
  function t(r, i) {
    return [r * e, wn(i) / e];
  }
  return t.invert = function(r, i) {
    return [r / e, it(i * e)];
  }, t;
}
function Ob(n, e) {
  var t = wn(n), r = (t + wn(e)) / 2;
  if (Xn(r) < Rn)
    return Ek(n);
  var i = 1 + t * (2 * r - t), o = Re(i) / r;
  function f(s, l) {
    var c = Re(i - 2 * r * wn(l)) / r;
    return [c * wn(s *= r), o - c * Sn(s)];
  }
  return f.invert = function(s, l) {
    var c = o - l, p = rt(s, Xn(c)) * It(c);
    return c * r < 0 && (p -= Wn * It(s) * It(c)), [p / r, it((i - (s * s + c * c) * r * r) / (2 * r))];
  }, f;
}
function Zs() {
  return Yd(Ob).scale(155.424).center([0, 33.6442]);
}
function Ib() {
  return Zs().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
function Ck(n) {
  var e = n.length;
  return {
    point: function(t, r) {
      for (var i = -1; ++i < e; )
        n[i].point(t, r);
    },
    sphere: function() {
      for (var t = -1; ++t < e; )
        n[t].sphere();
    },
    lineStart: function() {
      for (var t = -1; ++t < e; )
        n[t].lineStart();
    },
    lineEnd: function() {
      for (var t = -1; ++t < e; )
        n[t].lineEnd();
    },
    polygonStart: function() {
      for (var t = -1; ++t < e; )
        n[t].polygonStart();
    },
    polygonEnd: function() {
      for (var t = -1; ++t < e; )
        n[t].polygonEnd();
    }
  };
}
function Pk() {
  var n, e, t = Ib(), r, i = Zs().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), o, f = Zs().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), s, l, c = { point: function(d, v) {
    l = [d, v];
  } };
  function p(d) {
    var v = d[0], b = d[1];
    return l = null, r.point(v, b), l || (o.point(v, b), l) || (s.point(v, b), l);
  }
  p.invert = function(d) {
    var v = t.scale(), b = t.translate(), w = (d[0] - b[0]) / v, m = (d[1] - b[1]) / v;
    return (m >= 0.12 && m < 0.234 && w >= -0.425 && w < -0.214 ? i : m >= 0.166 && m < 0.234 && w >= -0.214 && w < -0.115 ? f : t).invert(d);
  }, p.stream = function(d) {
    return n && e === d ? n : n = Ck([t.stream(e = d), i.stream(d), f.stream(d)]);
  }, p.precision = function(d) {
    return arguments.length ? (t.precision(d), i.precision(d), f.precision(d), g()) : t.precision();
  }, p.scale = function(d) {
    return arguments.length ? (t.scale(d), i.scale(d * 0.35), f.scale(d), p.translate(t.translate())) : t.scale();
  }, p.translate = function(d) {
    if (!arguments.length)
      return t.translate();
    var v = t.scale(), b = +d[0], w = +d[1];
    return r = t.translate(d).clipExtent([[b - 0.455 * v, w - 0.238 * v], [b + 0.455 * v, w + 0.238 * v]]).stream(c), o = i.translate([b - 0.307 * v, w + 0.201 * v]).clipExtent([[b - 0.425 * v + Rn, w + 0.12 * v + Rn], [b - 0.214 * v - Rn, w + 0.234 * v - Rn]]).stream(c), s = f.translate([b - 0.205 * v, w + 0.212 * v]).clipExtent([[b - 0.214 * v + Rn, w + 0.166 * v + Rn], [b - 0.115 * v - Rn, w + 0.234 * v - Rn]]).stream(c), g();
  }, p.fitExtent = function(d, v) {
    return Rl(p, d, v);
  }, p.fitSize = function(d, v) {
    return Gd(p, d, v);
  }, p.fitWidth = function(d, v) {
    return qd(p, d, v);
  }, p.fitHeight = function(d, v) {
    return Wd(p, d, v);
  };
  function g() {
    return n = e = null, p;
  }
  return p.scale(1070);
}
function Lb(n) {
  return function(e, t) {
    var r = Sn(e), i = Sn(t), o = n(r * i);
    return o === 1 / 0 ? [2, 0] : [
      o * i * wn(e),
      o * wn(t)
    ];
  };
}
function Cu(n) {
  return function(e, t) {
    var r = Re(e * e + t * t), i = n(r), o = wn(i), f = Sn(i);
    return [
      rt(e * o, r * f),
      it(r && t * o / r)
    ];
  };
}
var Xd = Lb(function(n) {
  return Re(2 / (1 + n));
});
Xd.invert = Cu(function(n) {
  return 2 * it(n / 2);
});
function Rk() {
  return gr(Xd).scale(124.75).clipAngle(180 - 1e-3);
}
var Kd = Lb(function(n) {
  return (n = tb(n)) && n / wn(n);
});
Kd.invert = Cu(function(n) {
  return n;
});
function Nk() {
  return gr(Kd).scale(79.4188).clipAngle(180 - 1e-3);
}
function Pu(n, e) {
  return [n, Cs(Bd((ve + e) / 2))];
}
Pu.invert = function(n, e) {
  return [n, 2 * io(eb(e)) - ve];
};
function $k() {
  return Db(Pu).scale(961 / tt);
}
function Db(n) {
  var e = gr(n), t = e.center, r = e.scale, i = e.translate, o = e.clipExtent, f = null, s, l, c;
  e.scale = function(g) {
    return arguments.length ? (r(g), p()) : r();
  }, e.translate = function(g) {
    return arguments.length ? (i(g), p()) : i();
  }, e.center = function(g) {
    return arguments.length ? (t(g), p()) : t();
  }, e.clipExtent = function(g) {
    return arguments.length ? (g == null ? f = s = l = c = null : (f = +g[0][0], s = +g[0][1], l = +g[1][0], c = +g[1][1]), p()) : f == null ? null : [[f, s], [l, c]];
  };
  function p() {
    var g = Wn * r(), d = e(db(e.rotate()).invert([0, 0]));
    return o(f == null ? [[d[0] - g, d[1] - g], [d[0] + g, d[1] + g]] : n === Pu ? [[Math.max(d[0] - g, f), s], [Math.min(d[0] + g, l), c]] : [[f, Math.max(d[1] - g, s)], [l, Math.min(d[1] + g, c)]]);
  }
  return p();
}
function Ff(n) {
  return Bd((ve + n) / 2);
}
function Fb(n, e) {
  var t = Sn(n), r = n === e ? wn(n) : Cs(t / Sn(e)) / Cs(Ff(e) / Ff(n)), i = t * Oh(Ff(n), r) / r;
  if (!r)
    return Pu;
  function o(f, s) {
    i > 0 ? s < -ve + Rn && (s = -ve + Rn) : s > ve - Rn && (s = ve - Rn);
    var l = i / Oh(Ff(s), r);
    return [l * wn(r * f), i - l * Sn(r * f)];
  }
  return o.invert = function(f, s) {
    var l = i - s, c = It(r) * Re(f * f + l * l), p = rt(f, Xn(l)) * It(l);
    return l * r < 0 && (p -= Wn * It(f) * It(l)), [p / r, 2 * io(Oh(i / c, 1 / r)) - ve];
  }, o;
}
function kk() {
  return Yd(Fb).scale(109.5).parallels([30, 30]);
}
function pu(n, e) {
  return [n, e];
}
pu.invert = pu;
function Ok() {
  return gr(pu).scale(152.63);
}
function Bb(n, e) {
  var t = Sn(n), r = n === e ? wn(n) : (t - Sn(e)) / (e - n), i = t / r + n;
  if (Xn(r) < Rn)
    return pu;
  function o(f, s) {
    var l = i - s, c = r * f;
    return [l * wn(c), i - l * Sn(c)];
  }
  return o.invert = function(f, s) {
    var l = i - s, c = rt(f, Xn(l)) * It(l);
    return l * r < 0 && (c -= Wn * It(f) * It(l)), [c / r, i - It(r) * Re(f * f + l * l)];
  }, o;
}
function Ik() {
  return Yd(Bb).scale(131.154).center([0, 13.9389]);
}
var Ko = 1.340264, Zo = -0.081106, Jo = 893e-6, Qo = 3796e-6, Js = Re(3) / 2, Lk = 12;
function Zd(n, e) {
  var t = it(Js * wn(e)), r = t * t, i = r * r * r;
  return [
    n * Sn(t) / (Js * (Ko + 3 * Zo * r + i * (7 * Jo + 9 * Qo * r))),
    t * (Ko + Zo * r + i * (Jo + Qo * r))
  ];
}
Zd.invert = function(n, e) {
  for (var t = e, r = t * t, i = r * r * r, o = 0, f, s, l; o < Lk && (s = t * (Ko + Zo * r + i * (Jo + Qo * r)) - e, l = Ko + 3 * Zo * r + i * (7 * Jo + 9 * Qo * r), t -= f = s / l, r = t * t, i = r * r * r, !(Xn(f) < cu)); ++o)
    ;
  return [
    Js * n * (Ko + 3 * Zo * r + i * (7 * Jo + 9 * Qo * r)) / Sn(t),
    it(wn(t) / Js)
  ];
};
function Dk() {
  return gr(Zd).scale(177.158);
}
function Jd(n, e) {
  var t = Sn(e), r = Sn(n) * t;
  return [t * wn(n) / r, wn(e) / r];
}
Jd.invert = Cu(io);
function Fk() {
  return gr(Jd).scale(144.049).clipAngle(60);
}
function Bk() {
  var n = 1, e = 0, t = 0, r = 1, i = 1, o = 0, f, s, l = null, c, p, g, d = 1, v = 1, b = Eu({
    point: function(T, S) {
      var R = A([T, S]);
      this.stream.point(R[0], R[1]);
    }
  }), w = hu, m, _;
  function x() {
    return d = n * r, v = n * i, m = _ = null, A;
  }
  function A(T) {
    var S = T[0] * d, R = T[1] * v;
    if (o) {
      var I = R * f - S * s;
      S = S * f + R * s, R = I;
    }
    return [S + e, R + t];
  }
  return A.invert = function(T) {
    var S = T[0] - e, R = T[1] - t;
    if (o) {
      var I = R * f + S * s;
      S = S * f - R * s, R = I;
    }
    return [S / d, R / v];
  }, A.stream = function(T) {
    return m && _ === T ? m : m = b(w(_ = T));
  }, A.postclip = function(T) {
    return arguments.length ? (w = T, l = c = p = g = null, x()) : w;
  }, A.clipExtent = function(T) {
    return arguments.length ? (w = T == null ? (l = c = p = g = null, hu) : Pl(l = +T[0][0], c = +T[0][1], p = +T[1][0], g = +T[1][1]), x()) : l == null ? null : [[l, c], [p, g]];
  }, A.scale = function(T) {
    return arguments.length ? (n = +T, x()) : n;
  }, A.translate = function(T) {
    return arguments.length ? (e = +T[0], t = +T[1], x()) : [e, t];
  }, A.angle = function(T) {
    return arguments.length ? (o = T % 360 * Nn, s = wn(o), f = Sn(o), x()) : o * te;
  }, A.reflectX = function(T) {
    return arguments.length ? (r = T ? -1 : 1, x()) : r < 0;
  }, A.reflectY = function(T) {
    return arguments.length ? (i = T ? -1 : 1, x()) : i < 0;
  }, A.fitExtent = function(T, S) {
    return Rl(A, T, S);
  }, A.fitSize = function(T, S) {
    return Gd(A, T, S);
  }, A.fitWidth = function(T, S) {
    return qd(A, T, S);
  }, A.fitHeight = function(T, S) {
    return Wd(A, T, S);
  }, A;
}
function Qd(n, e) {
  var t = e * e, r = t * t;
  return [
    n * (0.8707 - 0.131979 * t + r * (-0.013791 + r * (3971e-6 * t - 1529e-6 * r))),
    e * (1.007226 + t * (0.015085 + r * (-0.044475 + 0.028874 * t - 5916e-6 * r)))
  ];
}
Qd.invert = function(n, e) {
  var t = e, r = 25, i;
  do {
    var o = t * t, f = o * o;
    t -= i = (t * (1.007226 + o * (0.015085 + f * (-0.044475 + 0.028874 * o - 5916e-6 * f))) - e) / (1.007226 + o * (0.015085 * 3 + f * (-0.044475 * 7 + 0.028874 * 9 * o - 5916e-6 * 11 * f)));
  } while (Xn(i) > Rn && --r > 0);
  return [
    n / (0.8707 + (o = t * t) * (-0.131979 + o * (-0.013791 + o * o * o * (3971e-6 - 1529e-6 * o)))),
    t
  ];
};
function zk() {
  return gr(Qd).scale(175.295);
}
function jd(n, e) {
  return [Sn(e) * wn(n), wn(e)];
}
jd.invert = Cu(it);
function Vk() {
  return gr(jd).scale(249.5).clipAngle(90 + Rn);
}
function n1(n, e) {
  var t = Sn(e), r = 1 + Sn(n) * t;
  return [t * wn(n) / r, wn(e) / r];
}
n1.invert = Cu(function(n) {
  return 2 * io(n);
});
function Uk() {
  return gr(n1).scale(250).clipAngle(142);
}
function e1(n, e) {
  return [Cs(Bd((ve + e) / 2)), -n];
}
e1.invert = function(n, e) {
  return [-e, 2 * io(eb(n)) - ve];
};
function Gk() {
  var n = Db(e1), e = n.center, t = n.rotate;
  return n.center = function(r) {
    return arguments.length ? e([-r[1], r[0]]) : (r = e(), [r[1], -r[0]]);
  }, n.rotate = function(r) {
    return arguments.length ? t([r[0], r[1], r.length > 2 ? r[2] + 90 : 90]) : (r = t(), [r[0], r[1], r[2] - 90]);
  }, t([0, 0, 90]).scale(159.155);
}
function qk(n, e) {
  return n.parent === e.parent ? 1 : 2;
}
function Wk(n) {
  return n.reduce(Hk, 0) / n.length;
}
function Hk(n, e) {
  return n + e.x;
}
function Yk(n) {
  return 1 + n.reduce(Xk, 0);
}
function Xk(n, e) {
  return Math.max(n, e.y);
}
function Kk(n) {
  for (var e; e = n.children; )
    n = e[0];
  return n;
}
function Zk(n) {
  for (var e; e = n.children; )
    n = e[e.length - 1];
  return n;
}
function Jk() {
  var n = qk, e = 1, t = 1, r = !1;
  function i(o) {
    var f, s = 0;
    o.eachAfter(function(d) {
      var v = d.children;
      v ? (d.x = Wk(v), d.y = Yk(v)) : (d.x = f ? s += n(d, f) : 0, d.y = 0, f = d);
    });
    var l = Kk(o), c = Zk(o), p = l.x - n(l, c) / 2, g = c.x + n(c, l) / 2;
    return o.eachAfter(r ? function(d) {
      d.x = (d.x - o.x) * e, d.y = (o.y - d.y) * t;
    } : function(d) {
      d.x = (d.x - p) / (g - p) * e, d.y = (1 - (o.y ? d.y / o.y : 1)) * t;
    });
  }
  return i.separation = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.size = function(o) {
    return arguments.length ? (r = !1, e = +o[0], t = +o[1], i) : r ? null : [e, t];
  }, i.nodeSize = function(o) {
    return arguments.length ? (r = !0, e = +o[0], t = +o[1], i) : r ? [e, t] : null;
  }, i;
}
function Qk(n) {
  var e = 0, t = n.children, r = t && t.length;
  if (!r)
    e = 1;
  else
    for (; --r >= 0; )
      e += t[r].value;
  n.value = e;
}
function jk() {
  return this.eachAfter(Qk);
}
function nO(n, e) {
  let t = -1;
  for (const r of this)
    n.call(e, r, ++t, this);
  return this;
}
function eO(n, e) {
  for (var t = this, r = [t], i, o, f = -1; t = r.pop(); )
    if (n.call(e, t, ++f, this), i = t.children)
      for (o = i.length - 1; o >= 0; --o)
        r.push(i[o]);
  return this;
}
function tO(n, e) {
  for (var t = this, r = [t], i = [], o, f, s, l = -1; t = r.pop(); )
    if (i.push(t), o = t.children)
      for (f = 0, s = o.length; f < s; ++f)
        r.push(o[f]);
  for (; t = i.pop(); )
    n.call(e, t, ++l, this);
  return this;
}
function rO(n, e) {
  let t = -1;
  for (const r of this)
    if (n.call(e, r, ++t, this))
      return r;
}
function iO(n) {
  return this.eachAfter(function(e) {
    for (var t = +n(e.data) || 0, r = e.children, i = r && r.length; --i >= 0; )
      t += r[i].value;
    e.value = t;
  });
}
function aO(n) {
  return this.eachBefore(function(e) {
    e.children && e.children.sort(n);
  });
}
function oO(n) {
  for (var e = this, t = uO(e, n), r = [e]; e !== t; )
    e = e.parent, r.push(e);
  for (var i = r.length; n !== t; )
    r.splice(i, 0, n), n = n.parent;
  return r;
}
function uO(n, e) {
  if (n === e)
    return n;
  var t = n.ancestors(), r = e.ancestors(), i = null;
  for (n = t.pop(), e = r.pop(); n === e; )
    i = n, n = t.pop(), e = r.pop();
  return i;
}
function fO() {
  for (var n = this, e = [n]; n = n.parent; )
    e.push(n);
  return e;
}
function sO() {
  return Array.from(this);
}
function lO() {
  var n = [];
  return this.eachBefore(function(e) {
    e.children || n.push(e);
  }), n;
}
function cO() {
  var n = this, e = [];
  return n.each(function(t) {
    t !== n && e.push({ source: t.parent, target: t });
  }), e;
}
function* hO() {
  var n = this, e, t = [n], r, i, o;
  do
    for (e = t.reverse(), t = []; n = e.pop(); )
      if (yield n, r = n.children)
        for (i = 0, o = r.length; i < o; ++i)
          t.push(r[i]);
  while (t.length);
}
function t1(n, e) {
  n instanceof Map ? (n = [void 0, n], e === void 0 && (e = gO)) : e === void 0 && (e = pO);
  for (var t = new qi(n), r, i = [t], o, f, s, l; r = i.pop(); )
    if ((f = e(r.data)) && (l = (f = Array.from(f)).length))
      for (r.children = f, s = l - 1; s >= 0; --s)
        i.push(o = f[s] = new qi(f[s])), o.parent = r, o.depth = r.depth + 1;
  return t.eachBefore(zb);
}
function dO() {
  return t1(this).eachBefore(vO);
}
function pO(n) {
  return n.children;
}
function gO(n) {
  return Array.isArray(n) ? n[1] : null;
}
function vO(n) {
  n.data.value !== void 0 && (n.value = n.data.value), n.data = n.data.data;
}
function zb(n) {
  var e = 0;
  do
    n.height = e;
  while ((n = n.parent) && n.height < ++e);
}
function qi(n) {
  this.data = n, this.depth = this.height = 0, this.parent = null;
}
qi.prototype = t1.prototype = {
  constructor: qi,
  count: jk,
  each: nO,
  eachAfter: tO,
  eachBefore: eO,
  find: rO,
  sum: iO,
  sort: aO,
  path: oO,
  ancestors: fO,
  descendants: sO,
  leaves: lO,
  links: cO,
  copy: dO,
  [Symbol.iterator]: hO
};
function as(n) {
  return n == null ? null : Vb(n);
}
function Vb(n) {
  if (typeof n != "function")
    throw new Error();
  return n;
}
function Pi() {
  return 0;
}
function Ca(n) {
  return function() {
    return n;
  };
}
const mO = 1664525, yO = 1013904223, ty = 4294967296;
function r1() {
  let n = 1;
  return () => (n = (mO * n + yO) % ty) / ty;
}
function _O(n) {
  return typeof n == "object" && "length" in n ? n : Array.from(n);
}
function bO(n, e) {
  let t = n.length, r, i;
  for (; t; )
    i = e() * t-- | 0, r = n[t], n[t] = n[i], n[i] = r;
  return n;
}
function wO(n) {
  return Ub(n, r1());
}
function Ub(n, e) {
  for (var t = 0, r = (n = bO(Array.from(n), e)).length, i = [], o, f; t < r; )
    o = n[t], f && Gb(f, o) ? ++t : (f = TO(i = xO(i, o)), t = 0);
  return f;
}
function xO(n, e) {
  var t, r;
  if (Bh(e, n))
    return [e];
  for (t = 0; t < n.length; ++t)
    if (Bf(e, n[t]) && Bh(qo(n[t], e), n))
      return [n[t], e];
  for (t = 0; t < n.length - 1; ++t)
    for (r = t + 1; r < n.length; ++r)
      if (Bf(qo(n[t], n[r]), e) && Bf(qo(n[t], e), n[r]) && Bf(qo(n[r], e), n[t]) && Bh(qb(n[t], n[r], e), n))
        return [n[t], n[r], e];
  throw new Error();
}
function Bf(n, e) {
  var t = n.r - e.r, r = e.x - n.x, i = e.y - n.y;
  return t < 0 || t * t < r * r + i * i;
}
function Gb(n, e) {
  var t = n.r - e.r + Math.max(n.r, e.r, 1) * 1e-9, r = e.x - n.x, i = e.y - n.y;
  return t > 0 && t * t > r * r + i * i;
}
function Bh(n, e) {
  for (var t = 0; t < e.length; ++t)
    if (!Gb(n, e[t]))
      return !1;
  return !0;
}
function TO(n) {
  switch (n.length) {
    case 1:
      return AO(n[0]);
    case 2:
      return qo(n[0], n[1]);
    case 3:
      return qb(n[0], n[1], n[2]);
  }
}
function AO(n) {
  return {
    x: n.x,
    y: n.y,
    r: n.r
  };
}
function qo(n, e) {
  var t = n.x, r = n.y, i = n.r, o = e.x, f = e.y, s = e.r, l = o - t, c = f - r, p = s - i, g = Math.sqrt(l * l + c * c);
  return {
    x: (t + o + l / g * p) / 2,
    y: (r + f + c / g * p) / 2,
    r: (g + i + s) / 2
  };
}
function qb(n, e, t) {
  var r = n.x, i = n.y, o = n.r, f = e.x, s = e.y, l = e.r, c = t.x, p = t.y, g = t.r, d = r - f, v = r - c, b = i - s, w = i - p, m = l - o, _ = g - o, x = r * r + i * i - o * o, A = x - f * f - s * s + l * l, T = x - c * c - p * p + g * g, S = v * b - d * w, R = (b * T - w * A) / (S * 2) - r, I = (w * m - b * _) / S, B = (v * A - d * T) / (S * 2) - i, F = (d * _ - v * m) / S, V = I * I + F * F - 1, E = 2 * (o + R * I + B * F), L = R * R + B * B - o * o, $ = -(Math.abs(V) > 1e-6 ? (E + Math.sqrt(E * E - 4 * V * L)) / (2 * V) : L / E);
  return {
    x: r + R + I * $,
    y: i + B + F * $,
    r: $
  };
}
function ry(n, e, t) {
  var r = n.x - e.x, i, o, f = n.y - e.y, s, l, c = r * r + f * f;
  c ? (o = e.r + t.r, o *= o, l = n.r + t.r, l *= l, o > l ? (i = (c + l - o) / (2 * c), s = Math.sqrt(Math.max(0, l / c - i * i)), t.x = n.x - i * r - s * f, t.y = n.y - i * f + s * r) : (i = (c + o - l) / (2 * c), s = Math.sqrt(Math.max(0, o / c - i * i)), t.x = e.x + i * r - s * f, t.y = e.y + i * f + s * r)) : (t.x = e.x + t.r, t.y = e.y);
}
function iy(n, e) {
  var t = n.r + e.r - 1e-6, r = e.x - n.x, i = e.y - n.y;
  return t > 0 && t * t > r * r + i * i;
}
function ay(n) {
  var e = n._, t = n.next._, r = e.r + t.r, i = (e.x * t.r + t.x * e.r) / r, o = (e.y * t.r + t.y * e.r) / r;
  return i * i + o * o;
}
function zf(n) {
  this._ = n, this.next = null, this.previous = null;
}
function Wb(n, e) {
  if (!(o = (n = _O(n)).length))
    return 0;
  var t, r, i, o, f, s, l, c, p, g, d;
  if (t = n[0], t.x = 0, t.y = 0, !(o > 1))
    return t.r;
  if (r = n[1], t.x = -r.r, r.x = t.r, r.y = 0, !(o > 2))
    return t.r + r.r;
  ry(r, t, i = n[2]), t = new zf(t), r = new zf(r), i = new zf(i), t.next = i.previous = r, r.next = t.previous = i, i.next = r.previous = t;
  n:
    for (l = 3; l < o; ++l) {
      ry(t._, r._, i = n[l]), i = new zf(i), c = r.next, p = t.previous, g = r._.r, d = t._.r;
      do
        if (g <= d) {
          if (iy(c._, i._)) {
            r = c, t.next = r, r.previous = t, --l;
            continue n;
          }
          g += c._.r, c = c.next;
        } else {
          if (iy(p._, i._)) {
            t = p, t.next = r, r.previous = t, --l;
            continue n;
          }
          d += p._.r, p = p.previous;
        }
      while (c !== p.next);
      for (i.previous = t, i.next = r, t.next = r.previous = r = i, f = ay(t); (i = i.next) !== r; )
        (s = ay(i)) < f && (t = i, f = s);
      r = t.next;
    }
  for (t = [r._], i = r; (i = i.next) !== r; )
    t.push(i._);
  for (i = Ub(t, e), l = 0; l < o; ++l)
    t = n[l], t.x -= i.x, t.y -= i.y;
  return i.r;
}
function MO(n) {
  return Wb(n, r1()), n;
}
function SO(n) {
  return Math.sqrt(n.value);
}
function EO() {
  var n = null, e = 1, t = 1, r = Pi;
  function i(o) {
    const f = r1();
    return o.x = e / 2, o.y = t / 2, n ? o.eachBefore(oy(n)).eachAfter(zh(r, 0.5, f)).eachBefore(uy(1)) : o.eachBefore(oy(SO)).eachAfter(zh(Pi, 1, f)).eachAfter(zh(r, o.r / Math.min(e, t), f)).eachBefore(uy(Math.min(e, t) / (2 * o.r))), o;
  }
  return i.radius = function(o) {
    return arguments.length ? (n = as(o), i) : n;
  }, i.size = function(o) {
    return arguments.length ? (e = +o[0], t = +o[1], i) : [e, t];
  }, i.padding = function(o) {
    return arguments.length ? (r = typeof o == "function" ? o : Ca(+o), i) : r;
  }, i;
}
function oy(n) {
  return function(e) {
    e.children || (e.r = Math.max(0, +n(e) || 0));
  };
}
function zh(n, e, t) {
  return function(r) {
    if (i = r.children) {
      var i, o, f = i.length, s = n(r) * e || 0, l;
      if (s)
        for (o = 0; o < f; ++o)
          i[o].r += s;
      if (l = Wb(i, t), s)
        for (o = 0; o < f; ++o)
          i[o].r -= s;
      r.r = l + s;
    }
  };
}
function uy(n) {
  return function(e) {
    var t = e.parent;
    e.r *= n, t && (e.x = t.x + n * e.x, e.y = t.y + n * e.y);
  };
}
function Hb(n) {
  n.x0 = Math.round(n.x0), n.y0 = Math.round(n.y0), n.x1 = Math.round(n.x1), n.y1 = Math.round(n.y1);
}
function Ru(n, e, t, r, i) {
  for (var o = n.children, f, s = -1, l = o.length, c = n.value && (r - e) / n.value; ++s < l; )
    f = o[s], f.y0 = t, f.y1 = i, f.x0 = e, f.x1 = e += f.value * c;
}
function CO() {
  var n = 1, e = 1, t = 0, r = !1;
  function i(f) {
    var s = f.height + 1;
    return f.x0 = f.y0 = t, f.x1 = n, f.y1 = e / s, f.eachBefore(o(e, s)), r && f.eachBefore(Hb), f;
  }
  function o(f, s) {
    return function(l) {
      l.children && Ru(l, l.x0, f * (l.depth + 1) / s, l.x1, f * (l.depth + 2) / s);
      var c = l.x0, p = l.y0, g = l.x1 - t, d = l.y1 - t;
      g < c && (c = g = (c + g) / 2), d < p && (p = d = (p + d) / 2), l.x0 = c, l.y0 = p, l.x1 = g, l.y1 = d;
    };
  }
  return i.round = function(f) {
    return arguments.length ? (r = !!f, i) : r;
  }, i.size = function(f) {
    return arguments.length ? (n = +f[0], e = +f[1], i) : [n, e];
  }, i.padding = function(f) {
    return arguments.length ? (t = +f, i) : t;
  }, i;
}
var PO = { depth: -1 }, fy = {}, Vh = {};
function RO(n) {
  return n.id;
}
function NO(n) {
  return n.parentId;
}
function $O() {
  var n = RO, e = NO, t;
  function r(i) {
    var o = Array.from(i), f = n, s = e, l, c, p, g, d, v, b, w, m = /* @__PURE__ */ new Map();
    if (t != null) {
      const _ = o.map((T, S) => kO(t(T, S, i))), x = _.map(sy), A = new Set(_).add("");
      for (const T of x)
        A.has(T) || (A.add(T), _.push(T), x.push(sy(T)), o.push(Vh));
      f = (T, S) => _[S], s = (T, S) => x[S];
    }
    for (p = 0, l = o.length; p < l; ++p)
      c = o[p], v = o[p] = new qi(c), (b = f(c, p, i)) != null && (b += "") && (w = v.id = b, m.set(w, m.has(w) ? fy : v)), (b = s(c, p, i)) != null && (b += "") && (v.parent = b);
    for (p = 0; p < l; ++p)
      if (v = o[p], b = v.parent) {
        if (d = m.get(b), !d)
          throw new Error("missing: " + b);
        if (d === fy)
          throw new Error("ambiguous: " + b);
        d.children ? d.children.push(v) : d.children = [v], v.parent = d;
      } else {
        if (g)
          throw new Error("multiple roots");
        g = v;
      }
    if (!g)
      throw new Error("no root");
    if (t != null) {
      for (; g.data === Vh && g.children.length === 1; )
        g = g.children[0], --l;
      for (let _ = o.length - 1; _ >= 0 && (v = o[_], v.data === Vh); --_)
        v.data = null;
    }
    if (g.parent = PO, g.eachBefore(function(_) {
      _.depth = _.parent.depth + 1, --l;
    }).eachBefore(zb), g.parent = null, l > 0)
      throw new Error("cycle");
    return g;
  }
  return r.id = function(i) {
    return arguments.length ? (n = as(i), r) : n;
  }, r.parentId = function(i) {
    return arguments.length ? (e = as(i), r) : e;
  }, r.path = function(i) {
    return arguments.length ? (t = as(i), r) : t;
  }, r;
}
function kO(n) {
  n = `${n}`;
  let e = n.length;
  return K0(n, e - 1) && !K0(n, e - 2) && (n = n.slice(0, -1)), n[0] === "/" ? n : `/${n}`;
}
function sy(n) {
  let e = n.length;
  if (e < 2)
    return "";
  for (; --e > 1 && !K0(n, e); )
    ;
  return n.slice(0, e);
}
function K0(n, e) {
  if (n[e] === "/") {
    let t = 0;
    for (; e > 0 && n[--e] === "\\"; )
      ++t;
    if (!(t & 1))
      return !0;
  }
  return !1;
}
function OO(n, e) {
  return n.parent === e.parent ? 1 : 2;
}
function Uh(n) {
  var e = n.children;
  return e ? e[0] : n.t;
}
function Gh(n) {
  var e = n.children;
  return e ? e[e.length - 1] : n.t;
}
function IO(n, e, t) {
  var r = t / (e.i - n.i);
  e.c -= r, e.s += t, n.c += r, e.z += t, e.m += t;
}
function LO(n) {
  for (var e = 0, t = 0, r = n.children, i = r.length, o; --i >= 0; )
    o = r[i], o.z += e, o.m += e, e += o.s + (t += o.c);
}
function DO(n, e, t) {
  return n.a.parent === e.parent ? n.a : t;
}
function os(n, e) {
  this._ = n, this.parent = null, this.children = null, this.A = null, this.a = this, this.z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = e;
}
os.prototype = Object.create(qi.prototype);
function FO(n) {
  for (var e = new os(n, 0), t, r = [e], i, o, f, s; t = r.pop(); )
    if (o = t._.children)
      for (t.children = new Array(s = o.length), f = s - 1; f >= 0; --f)
        r.push(i = t.children[f] = new os(o[f], f)), i.parent = t;
  return (e.parent = new os(null, 0)).children = [e], e;
}
function BO() {
  var n = OO, e = 1, t = 1, r = null;
  function i(c) {
    var p = FO(c);
    if (p.eachAfter(o), p.parent.m = -p.z, p.eachBefore(f), r)
      c.eachBefore(l);
    else {
      var g = c, d = c, v = c;
      c.eachBefore(function(x) {
        x.x < g.x && (g = x), x.x > d.x && (d = x), x.depth > v.depth && (v = x);
      });
      var b = g === d ? 1 : n(g, d) / 2, w = b - g.x, m = e / (d.x + b + w), _ = t / (v.depth || 1);
      c.eachBefore(function(x) {
        x.x = (x.x + w) * m, x.y = x.depth * _;
      });
    }
    return c;
  }
  function o(c) {
    var p = c.children, g = c.parent.children, d = c.i ? g[c.i - 1] : null;
    if (p) {
      LO(c);
      var v = (p[0].z + p[p.length - 1].z) / 2;
      d ? (c.z = d.z + n(c._, d._), c.m = c.z - v) : c.z = v;
    } else
      d && (c.z = d.z + n(c._, d._));
    c.parent.A = s(c, d, c.parent.A || g[0]);
  }
  function f(c) {
    c._.x = c.z + c.parent.m, c.m += c.parent.m;
  }
  function s(c, p, g) {
    if (p) {
      for (var d = c, v = c, b = p, w = d.parent.children[0], m = d.m, _ = v.m, x = b.m, A = w.m, T; b = Gh(b), d = Uh(d), b && d; )
        w = Uh(w), v = Gh(v), v.a = c, T = b.z + x - d.z - m + n(b._, d._), T > 0 && (IO(DO(b, c, g), c, T), m += T, _ += T), x += b.m, m += d.m, A += w.m, _ += v.m;
      b && !Gh(v) && (v.t = b, v.m += x - _), d && !Uh(w) && (w.t = d, w.m += m - A, g = c);
    }
    return g;
  }
  function l(c) {
    c.x *= e, c.y = c.depth * t;
  }
  return i.separation = function(c) {
    return arguments.length ? (n = c, i) : n;
  }, i.size = function(c) {
    return arguments.length ? (r = !1, e = +c[0], t = +c[1], i) : r ? null : [e, t];
  }, i.nodeSize = function(c) {
    return arguments.length ? (r = !0, e = +c[0], t = +c[1], i) : r ? [e, t] : null;
  }, i;
}
function Nl(n, e, t, r, i) {
  for (var o = n.children, f, s = -1, l = o.length, c = n.value && (i - t) / n.value; ++s < l; )
    f = o[s], f.x0 = e, f.x1 = r, f.y0 = t, f.y1 = t += f.value * c;
}
var Yb = (1 + Math.sqrt(5)) / 2;
function Xb(n, e, t, r, i, o) {
  for (var f = [], s = e.children, l, c, p = 0, g = 0, d = s.length, v, b, w = e.value, m, _, x, A, T, S, R; p < d; ) {
    v = i - t, b = o - r;
    do
      m = s[g++].value;
    while (!m && g < d);
    for (_ = x = m, S = Math.max(b / v, v / b) / (w * n), R = m * m * S, T = Math.max(x / R, R / _); g < d; ++g) {
      if (m += c = s[g].value, c < _ && (_ = c), c > x && (x = c), R = m * m * S, A = Math.max(x / R, R / _), A > T) {
        m -= c;
        break;
      }
      T = A;
    }
    f.push(l = { value: m, dice: v < b, children: s.slice(p, g) }), l.dice ? Ru(l, t, r, i, w ? r += b * m / w : o) : Nl(l, t, r, w ? t += v * m / w : i, o), w -= m, p = g;
  }
  return f;
}
const Kb = function n(e) {
  function t(r, i, o, f, s) {
    Xb(e, r, i, o, f, s);
  }
  return t.ratio = function(r) {
    return n((r = +r) > 1 ? r : 1);
  }, t;
}(Yb);
function zO() {
  var n = Kb, e = !1, t = 1, r = 1, i = [0], o = Pi, f = Pi, s = Pi, l = Pi, c = Pi;
  function p(d) {
    return d.x0 = d.y0 = 0, d.x1 = t, d.y1 = r, d.eachBefore(g), i = [0], e && d.eachBefore(Hb), d;
  }
  function g(d) {
    var v = i[d.depth], b = d.x0 + v, w = d.y0 + v, m = d.x1 - v, _ = d.y1 - v;
    m < b && (b = m = (b + m) / 2), _ < w && (w = _ = (w + _) / 2), d.x0 = b, d.y0 = w, d.x1 = m, d.y1 = _, d.children && (v = i[d.depth + 1] = o(d) / 2, b += c(d) - v, w += f(d) - v, m -= s(d) - v, _ -= l(d) - v, m < b && (b = m = (b + m) / 2), _ < w && (w = _ = (w + _) / 2), n(d, b, w, m, _));
  }
  return p.round = function(d) {
    return arguments.length ? (e = !!d, p) : e;
  }, p.size = function(d) {
    return arguments.length ? (t = +d[0], r = +d[1], p) : [t, r];
  }, p.tile = function(d) {
    return arguments.length ? (n = Vb(d), p) : n;
  }, p.padding = function(d) {
    return arguments.length ? p.paddingInner(d).paddingOuter(d) : p.paddingInner();
  }, p.paddingInner = function(d) {
    return arguments.length ? (o = typeof d == "function" ? d : Ca(+d), p) : o;
  }, p.paddingOuter = function(d) {
    return arguments.length ? p.paddingTop(d).paddingRight(d).paddingBottom(d).paddingLeft(d) : p.paddingTop();
  }, p.paddingTop = function(d) {
    return arguments.length ? (f = typeof d == "function" ? d : Ca(+d), p) : f;
  }, p.paddingRight = function(d) {
    return arguments.length ? (s = typeof d == "function" ? d : Ca(+d), p) : s;
  }, p.paddingBottom = function(d) {
    return arguments.length ? (l = typeof d == "function" ? d : Ca(+d), p) : l;
  }, p.paddingLeft = function(d) {
    return arguments.length ? (c = typeof d == "function" ? d : Ca(+d), p) : c;
  }, p;
}
function VO(n, e, t, r, i) {
  var o = n.children, f, s = o.length, l, c = new Array(s + 1);
  for (c[0] = l = f = 0; f < s; ++f)
    c[f + 1] = l += o[f].value;
  p(0, s, n.value, e, t, r, i);
  function p(g, d, v, b, w, m, _) {
    if (g >= d - 1) {
      var x = o[g];
      x.x0 = b, x.y0 = w, x.x1 = m, x.y1 = _;
      return;
    }
    for (var A = c[g], T = v / 2 + A, S = g + 1, R = d - 1; S < R; ) {
      var I = S + R >>> 1;
      c[I] < T ? S = I + 1 : R = I;
    }
    T - c[S - 1] < c[S] - T && g + 1 < S && --S;
    var B = c[S] - A, F = v - B;
    if (m - b > _ - w) {
      var V = v ? (b * F + m * B) / v : m;
      p(g, S, B, b, w, V, _), p(S, d, F, V, w, m, _);
    } else {
      var E = v ? (w * F + _ * B) / v : _;
      p(g, S, B, b, w, m, E), p(S, d, F, b, E, m, _);
    }
  }
}
function UO(n, e, t, r, i) {
  (n.depth & 1 ? Nl : Ru)(n, e, t, r, i);
}
const GO = function n(e) {
  function t(r, i, o, f, s) {
    if ((l = r._squarify) && l.ratio === e)
      for (var l, c, p, g, d = -1, v, b = l.length, w = r.value; ++d < b; ) {
        for (c = l[d], p = c.children, g = c.value = 0, v = p.length; g < v; ++g)
          c.value += p[g].value;
        c.dice ? Ru(c, i, o, f, w ? o += (s - o) * c.value / w : s) : Nl(c, i, o, w ? i += (f - i) * c.value / w : f, s), w -= c.value;
      }
    else
      r._squarify = l = Xb(e, r, i, o, f, s), l.ratio = e;
  }
  return t.ratio = function(r) {
    return n((r = +r) > 1 ? r : 1);
  }, t;
}(Yb);
function qO(n) {
  for (var e = -1, t = n.length, r, i = n[t - 1], o = 0; ++e < t; )
    r = i, i = n[e], o += r[1] * i[0] - r[0] * i[1];
  return o / 2;
}
function WO(n) {
  for (var e = -1, t = n.length, r = 0, i = 0, o, f = n[t - 1], s, l = 0; ++e < t; )
    o = f, f = n[e], l += s = o[0] * f[1] - f[0] * o[1], r += (o[0] + f[0]) * s, i += (o[1] + f[1]) * s;
  return l *= 3, [r / l, i / l];
}
function HO(n, e, t) {
  return (e[0] - n[0]) * (t[1] - n[1]) - (e[1] - n[1]) * (t[0] - n[0]);
}
function YO(n, e) {
  return n[0] - e[0] || n[1] - e[1];
}
function ly(n) {
  const e = n.length, t = [0, 1];
  let r = 2, i;
  for (i = 2; i < e; ++i) {
    for (; r > 1 && HO(n[t[r - 2]], n[t[r - 1]], n[i]) <= 0; )
      --r;
    t[r++] = i;
  }
  return t.slice(0, r);
}
function XO(n) {
  if ((t = n.length) < 3)
    return null;
  var e, t, r = new Array(t), i = new Array(t);
  for (e = 0; e < t; ++e)
    r[e] = [+n[e][0], +n[e][1], e];
  for (r.sort(YO), e = 0; e < t; ++e)
    i[e] = [r[e][0], -r[e][1]];
  var o = ly(r), f = ly(i), s = f[0] === o[0], l = f[f.length - 1] === o[o.length - 1], c = [];
  for (e = o.length - 1; e >= 0; --e)
    c.push(n[r[o[e]][2]]);
  for (e = +s; e < f.length - l; ++e)
    c.push(n[r[f[e]][2]]);
  return c;
}
function KO(n, e) {
  for (var t = n.length, r = n[t - 1], i = e[0], o = e[1], f = r[0], s = r[1], l, c, p = !1, g = 0; g < t; ++g)
    r = n[g], l = r[0], c = r[1], c > o != s > o && i < (f - l) * (o - c) / (s - c) + l && (p = !p), f = l, s = c;
  return p;
}
function ZO(n) {
  for (var e = -1, t = n.length, r = n[t - 1], i, o, f = r[0], s = r[1], l = 0; ++e < t; )
    i = f, o = s, r = n[e], f = r[0], s = r[1], i -= f, o -= s, l += Math.hypot(i, o);
  return l;
}
const Ie = Math.random, JO = function n(e) {
  function t(r, i) {
    return r = r == null ? 0 : +r, i = i == null ? 1 : +i, arguments.length === 1 ? (i = r, r = 0) : i -= r, function() {
      return e() * i + r;
    };
  }
  return t.source = n, t;
}(Ie), QO = function n(e) {
  function t(r, i) {
    return arguments.length < 2 && (i = r, r = 0), r = Math.floor(r), i = Math.floor(i) - r, function() {
      return Math.floor(e() * i + r);
    };
  }
  return t.source = n, t;
}(Ie), i1 = function n(e) {
  function t(r, i) {
    var o, f;
    return r = r == null ? 0 : +r, i = i == null ? 1 : +i, function() {
      var s;
      if (o != null)
        s = o, o = null;
      else
        do
          o = e() * 2 - 1, s = e() * 2 - 1, f = o * o + s * s;
        while (!f || f > 1);
      return r + i * s * Math.sqrt(-2 * Math.log(f) / f);
    };
  }
  return t.source = n, t;
}(Ie), jO = function n(e) {
  var t = i1.source(e);
  function r() {
    var i = t.apply(this, arguments);
    return function() {
      return Math.exp(i());
    };
  }
  return r.source = n, r;
}(Ie), Zb = function n(e) {
  function t(r) {
    return (r = +r) <= 0 ? () => 0 : function() {
      for (var i = 0, o = r; o > 1; --o)
        i += e();
      return i + o * e();
    };
  }
  return t.source = n, t;
}(Ie), nI = function n(e) {
  var t = Zb.source(e);
  function r(i) {
    if ((i = +i) == 0)
      return e;
    var o = t(i);
    return function() {
      return o() / i;
    };
  }
  return r.source = n, r;
}(Ie), eI = function n(e) {
  function t(r) {
    return function() {
      return -Math.log1p(-e()) / r;
    };
  }
  return t.source = n, t;
}(Ie), tI = function n(e) {
  function t(r) {
    if ((r = +r) < 0)
      throw new RangeError("invalid alpha");
    return r = 1 / -r, function() {
      return Math.pow(1 - e(), r);
    };
  }
  return t.source = n, t;
}(Ie), rI = function n(e) {
  function t(r) {
    if ((r = +r) < 0 || r > 1)
      throw new RangeError("invalid p");
    return function() {
      return Math.floor(e() + r);
    };
  }
  return t.source = n, t;
}(Ie), Jb = function n(e) {
  function t(r) {
    if ((r = +r) < 0 || r > 1)
      throw new RangeError("invalid p");
    return r === 0 ? () => 1 / 0 : r === 1 ? () => 1 : (r = Math.log1p(-r), function() {
      return 1 + Math.floor(Math.log1p(-e()) / r);
    });
  }
  return t.source = n, t;
}(Ie), a1 = function n(e) {
  var t = i1.source(e)();
  function r(i, o) {
    if ((i = +i) < 0)
      throw new RangeError("invalid k");
    if (i === 0)
      return () => 0;
    if (o = o == null ? 1 : +o, i === 1)
      return () => -Math.log1p(-e()) * o;
    var f = (i < 1 ? i + 1 : i) - 1 / 3, s = 1 / (3 * Math.sqrt(f)), l = i < 1 ? () => Math.pow(e(), 1 / i) : () => 1;
    return function() {
      do {
        do
          var c = t(), p = 1 + s * c;
        while (p <= 0);
        p *= p * p;
        var g = 1 - e();
      } while (g >= 1 - 0.0331 * c * c * c * c && Math.log(g) >= 0.5 * c * c + f * (1 - p + Math.log(p)));
      return f * p * l() * o;
    };
  }
  return r.source = n, r;
}(Ie), Qb = function n(e) {
  var t = a1.source(e);
  function r(i, o) {
    var f = t(i), s = t(o);
    return function() {
      var l = f();
      return l === 0 ? 0 : l / (l + s());
    };
  }
  return r.source = n, r;
}(Ie), jb = function n(e) {
  var t = Jb.source(e), r = Qb.source(e);
  function i(o, f) {
    return o = +o, (f = +f) >= 1 ? () => o : f <= 0 ? () => 0 : function() {
      for (var s = 0, l = o, c = f; l * c > 16 && l * (1 - c) > 16; ) {
        var p = Math.floor((l + 1) * c), g = r(p, l - p + 1)();
        g <= c ? (s += p, l -= p, c = (c - g) / (1 - g)) : (l = p - 1, c /= g);
      }
      for (var d = c < 0.5, v = d ? c : 1 - c, b = t(v), w = b(), m = 0; w <= l; ++m)
        w += b();
      return s + (d ? m : l - m);
    };
  }
  return i.source = n, i;
}(Ie), iI = function n(e) {
  function t(r, i, o) {
    var f;
    return (r = +r) == 0 ? f = (s) => -Math.log(s) : (r = 1 / r, f = (s) => Math.pow(s, r)), i = i == null ? 0 : +i, o = o == null ? 1 : +o, function() {
      return i + o * f(-Math.log1p(-e()));
    };
  }
  return t.source = n, t;
}(Ie), aI = function n(e) {
  function t(r, i) {
    return r = r == null ? 0 : +r, i = i == null ? 1 : +i, function() {
      return r + i * Math.tan(Math.PI * e());
    };
  }
  return t.source = n, t;
}(Ie), oI = function n(e) {
  function t(r, i) {
    return r = r == null ? 0 : +r, i = i == null ? 1 : +i, function() {
      var o = e();
      return r + i * Math.log(o / (1 - o));
    };
  }
  return t.source = n, t;
}(Ie), uI = function n(e) {
  var t = a1.source(e), r = jb.source(e);
  function i(o) {
    return function() {
      for (var f = 0, s = o; s > 16; ) {
        var l = Math.floor(0.875 * s), c = t(l)();
        if (c > s)
          return f + r(l - 1, s / c)();
        f += l, s -= c;
      }
      for (var p = -Math.log1p(-e()), g = 0; p <= s; ++g)
        p -= Math.log1p(-e());
      return f + g;
    };
  }
  return i.source = n, i;
}(Ie), fI = 1664525, sI = 1013904223, cy = 1 / 4294967296;
function lI(n = Math.random()) {
  let e = (0 <= n && n < 1 ? n / cy : Math.abs(n)) | 0;
  return () => (e = fI * e + sI | 0, cy * (e >>> 0));
}
function Ft(n, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(n);
      break;
    default:
      this.range(e).domain(n);
      break;
  }
  return this;
}
function zr(n, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof n == "function" ? this.interpolator(n) : this.range(n);
      break;
    }
    default: {
      this.domain(n), typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
  }
  return this;
}
const Z0 = Symbol("implicit");
function o1() {
  var n = new nu(), e = [], t = [], r = Z0;
  function i(o) {
    let f = n.get(o);
    if (f === void 0) {
      if (r !== Z0)
        return r;
      n.set(o, f = e.push(o) - 1);
    }
    return t[f % t.length];
  }
  return i.domain = function(o) {
    if (!arguments.length)
      return e.slice();
    e = [], n = new nu();
    for (const f of o)
      n.has(f) || n.set(f, e.push(f) - 1);
    return i;
  }, i.range = function(o) {
    return arguments.length ? (t = Array.from(o), i) : t.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return o1(e, t).unknown(r);
  }, Ft.apply(i, arguments), i;
}
function u1() {
  var n = o1().unknown(void 0), e = n.domain, t = n.range, r = 0, i = 1, o, f, s = !1, l = 0, c = 0, p = 0.5;
  delete n.unknown;
  function g() {
    var d = e().length, v = i < r, b = v ? i : r, w = v ? r : i;
    o = (w - b) / Math.max(1, d - l + c * 2), s && (o = Math.floor(o)), b += (w - b - o * (d - l)) * p, f = o * (1 - l), s && (b = Math.round(b), f = Math.round(f));
    var m = ti(d).map(function(_) {
      return b + o * _;
    });
    return t(v ? m.reverse() : m);
  }
  return n.domain = function(d) {
    return arguments.length ? (e(d), g()) : e();
  }, n.range = function(d) {
    return arguments.length ? ([r, i] = d, r = +r, i = +i, g()) : [r, i];
  }, n.rangeRound = function(d) {
    return [r, i] = d, r = +r, i = +i, s = !0, g();
  }, n.bandwidth = function() {
    return f;
  }, n.step = function() {
    return o;
  }, n.round = function(d) {
    return arguments.length ? (s = !!d, g()) : s;
  }, n.padding = function(d) {
    return arguments.length ? (l = Math.min(1, c = +d), g()) : l;
  }, n.paddingInner = function(d) {
    return arguments.length ? (l = Math.min(1, d), g()) : l;
  }, n.paddingOuter = function(d) {
    return arguments.length ? (c = +d, g()) : c;
  }, n.align = function(d) {
    return arguments.length ? (p = Math.max(0, Math.min(1, d)), g()) : p;
  }, n.copy = function() {
    return u1(e(), [r, i]).round(s).paddingInner(l).paddingOuter(c).align(p);
  }, Ft.apply(g(), arguments);
}
function nw(n) {
  var e = n.copy;
  return n.padding = n.paddingOuter, delete n.paddingInner, delete n.paddingOuter, n.copy = function() {
    return nw(e());
  }, n;
}
function cI() {
  return nw(u1.apply(null, arguments).paddingInner(1));
}
function hI(n) {
  return function() {
    return n;
  };
}
function Qs(n) {
  return +n;
}
var hy = [0, 1];
function nt(n) {
  return n;
}
function J0(n, e) {
  return (e -= n = +n) ? function(t) {
    return (t - n) / e;
  } : hI(isNaN(e) ? NaN : 0.5);
}
function dI(n, e) {
  var t;
  return n > e && (t = n, n = e, e = t), function(r) {
    return Math.max(n, Math.min(e, r));
  };
}
function pI(n, e, t) {
  var r = n[0], i = n[1], o = e[0], f = e[1];
  return i < r ? (r = J0(i, r), o = t(f, o)) : (r = J0(r, i), o = t(o, f)), function(s) {
    return o(r(s));
  };
}
function gI(n, e, t) {
  var r = Math.min(n.length, e.length) - 1, i = new Array(r), o = new Array(r), f = -1;
  for (n[r] < n[0] && (n = n.slice().reverse(), e = e.slice().reverse()); ++f < r; )
    i[f] = J0(n[f], n[f + 1]), o[f] = t(e[f], e[f + 1]);
  return function(s) {
    var l = Yi(n, s, 1, r) - 1;
    return o[l](i[l](s));
  };
}
function Nu(n, e) {
  return e.domain(n.domain()).range(n.range()).interpolate(n.interpolate()).clamp(n.clamp()).unknown(n.unknown());
}
function $l() {
  var n = hy, e = hy, t = li, r, i, o, f = nt, s, l, c;
  function p() {
    var d = Math.min(n.length, e.length);
    return f !== nt && (f = dI(n[0], n[d - 1])), s = d > 2 ? gI : pI, l = c = null, g;
  }
  function g(d) {
    return d == null || isNaN(d = +d) ? o : (l || (l = s(n.map(r), e, t)))(r(f(d)));
  }
  return g.invert = function(d) {
    return f(i((c || (c = s(e, n.map(r), Ot)))(d)));
  }, g.domain = function(d) {
    return arguments.length ? (n = Array.from(d, Qs), p()) : n.slice();
  }, g.range = function(d) {
    return arguments.length ? (e = Array.from(d), p()) : e.slice();
  }, g.rangeRound = function(d) {
    return e = Array.from(d), t = _l, p();
  }, g.clamp = function(d) {
    return arguments.length ? (f = d ? !0 : nt, p()) : f !== nt;
  }, g.interpolate = function(d) {
    return arguments.length ? (t = d, p()) : t;
  }, g.unknown = function(d) {
    return arguments.length ? (o = d, g) : o;
  }, function(d, v) {
    return r = d, i = v, p();
  };
}
function f1() {
  return $l()(nt, nt);
}
function ew(n, e, t, r) {
  var i = gs(n, e, t), o;
  switch (r = Ha(r ?? ",f"), r.type) {
    case "s": {
      var f = Math.max(Math.abs(n), Math.abs(e));
      return r.precision == null && !isNaN(o = j_(i, f)) && (r.precision = o), Fd(r, f);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(o = nb(i, Math.max(Math.abs(n), Math.abs(e)))) && (r.precision = o - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(o = Q_(i)) && (r.precision = o - (r.type === "%") * 2);
      break;
    }
  }
  return Cl(r);
}
function ci(n) {
  var e = n.domain;
  return n.ticks = function(t) {
    var r = e();
    return Di(r[0], r[r.length - 1], t ?? 10);
  }, n.tickFormat = function(t, r) {
    var i = e();
    return ew(i[0], i[i.length - 1], t ?? 10, r);
  }, n.nice = function(t) {
    t == null && (t = 10);
    var r = e(), i = 0, o = r.length - 1, f = r[i], s = r[o], l, c, p = 10;
    for (s < f && (c = f, f = s, s = c, c = i, i = o, o = c); p-- > 0; ) {
      if (c = Fi(f, s, t), c === l)
        return r[i] = f, r[o] = s, e(r);
      if (c > 0)
        f = Math.floor(f / c) * c, s = Math.ceil(s / c) * c;
      else if (c < 0)
        f = Math.ceil(f * c) / c, s = Math.floor(s * c) / c;
      else
        break;
      l = c;
    }
    return n;
  }, n;
}
function tw() {
  var n = f1();
  return n.copy = function() {
    return Nu(n, tw());
  }, Ft.apply(n, arguments), ci(n);
}
function rw(n) {
  var e;
  function t(r) {
    return r == null || isNaN(r = +r) ? e : r;
  }
  return t.invert = t, t.domain = t.range = function(r) {
    return arguments.length ? (n = Array.from(r, Qs), t) : n.slice();
  }, t.unknown = function(r) {
    return arguments.length ? (e = r, t) : e;
  }, t.copy = function() {
    return rw(n).unknown(e);
  }, n = arguments.length ? Array.from(n, Qs) : [0, 1], ci(t);
}
function iw(n, e) {
  n = n.slice();
  var t = 0, r = n.length - 1, i = n[t], o = n[r], f;
  return o < i && (f = t, t = r, r = f, f = i, i = o, o = f), n[t] = e.floor(i), n[r] = e.ceil(o), n;
}
function dy(n) {
  return Math.log(n);
}
function py(n) {
  return Math.exp(n);
}
function vI(n) {
  return -Math.log(-n);
}
function mI(n) {
  return -Math.exp(-n);
}
function yI(n) {
  return isFinite(n) ? +("1e" + n) : n < 0 ? 0 : n;
}
function _I(n) {
  return n === 10 ? yI : n === Math.E ? Math.exp : (e) => Math.pow(n, e);
}
function bI(n) {
  return n === Math.E ? Math.log : n === 10 && Math.log10 || n === 2 && Math.log2 || (n = Math.log(n), (e) => Math.log(e) / n);
}
function gy(n) {
  return (e, t) => -n(-e, t);
}
function s1(n) {
  const e = n(dy, py), t = e.domain;
  let r = 10, i, o;
  function f() {
    return i = bI(r), o = _I(r), t()[0] < 0 ? (i = gy(i), o = gy(o), n(vI, mI)) : n(dy, py), e;
  }
  return e.base = function(s) {
    return arguments.length ? (r = +s, f()) : r;
  }, e.domain = function(s) {
    return arguments.length ? (t(s), f()) : t();
  }, e.ticks = (s) => {
    const l = t();
    let c = l[0], p = l[l.length - 1];
    const g = p < c;
    g && ([c, p] = [p, c]);
    let d = i(c), v = i(p), b, w;
    const m = s == null ? 10 : +s;
    let _ = [];
    if (!(r % 1) && v - d < m) {
      if (d = Math.floor(d), v = Math.ceil(v), c > 0) {
        for (; d <= v; ++d)
          for (b = 1; b < r; ++b)
            if (w = d < 0 ? b / o(-d) : b * o(d), !(w < c)) {
              if (w > p)
                break;
              _.push(w);
            }
      } else
        for (; d <= v; ++d)
          for (b = r - 1; b >= 1; --b)
            if (w = d > 0 ? b / o(-d) : b * o(d), !(w < c)) {
              if (w > p)
                break;
              _.push(w);
            }
      _.length * 2 < m && (_ = Di(c, p, m));
    } else
      _ = Di(d, v, Math.min(v - d, m)).map(o);
    return g ? _.reverse() : _;
  }, e.tickFormat = (s, l) => {
    if (s == null && (s = 10), l == null && (l = r === 10 ? "s" : ","), typeof l != "function" && (!(r % 1) && (l = Ha(l)).precision == null && (l.trim = !0), l = Cl(l)), s === 1 / 0)
      return l;
    const c = Math.max(1, r * s / e.ticks().length);
    return (p) => {
      let g = p / o(Math.round(i(p)));
      return g * r < r - 0.5 && (g *= r), g <= c ? l(p) : "";
    };
  }, e.nice = () => t(iw(t(), {
    floor: (s) => o(Math.floor(i(s))),
    ceil: (s) => o(Math.ceil(i(s)))
  })), e;
}
function aw() {
  const n = s1($l()).domain([1, 10]);
  return n.copy = () => Nu(n, aw()).base(n.base()), Ft.apply(n, arguments), n;
}
function vy(n) {
  return function(e) {
    return Math.sign(e) * Math.log1p(Math.abs(e / n));
  };
}
function my(n) {
  return function(e) {
    return Math.sign(e) * Math.expm1(Math.abs(e)) * n;
  };
}
function l1(n) {
  var e = 1, t = n(vy(e), my(e));
  return t.constant = function(r) {
    return arguments.length ? n(vy(e = +r), my(e)) : e;
  }, ci(t);
}
function ow() {
  var n = l1($l());
  return n.copy = function() {
    return Nu(n, ow()).constant(n.constant());
  }, Ft.apply(n, arguments);
}
function yy(n) {
  return function(e) {
    return e < 0 ? -Math.pow(-e, n) : Math.pow(e, n);
  };
}
function wI(n) {
  return n < 0 ? -Math.sqrt(-n) : Math.sqrt(n);
}
function xI(n) {
  return n < 0 ? -n * n : n * n;
}
function c1(n) {
  var e = n(nt, nt), t = 1;
  function r() {
    return t === 1 ? n(nt, nt) : t === 0.5 ? n(wI, xI) : n(yy(t), yy(1 / t));
  }
  return e.exponent = function(i) {
    return arguments.length ? (t = +i, r()) : t;
  }, ci(e);
}
function h1() {
  var n = c1($l());
  return n.copy = function() {
    return Nu(n, h1()).exponent(n.exponent());
  }, Ft.apply(n, arguments), n;
}
function TI() {
  return h1.apply(null, arguments).exponent(0.5);
}
function _y(n) {
  return Math.sign(n) * n * n;
}
function AI(n) {
  return Math.sign(n) * Math.sqrt(Math.abs(n));
}
function uw() {
  var n = f1(), e = [0, 1], t = !1, r;
  function i(o) {
    var f = AI(n(o));
    return isNaN(f) ? r : t ? Math.round(f) : f;
  }
  return i.invert = function(o) {
    return n.invert(_y(o));
  }, i.domain = function(o) {
    return arguments.length ? (n.domain(o), i) : n.domain();
  }, i.range = function(o) {
    return arguments.length ? (n.range((e = Array.from(o, Qs)).map(_y)), i) : e.slice();
  }, i.rangeRound = function(o) {
    return i.range(o).round(!0);
  }, i.round = function(o) {
    return arguments.length ? (t = !!o, i) : t;
  }, i.clamp = function(o) {
    return arguments.length ? (n.clamp(o), i) : n.clamp();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return uw(n.domain(), e).round(t).clamp(n.clamp()).unknown(r);
  }, Ft.apply(i, arguments), ci(i);
}
function fw() {
  var n = [], e = [], t = [], r;
  function i() {
    var f = 0, s = Math.max(1, e.length);
    for (t = new Array(s - 1); ++f < s; )
      t[f - 1] = L2(n, f / s);
    return o;
  }
  function o(f) {
    return f == null || isNaN(f = +f) ? r : e[Yi(t, f)];
  }
  return o.invertExtent = function(f) {
    var s = e.indexOf(f);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? t[s - 1] : n[0],
      s < t.length ? t[s] : n[n.length - 1]
    ];
  }, o.domain = function(f) {
    if (!arguments.length)
      return n.slice();
    n = [];
    for (let s of f)
      s != null && !isNaN(s = +s) && n.push(s);
    return n.sort(de), i();
  }, o.range = function(f) {
    return arguments.length ? (e = Array.from(f), i()) : e.slice();
  }, o.unknown = function(f) {
    return arguments.length ? (r = f, o) : r;
  }, o.quantiles = function() {
    return t.slice();
  }, o.copy = function() {
    return fw().domain(n).range(e).unknown(r);
  }, Ft.apply(o, arguments);
}
function sw() {
  var n = 0, e = 1, t = 1, r = [0.5], i = [0, 1], o;
  function f(l) {
    return l != null && l <= l ? i[Yi(r, l, 0, t)] : o;
  }
  function s() {
    var l = -1;
    for (r = new Array(t); ++l < t; )
      r[l] = ((l + 1) * e - (l - t) * n) / (t + 1);
    return f;
  }
  return f.domain = function(l) {
    return arguments.length ? ([n, e] = l, n = +n, e = +e, s()) : [n, e];
  }, f.range = function(l) {
    return arguments.length ? (t = (i = Array.from(l)).length - 1, s()) : i.slice();
  }, f.invertExtent = function(l) {
    var c = i.indexOf(l);
    return c < 0 ? [NaN, NaN] : c < 1 ? [n, r[0]] : c >= t ? [r[t - 1], e] : [r[c - 1], r[c]];
  }, f.unknown = function(l) {
    return arguments.length && (o = l), f;
  }, f.thresholds = function() {
    return r.slice();
  }, f.copy = function() {
    return sw().domain([n, e]).range(i).unknown(o);
  }, Ft.apply(ci(f), arguments);
}
function lw() {
  var n = [0.5], e = [0, 1], t, r = 1;
  function i(o) {
    return o != null && o <= o ? e[Yi(n, o, 0, r)] : t;
  }
  return i.domain = function(o) {
    return arguments.length ? (n = Array.from(o), r = Math.min(n.length, e.length - 1), i) : n.slice();
  }, i.range = function(o) {
    return arguments.length ? (e = Array.from(o), r = Math.min(n.length, e.length - 1), i) : e.slice();
  }, i.invertExtent = function(o) {
    var f = e.indexOf(o);
    return [n[f - 1], n[f]];
  }, i.unknown = function(o) {
    return arguments.length ? (t = o, i) : t;
  }, i.copy = function() {
    return lw().domain(n).range(e).unknown(t);
  }, Ft.apply(i, arguments);
}
const qh = /* @__PURE__ */ new Date(), Wh = /* @__PURE__ */ new Date();
function be(n, e, t, r) {
  function i(o) {
    return n(o = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+o)), o;
  }
  return i.floor = (o) => (n(o = /* @__PURE__ */ new Date(+o)), o), i.ceil = (o) => (n(o = new Date(o - 1)), e(o, 1), n(o), o), i.round = (o) => {
    const f = i(o), s = i.ceil(o);
    return o - f < s - o ? f : s;
  }, i.offset = (o, f) => (e(o = /* @__PURE__ */ new Date(+o), f == null ? 1 : Math.floor(f)), o), i.range = (o, f, s) => {
    const l = [];
    if (o = i.ceil(o), s = s == null ? 1 : Math.floor(s), !(o < f) || !(s > 0))
      return l;
    let c;
    do
      l.push(c = /* @__PURE__ */ new Date(+o)), e(o, s), n(o);
    while (c < o && o < f);
    return l;
  }, i.filter = (o) => be((f) => {
    if (f >= f)
      for (; n(f), !o(f); )
        f.setTime(f - 1);
  }, (f, s) => {
    if (f >= f)
      if (s < 0)
        for (; ++s <= 0; )
          for (; e(f, -1), !o(f); )
            ;
      else
        for (; --s >= 0; )
          for (; e(f, 1), !o(f); )
            ;
  }), t && (i.count = (o, f) => (qh.setTime(+o), Wh.setTime(+f), n(qh), n(Wh), Math.floor(t(qh, Wh))), i.every = (o) => (o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? i.filter(r ? (f) => r(f) % o === 0 : (f) => i.count(0, f) % o === 0) : i)), i;
}
const Za = be(() => {
}, (n, e) => {
  n.setTime(+n + e);
}, (n, e) => e - n);
Za.every = (n) => (n = Math.floor(n), !isFinite(n) || !(n > 0) ? null : n > 1 ? be((e) => {
  e.setTime(Math.floor(e / n) * n);
}, (e, t) => {
  e.setTime(+e + t * n);
}, (e, t) => (t - e) / n) : Za);
const by = Za.range, kr = 1e3, Lt = kr * 60, Or = Lt * 60, Fr = Or * 24, d1 = Fr * 7, wy = Fr * 30, Hh = Fr * 365, Ir = be((n) => {
  n.setTime(n - n.getMilliseconds());
}, (n, e) => {
  n.setTime(+n + e * kr);
}, (n, e) => (e - n) / kr, (n) => n.getUTCSeconds()), xy = Ir.range, kl = be((n) => {
  n.setTime(n - n.getMilliseconds() - n.getSeconds() * kr);
}, (n, e) => {
  n.setTime(+n + e * Lt);
}, (n, e) => (e - n) / Lt, (n) => n.getMinutes()), MI = kl.range, Ol = be((n) => {
  n.setUTCSeconds(0, 0);
}, (n, e) => {
  n.setTime(+n + e * Lt);
}, (n, e) => (e - n) / Lt, (n) => n.getUTCMinutes()), SI = Ol.range, Il = be((n) => {
  n.setTime(n - n.getMilliseconds() - n.getSeconds() * kr - n.getMinutes() * Lt);
}, (n, e) => {
  n.setTime(+n + e * Or);
}, (n, e) => (e - n) / Or, (n) => n.getHours()), EI = Il.range, Ll = be((n) => {
  n.setUTCMinutes(0, 0, 0);
}, (n, e) => {
  n.setTime(+n + e * Or);
}, (n, e) => (e - n) / Or, (n) => n.getUTCHours()), CI = Ll.range, ao = be(
  (n) => n.setHours(0, 0, 0, 0),
  (n, e) => n.setDate(n.getDate() + e),
  (n, e) => (e - n - (e.getTimezoneOffset() - n.getTimezoneOffset()) * Lt) / Fr,
  (n) => n.getDate() - 1
), PI = ao.range, $u = be((n) => {
  n.setUTCHours(0, 0, 0, 0);
}, (n, e) => {
  n.setUTCDate(n.getUTCDate() + e);
}, (n, e) => (e - n) / Fr, (n) => n.getUTCDate() - 1), RI = $u.range, p1 = be((n) => {
  n.setUTCHours(0, 0, 0, 0);
}, (n, e) => {
  n.setUTCDate(n.getUTCDate() + e);
}, (n, e) => (e - n) / Fr, (n) => Math.floor(n / Fr)), NI = p1.range;
function Qi(n) {
  return be((e) => {
    e.setDate(e.getDate() - (e.getDay() + 7 - n) % 7), e.setHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setDate(e.getDate() + t * 7);
  }, (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Lt) / d1);
}
const Ja = Qi(0), gu = Qi(1), cw = Qi(2), hw = Qi(3), Wi = Qi(4), dw = Qi(5), pw = Qi(6), Ty = Ja.range, $I = gu.range, kI = cw.range, OI = hw.range, II = Wi.range, LI = dw.range, DI = pw.range;
function ji(n) {
  return be((e) => {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - n) % 7), e.setUTCHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setUTCDate(e.getUTCDate() + t * 7);
  }, (e, t) => (t - e) / d1);
}
const Qa = ji(0), vu = ji(1), gw = ji(2), vw = ji(3), Hi = ji(4), mw = ji(5), yw = ji(6), Ay = Qa.range, FI = vu.range, BI = gw.range, zI = vw.range, VI = Hi.range, UI = mw.range, GI = yw.range, Dl = be((n) => {
  n.setDate(1), n.setHours(0, 0, 0, 0);
}, (n, e) => {
  n.setMonth(n.getMonth() + e);
}, (n, e) => e.getMonth() - n.getMonth() + (e.getFullYear() - n.getFullYear()) * 12, (n) => n.getMonth()), qI = Dl.range, Fl = be((n) => {
  n.setUTCDate(1), n.setUTCHours(0, 0, 0, 0);
}, (n, e) => {
  n.setUTCMonth(n.getUTCMonth() + e);
}, (n, e) => e.getUTCMonth() - n.getUTCMonth() + (e.getUTCFullYear() - n.getUTCFullYear()) * 12, (n) => n.getUTCMonth()), WI = Fl.range, hr = be((n) => {
  n.setMonth(0, 1), n.setHours(0, 0, 0, 0);
}, (n, e) => {
  n.setFullYear(n.getFullYear() + e);
}, (n, e) => e.getFullYear() - n.getFullYear(), (n) => n.getFullYear());
hr.every = (n) => !isFinite(n = Math.floor(n)) || !(n > 0) ? null : be((e) => {
  e.setFullYear(Math.floor(e.getFullYear() / n) * n), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t * n);
});
const HI = hr.range, dr = be((n) => {
  n.setUTCMonth(0, 1), n.setUTCHours(0, 0, 0, 0);
}, (n, e) => {
  n.setUTCFullYear(n.getUTCFullYear() + e);
}, (n, e) => e.getUTCFullYear() - n.getUTCFullYear(), (n) => n.getUTCFullYear());
dr.every = (n) => !isFinite(n = Math.floor(n)) || !(n > 0) ? null : be((e) => {
  e.setUTCFullYear(Math.floor(e.getUTCFullYear() / n) * n), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t * n);
});
const YI = dr.range;
function _w(n, e, t, r, i, o) {
  const f = [
    [Ir, 1, kr],
    [Ir, 5, 5 * kr],
    [Ir, 15, 15 * kr],
    [Ir, 30, 30 * kr],
    [o, 1, Lt],
    [o, 5, 5 * Lt],
    [o, 15, 15 * Lt],
    [o, 30, 30 * Lt],
    [i, 1, Or],
    [i, 3, 3 * Or],
    [i, 6, 6 * Or],
    [i, 12, 12 * Or],
    [r, 1, Fr],
    [r, 2, 2 * Fr],
    [t, 1, d1],
    [e, 1, wy],
    [e, 3, 3 * wy],
    [n, 1, Hh]
  ];
  function s(c, p, g) {
    const d = p < c;
    d && ([c, p] = [p, c]);
    const v = g && typeof g.range == "function" ? g : l(c, p, g), b = v ? v.range(c, +p + 1) : [];
    return d ? b.reverse() : b;
  }
  function l(c, p, g) {
    const d = Math.abs(p - c) / g, v = fl(([, , m]) => m).right(f, d);
    if (v === f.length)
      return n.every(gs(c / Hh, p / Hh, g));
    if (v === 0)
      return Za.every(Math.max(gs(c, p, g), 1));
    const [b, w] = f[d / f[v - 1][2] < f[v][2] / d ? v - 1 : v];
    return b.every(w);
  }
  return [s, l];
}
const [bw, ww] = _w(dr, Fl, Qa, p1, Ll, Ol), [xw, Tw] = _w(hr, Dl, Ja, ao, Il, kl);
function Yh(n) {
  if (0 <= n.y && n.y < 100) {
    var e = new Date(-1, n.m, n.d, n.H, n.M, n.S, n.L);
    return e.setFullYear(n.y), e;
  }
  return new Date(n.y, n.m, n.d, n.H, n.M, n.S, n.L);
}
function Xh(n) {
  if (0 <= n.y && n.y < 100) {
    var e = new Date(Date.UTC(-1, n.m, n.d, n.H, n.M, n.S, n.L));
    return e.setUTCFullYear(n.y), e;
  }
  return new Date(Date.UTC(n.y, n.m, n.d, n.H, n.M, n.S, n.L));
}
function No(n, e, t) {
  return { y: n, m: e, d: t, H: 0, M: 0, S: 0, L: 0 };
}
function Aw(n) {
  var e = n.dateTime, t = n.date, r = n.time, i = n.periods, o = n.days, f = n.shortDays, s = n.months, l = n.shortMonths, c = $o(i), p = ko(i), g = $o(o), d = ko(o), v = $o(f), b = ko(f), w = $o(s), m = ko(s), _ = $o(l), x = ko(l), A = {
    a: W,
    A: K,
    b: Q,
    B: z,
    c: null,
    d: Ry,
    e: Ry,
    f: vL,
    g: SL,
    G: CL,
    H: dL,
    I: pL,
    j: gL,
    L: Mw,
    m: mL,
    M: yL,
    p: q,
    q: J,
    Q: ky,
    s: Oy,
    S: _L,
    u: bL,
    U: wL,
    V: xL,
    w: TL,
    W: AL,
    x: null,
    X: null,
    y: ML,
    Y: EL,
    Z: PL,
    "%": $y
  }, T = {
    a: en,
    A: fn,
    b: ln,
    B: Tn,
    c: null,
    d: Ny,
    e: Ny,
    f: kL,
    g: GL,
    G: WL,
    H: RL,
    I: NL,
    j: $L,
    L: Ew,
    m: OL,
    M: IL,
    p: gn,
    q: _n,
    Q: ky,
    s: Oy,
    S: LL,
    u: DL,
    U: FL,
    V: BL,
    w: zL,
    W: VL,
    x: null,
    X: null,
    y: UL,
    Y: qL,
    Z: HL,
    "%": $y
  }, S = {
    a: V,
    A: E,
    b: L,
    B: $,
    c: P,
    d: Cy,
    e: Cy,
    f: sL,
    g: Ey,
    G: Sy,
    H: Py,
    I: Py,
    j: aL,
    L: fL,
    m: iL,
    M: oL,
    p: F,
    q: rL,
    Q: cL,
    s: hL,
    S: uL,
    u: QI,
    U: jI,
    V: nL,
    w: JI,
    W: eL,
    x: k,
    X: O,
    y: Ey,
    Y: Sy,
    Z: tL,
    "%": lL
  };
  A.x = R(t, A), A.X = R(r, A), A.c = R(e, A), T.x = R(t, T), T.X = R(r, T), T.c = R(e, T);
  function R(tn, hn) {
    return function(vn) {
      var an = [], xn = -1, En = 0, In = tn.length, Ln, pn, Pn;
      for (vn instanceof Date || (vn = /* @__PURE__ */ new Date(+vn)); ++xn < In; )
        tn.charCodeAt(xn) === 37 && (an.push(tn.slice(En, xn)), (pn = My[Ln = tn.charAt(++xn)]) != null ? Ln = tn.charAt(++xn) : pn = Ln === "e" ? " " : "0", (Pn = hn[Ln]) && (Ln = Pn(vn, pn)), an.push(Ln), En = xn + 1);
      return an.push(tn.slice(En, xn)), an.join("");
    };
  }
  function I(tn, hn) {
    return function(vn) {
      var an = No(1900, void 0, 1), xn = B(an, tn, vn += "", 0), En, In;
      if (xn != vn.length)
        return null;
      if ("Q" in an)
        return new Date(an.Q);
      if ("s" in an)
        return new Date(an.s * 1e3 + ("L" in an ? an.L : 0));
      if (hn && !("Z" in an) && (an.Z = 0), "p" in an && (an.H = an.H % 12 + an.p * 12), an.m === void 0 && (an.m = "q" in an ? an.q : 0), "V" in an) {
        if (an.V < 1 || an.V > 53)
          return null;
        "w" in an || (an.w = 1), "Z" in an ? (En = Xh(No(an.y, 0, 1)), In = En.getUTCDay(), En = In > 4 || In === 0 ? vu.ceil(En) : vu(En), En = $u.offset(En, (an.V - 1) * 7), an.y = En.getUTCFullYear(), an.m = En.getUTCMonth(), an.d = En.getUTCDate() + (an.w + 6) % 7) : (En = Yh(No(an.y, 0, 1)), In = En.getDay(), En = In > 4 || In === 0 ? gu.ceil(En) : gu(En), En = ao.offset(En, (an.V - 1) * 7), an.y = En.getFullYear(), an.m = En.getMonth(), an.d = En.getDate() + (an.w + 6) % 7);
      } else
        ("W" in an || "U" in an) && ("w" in an || (an.w = "u" in an ? an.u % 7 : "W" in an ? 1 : 0), In = "Z" in an ? Xh(No(an.y, 0, 1)).getUTCDay() : Yh(No(an.y, 0, 1)).getDay(), an.m = 0, an.d = "W" in an ? (an.w + 6) % 7 + an.W * 7 - (In + 5) % 7 : an.w + an.U * 7 - (In + 6) % 7);
      return "Z" in an ? (an.H += an.Z / 100 | 0, an.M += an.Z % 100, Xh(an)) : Yh(an);
    };
  }
  function B(tn, hn, vn, an) {
    for (var xn = 0, En = hn.length, In = vn.length, Ln, pn; xn < En; ) {
      if (an >= In)
        return -1;
      if (Ln = hn.charCodeAt(xn++), Ln === 37) {
        if (Ln = hn.charAt(xn++), pn = S[Ln in My ? hn.charAt(xn++) : Ln], !pn || (an = pn(tn, vn, an)) < 0)
          return -1;
      } else if (Ln != vn.charCodeAt(an++))
        return -1;
    }
    return an;
  }
  function F(tn, hn, vn) {
    var an = c.exec(hn.slice(vn));
    return an ? (tn.p = p.get(an[0].toLowerCase()), vn + an[0].length) : -1;
  }
  function V(tn, hn, vn) {
    var an = v.exec(hn.slice(vn));
    return an ? (tn.w = b.get(an[0].toLowerCase()), vn + an[0].length) : -1;
  }
  function E(tn, hn, vn) {
    var an = g.exec(hn.slice(vn));
    return an ? (tn.w = d.get(an[0].toLowerCase()), vn + an[0].length) : -1;
  }
  function L(tn, hn, vn) {
    var an = _.exec(hn.slice(vn));
    return an ? (tn.m = x.get(an[0].toLowerCase()), vn + an[0].length) : -1;
  }
  function $(tn, hn, vn) {
    var an = w.exec(hn.slice(vn));
    return an ? (tn.m = m.get(an[0].toLowerCase()), vn + an[0].length) : -1;
  }
  function P(tn, hn, vn) {
    return B(tn, e, hn, vn);
  }
  function k(tn, hn, vn) {
    return B(tn, t, hn, vn);
  }
  function O(tn, hn, vn) {
    return B(tn, r, hn, vn);
  }
  function W(tn) {
    return f[tn.getDay()];
  }
  function K(tn) {
    return o[tn.getDay()];
  }
  function Q(tn) {
    return l[tn.getMonth()];
  }
  function z(tn) {
    return s[tn.getMonth()];
  }
  function q(tn) {
    return i[+(tn.getHours() >= 12)];
  }
  function J(tn) {
    return 1 + ~~(tn.getMonth() / 3);
  }
  function en(tn) {
    return f[tn.getUTCDay()];
  }
  function fn(tn) {
    return o[tn.getUTCDay()];
  }
  function ln(tn) {
    return l[tn.getUTCMonth()];
  }
  function Tn(tn) {
    return s[tn.getUTCMonth()];
  }
  function gn(tn) {
    return i[+(tn.getUTCHours() >= 12)];
  }
  function _n(tn) {
    return 1 + ~~(tn.getUTCMonth() / 3);
  }
  return {
    format: function(tn) {
      var hn = R(tn += "", A);
      return hn.toString = function() {
        return tn;
      }, hn;
    },
    parse: function(tn) {
      var hn = I(tn += "", !1);
      return hn.toString = function() {
        return tn;
      }, hn;
    },
    utcFormat: function(tn) {
      var hn = R(tn += "", T);
      return hn.toString = function() {
        return tn;
      }, hn;
    },
    utcParse: function(tn) {
      var hn = I(tn += "", !0);
      return hn.toString = function() {
        return tn;
      }, hn;
    }
  };
}
var My = { "-": "", _: " ", 0: "0" }, Ne = /^\s*\d+/, XI = /^%/, KI = /[\\^$*+?|[\]().{}]/g;
function Jn(n, e, t) {
  var r = n < 0 ? "-" : "", i = (r ? -n : n) + "", o = i.length;
  return r + (o < t ? new Array(t - o + 1).join(e) + i : i);
}
function ZI(n) {
  return n.replace(KI, "\\$&");
}
function $o(n) {
  return new RegExp("^(?:" + n.map(ZI).join("|") + ")", "i");
}
function ko(n) {
  return new Map(n.map((e, t) => [e.toLowerCase(), t]));
}
function JI(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 1));
  return r ? (n.w = +r[0], t + r[0].length) : -1;
}
function QI(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 1));
  return r ? (n.u = +r[0], t + r[0].length) : -1;
}
function jI(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 2));
  return r ? (n.U = +r[0], t + r[0].length) : -1;
}
function nL(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 2));
  return r ? (n.V = +r[0], t + r[0].length) : -1;
}
function eL(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 2));
  return r ? (n.W = +r[0], t + r[0].length) : -1;
}
function Sy(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 4));
  return r ? (n.y = +r[0], t + r[0].length) : -1;
}
function Ey(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 2));
  return r ? (n.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), t + r[0].length) : -1;
}
function tL(n, e, t) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(t, t + 6));
  return r ? (n.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), t + r[0].length) : -1;
}
function rL(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 1));
  return r ? (n.q = r[0] * 3 - 3, t + r[0].length) : -1;
}
function iL(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 2));
  return r ? (n.m = r[0] - 1, t + r[0].length) : -1;
}
function Cy(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 2));
  return r ? (n.d = +r[0], t + r[0].length) : -1;
}
function aL(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 3));
  return r ? (n.m = 0, n.d = +r[0], t + r[0].length) : -1;
}
function Py(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 2));
  return r ? (n.H = +r[0], t + r[0].length) : -1;
}
function oL(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 2));
  return r ? (n.M = +r[0], t + r[0].length) : -1;
}
function uL(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 2));
  return r ? (n.S = +r[0], t + r[0].length) : -1;
}
function fL(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 3));
  return r ? (n.L = +r[0], t + r[0].length) : -1;
}
function sL(n, e, t) {
  var r = Ne.exec(e.slice(t, t + 6));
  return r ? (n.L = Math.floor(r[0] / 1e3), t + r[0].length) : -1;
}
function lL(n, e, t) {
  var r = XI.exec(e.slice(t, t + 1));
  return r ? t + r[0].length : -1;
}
function cL(n, e, t) {
  var r = Ne.exec(e.slice(t));
  return r ? (n.Q = +r[0], t + r[0].length) : -1;
}
function hL(n, e, t) {
  var r = Ne.exec(e.slice(t));
  return r ? (n.s = +r[0], t + r[0].length) : -1;
}
function Ry(n, e) {
  return Jn(n.getDate(), e, 2);
}
function dL(n, e) {
  return Jn(n.getHours(), e, 2);
}
function pL(n, e) {
  return Jn(n.getHours() % 12 || 12, e, 2);
}
function gL(n, e) {
  return Jn(1 + ao.count(hr(n), n), e, 3);
}
function Mw(n, e) {
  return Jn(n.getMilliseconds(), e, 3);
}
function vL(n, e) {
  return Mw(n, e) + "000";
}
function mL(n, e) {
  return Jn(n.getMonth() + 1, e, 2);
}
function yL(n, e) {
  return Jn(n.getMinutes(), e, 2);
}
function _L(n, e) {
  return Jn(n.getSeconds(), e, 2);
}
function bL(n) {
  var e = n.getDay();
  return e === 0 ? 7 : e;
}
function wL(n, e) {
  return Jn(Ja.count(hr(n) - 1, n), e, 2);
}
function Sw(n) {
  var e = n.getDay();
  return e >= 4 || e === 0 ? Wi(n) : Wi.ceil(n);
}
function xL(n, e) {
  return n = Sw(n), Jn(Wi.count(hr(n), n) + (hr(n).getDay() === 4), e, 2);
}
function TL(n) {
  return n.getDay();
}
function AL(n, e) {
  return Jn(gu.count(hr(n) - 1, n), e, 2);
}
function ML(n, e) {
  return Jn(n.getFullYear() % 100, e, 2);
}
function SL(n, e) {
  return n = Sw(n), Jn(n.getFullYear() % 100, e, 2);
}
function EL(n, e) {
  return Jn(n.getFullYear() % 1e4, e, 4);
}
function CL(n, e) {
  var t = n.getDay();
  return n = t >= 4 || t === 0 ? Wi(n) : Wi.ceil(n), Jn(n.getFullYear() % 1e4, e, 4);
}
function PL(n) {
  var e = n.getTimezoneOffset();
  return (e > 0 ? "-" : (e *= -1, "+")) + Jn(e / 60 | 0, "0", 2) + Jn(e % 60, "0", 2);
}
function Ny(n, e) {
  return Jn(n.getUTCDate(), e, 2);
}
function RL(n, e) {
  return Jn(n.getUTCHours(), e, 2);
}
function NL(n, e) {
  return Jn(n.getUTCHours() % 12 || 12, e, 2);
}
function $L(n, e) {
  return Jn(1 + $u.count(dr(n), n), e, 3);
}
function Ew(n, e) {
  return Jn(n.getUTCMilliseconds(), e, 3);
}
function kL(n, e) {
  return Ew(n, e) + "000";
}
function OL(n, e) {
  return Jn(n.getUTCMonth() + 1, e, 2);
}
function IL(n, e) {
  return Jn(n.getUTCMinutes(), e, 2);
}
function LL(n, e) {
  return Jn(n.getUTCSeconds(), e, 2);
}
function DL(n) {
  var e = n.getUTCDay();
  return e === 0 ? 7 : e;
}
function FL(n, e) {
  return Jn(Qa.count(dr(n) - 1, n), e, 2);
}
function Cw(n) {
  var e = n.getUTCDay();
  return e >= 4 || e === 0 ? Hi(n) : Hi.ceil(n);
}
function BL(n, e) {
  return n = Cw(n), Jn(Hi.count(dr(n), n) + (dr(n).getUTCDay() === 4), e, 2);
}
function zL(n) {
  return n.getUTCDay();
}
function VL(n, e) {
  return Jn(vu.count(dr(n) - 1, n), e, 2);
}
function UL(n, e) {
  return Jn(n.getUTCFullYear() % 100, e, 2);
}
function GL(n, e) {
  return n = Cw(n), Jn(n.getUTCFullYear() % 100, e, 2);
}
function qL(n, e) {
  return Jn(n.getUTCFullYear() % 1e4, e, 4);
}
function WL(n, e) {
  var t = n.getUTCDay();
  return n = t >= 4 || t === 0 ? Hi(n) : Hi.ceil(n), Jn(n.getUTCFullYear() % 1e4, e, 4);
}
function HL() {
  return "+0000";
}
function $y() {
  return "%";
}
function ky(n) {
  return +n;
}
function Oy(n) {
  return Math.floor(+n / 1e3);
}
var Ea, g1, Pw, Bl, v1;
Rw({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function Rw(n) {
  return Ea = Aw(n), g1 = Ea.format, Pw = Ea.parse, Bl = Ea.utcFormat, v1 = Ea.utcParse, Ea;
}
var Nw = "%Y-%m-%dT%H:%M:%S.%LZ";
function YL(n) {
  return n.toISOString();
}
var XL = Date.prototype.toISOString ? YL : Bl(Nw);
const KL = XL;
function ZL(n) {
  var e = new Date(n);
  return isNaN(e) ? null : e;
}
var JL = +/* @__PURE__ */ new Date("2000-01-01T00:00:00.000Z") ? ZL : v1(Nw);
const QL = JL;
function jL(n) {
  return new Date(n);
}
function nD(n) {
  return n instanceof Date ? +n : +/* @__PURE__ */ new Date(+n);
}
function m1(n, e, t, r, i, o, f, s, l, c) {
  var p = f1(), g = p.invert, d = p.domain, v = c(".%L"), b = c(":%S"), w = c("%I:%M"), m = c("%I %p"), _ = c("%a %d"), x = c("%b %d"), A = c("%B"), T = c("%Y");
  function S(R) {
    return (l(R) < R ? v : s(R) < R ? b : f(R) < R ? w : o(R) < R ? m : r(R) < R ? i(R) < R ? _ : x : t(R) < R ? A : T)(R);
  }
  return p.invert = function(R) {
    return new Date(g(R));
  }, p.domain = function(R) {
    return arguments.length ? d(Array.from(R, nD)) : d().map(jL);
  }, p.ticks = function(R) {
    var I = d();
    return n(I[0], I[I.length - 1], R ?? 10);
  }, p.tickFormat = function(R, I) {
    return I == null ? S : c(I);
  }, p.nice = function(R) {
    var I = d();
    return (!R || typeof R.range != "function") && (R = e(I[0], I[I.length - 1], R ?? 10)), R ? d(iw(I, R)) : p;
  }, p.copy = function() {
    return Nu(p, m1(n, e, t, r, i, o, f, s, l, c));
  }, p;
}
function eD() {
  return Ft.apply(m1(xw, Tw, hr, Dl, Ja, ao, Il, kl, Ir, g1).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function tD() {
  return Ft.apply(m1(bw, ww, dr, Fl, Qa, $u, Ll, Ol, Ir, Bl).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function zl() {
  var n = 0, e = 1, t, r, i, o, f = nt, s = !1, l;
  function c(g) {
    return g == null || isNaN(g = +g) ? l : f(i === 0 ? 0.5 : (g = (o(g) - t) * i, s ? Math.max(0, Math.min(1, g)) : g));
  }
  c.domain = function(g) {
    return arguments.length ? ([n, e] = g, t = o(n = +n), r = o(e = +e), i = t === r ? 0 : 1 / (r - t), c) : [n, e];
  }, c.clamp = function(g) {
    return arguments.length ? (s = !!g, c) : s;
  }, c.interpolator = function(g) {
    return arguments.length ? (f = g, c) : f;
  };
  function p(g) {
    return function(d) {
      var v, b;
      return arguments.length ? ([v, b] = d, f = g(v, b), c) : [f(0), f(1)];
    };
  }
  return c.range = p(li), c.rangeRound = p(_l), c.unknown = function(g) {
    return arguments.length ? (l = g, c) : l;
  }, function(g) {
    return o = g, t = g(n), r = g(e), i = t === r ? 0 : 1 / (r - t), c;
  };
}
function hi(n, e) {
  return e.domain(n.domain()).interpolator(n.interpolator()).clamp(n.clamp()).unknown(n.unknown());
}
function $w() {
  var n = ci(zl()(nt));
  return n.copy = function() {
    return hi(n, $w());
  }, zr.apply(n, arguments);
}
function kw() {
  var n = s1(zl()).domain([1, 10]);
  return n.copy = function() {
    return hi(n, kw()).base(n.base());
  }, zr.apply(n, arguments);
}
function Ow() {
  var n = l1(zl());
  return n.copy = function() {
    return hi(n, Ow()).constant(n.constant());
  }, zr.apply(n, arguments);
}
function y1() {
  var n = c1(zl());
  return n.copy = function() {
    return hi(n, y1()).exponent(n.exponent());
  }, zr.apply(n, arguments);
}
function rD() {
  return y1.apply(null, arguments).exponent(0.5);
}
function Iw() {
  var n = [], e = nt;
  function t(r) {
    if (r != null && !isNaN(r = +r))
      return e((Yi(n, r, 1) - 1) / (n.length - 1));
  }
  return t.domain = function(r) {
    if (!arguments.length)
      return n.slice();
    n = [];
    for (let i of r)
      i != null && !isNaN(i = +i) && n.push(i);
    return n.sort(de), t;
  }, t.interpolator = function(r) {
    return arguments.length ? (e = r, t) : e;
  }, t.range = function() {
    return n.map((r, i) => e(i / (n.length - 1)));
  }, t.quantiles = function(r) {
    return Array.from({ length: r + 1 }, (i, o) => tu(n, o / r));
  }, t.copy = function() {
    return Iw(e).domain(n);
  }, zr.apply(t, arguments);
}
function Vl() {
  var n = 0, e = 0.5, t = 1, r = 1, i, o, f, s, l, c = nt, p, g = !1, d;
  function v(w) {
    return isNaN(w = +w) ? d : (w = 0.5 + ((w = +p(w)) - o) * (r * w < r * o ? s : l), c(g ? Math.max(0, Math.min(1, w)) : w));
  }
  v.domain = function(w) {
    return arguments.length ? ([n, e, t] = w, i = p(n = +n), o = p(e = +e), f = p(t = +t), s = i === o ? 0 : 0.5 / (o - i), l = o === f ? 0 : 0.5 / (f - o), r = o < i ? -1 : 1, v) : [n, e, t];
  }, v.clamp = function(w) {
    return arguments.length ? (g = !!w, v) : g;
  }, v.interpolator = function(w) {
    return arguments.length ? (c = w, v) : c;
  };
  function b(w) {
    return function(m) {
      var _, x, A;
      return arguments.length ? ([_, x, A] = m, c = C_(w, [_, x, A]), v) : [c(0), c(0.5), c(1)];
    };
  }
  return v.range = b(li), v.rangeRound = b(_l), v.unknown = function(w) {
    return arguments.length ? (d = w, v) : d;
  }, function(w) {
    return p = w, i = w(n), o = w(e), f = w(t), s = i === o ? 0 : 0.5 / (o - i), l = o === f ? 0 : 0.5 / (f - o), r = o < i ? -1 : 1, v;
  };
}
function Lw() {
  var n = ci(Vl()(nt));
  return n.copy = function() {
    return hi(n, Lw());
  }, zr.apply(n, arguments);
}
function Dw() {
  var n = s1(Vl()).domain([0.1, 1, 10]);
  return n.copy = function() {
    return hi(n, Dw()).base(n.base());
  }, zr.apply(n, arguments);
}
function Fw() {
  var n = l1(Vl());
  return n.copy = function() {
    return hi(n, Fw()).constant(n.constant());
  }, zr.apply(n, arguments);
}
function _1() {
  var n = c1(Vl());
  return n.copy = function() {
    return hi(n, _1()).exponent(n.exponent());
  }, zr.apply(n, arguments);
}
function iD() {
  return _1.apply(null, arguments).exponent(0.5);
}
function Vn(n) {
  for (var e = n.length / 6 | 0, t = new Array(e), r = 0; r < e; )
    t[r] = "#" + n.slice(r * 6, ++r * 6);
  return t;
}
const aD = Vn("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), oD = Vn("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"), uD = Vn("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"), fD = Vn("4269d0efb118ff725c6cc5b03ca951ff8ab7a463f297bbf59c6b4e9498a0"), sD = Vn("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"), lD = Vn("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"), cD = Vn("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"), hD = Vn("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"), dD = Vn("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"), pD = Vn("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"), gD = Vn("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab"), re = (n) => g_(n[n.length - 1]);
var Bw = new Array(3).concat(
  "d8b365f5f5f55ab4ac",
  "a6611adfc27d80cdc1018571",
  "a6611adfc27df5f5f580cdc1018571",
  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
).map(Vn);
const vD = re(Bw);
var zw = new Array(3).concat(
  "af8dc3f7f7f77fbf7b",
  "7b3294c2a5cfa6dba0008837",
  "7b3294c2a5cff7f7f7a6dba0008837",
  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
).map(Vn);
const mD = re(zw);
var Vw = new Array(3).concat(
  "e9a3c9f7f7f7a1d76a",
  "d01c8bf1b6dab8e1864dac26",
  "d01c8bf1b6daf7f7f7b8e1864dac26",
  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
).map(Vn);
const yD = re(Vw);
var Uw = new Array(3).concat(
  "998ec3f7f7f7f1a340",
  "5e3c99b2abd2fdb863e66101",
  "5e3c99b2abd2f7f7f7fdb863e66101",
  "542788998ec3d8daebfee0b6f1a340b35806",
  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
).map(Vn);
const _D = re(Uw);
var Gw = new Array(3).concat(
  "ef8a62f7f7f767a9cf",
  "ca0020f4a58292c5de0571b0",
  "ca0020f4a582f7f7f792c5de0571b0",
  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
).map(Vn);
const bD = re(Gw);
var qw = new Array(3).concat(
  "ef8a62ffffff999999",
  "ca0020f4a582bababa404040",
  "ca0020f4a582ffffffbababa404040",
  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
).map(Vn);
const wD = re(qw);
var Ww = new Array(3).concat(
  "fc8d59ffffbf91bfdb",
  "d7191cfdae61abd9e92c7bb6",
  "d7191cfdae61ffffbfabd9e92c7bb6",
  "d73027fc8d59fee090e0f3f891bfdb4575b4",
  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
).map(Vn);
const xD = re(Ww);
var Hw = new Array(3).concat(
  "fc8d59ffffbf91cf60",
  "d7191cfdae61a6d96a1a9641",
  "d7191cfdae61ffffbfa6d96a1a9641",
  "d73027fc8d59fee08bd9ef8b91cf601a9850",
  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
).map(Vn);
const TD = re(Hw);
var Yw = new Array(3).concat(
  "fc8d59ffffbf99d594",
  "d7191cfdae61abdda42b83ba",
  "d7191cfdae61ffffbfabdda42b83ba",
  "d53e4ffc8d59fee08be6f59899d5943288bd",
  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
).map(Vn);
const AD = re(Yw);
var Xw = new Array(3).concat(
  "e5f5f999d8c92ca25f",
  "edf8fbb2e2e266c2a4238b45",
  "edf8fbb2e2e266c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
).map(Vn);
const MD = re(Xw);
var Kw = new Array(3).concat(
  "e0ecf49ebcda8856a7",
  "edf8fbb3cde38c96c688419d",
  "edf8fbb3cde38c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
).map(Vn);
const SD = re(Kw);
var Zw = new Array(3).concat(
  "e0f3dba8ddb543a2ca",
  "f0f9e8bae4bc7bccc42b8cbe",
  "f0f9e8bae4bc7bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
).map(Vn);
const ED = re(Zw);
var Jw = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map(Vn);
const CD = re(Jw);
var Qw = new Array(3).concat(
  "ece2f0a6bddb1c9099",
  "f6eff7bdc9e167a9cf02818a",
  "f6eff7bdc9e167a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
).map(Vn);
const PD = re(Qw);
var jw = new Array(3).concat(
  "ece7f2a6bddb2b8cbe",
  "f1eef6bdc9e174a9cf0570b0",
  "f1eef6bdc9e174a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
).map(Vn);
const RD = re(jw);
var n3 = new Array(3).concat(
  "e7e1efc994c7dd1c77",
  "f1eef6d7b5d8df65b0ce1256",
  "f1eef6d7b5d8df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
).map(Vn);
const ND = re(n3);
var e3 = new Array(3).concat(
  "fde0ddfa9fb5c51b8a",
  "feebe2fbb4b9f768a1ae017e",
  "feebe2fbb4b9f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
).map(Vn);
const $D = re(e3);
var t3 = new Array(3).concat(
  "edf8b17fcdbb2c7fb8",
  "ffffcca1dab441b6c4225ea8",
  "ffffcca1dab441b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
).map(Vn);
const kD = re(t3);
var r3 = new Array(3).concat(
  "f7fcb9addd8e31a354",
  "ffffccc2e69978c679238443",
  "ffffccc2e69978c67931a354006837",
  "ffffccd9f0a3addd8e78c67931a354006837",
  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
).map(Vn);
const OD = re(r3);
var i3 = new Array(3).concat(
  "fff7bcfec44fd95f0e",
  "ffffd4fed98efe9929cc4c02",
  "ffffd4fed98efe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
).map(Vn);
const ID = re(i3);
var a3 = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map(Vn);
const LD = re(a3);
var o3 = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map(Vn);
const DD = re(o3);
var u3 = new Array(3).concat(
  "e5f5e0a1d99b31a354",
  "edf8e9bae4b374c476238b45",
  "edf8e9bae4b374c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
).map(Vn);
const FD = re(u3);
var f3 = new Array(3).concat(
  "f0f0f0bdbdbd636363",
  "f7f7f7cccccc969696525252",
  "f7f7f7cccccc969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
).map(Vn);
const BD = re(f3);
var s3 = new Array(3).concat(
  "efedf5bcbddc756bb1",
  "f2f0f7cbc9e29e9ac86a51a3",
  "f2f0f7cbc9e29e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
).map(Vn);
const zD = re(s3);
var l3 = new Array(3).concat(
  "fee0d2fc9272de2d26",
  "fee5d9fcae91fb6a4acb181d",
  "fee5d9fcae91fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
).map(Vn);
const VD = re(l3);
var c3 = new Array(3).concat(
  "fee6cefdae6be6550d",
  "feeddefdbe85fd8d3cd94701",
  "feeddefdbe85fd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
).map(Vn);
const UD = re(c3);
function GD(n) {
  return n = Math.max(0, Math.min(1, n)), "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - n * (35.34 - n * (2381.73 - n * (6402.7 - n * (7024.72 - n * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + n * (170.73 + n * (52.82 - n * (131.46 - n * (176.58 - n * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + n * (442.36 - n * (2482.43 - n * (6167.24 - n * (6614.94 - n * 2475.67))))))) + ")";
}
const qD = bl(Qt(300, 0.5, 0), Qt(-240, 0.5, 1));
var WD = bl(Qt(-100, 0.75, 0.35), Qt(80, 1.5, 0.8)), HD = bl(Qt(260, 0.75, 0.35), Qt(80, 1.5, 0.8)), Vf = Qt();
function YD(n) {
  (n < 0 || n > 1) && (n -= Math.floor(n));
  var e = Math.abs(n - 0.5);
  return Vf.h = 360 * n - 100, Vf.s = 1.5 - 1.5 * e, Vf.l = 0.8 - 0.9 * e, Vf + "";
}
var Uf = Ua(), XD = Math.PI / 3, KD = Math.PI * 2 / 3;
function ZD(n) {
  var e;
  return n = (0.5 - n) * Math.PI, Uf.r = 255 * (e = Math.sin(n)) * e, Uf.g = 255 * (e = Math.sin(n + XD)) * e, Uf.b = 255 * (e = Math.sin(n + KD)) * e, Uf + "";
}
function JD(n) {
  return n = Math.max(0, Math.min(1, n)), "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + n * (1172.33 - n * (10793.56 - n * (33300.12 - n * (38394.49 - n * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + n * (557.33 + n * (1225.33 - n * (3574.96 - n * (1073.77 + n * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + n * (3211.1 - n * (15327.97 - n * (27814 - n * (22569.18 - n * 6838.66))))))) + ")";
}
function Ul(n) {
  var e = n.length;
  return function(t) {
    return n[Math.max(0, Math.min(e - 1, Math.floor(t * e)))];
  };
}
const QD = Ul(Vn("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var jD = Ul(Vn("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")), nF = Ul(Vn("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")), eF = Ul(Vn("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
function zn(n) {
  return function() {
    return n;
  };
}
const Iy = Math.abs, Ve = Math.atan2, Nr = Math.cos, tF = Math.max, Fa = Math.min, ct = Math.sin, ue = Math.sqrt, Ge = 1e-12, ui = Math.PI, js = ui / 2, ii = 2 * ui;
function rF(n) {
  return n > 1 ? 0 : n < -1 ? ui : Math.acos(n);
}
function Ly(n) {
  return n >= 1 ? js : n <= -1 ? -js : Math.asin(n);
}
function ku(n) {
  let e = 3;
  return n.digits = function(t) {
    if (!arguments.length)
      return e;
    if (t == null)
      e = null;
    else {
      const r = Math.floor(t);
      if (!(r >= 0))
        throw new RangeError(`invalid digits: ${t}`);
      e = r;
    }
    return n;
  }, () => new Au(e);
}
function iF(n) {
  return n.innerRadius;
}
function aF(n) {
  return n.outerRadius;
}
function oF(n) {
  return n.startAngle;
}
function uF(n) {
  return n.endAngle;
}
function fF(n) {
  return n && n.padAngle;
}
function sF(n, e, t, r, i, o, f, s) {
  var l = t - n, c = r - e, p = f - i, g = s - o, d = g * l - p * c;
  if (!(d * d < Ge))
    return d = (p * (e - o) - g * (n - i)) / d, [n + d * l, e + d * c];
}
function Gf(n, e, t, r, i, o, f) {
  var s = n - t, l = e - r, c = (f ? o : -o) / ue(s * s + l * l), p = c * l, g = -c * s, d = n + p, v = e + g, b = t + p, w = r + g, m = (d + b) / 2, _ = (v + w) / 2, x = b - d, A = w - v, T = x * x + A * A, S = i - o, R = d * w - b * v, I = (A < 0 ? -1 : 1) * ue(tF(0, S * S * T - R * R)), B = (R * A - x * I) / T, F = (-R * x - A * I) / T, V = (R * A + x * I) / T, E = (-R * x + A * I) / T, L = B - m, $ = F - _, P = V - m, k = E - _;
  return L * L + $ * $ > P * P + k * k && (B = V, F = E), {
    cx: B,
    cy: F,
    x01: -p,
    y01: -g,
    x11: B * (i / S - 1),
    y11: F * (i / S - 1)
  };
}
function lF() {
  var n = iF, e = aF, t = zn(0), r = null, i = oF, o = uF, f = fF, s = null, l = ku(c);
  function c() {
    var p, g, d = +n.apply(this, arguments), v = +e.apply(this, arguments), b = i.apply(this, arguments) - js, w = o.apply(this, arguments) - js, m = Iy(w - b), _ = w > b;
    if (s || (s = p = l()), v < d && (g = v, v = d, d = g), !(v > Ge))
      s.moveTo(0, 0);
    else if (m > ii - Ge)
      s.moveTo(v * Nr(b), v * ct(b)), s.arc(0, 0, v, b, w, !_), d > Ge && (s.moveTo(d * Nr(w), d * ct(w)), s.arc(0, 0, d, w, b, _));
    else {
      var x = b, A = w, T = b, S = w, R = m, I = m, B = f.apply(this, arguments) / 2, F = B > Ge && (r ? +r.apply(this, arguments) : ue(d * d + v * v)), V = Fa(Iy(v - d) / 2, +t.apply(this, arguments)), E = V, L = V, $, P;
      if (F > Ge) {
        var k = Ly(F / d * ct(B)), O = Ly(F / v * ct(B));
        (R -= k * 2) > Ge ? (k *= _ ? 1 : -1, T += k, S -= k) : (R = 0, T = S = (b + w) / 2), (I -= O * 2) > Ge ? (O *= _ ? 1 : -1, x += O, A -= O) : (I = 0, x = A = (b + w) / 2);
      }
      var W = v * Nr(x), K = v * ct(x), Q = d * Nr(S), z = d * ct(S);
      if (V > Ge) {
        var q = v * Nr(A), J = v * ct(A), en = d * Nr(T), fn = d * ct(T), ln;
        if (m < ui)
          if (ln = sF(W, K, en, fn, q, J, Q, z)) {
            var Tn = W - ln[0], gn = K - ln[1], _n = q - ln[0], tn = J - ln[1], hn = 1 / ct(rF((Tn * _n + gn * tn) / (ue(Tn * Tn + gn * gn) * ue(_n * _n + tn * tn))) / 2), vn = ue(ln[0] * ln[0] + ln[1] * ln[1]);
            E = Fa(V, (d - vn) / (hn - 1)), L = Fa(V, (v - vn) / (hn + 1));
          } else
            E = L = 0;
      }
      I > Ge ? L > Ge ? ($ = Gf(en, fn, W, K, v, L, _), P = Gf(q, J, Q, z, v, L, _), s.moveTo($.cx + $.x01, $.cy + $.y01), L < V ? s.arc($.cx, $.cy, L, Ve($.y01, $.x01), Ve(P.y01, P.x01), !_) : (s.arc($.cx, $.cy, L, Ve($.y01, $.x01), Ve($.y11, $.x11), !_), s.arc(0, 0, v, Ve($.cy + $.y11, $.cx + $.x11), Ve(P.cy + P.y11, P.cx + P.x11), !_), s.arc(P.cx, P.cy, L, Ve(P.y11, P.x11), Ve(P.y01, P.x01), !_))) : (s.moveTo(W, K), s.arc(0, 0, v, x, A, !_)) : s.moveTo(W, K), !(d > Ge) || !(R > Ge) ? s.lineTo(Q, z) : E > Ge ? ($ = Gf(Q, z, q, J, d, -E, _), P = Gf(W, K, en, fn, d, -E, _), s.lineTo($.cx + $.x01, $.cy + $.y01), E < V ? s.arc($.cx, $.cy, E, Ve($.y01, $.x01), Ve(P.y01, P.x01), !_) : (s.arc($.cx, $.cy, E, Ve($.y01, $.x01), Ve($.y11, $.x11), !_), s.arc(0, 0, d, Ve($.cy + $.y11, $.cx + $.x11), Ve(P.cy + P.y11, P.cx + P.x11), _), s.arc(P.cx, P.cy, E, Ve(P.y11, P.x11), Ve(P.y01, P.x01), !_))) : s.arc(0, 0, d, S, T, _);
    }
    if (s.closePath(), p)
      return s = null, p + "" || null;
  }
  return c.centroid = function() {
    var p = (+n.apply(this, arguments) + +e.apply(this, arguments)) / 2, g = (+i.apply(this, arguments) + +o.apply(this, arguments)) / 2 - ui / 2;
    return [Nr(g) * p, ct(g) * p];
  }, c.innerRadius = function(p) {
    return arguments.length ? (n = typeof p == "function" ? p : zn(+p), c) : n;
  }, c.outerRadius = function(p) {
    return arguments.length ? (e = typeof p == "function" ? p : zn(+p), c) : e;
  }, c.cornerRadius = function(p) {
    return arguments.length ? (t = typeof p == "function" ? p : zn(+p), c) : t;
  }, c.padRadius = function(p) {
    return arguments.length ? (r = p == null ? null : typeof p == "function" ? p : zn(+p), c) : r;
  }, c.startAngle = function(p) {
    return arguments.length ? (i = typeof p == "function" ? p : zn(+p), c) : i;
  }, c.endAngle = function(p) {
    return arguments.length ? (o = typeof p == "function" ? p : zn(+p), c) : o;
  }, c.padAngle = function(p) {
    return arguments.length ? (f = typeof p == "function" ? p : zn(+p), c) : f;
  }, c.context = function(p) {
    return arguments.length ? (s = p ?? null, c) : s;
  }, c;
}
var cF = Array.prototype.slice;
function Gl(n) {
  return typeof n == "object" && "length" in n ? n : Array.from(n);
}
function h3(n) {
  this._context = n;
}
h3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, e) {
    switch (n = +n, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, e) : this._context.moveTo(n, e);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(n, e);
        break;
    }
  }
};
function ql(n) {
  return new h3(n);
}
function b1(n) {
  return n[0];
}
function w1(n) {
  return n[1];
}
function x1(n, e) {
  var t = zn(!0), r = null, i = ql, o = null, f = ku(s);
  n = typeof n == "function" ? n : n === void 0 ? b1 : zn(n), e = typeof e == "function" ? e : e === void 0 ? w1 : zn(e);
  function s(l) {
    var c, p = (l = Gl(l)).length, g, d = !1, v;
    for (r == null && (o = i(v = f())), c = 0; c <= p; ++c)
      !(c < p && t(g = l[c], c, l)) === d && ((d = !d) ? o.lineStart() : o.lineEnd()), d && o.point(+n(g, c, l), +e(g, c, l));
    if (v)
      return o = null, v + "" || null;
  }
  return s.x = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : zn(+l), s) : n;
  }, s.y = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : zn(+l), s) : e;
  }, s.defined = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : zn(!!l), s) : t;
  }, s.curve = function(l) {
    return arguments.length ? (i = l, r != null && (o = i(r)), s) : i;
  }, s.context = function(l) {
    return arguments.length ? (l == null ? r = o = null : o = i(r = l), s) : r;
  }, s;
}
function d3(n, e, t) {
  var r = null, i = zn(!0), o = null, f = ql, s = null, l = ku(c);
  n = typeof n == "function" ? n : n === void 0 ? b1 : zn(+n), e = typeof e == "function" ? e : zn(e === void 0 ? 0 : +e), t = typeof t == "function" ? t : t === void 0 ? w1 : zn(+t);
  function c(g) {
    var d, v, b, w = (g = Gl(g)).length, m, _ = !1, x, A = new Array(w), T = new Array(w);
    for (o == null && (s = f(x = l())), d = 0; d <= w; ++d) {
      if (!(d < w && i(m = g[d], d, g)) === _)
        if (_ = !_)
          v = d, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), b = d - 1; b >= v; --b)
            s.point(A[b], T[b]);
          s.lineEnd(), s.areaEnd();
        }
      _ && (A[d] = +n(m, d, g), T[d] = +e(m, d, g), s.point(r ? +r(m, d, g) : A[d], t ? +t(m, d, g) : T[d]));
    }
    if (x)
      return s = null, x + "" || null;
  }
  function p() {
    return x1().defined(i).curve(f).context(o);
  }
  return c.x = function(g) {
    return arguments.length ? (n = typeof g == "function" ? g : zn(+g), r = null, c) : n;
  }, c.x0 = function(g) {
    return arguments.length ? (n = typeof g == "function" ? g : zn(+g), c) : n;
  }, c.x1 = function(g) {
    return arguments.length ? (r = g == null ? null : typeof g == "function" ? g : zn(+g), c) : r;
  }, c.y = function(g) {
    return arguments.length ? (e = typeof g == "function" ? g : zn(+g), t = null, c) : e;
  }, c.y0 = function(g) {
    return arguments.length ? (e = typeof g == "function" ? g : zn(+g), c) : e;
  }, c.y1 = function(g) {
    return arguments.length ? (t = g == null ? null : typeof g == "function" ? g : zn(+g), c) : t;
  }, c.lineX0 = c.lineY0 = function() {
    return p().x(n).y(e);
  }, c.lineY1 = function() {
    return p().x(n).y(t);
  }, c.lineX1 = function() {
    return p().x(r).y(e);
  }, c.defined = function(g) {
    return arguments.length ? (i = typeof g == "function" ? g : zn(!!g), c) : i;
  }, c.curve = function(g) {
    return arguments.length ? (f = g, o != null && (s = f(o)), c) : f;
  }, c.context = function(g) {
    return arguments.length ? (g == null ? o = s = null : s = f(o = g), c) : o;
  }, c;
}
function hF(n, e) {
  return e < n ? -1 : e > n ? 1 : e >= n ? 0 : NaN;
}
function dF(n) {
  return n;
}
function pF() {
  var n = dF, e = hF, t = null, r = zn(0), i = zn(ii), o = zn(0);
  function f(s) {
    var l, c = (s = Gl(s)).length, p, g, d = 0, v = new Array(c), b = new Array(c), w = +r.apply(this, arguments), m = Math.min(ii, Math.max(-ii, i.apply(this, arguments) - w)), _, x = Math.min(Math.abs(m) / c, o.apply(this, arguments)), A = x * (m < 0 ? -1 : 1), T;
    for (l = 0; l < c; ++l)
      (T = b[v[l] = l] = +n(s[l], l, s)) > 0 && (d += T);
    for (e != null ? v.sort(function(S, R) {
      return e(b[S], b[R]);
    }) : t != null && v.sort(function(S, R) {
      return t(s[S], s[R]);
    }), l = 0, g = d ? (m - c * A) / d : 0; l < c; ++l, w = _)
      p = v[l], T = b[p], _ = w + (T > 0 ? T * g : 0) + A, b[p] = {
        data: s[p],
        index: l,
        value: T,
        startAngle: w,
        endAngle: _,
        padAngle: x
      };
    return b;
  }
  return f.value = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : zn(+s), f) : n;
  }, f.sortValues = function(s) {
    return arguments.length ? (e = s, t = null, f) : e;
  }, f.sort = function(s) {
    return arguments.length ? (t = s, e = null, f) : t;
  }, f.startAngle = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : zn(+s), f) : r;
  }, f.endAngle = function(s) {
    return arguments.length ? (i = typeof s == "function" ? s : zn(+s), f) : i;
  }, f.padAngle = function(s) {
    return arguments.length ? (o = typeof s == "function" ? s : zn(+s), f) : o;
  }, f;
}
var p3 = T1(ql);
function g3(n) {
  this._curve = n;
}
g3.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(n, e) {
    this._curve.point(e * Math.sin(n), e * -Math.cos(n));
  }
};
function T1(n) {
  function e(t) {
    return new g3(n(t));
  }
  return e._curve = n, e;
}
function Wo(n) {
  var e = n.curve;
  return n.angle = n.x, delete n.x, n.radius = n.y, delete n.y, n.curve = function(t) {
    return arguments.length ? e(T1(t)) : e()._curve;
  }, n;
}
function Dy() {
  return Wo(x1().curve(p3));
}
function Fy() {
  var n = d3().curve(p3), e = n.curve, t = n.lineX0, r = n.lineX1, i = n.lineY0, o = n.lineY1;
  return n.angle = n.x, delete n.x, n.startAngle = n.x0, delete n.x0, n.endAngle = n.x1, delete n.x1, n.radius = n.y, delete n.y, n.innerRadius = n.y0, delete n.y0, n.outerRadius = n.y1, delete n.y1, n.lineStartAngle = function() {
    return Wo(t());
  }, delete n.lineX0, n.lineEndAngle = function() {
    return Wo(r());
  }, delete n.lineX1, n.lineInnerRadius = function() {
    return Wo(i());
  }, delete n.lineY0, n.lineOuterRadius = function() {
    return Wo(o());
  }, delete n.lineY1, n.curve = function(f) {
    return arguments.length ? e(T1(f)) : e()._curve;
  }, n;
}
function Ho(n, e) {
  return [(e = +e) * Math.cos(n -= Math.PI / 2), e * Math.sin(n)];
}
class v3 {
  constructor(e, t) {
    this._context = e, this._x = t;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + e) / 2, this._y0, this._x0, t, e, t) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + t) / 2, e, this._y0, e, t);
        break;
      }
    }
    this._x0 = e, this._y0 = t;
  }
}
class gF {
  constructor(e) {
    this._context = e;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
  }
  point(e, t) {
    if (e = +e, t = +t, this._point === 0)
      this._point = 1;
    else {
      const r = Ho(this._x0, this._y0), i = Ho(this._x0, this._y0 = (this._y0 + t) / 2), o = Ho(e, this._y0), f = Ho(e, t);
      this._context.moveTo(...r), this._context.bezierCurveTo(...i, ...o, ...f);
    }
    this._x0 = e, this._y0 = t;
  }
}
function m3(n) {
  return new v3(n, !0);
}
function y3(n) {
  return new v3(n, !1);
}
function vF(n) {
  return new gF(n);
}
function mF(n) {
  return n.source;
}
function yF(n) {
  return n.target;
}
function Wl(n) {
  let e = mF, t = yF, r = b1, i = w1, o = null, f = null, s = ku(l);
  function l() {
    let c;
    const p = cF.call(arguments), g = e.apply(this, p), d = t.apply(this, p);
    if (o == null && (f = n(c = s())), f.lineStart(), p[0] = g, f.point(+r.apply(this, p), +i.apply(this, p)), p[0] = d, f.point(+r.apply(this, p), +i.apply(this, p)), f.lineEnd(), c)
      return f = null, c + "" || null;
  }
  return l.source = function(c) {
    return arguments.length ? (e = c, l) : e;
  }, l.target = function(c) {
    return arguments.length ? (t = c, l) : t;
  }, l.x = function(c) {
    return arguments.length ? (r = typeof c == "function" ? c : zn(+c), l) : r;
  }, l.y = function(c) {
    return arguments.length ? (i = typeof c == "function" ? c : zn(+c), l) : i;
  }, l.context = function(c) {
    return arguments.length ? (c == null ? o = f = null : f = n(o = c), l) : o;
  }, l;
}
function _F() {
  return Wl(m3);
}
function bF() {
  return Wl(y3);
}
function wF() {
  const n = Wl(vF);
  return n.angle = n.x, delete n.x, n.radius = n.y, delete n.y, n;
}
const xF = ue(3), _3 = {
  draw(n, e) {
    const t = ue(e + Fa(e / 28, 0.75)) * 0.59436, r = t / 2, i = r * xF;
    n.moveTo(0, t), n.lineTo(0, -t), n.moveTo(-i, -r), n.lineTo(i, r), n.moveTo(-i, r), n.lineTo(i, -r);
  }
}, Hl = {
  draw(n, e) {
    const t = ue(e / ui);
    n.moveTo(t, 0), n.arc(0, 0, t, 0, ii);
  }
}, b3 = {
  draw(n, e) {
    const t = ue(e / 5) / 2;
    n.moveTo(-3 * t, -t), n.lineTo(-t, -t), n.lineTo(-t, -3 * t), n.lineTo(t, -3 * t), n.lineTo(t, -t), n.lineTo(3 * t, -t), n.lineTo(3 * t, t), n.lineTo(t, t), n.lineTo(t, 3 * t), n.lineTo(-t, 3 * t), n.lineTo(-t, t), n.lineTo(-3 * t, t), n.closePath();
  }
}, w3 = ue(1 / 3), TF = w3 * 2, x3 = {
  draw(n, e) {
    const t = ue(e / TF), r = t * w3;
    n.moveTo(0, -t), n.lineTo(r, 0), n.lineTo(0, t), n.lineTo(-r, 0), n.closePath();
  }
}, T3 = {
  draw(n, e) {
    const t = ue(e) * 0.62625;
    n.moveTo(0, -t), n.lineTo(t, 0), n.lineTo(0, t), n.lineTo(-t, 0), n.closePath();
  }
}, A3 = {
  draw(n, e) {
    const t = ue(e - Fa(e / 7, 2)) * 0.87559;
    n.moveTo(-t, 0), n.lineTo(t, 0), n.moveTo(0, t), n.lineTo(0, -t);
  }
}, M3 = {
  draw(n, e) {
    const t = ue(e), r = -t / 2;
    n.rect(r, r, t, t);
  }
}, S3 = {
  draw(n, e) {
    const t = ue(e) * 0.4431;
    n.moveTo(t, t), n.lineTo(t, -t), n.lineTo(-t, -t), n.lineTo(-t, t), n.closePath();
  }
}, AF = 0.8908130915292852, E3 = ct(ui / 10) / ct(7 * ui / 10), MF = ct(ii / 10) * E3, SF = -Nr(ii / 10) * E3, C3 = {
  draw(n, e) {
    const t = ue(e * AF), r = MF * t, i = SF * t;
    n.moveTo(0, -t), n.lineTo(r, i);
    for (let o = 1; o < 5; ++o) {
      const f = ii * o / 5, s = Nr(f), l = ct(f);
      n.lineTo(l * t, -s * t), n.lineTo(s * r - l * i, l * r + s * i);
    }
    n.closePath();
  }
}, Kh = ue(3), P3 = {
  draw(n, e) {
    const t = -ue(e / (Kh * 3));
    n.moveTo(0, t * 2), n.lineTo(-Kh * t, -t), n.lineTo(Kh * t, -t), n.closePath();
  }
}, EF = ue(3), R3 = {
  draw(n, e) {
    const t = ue(e) * 0.6824, r = t / 2, i = t * EF / 2;
    n.moveTo(0, -t), n.lineTo(i, r), n.lineTo(-i, r), n.closePath();
  }
}, Nt = -0.5, $t = ue(3) / 2, Q0 = 1 / ue(12), CF = (Q0 / 2 + 1) * 3, N3 = {
  draw(n, e) {
    const t = ue(e / CF), r = t / 2, i = t * Q0, o = r, f = t * Q0 + t, s = -o, l = f;
    n.moveTo(r, i), n.lineTo(o, f), n.lineTo(s, l), n.lineTo(Nt * r - $t * i, $t * r + Nt * i), n.lineTo(Nt * o - $t * f, $t * o + Nt * f), n.lineTo(Nt * s - $t * l, $t * s + Nt * l), n.lineTo(Nt * r + $t * i, Nt * i - $t * r), n.lineTo(Nt * o + $t * f, Nt * f - $t * o), n.lineTo(Nt * s + $t * l, Nt * l - $t * s), n.closePath();
  }
}, j0 = {
  draw(n, e) {
    const t = ue(e - Fa(e / 6, 1.7)) * 0.6189;
    n.moveTo(-t, -t), n.lineTo(t, t), n.moveTo(-t, t), n.lineTo(t, -t);
  }
}, By = [
  Hl,
  b3,
  x3,
  M3,
  C3,
  P3,
  N3
], PF = [
  Hl,
  A3,
  j0,
  R3,
  _3,
  S3,
  T3
];
function RF(n, e) {
  let t = null, r = ku(i);
  n = typeof n == "function" ? n : zn(n || Hl), e = typeof e == "function" ? e : zn(e === void 0 ? 64 : +e);
  function i() {
    let o;
    if (t || (t = o = r()), n.apply(this, arguments).draw(t, +e.apply(this, arguments)), o)
      return t = null, o + "" || null;
  }
  return i.type = function(o) {
    return arguments.length ? (n = typeof o == "function" ? o : zn(o), i) : n;
  }, i.size = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : zn(+o), i) : e;
  }, i.context = function(o) {
    return arguments.length ? (t = o ?? null, i) : t;
  }, i;
}
function fi() {
}
function nl(n, e, t) {
  n._context.bezierCurveTo(
    (2 * n._x0 + n._x1) / 3,
    (2 * n._y0 + n._y1) / 3,
    (n._x0 + 2 * n._x1) / 3,
    (n._y0 + 2 * n._y1) / 3,
    (n._x0 + 4 * n._x1 + e) / 6,
    (n._y0 + 4 * n._y1 + t) / 6
  );
}
function Yl(n) {
  this._context = n;
}
Yl.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        nl(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, e) {
    switch (n = +n, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, e) : this._context.moveTo(n, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        nl(this, n, e);
        break;
    }
    this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = e;
  }
};
function NF(n) {
  return new Yl(n);
}
function $3(n) {
  this._context = n;
}
$3.prototype = {
  areaStart: fi,
  areaEnd: fi,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(n, e) {
    switch (n = +n, e = +e, this._point) {
      case 0:
        this._point = 1, this._x2 = n, this._y2 = e;
        break;
      case 1:
        this._point = 2, this._x3 = n, this._y3 = e;
        break;
      case 2:
        this._point = 3, this._x4 = n, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + n) / 6, (this._y0 + 4 * this._y1 + e) / 6);
        break;
      default:
        nl(this, n, e);
        break;
    }
    this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = e;
  }
};
function $F(n) {
  return new $3(n);
}
function k3(n) {
  this._context = n;
}
k3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, e) {
    switch (n = +n, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var t = (this._x0 + 4 * this._x1 + n) / 6, r = (this._y0 + 4 * this._y1 + e) / 6;
        this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      case 3:
        this._point = 4;
      default:
        nl(this, n, e);
        break;
    }
    this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = e;
  }
};
function kF(n) {
  return new k3(n);
}
function O3(n, e) {
  this._basis = new Yl(n), this._beta = e;
}
O3.prototype = {
  lineStart: function() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function() {
    var n = this._x, e = this._y, t = n.length - 1;
    if (t > 0)
      for (var r = n[0], i = e[0], o = n[t] - r, f = e[t] - i, s = -1, l; ++s <= t; )
        l = s / t, this._basis.point(
          this._beta * n[s] + (1 - this._beta) * (r + l * o),
          this._beta * e[s] + (1 - this._beta) * (i + l * f)
        );
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function(n, e) {
    this._x.push(+n), this._y.push(+e);
  }
};
const OF = function n(e) {
  function t(r) {
    return e === 1 ? new Yl(r) : new O3(r, e);
  }
  return t.beta = function(r) {
    return n(+r);
  }, t;
}(0.85);
function el(n, e, t) {
  n._context.bezierCurveTo(
    n._x1 + n._k * (n._x2 - n._x0),
    n._y1 + n._k * (n._y2 - n._y0),
    n._x2 + n._k * (n._x1 - e),
    n._y2 + n._k * (n._y1 - t),
    n._x2,
    n._y2
  );
}
function A1(n, e) {
  this._context = n, this._k = (1 - e) / 6;
}
A1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        el(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, e) {
    switch (n = +n, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, e) : this._context.moveTo(n, e);
        break;
      case 1:
        this._point = 2, this._x1 = n, this._y1 = e;
        break;
      case 2:
        this._point = 3;
      default:
        el(this, n, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const IF = function n(e) {
  function t(r) {
    return new A1(r, e);
  }
  return t.tension = function(r) {
    return n(+r);
  }, t;
}(0);
function M1(n, e) {
  this._context = n, this._k = (1 - e) / 6;
}
M1.prototype = {
  areaStart: fi,
  areaEnd: fi,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(n, e) {
    switch (n = +n, e = +e, this._point) {
      case 0:
        this._point = 1, this._x3 = n, this._y3 = e;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = n, this._y4 = e);
        break;
      case 2:
        this._point = 3, this._x5 = n, this._y5 = e;
        break;
      default:
        el(this, n, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const LF = function n(e) {
  function t(r) {
    return new M1(r, e);
  }
  return t.tension = function(r) {
    return n(+r);
  }, t;
}(0);
function S1(n, e) {
  this._context = n, this._k = (1 - e) / 6;
}
S1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, e) {
    switch (n = +n, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        el(this, n, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const DF = function n(e) {
  function t(r) {
    return new S1(r, e);
  }
  return t.tension = function(r) {
    return n(+r);
  }, t;
}(0);
function E1(n, e, t) {
  var r = n._x1, i = n._y1, o = n._x2, f = n._y2;
  if (n._l01_a > Ge) {
    var s = 2 * n._l01_2a + 3 * n._l01_a * n._l12_a + n._l12_2a, l = 3 * n._l01_a * (n._l01_a + n._l12_a);
    r = (r * s - n._x0 * n._l12_2a + n._x2 * n._l01_2a) / l, i = (i * s - n._y0 * n._l12_2a + n._y2 * n._l01_2a) / l;
  }
  if (n._l23_a > Ge) {
    var c = 2 * n._l23_2a + 3 * n._l23_a * n._l12_a + n._l12_2a, p = 3 * n._l23_a * (n._l23_a + n._l12_a);
    o = (o * c + n._x1 * n._l23_2a - e * n._l12_2a) / p, f = (f * c + n._y1 * n._l23_2a - t * n._l12_2a) / p;
  }
  n._context.bezierCurveTo(r, i, o, f, n._x2, n._y2);
}
function I3(n, e) {
  this._context = n, this._alpha = e;
}
I3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, e) {
    if (n = +n, e = +e, this._point) {
      var t = this._x2 - n, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(t * t + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, e) : this._context.moveTo(n, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        E1(this, n, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const FF = function n(e) {
  function t(r) {
    return e ? new I3(r, e) : new A1(r, 0);
  }
  return t.alpha = function(r) {
    return n(+r);
  }, t;
}(0.5);
function L3(n, e) {
  this._context = n, this._alpha = e;
}
L3.prototype = {
  areaStart: fi,
  areaEnd: fi,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(n, e) {
    if (n = +n, e = +e, this._point) {
      var t = this._x2 - n, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(t * t + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = n, this._y3 = e;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = n, this._y4 = e);
        break;
      case 2:
        this._point = 3, this._x5 = n, this._y5 = e;
        break;
      default:
        E1(this, n, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const BF = function n(e) {
  function t(r) {
    return e ? new L3(r, e) : new M1(r, 0);
  }
  return t.alpha = function(r) {
    return n(+r);
  }, t;
}(0.5);
function D3(n, e) {
  this._context = n, this._alpha = e;
}
D3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, e) {
    if (n = +n, e = +e, this._point) {
      var t = this._x2 - n, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(t * t + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        E1(this, n, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const zF = function n(e) {
  function t(r) {
    return e ? new D3(r, e) : new S1(r, 0);
  }
  return t.alpha = function(r) {
    return n(+r);
  }, t;
}(0.5);
function F3(n) {
  this._context = n;
}
F3.prototype = {
  areaStart: fi,
  areaEnd: fi,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(n, e) {
    n = +n, e = +e, this._point ? this._context.lineTo(n, e) : (this._point = 1, this._context.moveTo(n, e));
  }
};
function VF(n) {
  return new F3(n);
}
function zy(n) {
  return n < 0 ? -1 : 1;
}
function Vy(n, e, t) {
  var r = n._x1 - n._x0, i = e - n._x1, o = (n._y1 - n._y0) / (r || i < 0 && -0), f = (t - n._y1) / (i || r < 0 && -0), s = (o * i + f * r) / (r + i);
  return (zy(o) + zy(f)) * Math.min(Math.abs(o), Math.abs(f), 0.5 * Math.abs(s)) || 0;
}
function Uy(n, e) {
  var t = n._x1 - n._x0;
  return t ? (3 * (n._y1 - n._y0) / t - e) / 2 : e;
}
function Zh(n, e, t) {
  var r = n._x0, i = n._y0, o = n._x1, f = n._y1, s = (o - r) / 3;
  n._context.bezierCurveTo(r + s, i + s * e, o - s, f - s * t, o, f);
}
function tl(n) {
  this._context = n;
}
tl.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        Zh(this, this._t0, Uy(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, e) {
    var t = NaN;
    if (n = +n, e = +e, !(n === this._x1 && e === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(n, e) : this._context.moveTo(n, e);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, Zh(this, Uy(this, t = Vy(this, n, e)), t);
          break;
        default:
          Zh(this, this._t0, t = Vy(this, n, e));
          break;
      }
      this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = e, this._t0 = t;
    }
  }
};
function B3(n) {
  this._context = new z3(n);
}
(B3.prototype = Object.create(tl.prototype)).point = function(n, e) {
  tl.prototype.point.call(this, e, n);
};
function z3(n) {
  this._context = n;
}
z3.prototype = {
  moveTo: function(n, e) {
    this._context.moveTo(e, n);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(n, e) {
    this._context.lineTo(e, n);
  },
  bezierCurveTo: function(n, e, t, r, i, o) {
    this._context.bezierCurveTo(e, n, r, t, o, i);
  }
};
function UF(n) {
  return new tl(n);
}
function GF(n) {
  return new B3(n);
}
function V3(n) {
  this._context = n;
}
V3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var n = this._x, e = this._y, t = n.length;
    if (t)
      if (this._line ? this._context.lineTo(n[0], e[0]) : this._context.moveTo(n[0], e[0]), t === 2)
        this._context.lineTo(n[1], e[1]);
      else
        for (var r = Gy(n), i = Gy(e), o = 0, f = 1; f < t; ++o, ++f)
          this._context.bezierCurveTo(r[0][o], i[0][o], r[1][o], i[1][o], n[f], e[f]);
    (this._line || this._line !== 0 && t === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(n, e) {
    this._x.push(+n), this._y.push(+e);
  }
};
function Gy(n) {
  var e, t = n.length - 1, r, i = new Array(t), o = new Array(t), f = new Array(t);
  for (i[0] = 0, o[0] = 2, f[0] = n[0] + 2 * n[1], e = 1; e < t - 1; ++e)
    i[e] = 1, o[e] = 4, f[e] = 4 * n[e] + 2 * n[e + 1];
  for (i[t - 1] = 2, o[t - 1] = 7, f[t - 1] = 8 * n[t - 1] + n[t], e = 1; e < t; ++e)
    r = i[e] / o[e - 1], o[e] -= r, f[e] -= r * f[e - 1];
  for (i[t - 1] = f[t - 1] / o[t - 1], e = t - 2; e >= 0; --e)
    i[e] = (f[e] - i[e + 1]) / o[e];
  for (o[t - 1] = (n[t] + i[t - 1]) / 2, e = 0; e < t - 1; ++e)
    o[e] = 2 * n[e + 1] - i[e + 1];
  return [i, o];
}
function qF(n) {
  return new V3(n);
}
function Xl(n, e) {
  this._context = n, this._t = e;
}
Xl.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(n, e) {
    switch (n = +n, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, e) : this._context.moveTo(n, e);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, e), this._context.lineTo(n, e);
        else {
          var t = this._x * (1 - this._t) + n * this._t;
          this._context.lineTo(t, this._y), this._context.lineTo(t, e);
        }
        break;
      }
    }
    this._x = n, this._y = e;
  }
};
function WF(n) {
  return new Xl(n, 0.5);
}
function HF(n) {
  return new Xl(n, 0);
}
function YF(n) {
  return new Xl(n, 1);
}
function ja(n, e) {
  if ((f = n.length) > 1)
    for (var t = 1, r, i, o = n[e[0]], f, s = o.length; t < f; ++t)
      for (i = o, o = n[e[t]], r = 0; r < s; ++r)
        o[r][1] += o[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function no(n) {
  for (var e = n.length, t = new Array(e); --e >= 0; )
    t[e] = e;
  return t;
}
function XF(n, e) {
  return n[e];
}
function KF(n) {
  const e = [];
  return e.key = n, e;
}
function ZF() {
  var n = zn([]), e = no, t = ja, r = XF;
  function i(o) {
    var f = Array.from(n.apply(this, arguments), KF), s, l = f.length, c = -1, p;
    for (const g of o)
      for (s = 0, ++c; s < l; ++s)
        (f[s][c] = [0, +r(g, f[s].key, c, o)]).data = g;
    for (s = 0, p = Gl(e(f)); s < l; ++s)
      f[p[s]].index = s;
    return t(f, p), f;
  }
  return i.keys = function(o) {
    return arguments.length ? (n = typeof o == "function" ? o : zn(Array.from(o)), i) : n;
  }, i.value = function(o) {
    return arguments.length ? (r = typeof o == "function" ? o : zn(+o), i) : r;
  }, i.order = function(o) {
    return arguments.length ? (e = o == null ? no : typeof o == "function" ? o : zn(Array.from(o)), i) : e;
  }, i.offset = function(o) {
    return arguments.length ? (t = o ?? ja, i) : t;
  }, i;
}
function JF(n, e) {
  if ((r = n.length) > 0) {
    for (var t, r, i = 0, o = n[0].length, f; i < o; ++i) {
      for (f = t = 0; t < r; ++t)
        f += n[t][i][1] || 0;
      if (f)
        for (t = 0; t < r; ++t)
          n[t][i][1] /= f;
    }
    ja(n, e);
  }
}
function QF(n, e) {
  if ((l = n.length) > 0)
    for (var t, r = 0, i, o, f, s, l, c = n[e[0]].length; r < c; ++r)
      for (f = s = 0, t = 0; t < l; ++t)
        (o = (i = n[e[t]][r])[1] - i[0]) > 0 ? (i[0] = f, i[1] = f += o) : o < 0 ? (i[1] = s, i[0] = s += o) : (i[0] = 0, i[1] = o);
}
function jF(n, e) {
  if ((i = n.length) > 0) {
    for (var t = 0, r = n[e[0]], i, o = r.length; t < o; ++t) {
      for (var f = 0, s = 0; f < i; ++f)
        s += n[f][t][1] || 0;
      r[t][1] += r[t][0] = -s / 2;
    }
    ja(n, e);
  }
}
function nB(n, e) {
  if (!(!((f = n.length) > 0) || !((o = (i = n[e[0]]).length) > 0))) {
    for (var t = 0, r = 1, i, o, f; r < o; ++r) {
      for (var s = 0, l = 0, c = 0; s < f; ++s) {
        for (var p = n[e[s]], g = p[r][1] || 0, d = p[r - 1][1] || 0, v = (g - d) / 2, b = 0; b < s; ++b) {
          var w = n[e[b]], m = w[r][1] || 0, _ = w[r - 1][1] || 0;
          v += m - _;
        }
        l += g, c += v * g;
      }
      i[r - 1][1] += i[r - 1][0] = t, l && (t -= c / l);
    }
    i[r - 1][1] += i[r - 1][0] = t, ja(n, e);
  }
}
function U3(n) {
  var e = n.map(eB);
  return no(n).sort(function(t, r) {
    return e[t] - e[r];
  });
}
function eB(n) {
  for (var e = -1, t = 0, r = n.length, i, o = -1 / 0; ++e < r; )
    (i = +n[e][1]) > o && (o = i, t = e);
  return t;
}
function G3(n) {
  var e = n.map(q3);
  return no(n).sort(function(t, r) {
    return e[t] - e[r];
  });
}
function q3(n) {
  for (var e = 0, t = -1, r = n.length, i; ++t < r; )
    (i = +n[t][1]) && (e += i);
  return e;
}
function tB(n) {
  return G3(n).reverse();
}
function rB(n) {
  var e = n.length, t, r, i = n.map(q3), o = U3(n), f = 0, s = 0, l = [], c = [];
  for (t = 0; t < e; ++t)
    r = o[t], f < s ? (f += i[r], l.push(r)) : (s += i[r], c.push(r));
  return c.reverse().concat(l);
}
function iB(n) {
  return no(n).reverse();
}
const qf = (n) => () => n;
function aB(n, {
  sourceEvent: e,
  target: t,
  transform: r,
  dispatch: i
}) {
  Object.defineProperties(this, {
    type: { value: n, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    target: { value: t, enumerable: !0, configurable: !0 },
    transform: { value: r, enumerable: !0, configurable: !0 },
    _: { value: i }
  });
}
function fr(n, e, t) {
  this.k = n, this.x = e, this.y = t;
}
fr.prototype = {
  constructor: fr,
  scale: function(n) {
    return n === 1 ? this : new fr(this.k * n, this.x, this.y);
  },
  translate: function(n, e) {
    return n === 0 & e === 0 ? this : new fr(this.k, this.x + this.k * n, this.y + this.k * e);
  },
  apply: function(n) {
    return [n[0] * this.k + this.x, n[1] * this.k + this.y];
  },
  applyX: function(n) {
    return n * this.k + this.x;
  },
  applyY: function(n) {
    return n * this.k + this.y;
  },
  invert: function(n) {
    return [(n[0] - this.x) / this.k, (n[1] - this.y) / this.k];
  },
  invertX: function(n) {
    return (n - this.x) / this.k;
  },
  invertY: function(n) {
    return (n - this.y) / this.k;
  },
  rescaleX: function(n) {
    return n.copy().domain(n.range().map(this.invertX, this).map(n.invert, n));
  },
  rescaleY: function(n) {
    return n.copy().domain(n.range().map(this.invertY, this).map(n.invert, n));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var Kl = new fr(1, 0, 0);
W3.prototype = fr.prototype;
function W3(n) {
  for (; !n.__zoom; )
    if (!(n = n.parentNode))
      return Kl;
  return n.__zoom;
}
function Jh(n) {
  n.stopImmediatePropagation();
}
function Oo(n) {
  n.preventDefault(), n.stopImmediatePropagation();
}
function oB(n) {
  return (!n.ctrlKey || n.type === "wheel") && !n.button;
}
function uB() {
  var n = this;
  return n instanceof SVGElement ? (n = n.ownerSVGElement || n, n.hasAttribute("viewBox") ? (n = n.viewBox.baseVal, [[n.x, n.y], [n.x + n.width, n.y + n.height]]) : [[0, 0], [n.width.baseVal.value, n.height.baseVal.value]]) : [[0, 0], [n.clientWidth, n.clientHeight]];
}
function qy() {
  return this.__zoom || Kl;
}
function fB(n) {
  return -n.deltaY * (n.deltaMode === 1 ? 0.05 : n.deltaMode ? 1 : 2e-3) * (n.ctrlKey ? 10 : 1);
}
function sB() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function lB(n, e, t) {
  var r = n.invertX(e[0][0]) - t[0][0], i = n.invertX(e[1][0]) - t[1][0], o = n.invertY(e[0][1]) - t[0][1], f = n.invertY(e[1][1]) - t[1][1];
  return n.translate(
    i > r ? (r + i) / 2 : Math.min(0, r) || Math.max(0, i),
    f > o ? (o + f) / 2 : Math.min(0, o) || Math.max(0, f)
  );
}
function cB() {
  var n = oB, e = uB, t = lB, r = fB, i = sB, o = [0, 1 / 0], f = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], s = 250, l = A_, c = Xi("start", "zoom", "end"), p, g, d, v = 500, b = 150, w = 0, m = 10;
  function _(P) {
    P.property("__zoom", qy).on("wheel.zoom", B, { passive: !1 }).on("mousedown.zoom", F).on("dblclick.zoom", V).filter(i).on("touchstart.zoom", E).on("touchmove.zoom", L).on("touchend.zoom touchcancel.zoom", $).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  _.transform = function(P, k, O, W) {
    var K = P.selection ? P.selection() : P;
    K.property("__zoom", qy), P !== K ? S(P, k, O, W) : K.interrupt().each(function() {
      R(this, arguments).event(W).start().zoom(null, typeof k == "function" ? k.apply(this, arguments) : k).end();
    });
  }, _.scaleBy = function(P, k, O, W) {
    _.scaleTo(P, function() {
      var K = this.__zoom.k, Q = typeof k == "function" ? k.apply(this, arguments) : k;
      return K * Q;
    }, O, W);
  }, _.scaleTo = function(P, k, O, W) {
    _.transform(P, function() {
      var K = e.apply(this, arguments), Q = this.__zoom, z = O == null ? T(K) : typeof O == "function" ? O.apply(this, arguments) : O, q = Q.invert(z), J = typeof k == "function" ? k.apply(this, arguments) : k;
      return t(A(x(Q, J), z, q), K, f);
    }, O, W);
  }, _.translateBy = function(P, k, O, W) {
    _.transform(P, function() {
      return t(this.__zoom.translate(
        typeof k == "function" ? k.apply(this, arguments) : k,
        typeof O == "function" ? O.apply(this, arguments) : O
      ), e.apply(this, arguments), f);
    }, null, W);
  }, _.translateTo = function(P, k, O, W, K) {
    _.transform(P, function() {
      var Q = e.apply(this, arguments), z = this.__zoom, q = W == null ? T(Q) : typeof W == "function" ? W.apply(this, arguments) : W;
      return t(Kl.translate(q[0], q[1]).scale(z.k).translate(
        typeof k == "function" ? -k.apply(this, arguments) : -k,
        typeof O == "function" ? -O.apply(this, arguments) : -O
      ), Q, f);
    }, W, K);
  };
  function x(P, k) {
    return k = Math.max(o[0], Math.min(o[1], k)), k === P.k ? P : new fr(k, P.x, P.y);
  }
  function A(P, k, O) {
    var W = k[0] - O[0] * P.k, K = k[1] - O[1] * P.k;
    return W === P.x && K === P.y ? P : new fr(P.k, W, K);
  }
  function T(P) {
    return [(+P[0][0] + +P[1][0]) / 2, (+P[0][1] + +P[1][1]) / 2];
  }
  function S(P, k, O, W) {
    P.on("start.zoom", function() {
      R(this, arguments).event(W).start();
    }).on("interrupt.zoom end.zoom", function() {
      R(this, arguments).event(W).end();
    }).tween("zoom", function() {
      var K = this, Q = arguments, z = R(K, Q).event(W), q = e.apply(K, Q), J = O == null ? T(q) : typeof O == "function" ? O.apply(K, Q) : O, en = Math.max(q[1][0] - q[0][0], q[1][1] - q[0][1]), fn = K.__zoom, ln = typeof k == "function" ? k.apply(K, Q) : k, Tn = l(fn.invert(J).concat(en / fn.k), ln.invert(J).concat(en / ln.k));
      return function(gn) {
        if (gn === 1)
          gn = ln;
        else {
          var _n = Tn(gn), tn = en / _n[2];
          gn = new fr(tn, J[0] - _n[0] * tn, J[1] - _n[1] * tn);
        }
        z.zoom(null, gn);
      };
    });
  }
  function R(P, k, O) {
    return !O && P.__zooming || new I(P, k);
  }
  function I(P, k) {
    this.that = P, this.args = k, this.active = 0, this.sourceEvent = null, this.extent = e.apply(P, k), this.taps = 0;
  }
  I.prototype = {
    event: function(P) {
      return P && (this.sourceEvent = P), this;
    },
    start: function() {
      return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
    },
    zoom: function(P, k) {
      return this.mouse && P !== "mouse" && (this.mouse[1] = k.invert(this.mouse[0])), this.touch0 && P !== "touch" && (this.touch0[1] = k.invert(this.touch0[0])), this.touch1 && P !== "touch" && (this.touch1[1] = k.invert(this.touch1[0])), this.that.__zoom = k, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
    },
    emit: function(P) {
      var k = qe(this.that).datum();
      c.call(
        P,
        this.that,
        new aB(P, {
          sourceEvent: this.sourceEvent,
          target: _,
          type: P,
          transform: this.that.__zoom,
          dispatch: c
        }),
        k
      );
    }
  };
  function B(P, ...k) {
    if (!n.apply(this, arguments))
      return;
    var O = R(this, k).event(P), W = this.__zoom, K = Math.max(o[0], Math.min(o[1], W.k * Math.pow(2, r.apply(this, arguments)))), Q = bt(P);
    if (O.wheel)
      (O.mouse[0][0] !== Q[0] || O.mouse[0][1] !== Q[1]) && (O.mouse[1] = W.invert(O.mouse[0] = Q)), clearTimeout(O.wheel);
    else {
      if (W.k === K)
        return;
      O.mouse = [Q, W.invert(Q)], Ii(this), O.start();
    }
    Oo(P), O.wheel = setTimeout(z, b), O.zoom("mouse", t(A(x(W, K), O.mouse[0], O.mouse[1]), O.extent, f));
    function z() {
      O.wheel = null, O.end();
    }
  }
  function F(P, ...k) {
    if (d || !n.apply(this, arguments))
      return;
    var O = P.currentTarget, W = R(this, k, !0).event(P), K = qe(P.view).on("mousemove.zoom", J, !0).on("mouseup.zoom", en, !0), Q = bt(P, O), z = P.clientX, q = P.clientY;
    pl(P.view), Jh(P), W.mouse = [Q, this.__zoom.invert(Q)], Ii(this), W.start();
    function J(fn) {
      if (Oo(fn), !W.moved) {
        var ln = fn.clientX - z, Tn = fn.clientY - q;
        W.moved = ln * ln + Tn * Tn > w;
      }
      W.event(fn).zoom("mouse", t(A(W.that.__zoom, W.mouse[0] = bt(fn, O), W.mouse[1]), W.extent, f));
    }
    function en(fn) {
      K.on("mousemove.zoom mouseup.zoom", null), gl(fn.view, W.moved), Oo(fn), W.event(fn).end();
    }
  }
  function V(P, ...k) {
    if (n.apply(this, arguments)) {
      var O = this.__zoom, W = bt(P.changedTouches ? P.changedTouches[0] : P, this), K = O.invert(W), Q = O.k * (P.shiftKey ? 0.5 : 2), z = t(A(x(O, Q), W, K), e.apply(this, k), f);
      Oo(P), s > 0 ? qe(this).transition().duration(s).call(S, z, W, P) : qe(this).call(_.transform, z, W, P);
    }
  }
  function E(P, ...k) {
    if (n.apply(this, arguments)) {
      var O = P.touches, W = O.length, K = R(this, k, P.changedTouches.length === W).event(P), Q, z, q, J;
      for (Jh(P), z = 0; z < W; ++z)
        q = O[z], J = bt(q, this), J = [J, this.__zoom.invert(J), q.identifier], K.touch0 ? !K.touch1 && K.touch0[2] !== J[2] && (K.touch1 = J, K.taps = 0) : (K.touch0 = J, Q = !0, K.taps = 1 + !!p);
      p && (p = clearTimeout(p)), Q && (K.taps < 2 && (g = J[0], p = setTimeout(function() {
        p = null;
      }, v)), Ii(this), K.start());
    }
  }
  function L(P, ...k) {
    if (this.__zooming) {
      var O = R(this, k).event(P), W = P.changedTouches, K = W.length, Q, z, q, J;
      for (Oo(P), Q = 0; Q < K; ++Q)
        z = W[Q], q = bt(z, this), O.touch0 && O.touch0[2] === z.identifier ? O.touch0[0] = q : O.touch1 && O.touch1[2] === z.identifier && (O.touch1[0] = q);
      if (z = O.that.__zoom, O.touch1) {
        var en = O.touch0[0], fn = O.touch0[1], ln = O.touch1[0], Tn = O.touch1[1], gn = (gn = ln[0] - en[0]) * gn + (gn = ln[1] - en[1]) * gn, _n = (_n = Tn[0] - fn[0]) * _n + (_n = Tn[1] - fn[1]) * _n;
        z = x(z, Math.sqrt(gn / _n)), q = [(en[0] + ln[0]) / 2, (en[1] + ln[1]) / 2], J = [(fn[0] + Tn[0]) / 2, (fn[1] + Tn[1]) / 2];
      } else if (O.touch0)
        q = O.touch0[0], J = O.touch0[1];
      else
        return;
      O.zoom("touch", t(A(z, q, J), O.extent, f));
    }
  }
  function $(P, ...k) {
    if (this.__zooming) {
      var O = R(this, k).event(P), W = P.changedTouches, K = W.length, Q, z;
      for (Jh(P), d && clearTimeout(d), d = setTimeout(function() {
        d = null;
      }, v), Q = 0; Q < K; ++Q)
        z = W[Q], O.touch0 && O.touch0[2] === z.identifier ? delete O.touch0 : O.touch1 && O.touch1[2] === z.identifier && delete O.touch1;
      if (O.touch1 && !O.touch0 && (O.touch0 = O.touch1, delete O.touch1), O.touch0)
        O.touch0[1] = this.__zoom.invert(O.touch0[0]);
      else if (O.end(), O.taps === 2 && (z = bt(z, this), Math.hypot(g[0] - z[0], g[1] - z[1]) < m)) {
        var q = qe(this).on("dblclick.zoom");
        q && q.apply(this, arguments);
      }
    }
  }
  return _.wheelDelta = function(P) {
    return arguments.length ? (r = typeof P == "function" ? P : qf(+P), _) : r;
  }, _.filter = function(P) {
    return arguments.length ? (n = typeof P == "function" ? P : qf(!!P), _) : n;
  }, _.touchable = function(P) {
    return arguments.length ? (i = typeof P == "function" ? P : qf(!!P), _) : i;
  }, _.extent = function(P) {
    return arguments.length ? (e = typeof P == "function" ? P : qf([[+P[0][0], +P[0][1]], [+P[1][0], +P[1][1]]]), _) : e;
  }, _.scaleExtent = function(P) {
    return arguments.length ? (o[0] = +P[0], o[1] = +P[1], _) : [o[0], o[1]];
  }, _.translateExtent = function(P) {
    return arguments.length ? (f[0][0] = +P[0][0], f[1][0] = +P[1][0], f[0][1] = +P[0][1], f[1][1] = +P[1][1], _) : [[f[0][0], f[0][1]], [f[1][0], f[1][1]]];
  }, _.constrain = function(P) {
    return arguments.length ? (t = P, _) : t;
  }, _.duration = function(P) {
    return arguments.length ? (s = +P, _) : s;
  }, _.interpolate = function(P) {
    return arguments.length ? (l = P, _) : l;
  }, _.on = function() {
    var P = c.on.apply(c, arguments);
    return P === c ? _ : P;
  }, _.clickDistance = function(P) {
    return arguments.length ? (w = (P = +P) * P, _) : Math.sqrt(w);
  }, _.tapDistance = function(P) {
    return arguments.length ? (m = +P, _) : m;
  }, _;
}
const hB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Adder: Ae,
  Delaunay: Id,
  FormatSpecifier: El,
  InternMap: nu,
  InternSet: Li,
  Node: qi,
  Path: Au,
  Voronoi: G_,
  ZoomTransform: fr,
  active: iR,
  arc: lF,
  area: d3,
  areaRadial: Fy,
  ascending: de,
  autoType: CN,
  axisBottom: XM,
  axisLeft: KM,
  axisRight: YM,
  axisTop: HM,
  bin: Sv,
  bisect: Yi,
  bisectCenter: UA,
  bisectLeft: VA,
  bisectRight: b2,
  bisector: fl,
  blob: NN,
  blur: GA,
  blur2: w2,
  blurImage: qA,
  brush: mR,
  brushSelection: pR,
  brushX: gR,
  brushY: vR,
  buffer: kN,
  chord: _R,
  chordDirected: wR,
  chordTranspose: bR,
  cluster: Jk,
  color: ai,
  contourDensity: YR,
  contours: T0,
  count: sl,
  create: RE,
  creator: hl,
  cross: JA,
  csv: LN,
  csvFormat: mN,
  csvFormatBody: yN,
  csvFormatRow: bN,
  csvFormatRows: _N,
  csvFormatValue: wN,
  csvParse: W_,
  csvParseRows: vN,
  cubehelix: Qt,
  cumsum: QA,
  curveBasis: NF,
  curveBasisClosed: $F,
  curveBasisOpen: kF,
  curveBumpX: m3,
  curveBumpY: y3,
  curveBundle: OF,
  curveCardinal: IF,
  curveCardinalClosed: LF,
  curveCardinalOpen: DF,
  curveCatmullRom: FF,
  curveCatmullRomClosed: BF,
  curveCatmullRomOpen: zF,
  curveLinear: ql,
  curveLinearClosed: VF,
  curveMonotoneX: UF,
  curveMonotoneY: GF,
  curveNatural: qF,
  curveStep: WF,
  curveStepAfter: YF,
  curveStepBefore: HF,
  descending: y2,
  deviation: A2,
  difference: OM,
  disjoint: IM,
  dispatch: Xi,
  drag: BE,
  dragDisable: pl,
  dragEnable: gl,
  dsv: IN,
  dsvFormat: Al,
  easeBack: Zv,
  easeBackIn: ZP,
  easeBackInOut: Zv,
  easeBackOut: JP,
  easeBounce: su,
  easeBounceIn: XP,
  easeBounceInOut: KP,
  easeBounceOut: su,
  easeCircle: Kv,
  easeCircleIn: FP,
  easeCircleInOut: Kv,
  easeCircleOut: BP,
  easeCubic: y0,
  easeCubicIn: RP,
  easeCubicInOut: y0,
  easeCubicOut: NP,
  easeElastic: Jv,
  easeElasticIn: QP,
  easeElasticInOut: jP,
  easeElasticOut: Jv,
  easeExp: Xv,
  easeExpIn: LP,
  easeExpInOut: Xv,
  easeExpOut: DP,
  easeLinear: EP,
  easePoly: Hv,
  easePolyIn: $P,
  easePolyInOut: Hv,
  easePolyOut: kP,
  easeQuad: Wv,
  easeQuadIn: CP,
  easeQuadInOut: Wv,
  easeQuadOut: PP,
  easeSin: Yv,
  easeSinIn: OP,
  easeSinInOut: Yv,
  easeSinOut: IP,
  every: CM,
  extent: Yo,
  fcumsum: nM,
  filter: RM,
  flatGroup: eM,
  flatRollup: tM,
  forceCenter: qN,
  forceCollide: s$,
  forceLink: c$,
  forceManyBody: b$,
  forceRadial: w$,
  forceSimulation: _$,
  forceX: x$,
  forceY: T$,
  get format() {
    return Cl;
  },
  formatDefaultLocale: J_,
  formatLocale: Z_,
  get formatPrefix() {
    return Fd;
  },
  formatSpecifier: Ha,
  fsum: jA,
  geoAlbers: Ib,
  geoAlbersUsa: Pk,
  geoArea: k$,
  geoAzimuthalEqualArea: Rk,
  geoAzimuthalEqualAreaRaw: Xd,
  geoAzimuthalEquidistant: Nk,
  geoAzimuthalEquidistantRaw: Kd,
  geoBounds: D$,
  geoCentroid: G$,
  geoCircle: q$,
  geoClipAntimeridian: L0,
  geoClipCircle: _b,
  geoClipExtent: J$,
  geoClipRectangle: Pl,
  geoConicConformal: kk,
  geoConicConformalRaw: Fb,
  geoConicEqualArea: Zs,
  geoConicEqualAreaRaw: Ob,
  geoConicEquidistant: Ik,
  geoConicEquidistantRaw: Bb,
  geoContains: ik,
  geoDistance: Vs,
  geoEqualEarth: Dk,
  geoEqualEarthRaw: Zd,
  geoEquirectangular: Ok,
  geoEquirectangularRaw: pu,
  geoGnomonic: Fk,
  geoGnomonicRaw: Jd,
  geoGraticule: xb,
  geoGraticule10: ak,
  geoIdentity: Bk,
  geoInterpolate: ok,
  geoLength: bb,
  geoMercator: $k,
  geoMercatorRaw: Pu,
  geoNaturalEarth1: zk,
  geoNaturalEarth1Raw: Qd,
  geoOrthographic: Vk,
  geoOrthographicRaw: jd,
  geoPath: _k,
  geoProjection: gr,
  geoProjectionMutator: Hd,
  geoRotation: db,
  geoStereographic: Uk,
  geoStereographicRaw: n1,
  geoStream: Ht,
  geoTransform: bk,
  geoTransverseMercator: Gk,
  geoTransverseMercatorRaw: e1,
  gray: JE,
  greatest: I2,
  greatestIndex: xM,
  group: C2,
  groupSort: aM,
  groups: P2,
  hcl: xs,
  hierarchy: t1,
  histogram: Sv,
  hsl: _s,
  html: UN,
  image: FN,
  index: rM,
  indexes: iM,
  interpolate: li,
  interpolateArray: rC,
  interpolateBasis: c_,
  interpolateBasisClosed: h_,
  interpolateBlues: DD,
  interpolateBrBG: vD,
  interpolateBuGn: MD,
  interpolateBuPu: SD,
  interpolateCividis: GD,
  interpolateCool: HD,
  interpolateCubehelix: yC,
  interpolateCubehelixDefault: qD,
  interpolateCubehelixLong: bl,
  interpolateDate: y_,
  interpolateDiscrete: oC,
  interpolateGnBu: ED,
  interpolateGreens: FD,
  interpolateGreys: BD,
  interpolateHcl: vC,
  interpolateHclLong: mC,
  interpolateHsl: dC,
  interpolateHslLong: pC,
  interpolateHue: uC,
  interpolateInferno: nF,
  interpolateLab: gC,
  interpolateMagma: jD,
  interpolateNumber: Ot,
  interpolateNumberArray: Ad,
  interpolateObject: __,
  interpolateOrRd: CD,
  interpolateOranges: UD,
  interpolatePRGn: mD,
  interpolatePiYG: yD,
  interpolatePlasma: eF,
  interpolatePuBu: RD,
  interpolatePuBuGn: PD,
  interpolatePuOr: _D,
  interpolatePuRd: ND,
  interpolatePurples: zD,
  interpolateRainbow: YD,
  interpolateRdBu: bD,
  interpolateRdGy: wD,
  interpolateRdPu: $D,
  interpolateRdYlBu: xD,
  interpolateRdYlGn: TD,
  interpolateReds: VD,
  interpolateRgb: ou,
  interpolateRgbBasis: g_,
  interpolateRgbBasisClosed: tC,
  interpolateRound: _l,
  interpolateSinebow: ZD,
  interpolateSpectral: AD,
  interpolateString: Md,
  interpolateTransformCss: x_,
  interpolateTransformSvg: T_,
  interpolateTurbo: JD,
  interpolateViridis: QD,
  interpolateWarm: WD,
  interpolateYlGn: OD,
  interpolateYlGnBu: kD,
  interpolateYlOrBr: ID,
  interpolateYlOrRd: LD,
  interpolateZoom: A_,
  interrupt: Ii,
  intersection: LM,
  interval: TC,
  isoFormat: KL,
  isoParse: QL,
  json: zN,
  lab: ws,
  lch: QE,
  least: wM,
  leastIndex: F2,
  line: x1,
  lineRadial: Dy,
  link: Wl,
  linkHorizontal: _F,
  linkRadial: wF,
  linkVertical: bF,
  local: Z2,
  map: NM,
  matcher: md,
  max: eu,
  maxIndex: dd,
  mean: dM,
  median: pM,
  medianIndex: gM,
  merge: gd,
  min: vs,
  minIndex: pd,
  mode: mM,
  namespace: wu,
  namespaces: f0,
  nice: cd,
  now: Tu,
  pack: EO,
  packEnclose: wO,
  packSiblings: MO,
  pairs: yM,
  partition: CO,
  path: Od,
  pathRound: AR,
  permute: O2,
  pie: pF,
  piecewise: C_,
  pointRadial: Ho,
  pointer: bt,
  pointers: $E,
  polygonArea: qO,
  polygonCentroid: WO,
  polygonContains: KO,
  polygonHull: XO,
  polygonLength: ZO,
  precisionFixed: Q_,
  precisionPrefix: j_,
  precisionRound: nb,
  quadtree: Sl,
  quantile: tu,
  quantileIndex: D2,
  quantileSorted: L2,
  quantize: _C,
  quickselect: ll,
  radialArea: Fy,
  radialLine: Dy,
  randomBates: nI,
  randomBernoulli: rI,
  randomBeta: Qb,
  randomBinomial: jb,
  randomCauchy: aI,
  randomExponential: eI,
  randomGamma: a1,
  randomGeometric: Jb,
  randomInt: QO,
  randomIrwinHall: Zb,
  randomLcg: lI,
  randomLogNormal: jO,
  randomLogistic: oI,
  randomNormal: i1,
  randomPareto: tI,
  randomPoisson: uI,
  randomUniform: JO,
  randomWeibull: iI,
  range: ti,
  rank: bM,
  reduce: $M,
  reverse: kM,
  rgb: Ua,
  ribbon: $R,
  ribbonArrow: kR,
  rollup: N2,
  rollups: $2,
  scaleBand: u1,
  scaleDiverging: Lw,
  scaleDivergingLog: Dw,
  scaleDivergingPow: _1,
  scaleDivergingSqrt: iD,
  scaleDivergingSymlog: Fw,
  scaleIdentity: rw,
  scaleImplicit: Z0,
  scaleLinear: tw,
  scaleLog: aw,
  scaleOrdinal: o1,
  scalePoint: cI,
  scalePow: h1,
  scaleQuantile: fw,
  scaleQuantize: sw,
  scaleRadial: uw,
  scaleSequential: $w,
  scaleSequentialLog: kw,
  scaleSequentialPow: y1,
  scaleSequentialQuantile: Iw,
  scaleSequentialSqrt: rD,
  scaleSequentialSymlog: Ow,
  scaleSqrt: TI,
  scaleSymlog: ow,
  scaleThreshold: lw,
  scaleTime: eD,
  scaleUtc: tD,
  scan: TM,
  schemeAccent: oD,
  schemeBlues: o3,
  schemeBrBG: Bw,
  schemeBuGn: Xw,
  schemeBuPu: Kw,
  schemeCategory10: aD,
  schemeDark2: uD,
  schemeGnBu: Zw,
  schemeGreens: u3,
  schemeGreys: f3,
  schemeObservable10: fD,
  schemeOrRd: Jw,
  schemeOranges: c3,
  schemePRGn: zw,
  schemePaired: sD,
  schemePastel1: lD,
  schemePastel2: cD,
  schemePiYG: Vw,
  schemePuBu: jw,
  schemePuBuGn: Qw,
  schemePuOr: Uw,
  schemePuRd: n3,
  schemePurples: s3,
  schemeRdBu: Gw,
  schemeRdGy: qw,
  schemeRdPu: e3,
  schemeRdYlBu: Ww,
  schemeRdYlGn: Hw,
  schemeReds: l3,
  schemeSet1: hD,
  schemeSet2: dD,
  schemeSet3: pD,
  schemeSpectral: Yw,
  schemeTableau10: gD,
  schemeYlGn: r3,
  schemeYlGnBu: t3,
  schemeYlOrBr: i3,
  schemeYlOrRd: a3,
  select: qe,
  selectAll: kE,
  selection: Ki,
  selector: dl,
  selectorAll: vd,
  shuffle: AM,
  shuffler: B2,
  some: PM,
  sort: a0,
  stack: ZF,
  stackOffsetDiverging: QF,
  stackOffsetExpand: JF,
  stackOffsetNone: ja,
  stackOffsetSilhouette: jF,
  stackOffsetWiggle: nB,
  stackOrderAppearance: U3,
  stackOrderAscending: G3,
  stackOrderDescending: tB,
  stackOrderInsideOut: rB,
  stackOrderNone: no,
  stackOrderReverse: iB,
  stratify: $O,
  style: Bi,
  subset: FM,
  sum: MM,
  superset: V2,
  svg: GN,
  symbol: RF,
  symbolAsterisk: _3,
  symbolCircle: Hl,
  symbolCross: b3,
  symbolDiamond: x3,
  symbolDiamond2: T3,
  symbolPlus: A3,
  symbolSquare: M3,
  symbolSquare2: S3,
  symbolStar: C3,
  symbolTimes: j0,
  symbolTriangle: P3,
  symbolTriangle2: R3,
  symbolWye: N3,
  symbolX: j0,
  symbols: By,
  symbolsFill: By,
  symbolsStroke: PF,
  text: Ml,
  thresholdFreedmanDiaconis: cM,
  thresholdScott: hM,
  thresholdSturges: hd,
  tickFormat: ew,
  tickIncrement: Fi,
  tickStep: gs,
  ticks: Di,
  timeDay: ao,
  timeDays: PI,
  get timeFormat() {
    return g1;
  },
  timeFormatDefaultLocale: Rw,
  timeFormatLocale: Aw,
  timeFriday: dw,
  timeFridays: LI,
  timeHour: Il,
  timeHours: EI,
  timeInterval: be,
  timeMillisecond: Za,
  timeMilliseconds: by,
  timeMinute: kl,
  timeMinutes: MI,
  timeMonday: gu,
  timeMondays: $I,
  timeMonth: Dl,
  timeMonths: qI,
  get timeParse() {
    return Pw;
  },
  timeSaturday: pw,
  timeSaturdays: DI,
  timeSecond: Ir,
  timeSeconds: xy,
  timeSunday: Ja,
  timeSundays: Ty,
  timeThursday: Wi,
  timeThursdays: II,
  timeTickInterval: Tw,
  timeTicks: xw,
  timeTuesday: cw,
  timeTuesdays: kI,
  timeWednesday: hw,
  timeWednesdays: OI,
  timeWeek: Ja,
  timeWeeks: Ty,
  timeYear: hr,
  timeYears: HI,
  timeout: p0,
  timer: xl,
  timerFlush: N_,
  transition: I_,
  transpose: z2,
  tree: BO,
  treemap: zO,
  treemapBinary: VO,
  treemapDice: Ru,
  treemapResquarify: GO,
  treemapSlice: Nl,
  treemapSliceDice: UO,
  treemapSquarify: Kb,
  tsv: DN,
  tsvFormat: TN,
  tsvFormatBody: AN,
  tsvFormatRow: SN,
  tsvFormatRows: MN,
  tsvFormatValue: EN,
  tsvParse: H_,
  tsvParseRows: xN,
  union: BM,
  unixDay: p1,
  unixDays: NI,
  utcDay: $u,
  utcDays: RI,
  get utcFormat() {
    return Bl;
  },
  utcFriday: mw,
  utcFridays: UI,
  utcHour: Ll,
  utcHours: CI,
  utcMillisecond: Za,
  utcMilliseconds: by,
  utcMinute: Ol,
  utcMinutes: SI,
  utcMonday: vu,
  utcMondays: FI,
  utcMonth: Fl,
  utcMonths: WI,
  get utcParse() {
    return v1;
  },
  utcSaturday: yw,
  utcSaturdays: GI,
  utcSecond: Ir,
  utcSeconds: xy,
  utcSunday: Qa,
  utcSundays: Ay,
  utcThursday: Hi,
  utcThursdays: VI,
  utcTickInterval: ww,
  utcTicks: bw,
  utcTuesday: gw,
  utcTuesdays: BI,
  utcWednesday: vw,
  utcWednesdays: zI,
  utcWeek: Qa,
  utcWeeks: Ay,
  utcYear: dr,
  utcYears: YI,
  variance: T2,
  window: yd,
  xml: VN,
  zip: EM,
  zoom: cB,
  zoomIdentity: Kl,
  zoomTransform: W3
}, Symbol.toStringTag, { value: "Module" })), Zl = /* @__PURE__ */ xt(hB);
var Pr = {}, Qh = {}, Wy;
function H3() {
  return Wy || (Wy = 1, function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.defaultArc = n.getArcWidthByType = n.defaultSubArcs = void 0;
    var e = oo();
    n.defaultSubArcs = [
      { limit: 33, color: "#5BE12C" },
      { limit: 66, color: "#F5CD19" },
      { color: "#EA4228" }
    ];
    var t = function(r) {
      var i, o = (i = {}, i[e.GaugeType.Grafana] = 0.25, i[e.GaugeType.Semicircle] = 0.15, i[e.GaugeType.Radial] = 0.2, i);
      return r || (r = e.defaultGaugeProps.type), o[r];
    };
    n.getArcWidthByType = t, n.defaultArc = {
      padding: 0.05,
      width: 0.25,
      cornerRadius: 7,
      nbSubArcs: void 0,
      colorArray: void 0,
      subArcs: n.defaultSubArcs,
      gradient: !1
    };
  }(Qh)), Qh;
}
var C1 = {}, mu = {};
Object.defineProperty(mu, "__esModule", { value: !0 });
var Y3 = mu.defaultTickLabels = void 0, dB = {
  color: "rgb(173 172 171)",
  length: 7,
  width: 1,
  distanceFromArc: 3,
  hide: !1
}, pB = {
  formatTextValue: void 0,
  maxDecimalDigits: 2,
  style: {
    fontSize: "10px",
    fill: "rgb(173 172 171)"
  },
  hide: !1
}, gB = [];
Y3 = mu.defaultTickLabels = {
  type: "outer",
  hideMinMax: !1,
  ticks: gB,
  defaultTickValueConfig: pB,
  defaultTickLineConfig: dB
};
const vB = /* @__PURE__ */ Dt({
  __proto__: null,
  default: mu,
  get defaultTickLabels() {
    return Y3;
  }
}, [mu]), X3 = /* @__PURE__ */ xt(vB);
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.defaultLabels = n.defaultValueLabel = void 0;
  var e = X3;
  n.defaultValueLabel = {
    formatTextValue: void 0,
    matchColorWithArc: !1,
    maxDecimalDigits: 2,
    style: {
      fontSize: "35px",
      fill: "#fff",
      textShadow: "black 1px 0.5px 0px, black 0px 0px 0.03em, black 0px 0px 0.01em"
    },
    hide: !1
  }, n.defaultLabels = {
    valueLabel: n.defaultValueLabel,
    tickLabels: e.defaultTickLabels
  };
})(C1);
const mB = /* @__PURE__ */ Br(C1), yB = /* @__PURE__ */ Dt({
  __proto__: null,
  default: mB
}, [C1]), _B = /* @__PURE__ */ xt(yB);
var P1 = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.defaultPointer = n.defaultPointerRef = n.defaultPointerContext = n.PointerType = void 0;
  var e;
  (function(t) {
    t.Needle = "needle", t.Blob = "blob", t.Arrow = "arrow";
  })(e || (n.PointerType = e = {})), n.defaultPointerContext = {
    centerPoint: [0, 0],
    pointerRadius: 0,
    pathLength: 0,
    currentPercent: 0,
    prevPercent: 0,
    prevProgress: 0,
    pathStr: "",
    shouldDrawPath: !1,
    prevColor: ""
  }, n.defaultPointerRef = {
    element: void 0,
    path: void 0,
    context: n.defaultPointerContext
  }, n.defaultPointer = {
    type: e.Needle,
    color: "#5A5A5A",
    baseColor: "white",
    length: 0.7,
    width: 20,
    animate: !0,
    elastic: !1,
    animationDuration: 3e3,
    animationDelay: 100
  };
})(P1);
const bB = /* @__PURE__ */ Br(P1), wB = /* @__PURE__ */ Dt({
  __proto__: null,
  default: bB
}, [P1]), R1 = /* @__PURE__ */ xt(wB);
var Hy;
function oo() {
  if (Hy)
    return Pr;
  Hy = 1, Object.defineProperty(Pr, "__esModule", { value: !0 }), Pr.getGaugeMarginByType = Pr.defaultGaugeProps = Pr.GaugeType = void 0;
  var n = H3(), e = _B, t = R1, r;
  (function(o) {
    o.Semicircle = "semicircle", o.Radial = "radial", o.Grafana = "grafana";
  })(r || (Pr.GaugeType = r = {})), Pr.defaultGaugeProps = {
    id: "",
    className: "gauge-component-class",
    style: { width: "100%" },
    marginInPercent: 0.07,
    value: 33,
    minValue: 0,
    maxValue: 100,
    arc: n.defaultArc,
    labels: e.defaultLabels,
    pointer: t.defaultPointer,
    type: r.Grafana
  };
  var i = function(o) {
    var f, s = (f = {}, f[r.Grafana] = { top: 0.12, bottom: 0, left: 0.07, right: 0.07 }, f[r.Semicircle] = { top: 0.08, bottom: 0, left: 0.08, right: 0.08 }, f[r.Radial] = { top: 0.07, bottom: 0, left: 0.07, right: 0.07 }, f);
    return s[o];
  };
  return Pr.getGaugeMarginByType = i, Pr;
}
var N1 = {}, jh = {}, $1 = {};
(function(n) {
  var e = Dn && Dn.__assign || function() {
    return e = Object.assign || function(d) {
      for (var v, b = 1, w = arguments.length; b < w; b++) {
        v = arguments[b];
        for (var m in v)
          Object.prototype.hasOwnProperty.call(v, m) && (d[m] = v[m]);
      }
      return d;
    }, e.apply(this, arguments);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.camelCaseToKebabCase = n.getCurrentGaugeValueByPercentage = n.getCurrentGaugePercentageByValue = n.degToRad = n.normalize = n.floatingNumber = n.percentToRad = n.mergeObjects = n.isEmptyObject = n.calculatePercentage = void 0;
  var t = function(d, v, b) {
    if (b < d)
      return 0;
    if (b > v)
      return 100;
    var w = (b - d) / (v - d);
    return w;
  };
  n.calculatePercentage = t;
  var r = function(d) {
    return Object.keys(d).length === 0 && d.constructor === Object;
  };
  n.isEmptyObject = r;
  var i = function(d, v) {
    var b = e({}, d);
    return Object.keys(v).forEach(function(w) {
      var m = d[w], _ = v[w];
      Array.isArray(m) && Array.isArray(_) ? b[w] = _ : typeof m == "object" && typeof _ == "object" ? b[w] = (0, n.mergeObjects)(m, _) : _ !== void 0 && (b[w] = _);
    }), b;
  };
  n.mergeObjects = i;
  var o = function(d, v) {
    return d * (Math.PI / v);
  };
  n.percentToRad = o;
  var f = function(d, v) {
    return v === void 0 && (v = 2), Math.round(d * Math.pow(10, v)) / Math.pow(10, v);
  };
  n.floatingNumber = f;
  function s(d, v, b) {
    return (d - v) / (b - v) * 100;
  }
  n.normalize = s;
  var l = function(d) {
    return d * (Math.PI / 180);
  };
  n.degToRad = l;
  var c = function(d, v) {
    return (0, n.calculatePercentage)(v.minValue, v.maxValue, d);
  };
  n.getCurrentGaugePercentageByValue = c;
  var p = function(d, v) {
    var b = v.props.minValue, w = v.props.maxValue, m = b + d * (w - b);
    return m;
  };
  n.getCurrentGaugeValueByPercentage = p;
  var g = function(d) {
    return d.replace(/[A-Z]/g, function(v) {
      return "-".concat(v.toLowerCase());
    });
  };
  n.camelCaseToKebabCase = g;
})($1);
const xB = /* @__PURE__ */ Br($1), TB = /* @__PURE__ */ Dt({
  __proto__: null,
  default: xB
}, [$1]), Ou = /* @__PURE__ */ xt(TB);
var k1 = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.CONSTANTS = void 0, n.CONSTANTS = {
    arcTooltipClassname: "gauge-component-arc-tooltip",
    tickLineClassname: "tick-line",
    tickValueClassname: "tick-value",
    valueLabelClassname: "value-text",
    debugTicksRadius: !1,
    debugSingleGauge: !1,
    rangeBetweenCenteredTickValueLabel: [0.35, 0.65]
  }, n.default = n.CONSTANTS;
})(k1);
const AB = /* @__PURE__ */ Br(k1), MB = /* @__PURE__ */ Dt({
  __proto__: null,
  default: AB
}, [k1]), K3 = /* @__PURE__ */ xt(MB);
var yu = {};
Object.defineProperty(yu, "__esModule", { value: !0 });
var Z3 = yu.defaultTooltipStyle = void 0;
Z3 = yu.defaultTooltipStyle = {
  borderColor: "#5A5A5A",
  borderStyle: "solid",
  borderWidth: "1px",
  borderRadius: "5px",
  color: "white",
  padding: "5px",
  fontSize: "15px",
  textShadow: "1px 1px 2px black, 0 0 1em black, 0 0 0.2em black"
  // fontSize: '15px'
};
const SB = /* @__PURE__ */ Dt({
  __proto__: null,
  default: yu,
  get defaultTooltipStyle() {
    return Z3;
  }
}, [yu]), EB = /* @__PURE__ */ xt(SB), CB = /* @__PURE__ */ xt(VT);
var Yy;
function eo() {
  return Yy || (Yy = 1, function(n) {
    var e = Dn && Dn.__createBinding || (Object.create ? function(z, q, J, en) {
      en === void 0 && (en = J);
      var fn = Object.getOwnPropertyDescriptor(q, J);
      (!fn || ("get" in fn ? !q.__esModule : fn.writable || fn.configurable)) && (fn = { enumerable: !0, get: function() {
        return q[J];
      } }), Object.defineProperty(z, en, fn);
    } : function(z, q, J, en) {
      en === void 0 && (en = J), z[en] = q[J];
    }), t = Dn && Dn.__setModuleDefault || (Object.create ? function(z, q) {
      Object.defineProperty(z, "default", { enumerable: !0, value: q });
    } : function(z, q) {
      z.default = q;
    }), r = Dn && Dn.__importStar || function(z) {
      if (z && z.__esModule)
        return z;
      var q = {};
      if (z != null)
        for (var J in z)
          J !== "default" && Object.prototype.hasOwnProperty.call(z, J) && e(q, z, J);
      return t(q, z), q;
    }, i = Dn && Dn.__importDefault || function(z) {
      return z && z.__esModule ? z : { default: z };
    };
    Object.defineProperty(n, "__esModule", { value: !0 }), n.validateArcs = n.clearOuterArcs = n.clearArcs = n.redrawArcs = n.getCoordByValue = n.createGradientElement = n.getColors = n.applyGradientColors = n.getArcDataByPercentage = n.getArcDataByValue = n.applyColors = n.setupTooltip = n.setupArcs = n.drawArc = n.setArcData = n.hideTooltip = void 0;
    var o = r(Ou), f = Zl, s = r(eo()), l = i(K3), c = EB, p = oo(), g = CB, d = function(z, q, J) {
      if (q.data.tooltip != null) {
        var en = q.data.tooltip.text != J.tooltip.current.text();
        en && (J.tooltip.current.html(q.data.tooltip.text).style("position", "absolute").style("display", "block").style("opacity", 1), v(q.data.tooltip, q.data.color, J)), J.tooltip.current.style("left", z.pageX + 15 + "px").style("top", z.pageY - 10 + "px");
      }
      q.data.onMouseMove != null && q.data.onMouseMove(z);
    }, v = function(z, q, J) {
      Object.entries(c.defaultTooltipStyle).forEach(function(en) {
        var fn = en[0], ln = en[1];
        return J.tooltip.current.style(o.camelCaseToKebabCase(fn), ln);
      }), J.tooltip.current.style("background-color", q), z.style != null && Object.entries(z.style).forEach(function(en) {
        var fn = en[0], ln = en[1];
        return J.tooltip.current.style(o.camelCaseToKebabCase(fn), ln);
      });
    }, b = function(z, q, J, en) {
      en.cancel(), (0, n.hideTooltip)(J), q.data.onMouseLeave != null && q.data.onMouseLeave(z);
    }, w = function(z) {
      z.tooltip.current.html(" ").style("display", "none");
    };
    n.hideTooltip = w;
    var m = function(z, q, J) {
      z.target.style.stroke = "none";
    }, _ = function(z, q) {
      q.data.onMouseClick != null && q.data.onMouseClick(z);
    }, x = function(z) {
      var q, J, en = z.props.arc, fn = z.props.minValue, ln = z.props.maxValue, Tn = (en == null ? void 0 : en.nbSubArcs) || ((q = en == null ? void 0 : en.subArcs) === null || q === void 0 ? void 0 : q.length) || 1, gn = (0, n.getColors)(Tn, z);
      if (en != null && en.subArcs && !(en != null && en.nbSubArcs)) {
        var _n = 0, tn = 0, hn = [], vn = [], an = [];
        (J = en == null ? void 0 : en.subArcs) === null || J === void 0 || J.forEach(function(In, Ln) {
          var pn, Pn = 0, U = 0, X = In.limit;
          if (In.length != null)
            Pn = In.length, X = o.getCurrentGaugeValueByPercentage(Pn + tn, z);
          else if (In.limit == null) {
            U = _n;
            var j = void 0, mn = (pn = en == null ? void 0 : en.subArcs) === null || pn === void 0 ? void 0 : pn.slice(Ln), dn = (1 - o.calculatePercentage(fn, ln, _n)) * 100;
            j || (j = dn / Math.max((mn == null ? void 0 : mn.length) || 1, 1) / 100), X = _n + j * 100, Pn = j;
          } else
            U = X - _n, Ln !== 0 ? Pn = o.calculatePercentage(fn, ln, X) - tn : Pn = o.calculatePercentage(fn, ln, U);
          hn.push(Pn), vn.push(X), tn = hn.reduce(function(cn, An) {
            return cn + An;
          }, 0), _n = X, In.tooltip != null && an.push(In.tooltip);
        });
        var xn = en.subArcs;
        z.arcData.current = hn.map(function(In, Ln) {
          return {
            value: In,
            limit: vn[Ln],
            color: gn[Ln],
            showTick: xn[Ln].showTick || !1,
            tooltip: xn[Ln].tooltip || void 0,
            onMouseMove: xn[Ln].onMouseMove,
            onMouseLeave: xn[Ln].onMouseLeave,
            onMouseClick: xn[Ln].onClick
          };
        });
      } else {
        var En = ln / Tn;
        z.arcData.current = Array.from({ length: Tn }, function(In, Ln) {
          return {
            value: En,
            limit: (Ln + 1) * En,
            color: gn[Ln],
            tooltip: void 0
          };
        });
      }
    };
    n.setArcData = x;
    var A = function(z, q) {
      q === void 0 && (q = void 0);
      var J = q ?? o.calculatePercentage(z.props.minValue, z.props.maxValue, z.props.value), en = (0, n.getArcDataByPercentage)(J, z), fn = {
        value: J,
        //White indicate that no arc was found and work as an alert for debug
        color: (en == null ? void 0 : en.color) || "white"
        //disabled for now because onMouseOut is not working properly with the
        //high amount of renderings of this arc
        //tooltip: curArcData?.tooltip
      }, ln = {
        value: 1 - J,
        color: "#5C5C5C"
      };
      return [fn, ln];
    }, T = function(z, q) {
      q === void 0 && (q = !1);
      var J = z.dimensions.current.outerRadius;
      if (z.props.type == p.GaugeType.Grafana && q) {
        z.doughnut.current.selectAll(".outerSubArc").remove();
        var en = (0, f.arc)().outerRadius(J + 7).innerRadius(J + 2).cornerRadius(0).padAngle(0), fn = z.doughnut.current.selectAll("anyString").data(z.pieChart.current(z.arcData.current)).enter().append("g").attr("class", "outerSubArc"), ln = fn.append("path").attr("d", en);
        (0, n.applyColors)(ln, z);
        var Tn = (0, g.throttle)(function(gn, _n) {
          return d(gn, _n, z);
        }, 20);
        fn.on("mouseleave", function(gn, _n) {
          return b(gn, _n, z, Tn);
        }).on("mouseout", function(gn, _n) {
          return m(gn);
        }).on("mousemove", Tn).on("click", function(gn, _n) {
          return _(gn, _n);
        });
      }
    }, S = function(z, q) {
      var J, en;
      q === void 0 && (q = void 0);
      var fn = z.props.arc, ln = fn.padding, Tn = fn.cornerRadius, gn = z.dimensions.current, _n = gn.innerRadius, tn = gn.outerRadius, hn = {};
      !((en = (J = z.props) === null || J === void 0 ? void 0 : J.arc) === null || en === void 0) && en.gradient ? hn = [{ value: 1 }] : hn = z.arcData.current, z.props.type == p.GaugeType.Grafana && (hn = A(z, q));
      var vn = z.props.type == p.GaugeType.Grafana ? 0 : ln, an = z.props.type == p.GaugeType.Grafana ? 0 : Tn, xn = (0, f.arc)().outerRadius(tn).innerRadius(_n).cornerRadius(an).padAngle(vn), En = z.doughnut.current.selectAll("anyString").data(z.pieChart.current(hn)).enter().append("g").attr("class", "subArc"), In = En.append("path").attr("d", xn);
      (0, n.applyColors)(In, z);
      var Ln = (0, g.throttle)(function(pn, Pn) {
        return d(pn, Pn, z);
      }, 20);
      En.on("mouseleave", function(pn, Pn) {
        return b(pn, Pn, z, Ln);
      }).on("mouseout", function(pn, Pn) {
        return m(pn);
      }).on("mousemove", Ln).on("click", function(pn, Pn) {
        return _(pn, Pn);
      });
    };
    n.drawArc = S;
    var R = function(z, q) {
      q === void 0 && (q = !1), (0, n.setupTooltip)(z), T(z, q), (0, n.drawArc)(z);
    };
    n.setupArcs = R;
    var I = function(z) {
      var q = document.getElementsByClassName(l.default.arcTooltipClassname).length != 0;
      q || (0, f.select)("body").append("div").attr("class", l.default.arcTooltipClassname), z.tooltip.current = (0, f.select)(".".concat(l.default.arcTooltipClassname)), z.tooltip.current.on("mouseleave", function() {
        return s.hideTooltip(z);
      }).on("mouseout", function() {
        return s.hideTooltip(z);
      });
    };
    n.setupTooltip = I;
    var B = function(z, q) {
      var J, en;
      if (!((en = (J = q.props) === null || J === void 0 ? void 0 : J.arc) === null || en === void 0) && en.gradient) {
        var fn = "subArc-linear-gradient-".concat(Math.random()), ln = (0, n.createGradientElement)(q.doughnut.current, fn);
        (0, n.applyGradientColors)(ln, q), z.style("fill", function(Tn) {
          return "url(#".concat(fn, ")");
        });
      } else
        z.style("fill", function(Tn) {
          return Tn.data.color;
        });
    };
    n.applyColors = B;
    var F = function(z, q) {
      return q.arcData.current.find(function(J) {
        return z <= J.limit;
      });
    };
    n.getArcDataByValue = F;
    var V = function(z, q) {
      return (0, n.getArcDataByValue)(o.getCurrentGaugeValueByPercentage(z, q), q);
    };
    n.getArcDataByPercentage = V;
    var E = function(z, q) {
      q.arcData.current.forEach(function(J) {
        var en, fn, ln, Tn, gn = o.normalize(J == null ? void 0 : J.limit, (fn = (en = q == null ? void 0 : q.props) === null || en === void 0 ? void 0 : en.minValue) !== null && fn !== void 0 ? fn : 0, (Tn = (ln = q == null ? void 0 : q.props) === null || ln === void 0 ? void 0 : ln.maxValue) !== null && Tn !== void 0 ? Tn : 100);
        z.append("stop").attr("offset", "".concat(gn, "%")).style("stop-color", J.color).style("stop-opacity", 1);
      });
    };
    n.applyGradientColors = E;
    var L = function(z, q) {
      var J, en = q.props.arc, fn = [];
      if (en.colorArray)
        fn = en.colorArray;
      else {
        var ln = (J = en.subArcs) === null || J === void 0 ? void 0 : J.map(function(hn) {
          return hn.color;
        });
        fn = ln != null && ln.some(function(hn) {
          return hn != null;
        }) ? ln : l.default.defaultColors;
      }
      fn || (fn = ["#fff"]);
      var Tn = z === (fn == null ? void 0 : fn.length);
      if (Tn)
        return fn;
      for (var gn = (0, f.scaleLinear)().domain([1, z]).range([fn[0], fn[fn.length - 1]]).interpolate(f.interpolateHsl), _n = [], tn = 1; tn <= z; tn++)
        _n.push(gn(tn));
      return _n;
    };
    n.getColors = L;
    var $ = function(z, q) {
      var J = z.append("defs").append("linearGradient").attr("id", q).attr("x1", "0%").attr("x2", "100%").attr("y1", "0%").attr("y2", "0%");
      return J;
    };
    n.createGradientElement = $;
    var P = function(z, q, J, en, fn) {
      var ln;
      J === void 0 && (J = "inner"), en === void 0 && (en = 0), fn === void 0 && (fn = 1);
      var Tn = {
        outer: function() {
          return q.dimensions.current.outerRadius - en + 2;
        },
        inner: function() {
          return q.dimensions.current.innerRadius * fn - en + 9;
        },
        between: function() {
          var X = q.dimensions.current.outerRadius - q.dimensions.current.innerRadius, j = q.dimensions.current.innerRadius + X - 5;
          return j;
        }
      }, gn = Tn[J]();
      q.props.type === p.GaugeType.Grafana ? gn += 5 : q.props.type === p.GaugeType.Semicircle && (gn += -2);
      var _n = o.calculatePercentage(q.props.minValue, q.props.maxValue, z), tn = (ln = {}, ln[p.GaugeType.Grafana] = {
        startAngle: o.degToRad(-23),
        endAngle: o.degToRad(203)
      }, ln[p.GaugeType.Semicircle] = {
        startAngle: o.degToRad(0.9),
        endAngle: o.degToRad(179.1)
      }, ln[p.GaugeType.Radial] = {
        startAngle: o.degToRad(-39),
        endAngle: o.degToRad(219)
      }, ln), hn = tn[q.props.type], vn = hn.startAngle, an = hn.endAngle, xn = vn + _n * (an - vn), En = 1 * (q.dimensions.current.width / 500), In = [0, -En / 2], Ln = [
        In[0] - gn * Math.cos(xn),
        In[1] - gn * Math.sin(xn)
      ], pn = [q.dimensions.current.outerRadius, q.dimensions.current.outerRadius], Pn = pn[0] + Ln[0], U = pn[1] + Ln[1];
      return { x: Pn, y: U };
    };
    n.getCoordByValue = P;
    var k = function(z) {
      (0, n.clearArcs)(z), (0, n.setArcData)(z), (0, n.setupArcs)(z);
    };
    n.redrawArcs = k;
    var O = function(z) {
      z.doughnut.current.selectAll(".subArc").remove();
    };
    n.clearArcs = O;
    var W = function(z) {
      z.doughnut.current.selectAll(".outerSubArc").remove();
    };
    n.clearOuterArcs = W;
    var K = function(z) {
      Q(z);
    };
    n.validateArcs = K;
    var Q = function(z) {
      for (var q, J = z.props.minValue, en = z.props.maxValue, fn = z.props.arc, ln = fn.subArcs, Tn = void 0, gn = 0, _n = ((q = z.props.arc) === null || q === void 0 ? void 0 : q.subArcs) || []; gn < _n.length; gn++) {
        var tn = _n[gn], hn = tn.limit;
        if (typeof hn < "u") {
          if (hn < J || hn > en)
            throw new Error("The limit of a subArc must be between the minValue and maxValue. The limit of the subArc is ".concat(hn));
          if (typeof Tn < "u" && hn <= Tn)
            throw new Error("The limit of a subArc must be greater than the limit of the previous subArc. The limit of the subArc is ".concat(hn, `. If you're trying to specify length in percent of the arc, use property "length". refer to: https://github.com/antoniolago/react-gauge-component`));
          Tn = hn;
        }
      }
      if (ln.length > 0) {
        var vn = ln[ln.length - 1];
        vn.limit < en && (vn.limit = en);
      }
    };
  }(jh)), jh;
}
var O1 = {};
(function(n) {
  var e = Dn && Dn.__assign || function() {
    return e = Object.assign || function(E) {
      for (var L, $ = 1, P = arguments.length; $ < P; $++) {
        L = arguments[$];
        for (var k in L)
          Object.prototype.hasOwnProperty.call(L, k) && (E[k] = L[k]);
      }
      return E;
    }, e.apply(this, arguments);
  }, t = Dn && Dn.__createBinding || (Object.create ? function(E, L, $, P) {
    P === void 0 && (P = $);
    var k = Object.getOwnPropertyDescriptor(L, $);
    (!k || ("get" in k ? !L.__esModule : k.writable || k.configurable)) && (k = { enumerable: !0, get: function() {
      return L[$];
    } }), Object.defineProperty(E, P, k);
  } : function(E, L, $, P) {
    P === void 0 && (P = $), E[P] = L[$];
  }), r = Dn && Dn.__setModuleDefault || (Object.create ? function(E, L) {
    Object.defineProperty(E, "default", { enumerable: !0, value: L });
  } : function(E, L) {
    E.default = L;
  }), i = Dn && Dn.__importStar || function(E) {
    if (E && E.__esModule)
      return E;
    var L = {};
    if (E != null)
      for (var $ in E)
        $ !== "default" && Object.prototype.hasOwnProperty.call(E, $) && t(L, E, $);
    return r(L, E), L;
  }, o = Dn && Dn.__importDefault || function(E) {
    return E && E.__esModule ? E : { default: E };
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.calculateAnchorAndAngleByValue = n.clearTicks = n.clearValueLabel = n.addValueText = n.addText = n.getLabelCoordsByValue = n.addTick = n.addTickValue = n.addTickLine = n.mapTick = n.addArcTicks = n.setupTicks = n.setupValueLabel = n.setupLabels = void 0;
  var f = i(Ou), s = o(K3), l = X3, c = i(Zl), p = oo(), g = eo(), d = function(E) {
    (0, n.setupValueLabel)(E), (0, n.setupTicks)(E);
  };
  n.setupLabels = d;
  var v = function(E) {
    var L, $ = E.props.labels;
    !((L = $ == null ? void 0 : $.valueLabel) === null || L === void 0) && L.hide || (0, n.addValueText)(E);
  };
  n.setupValueLabel = v;
  var b = function(E) {
    var L, $, P, k, O, W, K, Q, z, q = E.props.labels, J = E.props.minValue, en = E.props.maxValue;
    if (s.default.debugTicksRadius)
      for (var fn = 0; fn < en; fn++) {
        var ln = (0, n.mapTick)(fn, E);
        (0, n.addTick)(ln, E);
      }
    else if (!(!((L = q.tickLabels) === null || L === void 0) && L.hideMinMax)) {
      var Tn = (P = ($ = q.tickLabels) === null || $ === void 0 ? void 0 : $.ticks) === null || P === void 0 ? void 0 : P.some(function(hn) {
        return hn.value == J;
      });
      if (!Tn) {
        var gn = (0, n.mapTick)(J, E);
        (0, n.addTick)(gn, E);
      }
      var _n = (O = (k = q.tickLabels) === null || k === void 0 ? void 0 : k.ticks) === null || O === void 0 ? void 0 : O.some(function(hn) {
        return hn.value == en;
      });
      if (!_n) {
        var tn = (0, n.mapTick)(en, E);
        (0, n.addTick)(tn, E);
      }
    }
    ((K = (W = q.tickLabels) === null || W === void 0 ? void 0 : W.ticks) === null || K === void 0 ? void 0 : K.length) > 0 && ((z = (Q = q.tickLabels) === null || Q === void 0 ? void 0 : Q.ticks) === null || z === void 0 || z.forEach(function(hn) {
      (0, n.addTick)(hn, E);
    })), (0, n.addArcTicks)(E);
  };
  n.setupTicks = b;
  var w = function(E) {
    var L;
    E.props.arc, (L = E.arcData.current) === null || L === void 0 || L.map(function($) {
      if ($.showTick)
        return $.limit;
    }).forEach(function($) {
      $ && (0, n.addTick)((0, n.mapTick)($, E), E);
    });
  };
  n.addArcTicks = w;
  var m = function(E, L) {
    var $ = L.props.labels.tickLabels;
    return {
      value: E,
      valueConfig: $ == null ? void 0 : $.defaultTickValueConfig,
      lineConfig: $ == null ? void 0 : $.defaultTickLineConfig
    };
  };
  n.mapTick = m;
  var _ = function(E, L) {
    var $, P, k, O, W, K, Q, z, q, J, en, fn, ln, Tn, gn, _n, tn, hn, vn = L.props.labels, an = (0, n.calculateAnchorAndAngleByValue)(E == null ? void 0 : E.value, L);
    an.tickAnchor;
    var xn = an.angle, En = ((P = ($ = vn == null ? void 0 : vn.tickLabels) === null || $ === void 0 ? void 0 : $.defaultTickLineConfig) === null || P === void 0 ? void 0 : P.distanceFromArc) || ((k = E.lineConfig) === null || k === void 0 ? void 0 : k.distanceFromArc) || 0;
    ((W = (O = L.props.labels) === null || O === void 0 ? void 0 : O.tickLabels) === null || W === void 0 ? void 0 : W.type) == "outer" && (En = -En);
    var In = (0, n.getLabelCoordsByValue)(E == null ? void 0 : E.value, L, En), Ln = ((Q = (K = vn == null ? void 0 : vn.tickLabels) === null || K === void 0 ? void 0 : K.defaultTickLineConfig) === null || Q === void 0 ? void 0 : Q.color) || ((z = E.lineConfig) === null || z === void 0 ? void 0 : z.color) || ((q = l.defaultTickLabels.defaultTickLineConfig) === null || q === void 0 ? void 0 : q.color), pn = ((en = (J = vn == null ? void 0 : vn.tickLabels) === null || J === void 0 ? void 0 : J.defaultTickLineConfig) === null || en === void 0 ? void 0 : en.width) || ((fn = E.lineConfig) === null || fn === void 0 ? void 0 : fn.width) || ((ln = l.defaultTickLabels.defaultTickLineConfig) === null || ln === void 0 ? void 0 : ln.width), Pn = ((gn = (Tn = vn == null ? void 0 : vn.tickLabels) === null || Tn === void 0 ? void 0 : Tn.defaultTickLineConfig) === null || gn === void 0 ? void 0 : gn.length) || ((_n = E.lineConfig) === null || _n === void 0 ? void 0 : _n.length) || ((tn = l.defaultTickLabels.defaultTickLineConfig) === null || tn === void 0 ? void 0 : tn.length), U, X;
    ((hn = vn == null ? void 0 : vn.tickLabels) === null || hn === void 0 ? void 0 : hn.type) == "inner" ? (U = In.x + Pn * Math.cos(xn * Math.PI / 180), X = In.y + Pn * Math.sin(xn * Math.PI / 180)) : (U = In.x - Pn * Math.cos(xn * Math.PI / 180), X = In.y - Pn * Math.sin(xn * Math.PI / 180));
    var j = c.line(), mn;
    mn = [[In.x, In.y], [U, X]], L.g.current.append("path").datum(mn).attr("class", s.default.tickLineClassname).attr("d", j).attr("stroke", Ln).attr("stroke-width", pn).attr("fill", "none");
  };
  n.addTickLine = _;
  var x = function(E, L) {
    var $, P, k, O, W, K, Q, z, q, J, en, fn, ln, Tn, gn, _n, tn, hn, vn, an, xn = L.props.labels, En = L.props.arc, In = En.width, Ln = E == null ? void 0 : E.value, pn = (0, n.calculateAnchorAndAngleByValue)(Ln, L).tickAnchor, Pn = 27 - In * 10, U = (($ = xn == null ? void 0 : xn.tickLabels) === null || $ === void 0 ? void 0 : $.type) == "inner";
    U ? Pn -= 10 : Pn = In * 10 - 10;
    var X = ((k = (P = xn == null ? void 0 : xn.tickLabels) === null || P === void 0 ? void 0 : P.defaultTickLineConfig) === null || k === void 0 ? void 0 : k.distanceFromArc) || ((O = E.lineConfig) === null || O === void 0 ? void 0 : O.distanceFromArc) || 0, j = ((K = (W = xn == null ? void 0 : xn.tickLabels) === null || W === void 0 ? void 0 : W.defaultTickLineConfig) === null || K === void 0 ? void 0 : K.length) || ((Q = E.lineConfig) === null || Q === void 0 ? void 0 : Q.length) || 0, mn = ((q = (z = xn == null ? void 0 : xn.tickLabels) === null || z === void 0 ? void 0 : z.defaultTickLineConfig) === null || q === void 0 ? void 0 : q.hide) || ((J = E.lineConfig) === null || J === void 0 ? void 0 : J.hide);
    mn || (U ? (Pn += X, Pn += j) : (Pn -= X, Pn -= j));
    var dn = (0, n.getLabelCoordsByValue)(Ln, L, Pn), cn = ((en = E.valueConfig) === null || en === void 0 ? void 0 : en.style) || ((ln = (fn = xn == null ? void 0 : xn.tickLabels) === null || fn === void 0 ? void 0 : fn.defaultTickValueConfig) === null || ln === void 0 ? void 0 : ln.style) || {};
    cn = e({}, cn);
    var An = "", Zn = (_n = (gn = (Tn = L.props.labels) === null || Tn === void 0 ? void 0 : Tn.tickLabels) === null || gn === void 0 ? void 0 : gn.defaultTickValueConfig) === null || _n === void 0 ? void 0 : _n.maxDecimalDigits;
    !((tn = E.valueConfig) === null || tn === void 0) && tn.formatTextValue ? An = E.valueConfig.formatTextValue(f.floatingNumber(Ln, Zn)) : !((vn = (hn = xn == null ? void 0 : xn.tickLabels) === null || hn === void 0 ? void 0 : hn.defaultTickValueConfig) === null || vn === void 0) && vn.formatTextValue ? An = xn.tickLabels.defaultTickValueConfig.formatTextValue(f.floatingNumber(Ln, Zn)) : L.props.minValue === 0 && L.props.maxValue === 100 ? (An = f.floatingNumber(Ln, Zn).toString(), An += "%") : An = f.floatingNumber(Ln, Zn).toString(), ((an = xn == null ? void 0 : xn.tickLabels) === null || an === void 0 ? void 0 : an.type) == "inner" ? (pn === "end" && (dn.x += 10), pn === "start" && (dn.x -= 10)) : pn === "middle" && (dn.y += 2), pn === "middle" ? dn.y += 0 : dn.y += 3, cn.textAnchor = pn, (0, n.addText)(An, dn.x, dn.y, L, cn, s.default.tickValueClassname);
  };
  n.addTickValue = x;
  var A = function(E, L) {
    var $, P, k, O, W = L.props;
    W.minValue, W.maxValue;
    var K = W.labels;
    W.arc, !((P = ($ = K == null ? void 0 : K.tickLabels) === null || $ === void 0 ? void 0 : $.defaultTickLineConfig) === null || P === void 0) && P.hide || (0, n.addTickLine)(E, L), !s.default.debugTicksRadius && !(!((O = (k = K == null ? void 0 : K.tickLabels) === null || k === void 0 ? void 0 : k.defaultTickValueConfig) === null || O === void 0) && O.hide) && (0, n.addTickValue)(E, L);
  };
  n.addTick = A;
  var T = function(E, L, $) {
    var P;
    $ === void 0 && ($ = 0);
    var k = L.props.labels, O = L.props.minValue, W = L.props.maxValue, K = (P = k.tickLabels) === null || P === void 0 ? void 0 : P.type, Q = (0, g.getCoordByValue)(E, L, K, $, 0.93), z = Q.x, q = Q.y;
    return f.calculatePercentage(O, W, E), L.props.type == p.GaugeType.Radial && (q += 3), { x: z, y: q };
  };
  n.getLabelCoordsByValue = T;
  var S = function(E, L, $, P, k, O, W) {
    W === void 0 && (W = 0);
    var K = P.g.current.append("g").attr("class", O).attr("transform", "translate(".concat(L, ", ").concat($, ")")).append("text").text(E);
    R(K, k), K.attr("transform", "rotate(".concat(W, ")"));
  };
  n.addText = S;
  var R = function(E, L) {
    Object.entries(L).forEach(function($) {
      var P = $[0], k = $[1];
      return E.style(f.camelCaseToKebabCase(P), k);
    }), L != null && Object.entries(L).forEach(function($) {
      var P = $[0], k = $[1];
      return E.style(f.camelCaseToKebabCase(P), k);
    });
  }, I = function(E) {
    var L, $, P, k, O, W = E.props.value, K = (L = E.props.labels) === null || L === void 0 ? void 0 : L.valueLabel, Q = 20, z = "", q = (P = ($ = E.props.labels) === null || $ === void 0 ? void 0 : $.valueLabel) === null || P === void 0 ? void 0 : P.maxDecimalDigits, J = f.floatingNumber(W, q);
    K.formatTextValue ? z = K.formatTextValue(J) : E.props.minValue === 0 && E.props.maxValue === 100 ? (z = J.toString(), z += "%") : z = J.toString();
    var en = 4, fn = (z == null ? void 0 : z.length) || 0, ln = fn > en ? en / fn * 1.5 : 1, Tn = (k = K == null ? void 0 : K.style) === null || k === void 0 ? void 0 : k.fontSize, gn = e({}, K.style), _n = E.dimensions.current.outerRadius, tn = 0;
    gn.textAnchor = "middle", E.props.type == p.GaugeType.Semicircle ? tn = E.dimensions.current.outerRadius / 1.5 + Q : E.props.type == p.GaugeType.Radial ? tn = E.dimensions.current.outerRadius * 1.45 + Q : E.props.type == p.GaugeType.Grafana && (tn = E.dimensions.current.outerRadius * 1 + Q);
    var hn = (E.props.type == p.GaugeType.Radial, 3e-3);
    ln = E.dimensions.current.width * hn * ln;
    var vn = parseInt(Tn, 10) * ln;
    gn.fontSize = vn + "px", K.matchColorWithArc && (gn.fill = ((O = (0, g.getArcDataByValue)(W, E)) === null || O === void 0 ? void 0 : O.color) || "white"), (0, n.addText)(z, _n, tn, E, gn, s.default.valueLabelClassname);
  };
  n.addValueText = I;
  var B = function(E) {
    return E.g.current.selectAll(".".concat(s.default.valueLabelClassname)).remove();
  };
  n.clearValueLabel = B;
  var F = function(E) {
    E.g.current.selectAll(".".concat(s.default.tickLineClassname)).remove(), E.g.current.selectAll(".".concat(s.default.tickValueClassname)).remove();
  };
  n.clearTicks = F;
  var V = function(E, L) {
    var $, P, k, O = L.props.minValue, W = L.props.maxValue, K = f.calculatePercentage(O, W, E), Q = ($ = {}, $[p.GaugeType.Grafana] = {
      startAngle: -20,
      endAngle: 220
    }, $[p.GaugeType.Semicircle] = {
      startAngle: 0,
      endAngle: 180
    }, $[p.GaugeType.Radial] = {
      startAngle: -42,
      endAngle: 266
    }, $), z = Q[L.props.type], q = z.startAngle, J = z.endAngle, en = q + K * 100 * J / 100, fn = f.calculatePercentage(O, W, W / 2), ln = fn, Tn = K < ln, gn = K > s.default.rangeBetweenCenteredTickValueLabel[0] && K < s.default.rangeBetweenCenteredTickValueLabel[1], _n = "", tn = ((k = (P = L.props.labels) === null || P === void 0 ? void 0 : P.tickLabels) === null || k === void 0 ? void 0 : k.type) == "inner";
    return gn ? _n = "middle" : Tn ? _n = tn ? "start" : "end" : _n = tn ? "end" : "start", { tickAnchor: _n, angle: en };
  };
  n.calculateAnchorAndAngleByValue = V;
})(O1);
const PB = /* @__PURE__ */ Br(O1), RB = /* @__PURE__ */ Dt({
  __proto__: null,
  default: PB
}, [O1]), NB = /* @__PURE__ */ xt(RB);
var I1 = {};
(function(n) {
  var e = Dn && Dn.__createBinding || (Object.create ? function(S, R, I, B) {
    B === void 0 && (B = I);
    var F = Object.getOwnPropertyDescriptor(R, I);
    (!F || ("get" in F ? !R.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return R[I];
    } }), Object.defineProperty(S, B, F);
  } : function(S, R, I, B) {
    B === void 0 && (B = I), S[B] = R[I];
  }), t = Dn && Dn.__setModuleDefault || (Object.create ? function(S, R) {
    Object.defineProperty(S, "default", { enumerable: !0, value: R });
  } : function(S, R) {
    S.default = R;
  }), r = Dn && Dn.__importStar || function(S) {
    if (S && S.__esModule)
      return S;
    var R = {};
    if (S != null)
      for (var I in S)
        I !== "default" && Object.prototype.hasOwnProperty.call(S, I) && e(R, S, I);
    return t(R, S), R;
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.clearPointerElement = n.addPointerElement = n.translatePointer = n.drawPointer = void 0;
  var i = Zl, o = R1, f = eo(), s = r(Ou), l = r(eo()), c = oo(), p = function(S, R) {
    var I;
    R === void 0 && (R = !1), S.pointer.current.context = g(S);
    var B = S.pointer.current.context, F = B.prevPercent, V = B.currentPercent, E = B.prevProgress, L = S.props.pointer, $ = ((I = S.prevProps) === null || I === void 0 ? void 0 : I.current.value) == null;
    ($ || R) && S.props.type != c.GaugeType.Grafana && d(S);
    var P = (!R || $) && L.animate;
    P ? S.doughnut.current.transition().delay(L.animationDelay).ease(L.elastic ? i.easeElastic : i.easeExpOut).duration(L.animationDuration).tween("progress", function() {
      var k = (0, i.interpolateNumber)(F, V);
      return function(O) {
        var W = k(O);
        w(W, E) && (S.props.type == c.GaugeType.Grafana ? (l.clearArcs(S), l.drawArc(S, W)) : v(W, S)), S.pointer.current.context.prevProgress = W;
      };
    }) : v(V, S);
  };
  n.drawPointer = p;
  var g = function(S) {
    var R, I = S.props.value, B = S.props.pointer, F = B.length, V = S.props.minValue, E = S.props.maxValue;
    S.pointer.current.context.pointerPath;
    var L = _(S), $ = B.type == o.PointerType.Needle ? F : 0.2, P = [o.PointerType.Needle, o.PointerType.Arrow], k = {
      centerPoint: [0, -L / 2],
      pointerRadius: _(S),
      pathLength: S.dimensions.current.outerRadius * $,
      currentPercent: s.calculatePercentage(V, E, I),
      prevPercent: s.calculatePercentage(V, E, ((R = S.prevProps) === null || R === void 0 ? void 0 : R.current.value) || V),
      prevProgress: 0,
      pathStr: "",
      shouldDrawPath: P.includes(B.type),
      prevColor: ""
    };
    return k;
  }, d = function(S) {
    var R = S.props.value, I = S.props.pointer, B = S.pointer.current.context, F = B.shouldDrawPath, V = B.centerPoint, E = B.pointerRadius;
    B.pathStr;
    var L = B.currentPercent, $ = B.prevPercent;
    F && (S.pointer.current.context.pathStr = m(S, $ || L), S.pointer.current.path = S.pointer.current.element.append("path").attr("d", S.pointer.current.context.pathStr).attr("fill", I.color)), I.type == o.PointerType.Needle ? S.pointer.current.element.append("circle").attr("cx", V[0]).attr("cy", V[1]).attr("r", E).attr("fill", I.color) : I.type == o.PointerType.Blob && S.pointer.current.element.append("circle").attr("cx", V[0]).attr("cy", V[1]).attr("r", E).attr("fill", I.baseColor).attr("stroke", I.color).attr("stroke-width", 8 * E / 10), b(E, R, S);
  }, v = function(S, R) {
    var I, B = R.props.pointer, F = R.pointer.current.context, V = F.pointerRadius, E = F.shouldDrawPath, L = F.prevColor;
    if (b(V, S, R), E && R.props.type != c.GaugeType.Grafana && R.pointer.current.path.attr("d", m(R, S)), B.type == o.PointerType.Blob) {
      var $ = (I = l.getArcDataByPercentage(S, R)) === null || I === void 0 ? void 0 : I.color, P = $ != L;
      P && R.pointer.current.element.select("circle").attr("stroke", $), R.pointer.current.context.prevColor = $;
    }
  }, b = function(S, R, I) {
    var B, F = I.props.pointer, V = F.type, E = I.dimensions, L = s.getCurrentGaugeValueByPercentage(R, I), $ = (B = {}, B[o.PointerType.Needle] = function() {
      (0, n.translatePointer)(E.current.outerRadius, E.current.outerRadius, I);
    }, B[o.PointerType.Arrow] = function() {
      var P = (0, f.getCoordByValue)(L, I, "inner", 0, 0.7), k = P.x, O = P.y;
      k -= 1, O += S - 3, (0, n.translatePointer)(k, O, I);
    }, B[o.PointerType.Blob] = function() {
      var P = (0, f.getCoordByValue)(L, I, "between", 0, 0.75), k = P.x, O = P.y;
      k -= 1, O += S, (0, n.translatePointer)(k, O, I);
    }, B);
    return $[V]();
  }, w = function(S, R, I) {
    var B = S > 1 || S < 0, F = Math.abs(S - R) < 1e-4, V = S == R;
    return !F && !V && !B;
  }, m = function(S, R) {
    var I = S.pointer.current.context, B = I.centerPoint, F = I.pointerRadius, V = I.pathLength, E = s.degToRad(S.props.type == c.GaugeType.Semicircle ? 0 : -42), L = s.degToRad(S.props.type == c.GaugeType.Semicircle ? 180 : 223), $ = E + R * (L - E), P = [
      B[0] - V * Math.cos($),
      B[1] - V * Math.sin($)
    ], k = $ - Math.PI / 2, O = [
      B[0] - F * Math.cos(k),
      B[1] - F * Math.sin(k)
    ], W = $ + Math.PI / 2, K = [
      B[0] - F * Math.cos(W),
      B[1] - F * Math.sin(W)
    ], Q = "M ".concat(O[0], " ").concat(O[1], " L ").concat(P[0], " ").concat(P[1], " L ").concat(K[0], " ").concat(K[1]);
    return Q;
  }, _ = function(S) {
    var R = S.props.pointer, I = R.width;
    return I * (S.dimensions.current.width / 500);
  }, x = function(S, R, I) {
    return I.pointer.current.element.attr("transform", "translate(" + S + ", " + R + ")");
  };
  n.translatePointer = x;
  var A = function(S) {
    return S.pointer.current.element = S.g.current.append("g").attr("class", "pointer");
  };
  n.addPointerElement = A;
  var T = function(S) {
    return S.pointer.current.element.selectAll("*").remove();
  };
  n.clearPointerElement = T;
})(I1);
const $B = /* @__PURE__ */ Br(I1), kB = /* @__PURE__ */ Dt({
  __proto__: null,
  default: $B
}, [I1]), OB = /* @__PURE__ */ xt(kB);
(function(n) {
  var e = Dn && Dn.__createBinding || (Object.create ? function(m, _, x, A) {
    A === void 0 && (A = x);
    var T = Object.getOwnPropertyDescriptor(_, x);
    (!T || ("get" in T ? !_.__esModule : T.writable || T.configurable)) && (T = { enumerable: !0, get: function() {
      return _[x];
    } }), Object.defineProperty(m, A, T);
  } : function(m, _, x, A) {
    A === void 0 && (A = x), m[A] = _[x];
  }), t = Dn && Dn.__setModuleDefault || (Object.create ? function(m, _) {
    Object.defineProperty(m, "default", { enumerable: !0, value: _ });
  } : function(m, _) {
    m.default = _;
  }), r = Dn && Dn.__importStar || function(m) {
    if (m && m.__esModule)
      return m;
    var _ = {};
    if (m != null)
      for (var x in m)
        x !== "default" && Object.prototype.hasOwnProperty.call(m, x) && e(_, m, x);
    return t(_, m), _;
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.clearChart = n.centerGraph = n.calculateRadius = n.updateDimensions = n.renderChart = n.calculateAngles = n.initChart = void 0;
  var i = oo(), o = r(eo()), f = r(NB), s = r(OB), l = r(Ou), c = function(m) {
    var _ = m.dimensions.current.angles, x = JSON.stringify(m.prevProps.current.value) !== JSON.stringify(m.props.value), A = l.isEmptyObject(m.svg.current);
    if (x && !A) {
      (0, n.renderChart)(m, !1);
      return;
    }
    m.container.current.select("svg").remove(), m.svg.current = m.container.current.append("svg"), m.g.current = m.svg.current.append("g"), m.doughnut.current = m.g.current.append("g").attr("class", "doughnut"), (0, n.calculateAngles)(m), m.pieChart.current.value(function(T) {
      return T.value;
    }).startAngle(_.startAngle).endAngle(_.endAngle).sort(null), s.addPointerElement(m), (0, n.renderChart)(m, !0);
  };
  n.initChart = c;
  var p = function(m) {
    var _ = m.dimensions.current.angles;
    m.props.type == i.GaugeType.Semicircle ? (_.startAngle = -Math.PI / 2 + 0.02, _.endAngle = Math.PI / 2 - 0.02) : m.props.type == i.GaugeType.Radial ? (_.startAngle = -Math.PI / 1.37, _.endAngle = Math.PI / 1.37) : m.props.type == i.GaugeType.Grafana && (_.startAngle = -Math.PI / 1.6, _.endAngle = Math.PI / 1.6);
  };
  n.calculateAngles = p;
  var g = function(m, _) {
    var x, A;
    _ === void 0 && (_ = !1);
    var T = m.dimensions, S = m.props.arc, R = m.props.labels;
    if (_) {
      (0, n.updateDimensions)(m), m.g.current.attr("transform", "translate(" + T.current.margin.left + ", 35)"), (0, n.calculateRadius)(m), m.doughnut.current.attr("transform", "translate(" + T.current.outerRadius + ", " + T.current.outerRadius + ")"), m.doughnut.current.on("mouseleave", function() {
        return o.hideTooltip(m);
      }).on("mouseout", function() {
        return o.hideTooltip(m);
      });
      var I = S.width;
      T.current.innerRadius = T.current.outerRadius * (1 - I), (0, n.clearChart)(m), o.setArcData(m), o.setupArcs(m, _), f.setupLabels(m), s.drawPointer(m, _);
      var B = (x = {}, x[i.GaugeType.Semicircle] = 50, x[i.GaugeType.Radial] = 55, x[i.GaugeType.Grafana] = 55, x), F = m.doughnut.current.node().getBoundingClientRect().height, V = m.container.current.node().getBoundingClientRect().width, E = m.props.type;
      m.svg.current.attr("width", V).attr("height", F + B[E]);
    } else {
      var L = JSON.stringify(m.prevProps.current.arc) !== JSON.stringify(m.props.arc), $ = JSON.stringify(m.prevProps.current.pointer) !== JSON.stringify(m.props.pointer), P = JSON.stringify(m.prevProps.current.value) !== JSON.stringify(m.props.value), k = JSON.stringify((A = m.prevProps.current.labels) === null || A === void 0 ? void 0 : A.tickLabels) !== JSON.stringify(R.tickLabels), O = L;
      O && (o.clearArcs(m), o.setArcData(m), o.setupArcs(m, _)), ($ || P) && s.drawPointer(m), (L || k) && (f.clearTicks(m), f.setupTicks(m)), P && (f.clearValueLabel(m), f.setupValueLabel(m));
    }
  };
  n.renderChart = g;
  var d = function(m) {
    var _ = m.props.marginInPercent, x = m.dimensions, A = m.container.current.node().getBoundingClientRect(), T = A.width, S = A.height;
    x.current.fixedHeight == 0 && (x.current.fixedHeight = S + 200);
    var R = typeof _ == "number", I = R ? _ : _.left, B = R ? _ : _.right, F = R ? _ : _.top, V = R ? _ : _.bottom;
    x.current.margin.left = T * I, x.current.margin.right = T * B, x.current.width = T - x.current.margin.left - x.current.margin.right, x.current.margin.top = x.current.fixedHeight * F, x.current.margin.bottom = x.current.fixedHeight * V, x.current.height = x.current.width / 2 - x.current.margin.top - x.current.margin.bottom;
  };
  n.updateDimensions = d;
  var v = function(m) {
    var _ = m.dimensions;
    _.current.width < 2 * _.current.height ? _.current.outerRadius = (_.current.width - _.current.margin.left - _.current.margin.right) / 2 : _.current.outerRadius = _.current.height - _.current.margin.top - _.current.margin.bottom + 35, (0, n.centerGraph)(m);
  };
  n.calculateRadius = v;
  var b = function(m) {
    var _ = m.dimensions;
    _.current.margin.left = _.current.width / 2 - _.current.outerRadius + _.current.margin.right, m.g.current.attr("transform", "translate(" + _.current.margin.left + ", " + _.current.margin.top + ")");
  };
  n.centerGraph = b;
  var w = function(m) {
    f.clearTicks(m), f.clearValueLabel(m), s.clearPointerElement(m), o.clearArcs(m);
  };
  n.clearChart = w;
})(N1);
const IB = /* @__PURE__ */ Br(N1), LB = /* @__PURE__ */ Dt({
  __proto__: null,
  default: IB
}, [N1]), DB = /* @__PURE__ */ xt(LB);
var L1 = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.defaultDimensions = n.defaultAngles = n.defaultMargins = void 0, n.defaultMargins = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, n.defaultAngles = {
    startAngle: 0,
    endAngle: 0,
    startAngleDeg: 0,
    endAngleDeg: 0
  }, n.defaultDimensions = {
    width: 0,
    height: 0,
    margin: n.defaultMargins,
    outerRadius: 0,
    innerRadius: 0,
    angles: n.defaultAngles,
    fixedHeight: 0
  };
})(L1);
const FB = /* @__PURE__ */ Br(L1), BB = /* @__PURE__ */ Dt({
  __proto__: null,
  default: FB
}, [L1]), zB = /* @__PURE__ */ xt(BB);
var jo = Dn && Dn.__assign || function() {
  return jo = Object.assign || function(n) {
    for (var e, t = 1, r = arguments.length; t < r; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (n[i] = e[i]);
    }
    return n;
  }, jo.apply(this, arguments);
}, VB = Dn && Dn.__createBinding || (Object.create ? function(n, e, t, r) {
  r === void 0 && (r = t);
  var i = Object.getOwnPropertyDescriptor(e, t);
  (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return e[t];
  } }), Object.defineProperty(n, r, i);
} : function(n, e, t, r) {
  r === void 0 && (r = t), n[r] = e[t];
}), UB = Dn && Dn.__setModuleDefault || (Object.create ? function(n, e) {
  Object.defineProperty(n, "default", { enumerable: !0, value: e });
} : function(n, e) {
  n.default = e;
}), D1 = Dn && Dn.__importStar || function(n) {
  if (n && n.__esModule)
    return n;
  var e = {};
  if (n != null)
    for (var t in n)
      t !== "default" && Object.prototype.hasOwnProperty.call(n, t) && VB(e, n, t);
  return UB(e, n), e;
};
Object.defineProperty(fd, "__esModule", { value: !0 });
var Ee = D1(sn), Xy = Zl, Wf = oo(), n0 = D1(DB), GB = D1(eo()), Ky = Ou, qB = zB, WB = R1, HB = H3(), YB = function(n) {
  var e, t, r, i, o = (0, Ee.useRef)({}), f = (0, Ee.useRef)({}), s = (0, Ee.useRef)({}), l = (0, Ee.useRef)({}), c = (0, Ee.useRef)(!0), p = (0, Ee.useRef)(0), g = (0, Ee.useRef)(jo({}, WB.defaultPointerRef)), d = (0, Ee.useRef)({}), v = (0, Ee.useRef)([]), b = (0, Ee.useRef)((0, Xy.pie)()), w = (0, Ee.useRef)(jo({}, qB.defaultDimensions)), m = (0, Ee.useRef)(n), _ = (0, Ee.useRef)({}), x = (0, Ee.useRef)(null), A = {
    props: m.current,
    prevProps: _,
    svg: o,
    g: s,
    dimensions: w,
    doughnut: l,
    isFirstRun: c,
    currentProgress: p,
    pointer: g,
    container: d,
    arcData: v,
    pieChart: b,
    tooltip: f
  }, T = function() {
    var F, V, E = jo({}, Wf.defaultGaugeProps);
    if (A.props = m.current = (0, Ky.mergeObjects)(E, n), ((F = A.props.arc) === null || F === void 0 ? void 0 : F.width) == ((V = Wf.defaultGaugeProps.arc) === null || V === void 0 ? void 0 : V.width)) {
      var L = m.current.arc;
      L.width = (0, HB.getArcWidthByType)(A.props.type);
    }
    A.props.marginInPercent == Wf.defaultGaugeProps.marginInPercent && (m.current.marginInPercent = (0, Wf.getGaugeMarginByType)(A.props.type)), GB.validateArcs(A);
  }, S = function() {
    var F = JSON.stringify(_.current.arc) !== JSON.stringify(m.current.arc), V = JSON.stringify(_.current.pointer) !== JSON.stringify(m.current.pointer), E = JSON.stringify(_.current.value) !== JSON.stringify(m.current.value), L = JSON.stringify(_.current.minValue) !== JSON.stringify(m.current.minValue), $ = JSON.stringify(_.current.maxValue) !== JSON.stringify(m.current.maxValue);
    return F || V || E || L || $;
  };
  (0, Ee.useLayoutEffect)(function() {
    T(), c.current = (0, Ky.isEmptyObject)(d.current), c.current && (d.current = (0, Xy.select)(x.current)), S() && n0.initChart(A), A.prevProps.current = m.current;
  }, [n]), (0, Ee.useEffect)(function() {
    var F, V = new MutationObserver(function() {
      var E;
      !((E = x.current) === null || E === void 0) && E.offsetParent && (n0.renderChart(A, !0), V.disconnect());
    });
    return V.observe((F = x.current) === null || F === void 0 ? void 0 : F.parentNode, { attributes: !0, subtree: !1 }), function() {
      return V.disconnect();
    };
  }, [(t = (e = x.current) === null || e === void 0 ? void 0 : e.parentNode) === null || t === void 0 ? void 0 : t.offsetWidth, (i = (r = x.current) === null || r === void 0 ? void 0 : r.parentNode) === null || i === void 0 ? void 0 : i.offsetHeight]), (0, Ee.useEffect)(function() {
    var F = function() {
      return n0.renderChart(A, !0);
    };
    return window.addEventListener("resize", F), function() {
      return window.removeEventListener("resize", F);
    };
  }, [n]);
  var R = n.id, I = n.style, B = n.className;
  return n.type, Ee.default.createElement("div", { id: R, className: "".concat(A.props.type, "-gauge").concat(B ? " " + B : ""), style: I, ref: function(F) {
    return x.current = F;
  } });
}, XB = fd.default = YB;
const KB = /* @__PURE__ */ Dt({
  __proto__: null,
  default: XB
}, [fd]), ZB = /* @__PURE__ */ xt(KB);
var JB = Dn && Dn.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(m2, "__esModule", { value: !0 });
var QB = JB(ZB), jB = m2.default = QB.default;
const nz = (n) => {
  const e = typeof window < "u" && window.screen.width < 720;
  return sn.createElement(jB, { value: n.value, type: "semicircle", labels: {
    valueLabel: { hide: !0 },
    tickLabels: {
      type: "outer",
      hideMinMax: !0,
      defaultTickLineConfig: {
        hide: !0
      },
      ticks: [
        { value: 10, label: "Strong Buyer" },
        { value: 30, label: "Buyer" },
        { value: 50, label: "Neutral" },
        { value: 70, label: "Seller" },
        { value: 90, label: "Strong Seller" }
      ].map((t) => ({
        value: t.value,
        valueConfig: {
          formatTextValue: (r) => t.label,
          style: {
            fontSize: "13px",
            fill: "#54545A",
            fontFamily: "sans-serif"
          }
        }
      }))
    }
  }, arc: {
    subArcs: [
      { color: n.value === 10 ? "#006AFF" : "#F1F1F4" },
      { color: n.value === 30 ? "#579DFF" : "#F1F1F4" },
      { color: n.value === 50 ? "#FFD237" : "#F1F1F4" },
      { color: n.value === 70 ? "#FF6B45" : "#F1F1F4" },
      { color: n.value === 90 ? "#DB3A00" : "#F1F1F4" }
    ],
    padding: 0.01,
    width: 0.35,
    cornerRadius: 0
  }, pointer: {
    animate: !1,
    width: 12,
    length: 0.8
  }, marginInPercent: {
    top: 0.13,
    bottom: e ? 0 : 0.08,
    left: 0.07,
    right: 0.07
  } });
}, Zy = typeof Zt == "function" ? Zt : Zt.default, uz = ({ marketSentiment: n = Xt.STRONG_SELLER, title: e }) => {
  const t = Zy(e0)`
    background-color: ${rl("colors.blue100")};
  `, r = Zy(i2)`
    padding: 0px;
  `;
  return sn.createElement(
    r,
    { cardType: "secondary" },
    sn.createElement(
      ni,
      { display: "flex", flexDirection: "column", justifyContent: "center", padding: "md" },
      sn.createElement(ed, { level: "5", fontFamily: "serif", paddingTop: { sm_lte: "md" } }, e),
      sn.createElement(
        e0,
        { marginTop: "md" },
        sn.createElement(nz, { value: CA(n) }),
        sn.createElement(
          ni,
          { display: "flex", flexDirection: "row", justifyContent: "space-between" },
          sn.createElement(ka, { fontType: { default: "finePrint", md: "bodySmall" }, paddingX: { default: "lg", md: "xl" }, marginLeft: { md_gte: "xl" } }, "Buyer's Market"),
          sn.createElement(ka, { fontType: { default: "finePrint", md: "bodySmall" }, paddingX: { default: "lg", md: "xl" }, marginRight: { md_gte: "xl" } }, "Seller's Market")
        )
      )
    ),
    sn.createElement(
      t,
      { padding: "md" },
      sn.createElement(
        ka,
        { fontType: { sm_lte: "finePrint", md: "body" } },
        sn.createElement(
          "b",
          null,
          n[0].toUpperCase() + n.slice(1),
          ":"
        ),
        " ",
        EA(n)
      )
    )
  );
};
export {
  uz as MarketTempNeedleChartBox,
  iz as PropertyTaxCalculator,
  az as TaxComparisonTable
};
//# sourceMappingURL=zrs-traffic.es.js.map
